/**
 * Generated by `bun run generate` from Lucide's icon data; regenerating
 * replaces any manual edits with a fresh pull from that source.
 *
 * @author [Sergio Xalambrí](https://sergiodxa.com)
 * @copyright Sergio Xalambrí 2026
 */

import type { IconNode } from "./create-lucide-icon.js";

export const aArrowDown = [
	["path", { d: "m14 12 4 4 4-4" }],
	["path", { d: "M18 16V7" }],
	["path", { d: "m2 16 4.039-9.69a.5.5 0 0 1 .923 0L11 16" }],
	["path", { d: "M3.304 13h6.392" }],
] satisfies IconNode;

export const aArrowUp = [
	["path", { d: "m14 11 4-4 4 4" }],
	["path", { d: "M18 16V7" }],
	["path", { d: "m2 16 4.039-9.69a.5.5 0 0 1 .923 0L11 16" }],
	["path", { d: "M3.304 13h6.392" }],
] satisfies IconNode;

export const aLargeSmall = [
	["path", { d: "m15 16 2.536-7.328a1.02 1.02 1 0 1 1.928 0L22 16" }],
	["path", { d: "M15.697 14h5.606" }],
	["path", { d: "m2 16 4.039-9.69a.5.5 0 0 1 .923 0L11 16" }],
	["path", { d: "M3.304 13h6.392" }],
] satisfies IconNode;

export const accessibility = [
	["circle", { cx: "16", cy: "4", r: "1" }],
	["path", { d: "m18 19 1-7-6 1" }],
	["path", { d: "m5 8 3-3 5.5 3-2.36 3.5" }],
	["path", { d: "M4.24 14.5a5 5 0 0 0 6.88 6" }],
	["path", { d: "M13.76 17.5a5 5 0 0 0-6.88-6" }],
] satisfies IconNode;

export const activity = [
	[
		"path",
		{
			d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
		},
	],
] satisfies IconNode;

export const ad = [
	["path", { d: "M10 13H6" }],
	["path", { d: "M10 15v-4a2 2 0 0 0-4 0v4" }],
	[
		"path",
		{
			d: "M14 14.5a.5.5 0 0 0 .5.5h1a2.5 2.5 0 0 0 2.5-2.5v-1A2.5 2.5 0 0 0 15.5 9h-1a.5.5 0 0 0-.5.5z",
		},
	],
	["rect", { x: "2", y: "5", width: "20", height: "14", rx: "2" }],
] satisfies IconNode;

export const airVent = [
	["path", { d: "M18 17.5a2.5 2.5 0 1 1-4 2.03V12" }],
	["path", { d: "M6 12H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" }],
	["path", { d: "M6 8h12" }],
	["path", { d: "M6.6 15.572A2 2 0 1 0 10 17v-5" }],
] satisfies IconNode;

export const airplay = [
	["path", { d: "M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1" }],
	["path", { d: "m12 15 5 6H7Z" }],
] satisfies IconNode;

export const alarmClock = [
	["circle", { cx: "12", cy: "13", r: "8" }],
	["path", { d: "M12 9v4l2 2" }],
	["path", { d: "M5 3 2 6" }],
	["path", { d: "m22 6-3-3" }],
	["path", { d: "M6.38 18.7 4 21" }],
	["path", { d: "M17.64 18.67 20 21" }],
] satisfies IconNode;

export const alarmClockCheck = [
	["circle", { cx: "12", cy: "13", r: "8" }],
	["path", { d: "M5 3 2 6" }],
	["path", { d: "m22 6-3-3" }],
	["path", { d: "M6.38 18.7 4 21" }],
	["path", { d: "M17.64 18.67 20 21" }],
	["path", { d: "m9 13 2 2 4-4" }],
] satisfies IconNode;

export const alarmClockMinus = [
	["circle", { cx: "12", cy: "13", r: "8" }],
	["path", { d: "M5 3 2 6" }],
	["path", { d: "m22 6-3-3" }],
	["path", { d: "M6.38 18.7 4 21" }],
	["path", { d: "M17.64 18.67 20 21" }],
	["path", { d: "M9 13h6" }],
] satisfies IconNode;

export const alarmClockOff = [
	["path", { d: "M6.87 6.87a8 8 0 1 0 11.26 11.26" }],
	["path", { d: "M19.9 14.25a8 8 0 0 0-9.15-9.15" }],
	["path", { d: "m22 6-3-3" }],
	["path", { d: "M6.26 18.67 4 21" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M4 4 2 6" }],
] satisfies IconNode;

export const alarmClockPlus = [
	["circle", { cx: "12", cy: "13", r: "8" }],
	["path", { d: "M5 3 2 6" }],
	["path", { d: "m22 6-3-3" }],
	["path", { d: "M6.38 18.7 4 21" }],
	["path", { d: "M17.64 18.67 20 21" }],
	["path", { d: "M12 10v6" }],
	["path", { d: "M9 13h6" }],
] satisfies IconNode;

export const alarmSmoke = [
	["path", { d: "M11 21c0-2.5 2-2.5 2-5" }],
	["path", { d: "M16 21c0-2.5 2-2.5 2-5" }],
	["path", { d: "m19 8-.8 3a1.25 1.25 0 0 1-1.2 1H7a1.25 1.25 0 0 1-1.2-1L5 8" }],
	["path", { d: "M21 3a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a1 1 0 0 1 1-1z" }],
	["path", { d: "M6 21c0-2.5 2-2.5 2-5" }],
] satisfies IconNode;

export const alignCenterHorizontal = [
	["path", { d: "M2 12h20" }],
	["path", { d: "M10 16v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4" }],
	["path", { d: "M10 8V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4" }],
	["path", { d: "M20 16v1a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1" }],
	["path", { d: "M14 8V7c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v1" }],
] satisfies IconNode;

export const alignCenterVertical = [
	["path", { d: "M12 2v20" }],
	["path", { d: "M8 10H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h4" }],
	["path", { d: "M16 10h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4" }],
	["path", { d: "M8 20H7a2 2 0 0 1-2-2v-2c0-1.1.9-2 2-2h1" }],
	["path", { d: "M16 14h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1" }],
] satisfies IconNode;

export const alignEndHorizontal = [
	["rect", { width: "6", height: "16", x: "4", y: "2", rx: "2" }],
	["rect", { width: "6", height: "9", x: "14", y: "9", rx: "2" }],
	["path", { d: "M22 22H2" }],
] satisfies IconNode;

export const alignEndVertical = [
	["rect", { width: "16", height: "6", x: "2", y: "4", rx: "2" }],
	["rect", { width: "9", height: "6", x: "9", y: "14", rx: "2" }],
	["path", { d: "M22 22V2" }],
] satisfies IconNode;

export const alignHorizontalDistributeCenter = [
	["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2" }],
	["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2" }],
	["path", { d: "M17 22v-5" }],
	["path", { d: "M17 7V2" }],
	["path", { d: "M7 22v-3" }],
	["path", { d: "M7 5V2" }],
] satisfies IconNode;

export const alignHorizontalDistributeEnd = [
	["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2" }],
	["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2" }],
	["path", { d: "M10 2v20" }],
	["path", { d: "M20 2v20" }],
] satisfies IconNode;

export const alignHorizontalDistributeStart = [
	["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2" }],
	["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2" }],
	["path", { d: "M4 2v20" }],
	["path", { d: "M14 2v20" }],
] satisfies IconNode;

export const alignHorizontalJustifyCenter = [
	["rect", { width: "6", height: "14", x: "2", y: "5", rx: "2" }],
	["rect", { width: "6", height: "10", x: "16", y: "7", rx: "2" }],
	["path", { d: "M12 2v20" }],
] satisfies IconNode;

export const alignHorizontalJustifyEnd = [
	["rect", { width: "6", height: "14", x: "2", y: "5", rx: "2" }],
	["rect", { width: "6", height: "10", x: "12", y: "7", rx: "2" }],
	["path", { d: "M22 2v20" }],
] satisfies IconNode;

export const alignHorizontalJustifyStart = [
	["rect", { width: "6", height: "14", x: "6", y: "5", rx: "2" }],
	["rect", { width: "6", height: "10", x: "16", y: "7", rx: "2" }],
	["path", { d: "M2 2v20" }],
] satisfies IconNode;

export const alignHorizontalSpaceAround = [
	["rect", { width: "6", height: "10", x: "9", y: "7", rx: "2" }],
	["path", { d: "M4 22V2" }],
	["path", { d: "M20 22V2" }],
] satisfies IconNode;

export const alignHorizontalSpaceBetween = [
	["rect", { width: "6", height: "14", x: "3", y: "5", rx: "2" }],
	["rect", { width: "6", height: "10", x: "15", y: "7", rx: "2" }],
	["path", { d: "M3 2v20" }],
	["path", { d: "M21 2v20" }],
] satisfies IconNode;

export const alignStartHorizontal = [
	["rect", { width: "6", height: "16", x: "4", y: "6", rx: "2" }],
	["rect", { width: "6", height: "9", x: "14", y: "6", rx: "2" }],
	["path", { d: "M22 2H2" }],
] satisfies IconNode;

export const alignStartVertical = [
	["rect", { width: "9", height: "6", x: "6", y: "14", rx: "2" }],
	["rect", { width: "16", height: "6", x: "6", y: "4", rx: "2" }],
	["path", { d: "M2 2v20" }],
] satisfies IconNode;

export const alignVerticalDistributeCenter = [
	["path", { d: "M22 17h-3" }],
	["path", { d: "M22 7h-5" }],
	["path", { d: "M5 17H2" }],
	["path", { d: "M7 7H2" }],
	["rect", { x: "5", y: "14", width: "14", height: "6", rx: "2" }],
	["rect", { x: "7", y: "4", width: "10", height: "6", rx: "2" }],
] satisfies IconNode;

export const alignVerticalDistributeEnd = [
	["rect", { width: "14", height: "6", x: "5", y: "14", rx: "2" }],
	["rect", { width: "10", height: "6", x: "7", y: "4", rx: "2" }],
	["path", { d: "M2 20h20" }],
	["path", { d: "M2 10h20" }],
] satisfies IconNode;

export const alignVerticalDistributeStart = [
	["rect", { width: "14", height: "6", x: "5", y: "14", rx: "2" }],
	["rect", { width: "10", height: "6", x: "7", y: "4", rx: "2" }],
	["path", { d: "M2 14h20" }],
	["path", { d: "M2 4h20" }],
] satisfies IconNode;

export const alignVerticalJustifyCenter = [
	["rect", { width: "14", height: "6", x: "5", y: "16", rx: "2" }],
	["rect", { width: "10", height: "6", x: "7", y: "2", rx: "2" }],
	["path", { d: "M2 12h20" }],
] satisfies IconNode;

export const alignVerticalJustifyEnd = [
	["rect", { width: "14", height: "6", x: "5", y: "12", rx: "2" }],
	["rect", { width: "10", height: "6", x: "7", y: "2", rx: "2" }],
	["path", { d: "M2 22h20" }],
] satisfies IconNode;

export const alignVerticalJustifyStart = [
	["rect", { width: "14", height: "6", x: "5", y: "16", rx: "2" }],
	["rect", { width: "10", height: "6", x: "7", y: "6", rx: "2" }],
	["path", { d: "M2 2h20" }],
] satisfies IconNode;

export const alignVerticalSpaceAround = [
	["rect", { width: "10", height: "6", x: "7", y: "9", rx: "2" }],
	["path", { d: "M22 20H2" }],
	["path", { d: "M22 4H2" }],
] satisfies IconNode;

export const alignVerticalSpaceBetween = [
	["rect", { width: "14", height: "6", x: "5", y: "15", rx: "2" }],
	["rect", { width: "10", height: "6", x: "7", y: "3", rx: "2" }],
	["path", { d: "M2 21h20" }],
	["path", { d: "M2 3h20" }],
] satisfies IconNode;

export const ambulance = [
	["path", { d: "M10 10H6" }],
	["path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" }],
	[
		"path",
		{
			d: "M19 18h2a1 1 0 0 0 1-1v-3.28a1 1 0 0 0-.684-.948l-1.923-.641a1 1 0 0 1-.578-.502l-1.539-3.076A1 1 0 0 0 16.382 8H14",
		},
	],
	["path", { d: "M8 8v4" }],
	["path", { d: "M9 18h6" }],
	["circle", { cx: "17", cy: "18", r: "2" }],
	["circle", { cx: "7", cy: "18", r: "2" }],
] satisfies IconNode;

export const ampersand = [
	["path", { d: "M16 12h3" }],
	[
		"path",
		{
			d: "M17.5 12a8 8 0 0 1-8 8A4.5 4.5 0 0 1 5 15.5c0-6 8-4 8-8.5a3 3 0 1 0-6 0c0 3 2.5 8.5 12 13",
		},
	],
] satisfies IconNode;

export const ampersands = [
	[
		"path",
		{ d: "M10 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5" },
	],
	[
		"path",
		{ d: "M22 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5" },
	],
] satisfies IconNode;

export const amphora = [
	["path", { d: "M10 2v5.632c0 .424-.272.795-.653.982A6 6 0 0 0 6 14c.006 4 3 7 5 8" }],
	["path", { d: "M10 5H8a2 2 0 0 0 0 4h.68" }],
	["path", { d: "M14 2v5.632c0 .424.272.795.652.982A6 6 0 0 1 18 14c0 4-3 7-5 8" }],
	["path", { d: "M14 5h2a2 2 0 0 1 0 4h-.68" }],
	["path", { d: "M18 22H6" }],
	["path", { d: "M9 2h6" }],
] satisfies IconNode;

export const anchor = [
	["path", { d: "M12 6v16" }],
	["path", { d: "m19 13 2-1a9 9 0 0 1-18 0l2 1" }],
	["path", { d: "M9 11h6" }],
	["circle", { cx: "12", cy: "4", r: "2" }],
] satisfies IconNode;

export const angle = [
	["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
	["path", { d: "M3 11a10 10 0 0 1 10 10" }],
] satisfies IconNode;

export const antenna = [
	["path", { d: "M2 12 7 2" }],
	["path", { d: "m7 12 5-10" }],
	["path", { d: "m12 12 5-10" }],
	["path", { d: "m17 12 5-10" }],
	["path", { d: "M4.5 7h15" }],
	["path", { d: "M12 16v6" }],
] satisfies IconNode;

export const anvil = [
	["path", { d: "M7 10H6a4 4 0 0 1-4-4 1 1 0 0 1 1-1h4" }],
	["path", { d: "M7 5a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1 7 7 0 0 1-7 7H8a1 1 0 0 1-1-1z" }],
	["path", { d: "M9 12v5" }],
	["path", { d: "M15 12v5" }],
	["path", { d: "M5 20a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3 1 1 0 0 1-1 1H6a1 1 0 0 1-1-1" }],
] satisfies IconNode;

export const aperture = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "m14.31 8 5.74 9.94" }],
	["path", { d: "M9.69 8h11.48" }],
	["path", { d: "m7.38 12 5.74-9.94" }],
	["path", { d: "M9.69 16 3.95 6.06" }],
	["path", { d: "M14.31 16H2.83" }],
	["path", { d: "m16.62 12-5.74 9.94" }],
] satisfies IconNode;

export const appWindow = [
	["rect", { x: "2", y: "4", width: "20", height: "16", rx: "2" }],
	["path", { d: "M10 4v4" }],
	["path", { d: "M2 8h20" }],
	["path", { d: "M6 4v4" }],
] satisfies IconNode;

export const appWindowMac = [
	["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2" }],
	["path", { d: "M6 8h.01" }],
	["path", { d: "M10 8h.01" }],
	["path", { d: "M14 8h.01" }],
] satisfies IconNode;

export const apple = [
	["path", { d: "M12 6.528V3a1 1 0 0 1 1-1h0" }],
	[
		"path",
		{
			d: "M18.237 21A15 15 0 0 0 22 11a6 6 0 0 0-10-4.472A6 6 0 0 0 2 11a15.1 15.1 0 0 0 3.763 10 3 3 0 0 0 3.648.648 5.5 5.5 0 0 1 5.178 0A3 3 0 0 0 18.237 21",
		},
	],
] satisfies IconNode;

export const archive = [
	["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1" }],
	["path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8" }],
	["path", { d: "M10 12h4" }],
] satisfies IconNode;

export const archiveRestore = [
	["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1" }],
	["path", { d: "M4 8v11a2 2 0 0 0 2 2h2" }],
	["path", { d: "M20 8v11a2 2 0 0 1-2 2h-2" }],
	["path", { d: "m9 15 3-3 3 3" }],
	["path", { d: "M12 12v9" }],
] satisfies IconNode;

export const archiveX = [
	["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1" }],
	["path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8" }],
	["path", { d: "m9.5 17 5-5" }],
	["path", { d: "m9.5 12 5 5" }],
] satisfies IconNode;

export const armchair = [
	["path", { d: "M19 9V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3" }],
	[
		"path",
		{
			d: "M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z",
		},
	],
	["path", { d: "M5 18v2" }],
	["path", { d: "M19 18v2" }],
] satisfies IconNode;

export const armenianDram = [
	["path", { d: "M11 10h8" }],
	["path", { d: "M11 14h8" }],
	["path", { d: "M17 20V10a6 6 0 0 0-12 0" }],
] satisfies IconNode;

export const arrowBigDown = [
	[
		"path",
		{
			d: "M9 5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v6a1 1 0 0 0 1 1h3.293a.707.707 0 0 1 .5 1.207l-7.086 7.086a1 1 0 0 1-1.414 0l-7.086-7.086a.707.707 0 0 1 .5-1.207H8a1 1 0 0 0 1-1z",
		},
	],
] satisfies IconNode;

export const arrowBigDownDash = [
	[
		"path",
		{
			d: "M14 8a1 1 0 0 1 1 1v2a1 1 0 0 0 1 1h3.293a.707.707 0 0 1 .5 1.207l-6.939 6.939a1.207 1.207 0 0 1-1.708 0l-6.94-6.94a.707.707 0 0 1 .5-1.206H8a1 1 0 0 0 1-1V9a1 1 0 0 1 1-1z",
		},
	],
	["path", { d: "M9 4h6" }],
] satisfies IconNode;

export const arrowBigLeft = [
	[
		"path",
		{
			d: "M10.793 19.793a.707.707 0 0 0 1.207-.5V16a1 1 0 0 1 1-1h6a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-6a1 1 0 0 1-1-1V4.707a.707.707 0 0 0-1.207-.5l-6.94 6.94a1.207 1.207 0 0 0 0 1.707z",
		},
	],
] satisfies IconNode;

export const arrowBigLeftDash = [
	[
		"path",
		{
			d: "M13 9a1 1 0 0 1-1-1V4.707a.707.707 0 0 0-1.207-.5l-6.94 6.94a1.207 1.207 0 0 0 0 1.707l6.94 6.94a.707.707 0 0 0 1.207-.5V16a1 1 0 0 1 1-1h2a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1z",
		},
	],
	["path", { d: "M20 9v6" }],
] satisfies IconNode;

export const arrowBigRight = [
	[
		"path",
		{
			d: "M13.207 19.793a.707.707 0 0 1-1.207-.5V16a1 1 0 0 0-1-1H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h6a1 1 0 0 0 1-1V4.707a.707.707 0 0 1 1.207-.5l6.94 6.94a1.207 1.207 0 0 1 0 1.707z",
		},
	],
] satisfies IconNode;

export const arrowBigRightDash = [
	[
		"path",
		{
			d: "M11 9a1 1 0 0 0 1-1V4.707a.707.707 0 0 1 1.207-.5l6.94 6.94a1.207 1.207 0 0 1 0 1.707l-6.94 6.94a.707.707 0 0 1-1.207-.5V16a1 1 0 0 0-1-1H9a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1z",
		},
	],
	["path", { d: "M4 9v6" }],
] satisfies IconNode;

export const arrowBigUp = [
	[
		"path",
		{
			d: "M9 19a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-6a1 1 0 0 1 1-1h3.293a.707.707 0 0 0 .5-1.207l-7.086-7.086a1 1 0 0 0-1.414 0l-7.086 7.086a.707.707 0 0 0 .5 1.207H8a1 1 0 0 1 1 1z",
		},
	],
] satisfies IconNode;

export const arrowBigUpDash = [
	[
		"path",
		{
			d: "M14 16a1 1 0 0 0 1-1v-2a1 1 0 0 1 1-1h3.293a.707.707 0 0 0 .5-1.207l-6.939-6.939a1.207 1.207 0 0 0-1.708 0l-6.94 6.94a.707.707 0 0 0 .5 1.206H8a1 1 0 0 1 1 1v2a1 1 0 0 0 1 1z",
		},
	],
	["path", { d: "M9 20h6" }],
] satisfies IconNode;

export const arrowDown = [
	["path", { d: "M12 5v14" }],
	["path", { d: "m19 12-7 7-7-7" }],
] satisfies IconNode;

export const arrowDown01 = [
	["path", { d: "m3 16 4 4 4-4" }],
	["path", { d: "M7 20V4" }],
	["rect", { x: "15", y: "4", width: "4", height: "6", ry: "2" }],
	["path", { d: "M17 20v-6h-2" }],
	["path", { d: "M15 20h4" }],
] satisfies IconNode;

export const arrowDown10 = [
	["path", { d: "m3 16 4 4 4-4" }],
	["path", { d: "M7 20V4" }],
	["path", { d: "M17 10V4h-2" }],
	["path", { d: "M15 10h4" }],
	["rect", { x: "15", y: "14", width: "4", height: "6", ry: "2" }],
] satisfies IconNode;

export const arrowDownAZ = [
	["path", { d: "m3 16 4 4 4-4" }],
	["path", { d: "M7 20V4" }],
	["path", { d: "M20 8h-5" }],
	["path", { d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10" }],
	["path", { d: "M15 14h5l-5 6h5" }],
] satisfies IconNode;

export const arrowDownFromLine = [
	["path", { d: "M19 3H5" }],
	["path", { d: "M12 21V7" }],
	["path", { d: "m6 15 6 6 6-6" }],
] satisfies IconNode;

export const arrowDownLeft = [
	["path", { d: "M17 7 7 17" }],
	["path", { d: "M17 17H7V7" }],
] satisfies IconNode;

export const arrowDownNarrowWide = [
	["path", { d: "m3 16 4 4 4-4" }],
	["path", { d: "M7 20V4" }],
	["path", { d: "M11 4h4" }],
	["path", { d: "M11 8h7" }],
	["path", { d: "M11 12h10" }],
] satisfies IconNode;

export const arrowDownRight = [
	["path", { d: "m7 7 10 10" }],
	["path", { d: "M17 7v10H7" }],
] satisfies IconNode;

export const arrowDownToDot = [
	["path", { d: "M12 2v14" }],
	["path", { d: "m19 9-7 7-7-7" }],
	["circle", { cx: "12", cy: "21", r: "1" }],
] satisfies IconNode;

export const arrowDownToLine = [
	["path", { d: "M12 17V3" }],
	["path", { d: "m6 11 6 6 6-6" }],
	["path", { d: "M19 21H5" }],
] satisfies IconNode;

export const arrowDownUp = [
	["path", { d: "m3 16 4 4 4-4" }],
	["path", { d: "M7 20V4" }],
	["path", { d: "m21 8-4-4-4 4" }],
	["path", { d: "M17 4v16" }],
] satisfies IconNode;

export const arrowDownWideNarrow = [
	["path", { d: "m3 16 4 4 4-4" }],
	["path", { d: "M7 20V4" }],
	["path", { d: "M11 4h10" }],
	["path", { d: "M11 8h7" }],
	["path", { d: "M11 12h4" }],
] satisfies IconNode;

export const arrowDownZA = [
	["path", { d: "m3 16 4 4 4-4" }],
	["path", { d: "M7 4v16" }],
	["path", { d: "M15 4h5l-5 6h5" }],
	["path", { d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20" }],
	["path", { d: "M20 18h-5" }],
] satisfies IconNode;

export const arrowLeft = [
	["path", { d: "m12 19-7-7 7-7" }],
	["path", { d: "M19 12H5" }],
] satisfies IconNode;

export const arrowLeftFromLine = [
	["path", { d: "m9 6-6 6 6 6" }],
	["path", { d: "M3 12h14" }],
	["path", { d: "M21 19V5" }],
] satisfies IconNode;

export const arrowLeftRight = [
	["path", { d: "M8 3 4 7l4 4" }],
	["path", { d: "M4 7h16" }],
	["path", { d: "m16 21 4-4-4-4" }],
	["path", { d: "M20 17H4" }],
] satisfies IconNode;

export const arrowLeftToLine = [
	["path", { d: "M3 19V5" }],
	["path", { d: "m13 6-6 6 6 6" }],
	["path", { d: "M7 12h14" }],
] satisfies IconNode;

export const arrowRight = [
	["path", { d: "M5 12h14" }],
	["path", { d: "m12 5 7 7-7 7" }],
] satisfies IconNode;

export const arrowRightFromLine = [
	["path", { d: "M3 5v14" }],
	["path", { d: "M21 12H7" }],
	["path", { d: "m15 18 6-6-6-6" }],
] satisfies IconNode;

export const arrowRightLeft = [
	["path", { d: "m16 3 4 4-4 4" }],
	["path", { d: "M20 7H4" }],
	["path", { d: "m8 21-4-4 4-4" }],
	["path", { d: "M4 17h16" }],
] satisfies IconNode;

export const arrowRightToLine = [
	["path", { d: "M17 12H3" }],
	["path", { d: "m11 18 6-6-6-6" }],
	["path", { d: "M21 5v14" }],
] satisfies IconNode;

export const arrowUp = [
	["path", { d: "m5 12 7-7 7 7" }],
	["path", { d: "M12 19V5" }],
] satisfies IconNode;

export const arrowUp01 = [
	["path", { d: "m3 8 4-4 4 4" }],
	["path", { d: "M7 4v16" }],
	["rect", { x: "15", y: "4", width: "4", height: "6", ry: "2" }],
	["path", { d: "M17 20v-6h-2" }],
	["path", { d: "M15 20h4" }],
] satisfies IconNode;

export const arrowUp10 = [
	["path", { d: "m3 8 4-4 4 4" }],
	["path", { d: "M7 4v16" }],
	["path", { d: "M17 10V4h-2" }],
	["path", { d: "M15 10h4" }],
	["rect", { x: "15", y: "14", width: "4", height: "6", ry: "2" }],
] satisfies IconNode;

export const arrowUpAZ = [
	["path", { d: "m3 8 4-4 4 4" }],
	["path", { d: "M7 4v16" }],
	["path", { d: "M20 8h-5" }],
	["path", { d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10" }],
	["path", { d: "M15 14h5l-5 6h5" }],
] satisfies IconNode;

export const arrowUpDown = [
	["path", { d: "m21 16-4 4-4-4" }],
	["path", { d: "M17 20V4" }],
	["path", { d: "m3 8 4-4 4 4" }],
	["path", { d: "M7 4v16" }],
] satisfies IconNode;

export const arrowUpFromDot = [
	["path", { d: "m5 9 7-7 7 7" }],
	["path", { d: "M12 16V2" }],
	["circle", { cx: "12", cy: "21", r: "1" }],
] satisfies IconNode;

export const arrowUpFromLine = [
	["path", { d: "m18 9-6-6-6 6" }],
	["path", { d: "M12 3v14" }],
	["path", { d: "M5 21h14" }],
] satisfies IconNode;

export const arrowUpLeft = [
	["path", { d: "M7 17V7h10" }],
	["path", { d: "M17 17 7 7" }],
] satisfies IconNode;

export const arrowUpNarrowWide = [
	["path", { d: "m3 8 4-4 4 4" }],
	["path", { d: "M7 4v16" }],
	["path", { d: "M11 12h4" }],
	["path", { d: "M11 16h7" }],
	["path", { d: "M11 20h10" }],
] satisfies IconNode;

export const arrowUpRight = [
	["path", { d: "M7 7h10v10" }],
	["path", { d: "M7 17 17 7" }],
] satisfies IconNode;

export const arrowUpToLine = [
	["path", { d: "M5 3h14" }],
	["path", { d: "m18 13-6-6-6 6" }],
	["path", { d: "M12 7v14" }],
] satisfies IconNode;

export const arrowUpWideNarrow = [
	["path", { d: "m3 8 4-4 4 4" }],
	["path", { d: "M7 4v16" }],
	["path", { d: "M11 12h10" }],
	["path", { d: "M11 16h7" }],
	["path", { d: "M11 20h4" }],
] satisfies IconNode;

export const arrowUpZA = [
	["path", { d: "m3 8 4-4 4 4" }],
	["path", { d: "M7 4v16" }],
	["path", { d: "M15 4h5l-5 6h5" }],
	["path", { d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20" }],
	["path", { d: "M20 18h-5" }],
] satisfies IconNode;

export const arrowsUpFromLine = [
	["path", { d: "m4 6 3-3 3 3" }],
	["path", { d: "M7 17V3" }],
	["path", { d: "m14 6 3-3 3 3" }],
	["path", { d: "M17 17V3" }],
	["path", { d: "M4 21h16" }],
] satisfies IconNode;

export const asterisk = [
	["path", { d: "M12 5v14" }],
	["path", { d: "m18.065 8.496-12.125 7" }],
	["path", { d: "m5.94 8.504 12.125 7" }],
] satisfies IconNode;

export const astroid = [
	[
		"path",
		{
			d: "M12.983 21.186a1 1 0 0 1-1.966 0 10 10 0 0 0-8.203-8.203 1 1 0 0 1 0-1.966 10 10 0 0 0 8.203-8.203 1 1 0 0 1 1.966 0 10 10 0 0 0 8.203 8.203 1 1 0 0 1 0 1.966 10 10 0 0 0-8.203 8.203",
		},
	],
] satisfies IconNode;

export const atSign = [
	["circle", { cx: "12", cy: "12", r: "4" }],
	["path", { d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8" }],
] satisfies IconNode;

export const atom = [
	["circle", { cx: "12", cy: "12", r: "1" }],
	[
		"path",
		{
			d: "M20.2 20.2c2.04-2.03.02-7.36-4.5-11.9-4.54-4.52-9.87-6.54-11.9-4.5-2.04 2.03-.02 7.36 4.5 11.9 4.54 4.52 9.87 6.54 11.9 4.5Z",
		},
	],
	[
		"path",
		{
			d: "M15.7 15.7c4.52-4.54 6.54-9.87 4.5-11.9-2.03-2.04-7.36-.02-11.9 4.5-4.52 4.54-6.54 9.87-4.5 11.9 2.03 2.04 7.36.02 11.9-4.5Z",
		},
	],
] satisfies IconNode;

export const audioLines = [
	["path", { d: "M2 10v3" }],
	["path", { d: "M6 6v11" }],
	["path", { d: "M10 3v18" }],
	["path", { d: "M14 8v7" }],
	["path", { d: "M18 5v13" }],
	["path", { d: "M22 10v3" }],
] satisfies IconNode;

export const audioLinesOff = [
	["path", { d: "M10 10v11" }],
	["path", { d: "M10 3v1.35" }],
	["path", { d: "M14 14v1" }],
	["path", { d: "M14 8v.35" }],
	["path", { d: "M18 5v7.35" }],
	["path", { d: "M2 10v3" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M22 10v3" }],
	["path", { d: "M6 6v11" }],
] satisfies IconNode;

export const audioLinesX = [
	["path", { d: "M10 3v18" }],
	["path", { d: "M14 8v6.35" }],
	["path", { d: "m17 17 5 5" }],
	["path", { d: "M18 5v8.1" }],
	["path", { d: "M2 10v3" }],
	["path", { d: "M22 10v3" }],
	["path", { d: "m22 17-5 5" }],
	["path", { d: "M6 6v11" }],
] satisfies IconNode;

export const audioWaveform = [
	[
		"path",
		{
			d: "M2 13a2 2 0 0 0 2-2V7a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0V4a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0v-4a2 2 0 0 1 2-2",
		},
	],
] satisfies IconNode;

export const avocado = [
	[
		"path",
		{
			d: "M13.465 3.464a5 5 0 017.07 0 5 5 0 010 7.072c-1.204 1.203-2.38 2.89-2.614 4.577A8 8 0 118.886 6.08c1.687-.235 3.375-1.41 4.579-2.615",
		},
	],
	["circle", { cx: "10", cy: "14", r: "3" }],
] satisfies IconNode;

export const award = [
	[
		"path",
		{
			d: "m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526",
		},
	],
	["circle", { cx: "12", cy: "8", r: "6" }],
] satisfies IconNode;

export const axe = [
	["path", { d: "m14 12-8.381 8.38a1 1 0 0 1-3.001-3L11 9" }],
	[
		"path",
		{
			d: "M15 15.5a.5.5 0 0 0 .5.5A6.5 6.5 0 0 0 22 9.5a.5.5 0 0 0-.5-.5h-1.672a2 2 0 0 1-1.414-.586l-5.062-5.062a1.205 1.205 0 0 0-1.704 0L9.352 5.648a1.205 1.205 0 0 0 0 1.704l5.062 5.062A2 2 0 0 1 15 13.828z",
		},
	],
] satisfies IconNode;

export const axis3d = [
	["path", { d: "M13.5 10.5 15 9" }],
	["path", { d: "M4 4v15a1 1 0 0 0 1 1h15" }],
	["path", { d: "M4.293 19.707 6 18" }],
	["path", { d: "m9 15 1.5-1.5" }],
] satisfies IconNode;

export const baby = [
	["path", { d: "M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5" }],
	["path", { d: "M15 12h.01" }],
	[
		"path",
		{
			d: "M19.38 6.813A9 9 0 0 1 20.8 10.2a2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1",
		},
	],
	["path", { d: "M9 12h.01" }],
] satisfies IconNode;

export const backpack = [
	["path", { d: "M4 10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z" }],
	["path", { d: "M8 10h8" }],
	["path", { d: "M8 18h8" }],
	["path", { d: "M8 22v-6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v6" }],
	["path", { d: "M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" }],
] satisfies IconNode;

export const bacon = [
	[
		"path",
		{
			d: "M2.795 16.804c-.789-.79-1.09-2.018-.442-2.928 1.933-2.713 4.414-1.05 6.145-5.378 1.868-4.67 4.608-2.366 6.592-6.107.218-.412.78-.53 1.11-.2l5.005 5.005c.789.79 1.09 2.018.442 2.928-1.933 2.713-4.414 1.05-6.145 5.378-1.868 4.67-4.608 2.366-6.591 6.107-.22.412-.78.53-1.11.2z",
		},
	],
	["path", { d: "M4.5 18.5c2-5 5-2 7-7s5-2 7-7" }],
] satisfies IconNode;

export const badge = [
	[
		"path",
		{
			d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
		},
	],
] satisfies IconNode;

export const badgeAlert = [
	[
		"path",
		{
			d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
		},
	],
	["line", { x1: "12", x2: "12", y1: "8", y2: "12" }],
	["line", { x1: "12", x2: "12.01", y1: "16", y2: "16" }],
] satisfies IconNode;

export const badgeCent = [
	[
		"path",
		{
			d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
		},
	],
	["path", { d: "M12 7v10" }],
	["path", { d: "M15.4 10a4 4 0 1 0 0 4" }],
] satisfies IconNode;

export const badgeCheck = [
	[
		"path",
		{
			d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
		},
	],
	["path", { d: "m16 9-5.5 5.5L8 12" }],
] satisfies IconNode;

export const badgeDollarSign = [
	[
		"path",
		{
			d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
		},
	],
	["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" }],
	["path", { d: "M12 18V6" }],
] satisfies IconNode;

export const badgeEuro = [
	[
		"path",
		{
			d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
		},
	],
	["path", { d: "M7 12h5" }],
	["path", { d: "M15 9.4a4 4 0 1 0 0 5.2" }],
] satisfies IconNode;

export const badgeIndianRupee = [
	[
		"path",
		{
			d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
		},
	],
	["path", { d: "M8 8h8" }],
	["path", { d: "M8 12h8" }],
	["path", { d: "m13 17-5-1h1a4 4 0 0 0 0-8" }],
] satisfies IconNode;

export const badgeInfo = [
	[
		"path",
		{
			d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
		},
	],
	["line", { x1: "12", x2: "12", y1: "16", y2: "12" }],
	["line", { x1: "12", x2: "12.01", y1: "8", y2: "8" }],
] satisfies IconNode;

export const badgeJapaneseYen = [
	[
		"path",
		{
			d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
		},
	],
	["path", { d: "m9 8 3 3v7" }],
	["path", { d: "m12 11 3-3" }],
	["path", { d: "M9 12h6" }],
	["path", { d: "M9 16h6" }],
] satisfies IconNode;

export const badgeMinus = [
	[
		"path",
		{
			d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
		},
	],
	["line", { x1: "8", x2: "16", y1: "12", y2: "12" }],
] satisfies IconNode;

export const badgePercent = [
	[
		"path",
		{
			d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
		},
	],
	["path", { d: "m15 9-6 6" }],
	["path", { d: "M9 9h.01" }],
	["path", { d: "M15 15h.01" }],
] satisfies IconNode;

export const badgePlus = [
	[
		"path",
		{
			d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
		},
	],
	["line", { x1: "12", x2: "12", y1: "8", y2: "16" }],
	["line", { x1: "8", x2: "16", y1: "12", y2: "12" }],
] satisfies IconNode;

export const badgePoundSterling = [
	[
		"path",
		{
			d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
		},
	],
	["path", { d: "M8 12h4" }],
	["path", { d: "M10 16V9.5a2.5 2.5 0 0 1 5 0" }],
	["path", { d: "M8 16h7" }],
] satisfies IconNode;

export const badgeQuestionMark = [
	[
		"path",
		{
			d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
		},
	],
	["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" }],
	["line", { x1: "12", x2: "12.01", y1: "17", y2: "17" }],
] satisfies IconNode;

export const badgeRussianRuble = [
	[
		"path",
		{
			d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
		},
	],
	["path", { d: "M9 16h5" }],
	["path", { d: "M9 12h5a2 2 0 1 0 0-4h-3v9" }],
] satisfies IconNode;

export const badgeSwissFranc = [
	[
		"path",
		{
			d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
		},
	],
	["path", { d: "M11 17V8h4" }],
	["path", { d: "M11 12h3" }],
	["path", { d: "M9 16h4" }],
] satisfies IconNode;

export const badgeTurkishLira = [
	["path", { d: "M11 7v10a5 5 0 0 0 5-5" }],
	["path", { d: "m15 8-6 3" }],
	[
		"path",
		{
			d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76",
		},
	],
] satisfies IconNode;

export const badgeX = [
	[
		"path",
		{
			d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
		},
	],
	["line", { x1: "15", x2: "9", y1: "9", y2: "15" }],
	["line", { x1: "9", x2: "15", y1: "9", y2: "15" }],
] satisfies IconNode;

export const baggageClaim = [
	["path", { d: "M22 18H6a2 2 0 0 1-2-2V7a2 2 0 0 0-2-2" }],
	["path", { d: "M17 14V4a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v10" }],
	["rect", { width: "13", height: "8", x: "8", y: "6", rx: "1" }],
	["circle", { cx: "18", cy: "20", r: "2" }],
	["circle", { cx: "9", cy: "20", r: "2" }],
] satisfies IconNode;

export const balloon = [
	["path", { d: "M12 16v1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v1" }],
	["path", { d: "M12 6a2 2 0 0 1 2 2" }],
	["path", { d: "M18 8c0 4-3.5 8-6 8s-6-4-6-8a6 6 0 0 1 12 0" }],
] satisfies IconNode;

export const ban = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M4.929 4.929 19.07 19.071" }],
] satisfies IconNode;

export const banana = [
	["path", { d: "M4 13c3.5-2 8-2 10 2a5.5 5.5 0 0 1 8 5" }],
	[
		"path",
		{
			d: "M5.15 17.89c5.52-1.52 8.65-6.89 7-12C11.55 4 11.5 2 13 2c3.22 0 5 5.5 5 8 0 6.5-4.2 12-10.49 12C5.11 22 2 22 2 20c0-1.5 1.14-1.55 3.15-2.11Z",
		},
	],
] satisfies IconNode;

export const bandage = [
	["path", { d: "M10 10.01h.01" }],
	["path", { d: "M10 14.01h.01" }],
	["path", { d: "M14 10.01h.01" }],
	["path", { d: "M14 14.01h.01" }],
	["path", { d: "M18 6v12" }],
	["path", { d: "M6 6v12" }],
	["rect", { x: "2", y: "6", width: "20", height: "12", rx: "2" }],
] satisfies IconNode;

export const bangladeshiTaka = [
	["path", { d: "M6 5a2 2 0 0 1 4 0v12a4 4 0 0 0 8 0 2 2 0 0 0-4 0" }],
	["path", { d: "M6 9h12" }],
] satisfies IconNode;

export const banknote = [
	["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2" }],
	["circle", { cx: "12", cy: "12", r: "2" }],
	["path", { d: "M6 12h.01M18 12h.01" }],
] satisfies IconNode;

export const banknoteArrowDown = [
	["path", { d: "M12 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5" }],
	["path", { d: "m16 19 3 3 3-3" }],
	["path", { d: "M18 12h.01" }],
	["path", { d: "M19 16v6" }],
	["path", { d: "M6 12h.01" }],
	["circle", { cx: "12", cy: "12", r: "2" }],
] satisfies IconNode;

export const banknoteArrowUp = [
	["path", { d: "M12 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5" }],
	["path", { d: "M18 12h.01" }],
	["path", { d: "M19 22v-6" }],
	["path", { d: "m22 19-3-3-3 3" }],
	["path", { d: "M6 12h.01" }],
	["circle", { cx: "12", cy: "12", r: "2" }],
] satisfies IconNode;

export const banknoteCheck = [
	["path", { d: "M11.748 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4.875" }],
	["path", { d: "m16 19 2 2 4-4" }],
	["path", { d: "M18 12h.01" }],
	["path", { d: "M6 12h.01" }],
	["circle", { cx: "12", cy: "12", r: "2" }],
] satisfies IconNode;

export const banknoteX = [
	["path", { d: "M13 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5" }],
	["path", { d: "m17 17 5 5" }],
	["path", { d: "M18 12h.01" }],
	["path", { d: "m22 17-5 5" }],
	["path", { d: "M6 12h.01" }],
	["circle", { cx: "12", cy: "12", r: "2" }],
] satisfies IconNode;

export const barcode = [
	["path", { d: "M3 5v14" }],
	["path", { d: "M8 5v14" }],
	["path", { d: "M12 5v14" }],
	["path", { d: "M17 5v14" }],
	["path", { d: "M21 5v14" }],
] satisfies IconNode;

export const barrel = [
	["path", { d: "M10.5 2a34.5 34.5 0 000 20" }],
	["path", { d: "M13.5 2a34.5 34.5 0 010 20" }],
	["path", { d: "M4.67 17h14.67" }],
	["path", { d: "M4.67 7h14.67" }],
	[
		"path",
		{
			d: "M6.23 3.06a19 19 0 000 17.88A2 2 0 008 22h8a2 2 0 001.77-1.06 19 19 0 000-17.88A2 2 0 0016 2H8a2 2 0 00-1.77 1.06",
		},
	],
] satisfies IconNode;

export const baseline = [
	["path", { d: "M4 20h16" }],
	["path", { d: "m6 16 6-12 6 12" }],
	["path", { d: "M8 12h8" }],
] satisfies IconNode;

export const bath = [
	["path", { d: "M10 4 8 6" }],
	["path", { d: "M17 19v2" }],
	["path", { d: "M2 12h20" }],
	["path", { d: "M7 19v2" }],
	["path", { d: "M9 5 7.621 3.621A2.121 2.121 0 0 0 4 5v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5" }],
] satisfies IconNode;

export const battery = [
	["path", { d: "M 22 14 L 22 10" }],
	["rect", { x: "2", y: "6", width: "16", height: "12", rx: "2" }],
] satisfies IconNode;

export const batteryCharging = [
	["path", { d: "m11 7-3 5h4l-3 5" }],
	["path", { d: "M14.856 6H16a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.935" }],
	["path", { d: "M22 14v-4" }],
	["path", { d: "M5.14 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2.936" }],
] satisfies IconNode;

export const batteryFull = [
	["path", { d: "M10 10v4" }],
	["path", { d: "M14 10v4" }],
	["path", { d: "M22 14v-4" }],
	["path", { d: "M6 10v4" }],
	["rect", { x: "2", y: "6", width: "16", height: "12", rx: "2" }],
] satisfies IconNode;

export const batteryLow = [
	["path", { d: "M22 14v-4" }],
	["path", { d: "M6 14v-4" }],
	["rect", { x: "2", y: "6", width: "16", height: "12", rx: "2" }],
] satisfies IconNode;

export const batteryMedium = [
	["path", { d: "M10 14v-4" }],
	["path", { d: "M22 14v-4" }],
	["path", { d: "M6 14v-4" }],
	["rect", { x: "2", y: "6", width: "16", height: "12", rx: "2" }],
] satisfies IconNode;

export const batteryPlus = [
	["path", { d: "M10 9v6" }],
	["path", { d: "M12.543 6H16a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.605" }],
	["path", { d: "M22 14v-4" }],
	["path", { d: "M7 12h6" }],
	["path", { d: "M7.606 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.606" }],
] satisfies IconNode;

export const batteryWarning = [
	["path", { d: "M10 17h.01" }],
	["path", { d: "M10 7v6" }],
	["path", { d: "M14 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2" }],
	["path", { d: "M22 14v-4" }],
	["path", { d: "M6 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2" }],
] satisfies IconNode;

export const beaker = [
	["path", { d: "M4.5 3h15" }],
	["path", { d: "M6 3v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3" }],
	["path", { d: "M6 14h12" }],
] satisfies IconNode;

export const bean = [
	[
		"path",
		{
			d: "M10.165 6.598C9.954 7.478 9.64 8.36 9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22c7.732 0 14-6.268 14-14a6 6 0 0 0-11.835-1.402Z",
		},
	],
	["path", { d: "M5.341 10.62a4 4 0 1 0 5.279-5.28" }],
] satisfies IconNode;

export const beanOff = [
	["path", { d: "M9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22a13.96 13.96 0 0 0 9.9-4.1" }],
	["path", { d: "M10.75 5.093A6 6 0 0 1 22 8c0 2.411-.61 4.68-1.683 6.66" }],
	["path", { d: "M5.341 10.62a4 4 0 0 0 6.487 1.208M10.62 5.341a4.015 4.015 0 0 1 2.039 2.04" }],
	["line", { x1: "2", x2: "22", y1: "2", y2: "22" }],
] satisfies IconNode;

export const bed = [
	["path", { d: "M2 4v16" }],
	["path", { d: "M2 8h18a2 2 0 0 1 2 2v10" }],
	["path", { d: "M2 17h20" }],
	["path", { d: "M6 8v9" }],
] satisfies IconNode;

export const bedDouble = [
	["path", { d: "M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8" }],
	["path", { d: "M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4" }],
	["path", { d: "M12 4v6" }],
	["path", { d: "M2 18h20" }],
] satisfies IconNode;

export const bedSingle = [
	["path", { d: "M3 20v-8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8" }],
	["path", { d: "M5 10V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4" }],
	["path", { d: "M3 18h18" }],
] satisfies IconNode;

export const beef = [
	[
		"path",
		{
			d: "M16.4 13.7A6.5 6.5 0 1 0 6.28 6.6c-1.1 3.13-.78 3.9-3.18 6.08A3 3 0 0 0 5 18c4 0 8.4-1.8 11.4-4.3",
		},
	],
	[
		"path",
		{
			d: "m18.5 6 1.754 3.5a6.48 6.48 0 0 1-1.854 8.2C15.4 20.2 11 22 7 22a3 3 0 0 1-2.68-1.66L2.4 16.5",
		},
	],
	["circle", { cx: "12.5", cy: "8.5", r: "2.5" }],
] satisfies IconNode;

export const beefOff = [
	["path", { d: "M11.771 6.109a2.5 2.5 0 0 1 3.12 3.12" }],
	["path", { d: "M17.852 12.185a6.5 6.5 0 0 0-9.035-9.04" }],
	["path", { d: "M18.013 18.013C15.029 20.349 10.831 22 7 22a3 3 0 0 1-2.68-1.66L2.4 16.5" }],
	["path", { d: "m18.5 6 2.19 4.5a6.48 6.48 0 0 1-.139 4.393" }],
	["path", { d: "m2 2 20 20" }],
	[
		"path",
		{
			d: "M6.355 6.37a7 7 0 0 0-.075.23c-1.1 3.13-.78 3.9-3.18 6.08A3 3 0 0 0 5 18c3.356 0 6.993-1.267 9.85-3.151",
		},
	],
] satisfies IconNode;

export const beer = [
	["path", { d: "M17 11h1a3 3 0 0 1 0 6h-1" }],
	["path", { d: "M9 12v6" }],
	["path", { d: "M13 12v6" }],
	[
		"path",
		{
			d: "M14 7.5c-1 0-1.44.5-3 .5s-2-.5-3-.5-1.72.5-2.5.5a2.5 2.5 0 0 1 0-5c.78 0 1.57.5 2.5.5S9.44 2 11 2s2 1.5 3 1.5 1.72-.5 2.5-.5a2.5 2.5 0 0 1 0 5c-.78 0-1.5-.5-2.5-.5Z",
		},
	],
	["path", { d: "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8" }],
] satisfies IconNode;

export const beerOff = [
	["path", { d: "M13 13v5" }],
	["path", { d: "M17 11.47V8" }],
	["path", { d: "M17 11h1a3 3 0 0 1 2.745 4.211" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-3" }],
	["path", { d: "M7.536 7.535C6.766 7.649 6.154 8 5.5 8a2.5 2.5 0 0 1-1.768-4.268" }],
	[
		"path",
		{
			d: "M8.727 3.204C9.306 2.767 9.885 2 11 2c1.56 0 2 1.5 3 1.5s1.72-.5 2.5-.5a1 1 0 1 1 0 5c-.78 0-1.5-.5-2.5-.5a3.149 3.149 0 0 0-.842.12",
		},
	],
	["path", { d: "M9 14.6V18" }],
] satisfies IconNode;

export const belarusianRuble = [
	["path", { d: "M3 16 L13 16" }],
	["path", { d: "M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7" }],
] satisfies IconNode;

export const bell = [
	["path", { d: "M10.268 21a2 2 0 0 0 3.464 0" }],
	[
		"path",
		{
			d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
		},
	],
] satisfies IconNode;

export const bellCheck = [
	["path", { d: "M10.268 21a2 2 0 0 0 3.464 0" }],
	["path", { d: "m15 8 2 2 4-4" }],
	["path", { d: "M16.8607 4.4824A6 6 0 0 0 6 8C6 12.499 4.589 13.956 3.262 15.326" }],
	[
		"path",
		{
			d: "M3.262 15.326A1 1 0 0 0 4 17H20A1 1 0 0 0 20.74 15.327C20.209 14.779 19.665 14.218 19.203 13.454",
		},
	],
] satisfies IconNode;

export const bellDot = [
	["path", { d: "M10.268 21a2 2 0 0 0 3.464 0" }],
	[
		"path",
		{
			d: "M11.68 2.009A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673c-.824-.85-1.678-1.731-2.21-3.348",
		},
	],
	["circle", { cx: "18", cy: "5", r: "3" }],
] satisfies IconNode;

export const bellElectric = [
	["path", { d: "M18.518 17.347A7 7 0 0 1 14 19" }],
	["path", { d: "M18.8 4A11 11 0 0 1 20 9" }],
	["path", { d: "M9 9h.01" }],
	["circle", { cx: "20", cy: "16", r: "2" }],
	["circle", { cx: "9", cy: "9", r: "7" }],
	["rect", { x: "4", y: "16", width: "10", height: "6", rx: "2" }],
] satisfies IconNode;

export const bellMinus = [
	["path", { d: "M10.268 21a2 2 0 0 0 3.464 0" }],
	["path", { d: "M15 8h6" }],
	[
		"path",
		{
			d: "M16.243 3.757A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673A9.4 9.4 0 0 1 18.667 12",
		},
	],
] satisfies IconNode;

export const bellOff = [
	["path", { d: "M10.268 21a2 2 0 0 0 3.464 0" }],
	["path", { d: "M17 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 .258-1.742" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M8.668 3.01A6 6 0 0 1 18 8c0 2.687.77 4.653 1.707 6.05" }],
] satisfies IconNode;

export const bellPlus = [
	["path", { d: "M10.268 21a2 2 0 0 0 3.464 0" }],
	["path", { d: "M15 8h6" }],
	["path", { d: "M18 5v6" }],
	[
		"path",
		{
			d: "M20.002 14.464a9 9 0 0 0 .738.863A1 1 0 0 1 20 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 8.75-5.332",
		},
	],
] satisfies IconNode;

export const bellRing = [
	["path", { d: "M10.268 21a2 2 0 0 0 3.464 0" }],
	["path", { d: "M22 8c0-2.3-.8-4.3-2-6" }],
	[
		"path",
		{
			d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
		},
	],
	["path", { d: "M4 2C2.8 3.7 2 5.7 2 8" }],
] satisfies IconNode;

export const betweenHorizontalEnd = [
	["rect", { width: "13", height: "7", x: "3", y: "3", rx: "1" }],
	["path", { d: "m22 15-3-3 3-3" }],
	["rect", { width: "13", height: "7", x: "3", y: "14", rx: "1" }],
] satisfies IconNode;

export const betweenHorizontalStart = [
	["rect", { width: "13", height: "7", x: "8", y: "3", rx: "1" }],
	["path", { d: "m2 9 3 3-3 3" }],
	["rect", { width: "13", height: "7", x: "8", y: "14", rx: "1" }],
] satisfies IconNode;

export const betweenVerticalEnd = [
	["rect", { width: "7", height: "13", x: "3", y: "3", rx: "1" }],
	["path", { d: "m9 22 3-3 3 3" }],
	["rect", { width: "7", height: "13", x: "14", y: "3", rx: "1" }],
] satisfies IconNode;

export const betweenVerticalStart = [
	["rect", { width: "7", height: "13", x: "3", y: "8", rx: "1" }],
	["path", { d: "m15 2-3 3-3-3" }],
	["rect", { width: "7", height: "13", x: "14", y: "8", rx: "1" }],
] satisfies IconNode;

export const bicepsFlexed = [
	[
		"path",
		{
			d: "M12.409 13.017A5 5 0 0 1 22 15c0 3.866-4 7-9 7-4.077 0-8.153-.82-10.371-2.462-.426-.316-.631-.832-.62-1.362C2.118 12.723 2.627 2 10 2a3 3 0 0 1 3 3 2 2 0 0 1-2 2c-1.105 0-1.64-.444-2-1",
		},
	],
	["path", { d: "M15 14a5 5 0 0 0-7.584 2" }],
	["path", { d: "M9.964 6.825C8.019 7.977 9.5 13 8 15" }],
] satisfies IconNode;

export const bike = [
	["circle", { cx: "18.5", cy: "17.5", r: "3.5" }],
	["circle", { cx: "5.5", cy: "17.5", r: "3.5" }],
	["circle", { cx: "15", cy: "5", r: "1" }],
	["path", { d: "M12 17.5V14l-3-3 4-3 2 3h2" }],
] satisfies IconNode;

export const binary = [
	["rect", { x: "14", y: "14", width: "4", height: "6", rx: "2" }],
	["rect", { x: "6", y: "4", width: "4", height: "6", rx: "2" }],
	["path", { d: "M6 20h4" }],
	["path", { d: "M14 10h4" }],
	["path", { d: "M6 14h2v6" }],
	["path", { d: "M14 4h2v6" }],
] satisfies IconNode;

export const binoculars = [
	["path", { d: "M10 10h4" }],
	["path", { d: "M19 7V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3" }],
	[
		"path",
		{
			d: "M20 21a2 2 0 0 0 2-2v-3.851c0-1.39-2-2.962-2-4.829V8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v11a2 2 0 0 0 2 2z",
		},
	],
	["path", { d: "M 22 16 L 2 16" }],
	[
		"path",
		{
			d: "M4 21a2 2 0 0 1-2-2v-3.851c0-1.39 2-2.962 2-4.829V8a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v11a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M9 7V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v3" }],
] satisfies IconNode;

export const biohazard = [
	["circle", { cx: "12", cy: "11.9", r: "2" }],
	["path", { d: "M6.7 3.4c-.9 2.5 0 5.2 2.2 6.7C6.5 9 3.7 9.6 2 11.6" }],
	["path", { d: "m8.9 10.1 1.4.8" }],
	["path", { d: "M17.3 3.4c.9 2.5 0 5.2-2.2 6.7 2.4-1.2 5.2-.6 6.9 1.5" }],
	["path", { d: "m15.1 10.1-1.4.8" }],
	["path", { d: "M16.7 20.8c-2.6-.4-4.6-2.6-4.7-5.3-.2 2.6-2.1 4.8-4.7 5.2" }],
	["path", { d: "M12 13.9v1.6" }],
	["path", { d: "M13.5 5.4c-1-.2-2-.2-3 0" }],
	["path", { d: "M17 16.4c.7-.7 1.2-1.6 1.5-2.5" }],
	["path", { d: "M5.5 13.9c.3.9.8 1.8 1.5 2.5" }],
] satisfies IconNode;

export const bird = [
	["path", { d: "M16 7h.01" }],
	["path", { d: "M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 20" }],
	["path", { d: "m20 7 2 .5-2 .5" }],
	["path", { d: "M10 18v3" }],
	["path", { d: "M14 17.75V21" }],
	["path", { d: "M7 18a6 6 0 0 0 3.84-10.61" }],
] satisfies IconNode;

export const birdhouse = [
	["path", { d: "M12 18v4" }],
	["path", { d: "m17 18 1.956-11.468" }],
	["path", { d: "m3 8 7.82-5.615a2 2 0 0 1 2.36 0L21 8" }],
	["path", { d: "M4 18h16" }],
	["path", { d: "M7 18 5.044 6.532" }],
	["circle", { cx: "12", cy: "10", r: "2" }],
] satisfies IconNode;

export const bitcoin = [
	[
		"path",
		{
			d: "M11.767 19.089c4.924.868 6.14-6.025 1.216-6.894m-1.216 6.894L5.86 18.047m5.908 1.042-.347 1.97m1.563-8.864c4.924.869 6.14-6.025 1.215-6.893m-1.215 6.893-3.94-.694m5.155-6.2L8.29 4.26m5.908 1.042.348-1.97M7.48 20.364l3.126-17.727",
		},
	],
] satisfies IconNode;

export const blend = [
	["circle", { cx: "15", cy: "9", r: "7" }],
	["circle", { cx: "9", cy: "15", r: "7" }],
] satisfies IconNode;

export const blender = [
	[
		"path",
		{
			d: "M8 14a2 2 0 0 0-1.963 1.615l-1.018 5.193A1 1 0 0 0 6 22h12a1 1 0 0 0 .981-1.192l-1.018-5.193A2 2 0 0 0 16 14z",
		},
	],
	["path", { d: "m17 2-1 12" }],
	["path", { d: "M8.006 14 7 2" }],
	["path", { d: "M7.565 8.787A5 5 0 0 0 12 8a5 5 0 0 1 4.56-.75" }],
	["path", { d: "M19 2H5a2 2 0 0 0-2 2v5a2 2 0 0 0 .688 1.5" }],
	["path", { d: "M12 18h.01" }],
] satisfies IconNode;

export const blinds = [
	["path", { d: "M3 3h18" }],
	["path", { d: "M20 7H8" }],
	["path", { d: "M20 11H8" }],
	["path", { d: "M10 19h10" }],
	["path", { d: "M8 15h12" }],
	["path", { d: "M4 3v14" }],
	["circle", { cx: "4", cy: "19", r: "2" }],
] satisfies IconNode;

export const blocks = [
	[
		"path",
		{
			d: "M10 22V7a1 1 0 0 0-1-1H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5a1 1 0 0 0-1-1H2",
		},
	],
	["rect", { x: "14", y: "2", width: "8", height: "8", rx: "1" }],
] satisfies IconNode;

export const bluetooth = [["path", { d: "m7 7 10 10-5 5V2l5 5L7 17" }]] satisfies IconNode;

export const bluetoothConnected = [
	["path", { d: "m7 7 10 10-5 5V2l5 5L7 17" }],
	["line", { x1: "18", x2: "21", y1: "12", y2: "12" }],
	["line", { x1: "3", x2: "6", y1: "12", y2: "12" }],
] satisfies IconNode;

export const bluetoothOff = [
	["path", { d: "m17 17-5 5V12l-5 5" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M14.5 9.5 17 7l-5-5v4.5" }],
] satisfies IconNode;

export const bluetoothSearching = [
	["path", { d: "m7 7 10 10-5 5V2l5 5L7 17" }],
	["path", { d: "M20.83 14.83a4 4 0 0 0 0-5.66" }],
	["path", { d: "M18 12h.01" }],
] satisfies IconNode;

export const bold = [
	["path", { d: "M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8" }],
] satisfies IconNode;

export const bolt = [
	[
		"path",
		{
			d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
		},
	],
	["circle", { cx: "12", cy: "12", r: "4" }],
] satisfies IconNode;

export const bomb = [
	["circle", { cx: "11", cy: "13", r: "9" }],
	[
		"path",
		{ d: "M14.35 4.65 16.3 2.7a2.41 2.41 0 0 1 3.4 0l1.6 1.6a2.4 2.4 0 0 1 0 3.4l-1.95 1.95" },
	],
	["path", { d: "m22 2-1.5 1.5" }],
] satisfies IconNode;

export const bone = [
	[
		"path",
		{
			d: "M17 10c.7-.7 1.69 0 2.5 0a2.5 2.5 0 1 0 0-5 .5.5 0 0 1-.5-.5 2.5 2.5 0 1 0-5 0c0 .81.7 1.8 0 2.5l-7 7c-.7.7-1.69 0-2.5 0a2.5 2.5 0 0 0 0 5c.28 0 .5.22.5.5a2.5 2.5 0 1 0 5 0c0-.81-.7-1.8 0-2.5Z",
		},
	],
] satisfies IconNode;

export const boneFracture = [
	[
		"path",
		{
			d: "M14 4.5a1 1 0 0 1 5 0 .5.5 0 0 0 .5.5 1 1 0 0 1 0 5c-.81 0-1.8-.7-2.5 0l-1.958 1.957a.15.15 0 0 1-.252-.072l-.493-2.07a.15.15 0 0 0-.111-.112l-2.072-.494a.15.15 0 0 1-.072-.252L14 7c.7-.7 0-1.69 0-2.5",
		},
	],
	["path", { d: "m16 20-1-2" }],
	["path", { d: "m20 16-2-1" }],
	["path", { d: "m4 8 2 1" }],
	["path", { d: "m8 4 1 2" }],
	[
		"path",
		{
			d: "M9.698 14.19a.15.15 0 0 0 .112.112l2.074.489a.15.15 0 0 1 .072.252L10 17c-.7.7 0 1.69 0 2.5a1 1 0 0 1-5 0 .495.495 0 0 0-.5-.5 1 1 0 0 1 0-5c.81 0 1.8.7 2.5 0l1.956-1.957a.15.15 0 0 1 .252.072z",
		},
	],
] satisfies IconNode;

export const book = [
	[
		"path",
		{ d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" },
	],
] satisfies IconNode;

export const bookA = [
	[
		"path",
		{ d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" },
	],
	["path", { d: "m8 13 4-7 4 7" }],
	["path", { d: "M9.1 11h5.7" }],
] satisfies IconNode;

export const bookAlert = [
	["path", { d: "M12 13h.01" }],
	["path", { d: "M12 6v3" }],
	[
		"path",
		{ d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" },
	],
] satisfies IconNode;

export const bookAudio = [
	["path", { d: "M12 6v7" }],
	["path", { d: "M16 8v3" }],
	[
		"path",
		{ d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" },
	],
	["path", { d: "M8 8v3" }],
] satisfies IconNode;

export const bookBookmark = [
	[
		"path",
		{
			d: "M10 2v7.751a.25.25 0 00.407.195l2.28-1.834a.5.5 0 01.627 0l2.28 1.834A.25.25 0 0016 9.751V2",
		},
	],
	[
		"path",
		{ d: "M4 19.5v-15A2.5 2.5 0 016.5 2H19a1 1 0 011 1v18a1 1 0 01-1 1H6.5a1 1 0 010-5H20" },
	],
] satisfies IconNode;

export const bookCheck = [
	[
		"path",
		{ d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" },
	],
	["path", { d: "m9 9.5 2 2 4-4" }],
] satisfies IconNode;

export const bookCopy = [
	["path", { d: "M5 7a2 2 0 0 0-2 2v11" }],
	["path", { d: "M5.803 18H5a2 2 0 0 0 0 4h9.5a.5.5 0 0 0 .5-.5V21" }],
	[
		"path",
		{ d: "M9 15V4a2 2 0 0 1 2-2h9.5a.5.5 0 0 1 .5.5v14a.5.5 0 0 1-.5.5H11a2 2 0 0 1 0-4h10" },
	],
] satisfies IconNode;

export const bookDashed = [
	["path", { d: "M12 17h1.5" }],
	["path", { d: "M12 22h1.5" }],
	["path", { d: "M12 2h1.5" }],
	["path", { d: "M17.5 22H19a1 1 0 0 0 1-1" }],
	["path", { d: "M17.5 2H19a1 1 0 0 1 1 1v1.5" }],
	["path", { d: "M20 14v3h-2.5" }],
	["path", { d: "M20 8.5V10" }],
	["path", { d: "M4 10V8.5" }],
	["path", { d: "M4 19.5V14" }],
	["path", { d: "M4 4.5A2.5 2.5 0 0 1 6.5 2H8" }],
	["path", { d: "M8 22H6.5a1 1 0 0 1 0-5H8" }],
] satisfies IconNode;

export const bookDown = [
	["path", { d: "M12 13V7" }],
	[
		"path",
		{ d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" },
	],
	["path", { d: "m9 10 3 3 3-3" }],
] satisfies IconNode;

export const bookHeadphones = [
	[
		"path",
		{ d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" },
	],
	["path", { d: "M8 12v-2a4 4 0 0 1 8 0v2" }],
	["circle", { cx: "15", cy: "12", r: "1" }],
	["circle", { cx: "9", cy: "12", r: "1" }],
] satisfies IconNode;

export const bookHeart = [
	[
		"path",
		{ d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" },
	],
	[
		"path",
		{
			d: "M8.62 9.8A2.25 2.25 0 1 1 12 6.836a2.25 2.25 0 1 1 3.38 2.966l-2.626 2.856a.998.998 0 0 1-1.507 0z",
		},
	],
] satisfies IconNode;

export const bookImage = [
	["path", { d: "m20 13.7-2.1-2.1a2 2 0 0 0-2.8 0L9.7 17" }],
	[
		"path",
		{ d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" },
	],
	["circle", { cx: "10", cy: "8", r: "2" }],
] satisfies IconNode;

export const bookKey = [
	["path", { d: "M13 2H6.5A2.5 2.5 0 0 0 4 4.5v15" }],
	["path", { d: "M17 2v6" }],
	["path", { d: "M17 4h2" }],
	["path", { d: "M20 15.2V21a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" }],
	["circle", { cx: "17", cy: "10", r: "2" }],
] satisfies IconNode;

export const bookLock = [
	["path", { d: "M18 6V4a2 2 0 1 0-4 0v2" }],
	["path", { d: "M20 15v6a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" }],
	["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H10" }],
	["rect", { x: "12", y: "6", width: "8", height: "5", rx: "1" }],
] satisfies IconNode;

export const bookMinus = [
	[
		"path",
		{ d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" },
	],
	["path", { d: "M9 10h6" }],
] satisfies IconNode;

export const bookOpen = [
	["path", { d: "M12 5v16" }],
	[
		"path",
		{
			d: "M20.001 19A2 2 0 0022 17V5a2 2 0 00-1.999-2L16 3.002A5 5 0 0012 5a5 5 0 00-4-2H4a2 2 0 00-2 2v12a2 2 0 001.999 2H8a5 5 0 014 2 5 5 0 014-2z",
		},
	],
] satisfies IconNode;

export const bookOpenCheck = [
	["path", { d: "M12 5v16" }],
	["path", { d: "m16 12 2 2 4-4" }],
	[
		"path",
		{
			d: "M22 6V5a2 2 0 00-1.999-2L16 3.002A5 5 0 0012 5a5 5 0 00-4-2H4a2 2 0 00-2 2v12a2 2 0 001.999 2H8a5 5 0 014 2 5 5 0 014-2h4.001A2 2 0 0022 17v-1.344",
		},
	],
] satisfies IconNode;

export const bookOpenText = [
	["path", { d: "M12 5v16" }],
	["path", { d: "M16 13h2" }],
	["path", { d: "M16 9h2" }],
	[
		"path",
		{
			d: "M20.001 19A2 2 0 0022 17V5a2 2 0 00-1.999-2L16 3.002A5 5 0 0012 5a5 5 0 00-4-2H4a2 2 0 00-2 2v12a2 2 0 001.999 2H8a5 5 0 014 2 5 5 0 014-2z",
		},
	],
	["path", { d: "M6 13h2" }],
	["path", { d: "M6 9h2" }],
] satisfies IconNode;

export const bookPlus = [
	["path", { d: "M12 7v6" }],
	[
		"path",
		{ d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" },
	],
	["path", { d: "M9 10h6" }],
] satisfies IconNode;

export const bookSearch = [
	["path", { d: "M11 22H5.5a1 1 0 0 1 0-5h4.501" }],
	["path", { d: "m21 22-1.879-1.878" }],
	["path", { d: "M3 19.5v-15A2.5 2.5 0 0 1 5.5 2H18a1 1 0 0 1 1 1v8" }],
	["circle", { cx: "17", cy: "18", r: "3" }],
] satisfies IconNode;

export const bookText = [
	[
		"path",
		{ d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" },
	],
	["path", { d: "M8 11h8" }],
	["path", { d: "M8 7h6" }],
] satisfies IconNode;

export const bookType = [
	["path", { d: "M10 13h4" }],
	["path", { d: "M12 6v7" }],
	["path", { d: "M16 8V6H8v2" }],
	[
		"path",
		{ d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" },
	],
] satisfies IconNode;

export const bookUp = [
	["path", { d: "M12 13V7" }],
	[
		"path",
		{ d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" },
	],
	["path", { d: "m9 10 3-3 3 3" }],
] satisfies IconNode;

export const bookUp2 = [
	["path", { d: "M12 13V7" }],
	["path", { d: "M18 2h1a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" }],
	["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2" }],
	["path", { d: "m9 10 3-3 3 3" }],
	["path", { d: "m9 5 3-3 3 3" }],
] satisfies IconNode;

export const bookUser = [
	["path", { d: "M15 13a3 3 0 1 0-6 0" }],
	[
		"path",
		{ d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" },
	],
	["circle", { cx: "12", cy: "8", r: "2" }],
] satisfies IconNode;

export const bookX = [
	["path", { d: "m14.5 7.5-5 5" }],
	[
		"path",
		{ d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" },
	],
	["path", { d: "m9.5 7.5 5 5" }],
] satisfies IconNode;

export const bookmark = [
	[
		"path",
		{
			d: "M17 3a2 2 0 0 1 2 2v15a1 1 0 0 1-1.496.868l-4.512-2.578a2 2 0 0 0-1.984 0l-4.512 2.578A1 1 0 0 1 5 20V5a2 2 0 0 1 2-2z",
		},
	],
] satisfies IconNode;

export const bookmarkCheck = [
	[
		"path",
		{
			d: "M17 3a2 2 0 0 1 2 2v15a1 1 0 0 1-1.496.868l-4.512-2.578a2 2 0 0 0-1.984 0l-4.512 2.578A1 1 0 0 1 5 20V5a2 2 0 0 1 2-2z",
		},
	],
	["path", { d: "m9 10 2 2 4-4" }],
] satisfies IconNode;

export const bookmarkMinus = [
	["path", { d: "M15 10H9" }],
	[
		"path",
		{
			d: "M17 3a2 2 0 0 1 2 2v15a1 1 0 0 1-1.496.868l-4.512-2.578a2 2 0 0 0-1.984 0l-4.512 2.578A1 1 0 0 1 5 20V5a2 2 0 0 1 2-2z",
		},
	],
] satisfies IconNode;

export const bookmarkOff = [
	[
		"path",
		{
			d: "M19 19v1a1 1 0 0 1-1.496.868l-4.512-2.578a2 2 0 0 0-1.984 0l-4.512 2.578A1 1 0 0 1 5 20V5",
		},
	],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M8.656 3H17a2 2 0 0 1 2 2v8.344" }],
] satisfies IconNode;

export const bookmarkPlus = [
	["path", { d: "M12 7v6" }],
	["path", { d: "M15 10H9" }],
	[
		"path",
		{
			d: "M17 3a2 2 0 0 1 2 2v15a1 1 0 0 1-1.496.868l-4.512-2.578a2 2 0 0 0-1.984 0l-4.512 2.578A1 1 0 0 1 5 20V5a2 2 0 0 1 2-2z",
		},
	],
] satisfies IconNode;

export const bookmarkX = [
	["path", { d: "m14.5 7.5-5 5" }],
	[
		"path",
		{
			d: "M17 3a2 2 0 0 1 2 2v15a1 1 0 0 1-1.496.868l-4.512-2.578a2 2 0 0 0-1.984 0l-4.512 2.578A1 1 0 0 1 5 20V5a2 2 0 0 1 2-2z",
		},
	],
	["path", { d: "m9.5 7.5 5 5" }],
] satisfies IconNode;

export const boomBox = [
	["path", { d: "M4 9V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4" }],
	["path", { d: "M8 8v1" }],
	["path", { d: "M12 8v1" }],
	["path", { d: "M16 8v1" }],
	["rect", { width: "20", height: "12", x: "2", y: "9", rx: "2" }],
	["circle", { cx: "8", cy: "15", r: "2" }],
	["circle", { cx: "16", cy: "15", r: "2" }],
] satisfies IconNode;

export const bot = [
	["path", { d: "M12 8V4H8" }],
	["rect", { width: "16", height: "12", x: "4", y: "8", rx: "2" }],
	["path", { d: "M2 14h2" }],
	["path", { d: "M20 14h2" }],
	["path", { d: "M15 13v2" }],
	["path", { d: "M9 13v2" }],
] satisfies IconNode;

export const botMessageSquare = [
	["path", { d: "M12 6V2H8" }],
	["path", { d: "M15 11v2" }],
	["path", { d: "M2 12h2" }],
	["path", { d: "M20 12h2" }],
	[
		"path",
		{
			d: "M20 16a2 2 0 0 1-2 2H8.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 4 20.286V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z",
		},
	],
	["path", { d: "M9 11v2" }],
] satisfies IconNode;

export const botOff = [
	["path", { d: "M13.67 8H18a2 2 0 0 1 2 2v4.33" }],
	["path", { d: "M2 14h2" }],
	["path", { d: "M20 14h2" }],
	["path", { d: "M22 22 2 2" }],
	["path", { d: "M8 8H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 1.414-.586" }],
	["path", { d: "M9 13v2" }],
	["path", { d: "M9.67 4H12v2.33" }],
] satisfies IconNode;

export const bottleWine = [
	[
		"path",
		{
			d: "M10 3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a6 6 0 0 0 1.2 3.6l.6.8A6 6 0 0 1 17 13v8a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-8a6 6 0 0 1 1.2-3.6l.6-.8A6 6 0 0 0 10 5z",
		},
	],
	["path", { d: "M17 13h-4a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h4" }],
] satisfies IconNode;

export const bowArrow = [
	["path", { d: "M17 3h4v4" }],
	["path", { d: "M18.575 11.082a13 13 0 0 1 1.048 9.027 1.17 1.17 0 0 1-1.914.597L14 17" }],
	["path", { d: "M7 10 3.29 6.29a1.17 1.17 0 0 1 .6-1.91 13 13 0 0 1 9.03 1.05" }],
	[
		"path",
		{
			d: "M7 14a1.7 1.7 0 0 0-1.207.5l-2.646 2.646A.5.5 0 0 0 3.5 18H5a1 1 0 0 1 1 1v1.5a.5.5 0 0 0 .854.354L9.5 18.207A1.7 1.7 0 0 0 10 17v-2a1 1 0 0 0-1-1z",
		},
	],
	["path", { d: "M9.707 14.293 21 3" }],
] satisfies IconNode;

export const box = [
	[
		"path",
		{
			d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z",
		},
	],
	["path", { d: "m3.3 7 8.7 5 8.7-5" }],
	["path", { d: "M12 22V12" }],
] satisfies IconNode;

export const boxes = [
	[
		"path",
		{
			d: "M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z",
		},
	],
	["path", { d: "m7 16.5-4.74-2.85" }],
	["path", { d: "m7 16.5 5-3" }],
	["path", { d: "M7 16.5v5.17" }],
	[
		"path",
		{
			d: "M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z",
		},
	],
	["path", { d: "m17 16.5-5-3" }],
	["path", { d: "m17 16.5 4.74-2.85" }],
	["path", { d: "M17 16.5v5.17" }],
	[
		"path",
		{
			d: "M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z",
		},
	],
	["path", { d: "M12 8 7.26 5.15" }],
	["path", { d: "m12 8 4.74-2.85" }],
	["path", { d: "M12 13.5V8" }],
] satisfies IconNode;

export const braces = [
	["path", { d: "M8 3H7a2 2 0 0 0-2 2v5a2 2 0 0 1-2 2 2 2 0 0 1 2 2v5c0 1.1.9 2 2 2h1" }],
	["path", { d: "M16 21h1a2 2 0 0 0 2-2v-5c0-1.1.9-2 2-2a2 2 0 0 1-2-2V5a2 2 0 0 0-2-2h-1" }],
] satisfies IconNode;

export const brackets = [
	["path", { d: "M16 3h3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-3" }],
	["path", { d: "M8 21H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h3" }],
] satisfies IconNode;

export const brain = [
	["path", { d: "M12 18V5" }],
	["path", { d: "M15 13a4.17 4.17 0 01-3-4 4.17 4.17 0 01-3 4" }],
	["path", { d: "M17.707 6.294A3 3 0 1012 5a3 3 0 10-5.707 1.294" }],
	["path", { d: "M17.996 5.125a4 4 0 012.526 5.77" }],
	["path", { d: "M18 18a4 4 0 002-7.465" }],
	["path", { d: "M19.967 17.482a4 4 0 11-7.967.517 4 4 0 11-7.967-.517" }],
	["path", { d: "M6 18a4 4 0 01-2-7.465" }],
	["path", { d: "M6.004 5.125a4 4 0 00-2.526 5.77" }],
] satisfies IconNode;

export const brainCircuit = [
	["path", { d: "M12 13h4" }],
	["path", { d: "M12 18h6a2 2 0 012 2v1" }],
	["path", { d: "M12 8h8" }],
	["path", { d: "M12 9a4.17 4.17 0 01-3 4" }],
	["path", { d: "M16 8V5a2 2 0 012-2" }],
	["path", { d: "M6 18a4 4 0 01-2-7.465" }],
	["path", { d: "M6.004 5.125a4 4 0 00-2.526 5.77" }],
	["path", { d: "M6.294 6.294A3 3 0 1112 5v13a4 4 0 11-7.967-.518" }],
	["circle", { cx: "16", cy: "13", r: "0.5", fill: "currentColor" }],
	["circle", { cx: "18", cy: "3", r: "0.5", fill: "currentColor" }],
	["circle", { cx: "20", cy: "21", r: "0.5", fill: "currentColor" }],
	["circle", { cx: "20", cy: "8", r: "0.5", fill: "currentColor" }],
] satisfies IconNode;

export const brainCog = [
	["path", { d: "m10.852 14.772-.383.923" }],
	["path", { d: "m10.852 9.228-.383-.923" }],
	["path", { d: "m13.148 14.772.382.924" }],
	["path", { d: "m13.53 8.305-.382.923" }],
	["path", { d: "m14.772 10.852.923-.383" }],
	["path", { d: "m14.772 13.148.923.383" }],
	["path", { d: "M17.997 5.125a4 4 0 012.526 5.77" }],
	["path", { d: "M18 18a4 4 0 002-7.464" }],
	["path", { d: "M4.033 17.483A4 4 0 0011.46 20c.184-.31.896-.31 1.076 0a4 4 0 007.43-2.517" }],
	["path", { d: "M6 18a4 4 0 01-2-7.464" }],
	["path", { d: "M6.002 5.125a4 4 0 00-2.525 5.77" }],
	[
		"path",
		{
			d: "M6.293 6.294a3 3 0 01-.287-1.098l-.004-.07a3 3 0 015.968-.543c.05.02.057.01.059 0a3 3 0 015.968.542l-.004.071a3 3 0 01-.287 1.098",
		},
	],
	["path", { d: "m9.228 10.852-.923-.383" }],
	["path", { d: "m9.228 13.148-.923.383" }],
	["circle", { cx: "12", cy: "12", r: "3" }],
] satisfies IconNode;

export const brainOff = [
	["path", { d: "M12 18v-6" }],
	["path", { d: "M12 5v1.344" }],
	["path", { d: "M17.707 6.293A3 3 0 1012 5a3 3 0 00-4.124-2.781" }],
	["path", { d: "M17.997 5.125a4 4 0 012.526 5.77" }],
	["path", { d: "M19.644 19.644A4 4 0 0112 18a4 4 0 11-7.967-.517" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M20 10.536a4 4 0 011.533 5.34" }],
	["path", { d: "M3.477 10.895a4 4 0 011.876-5.542" }],
	["path", { d: "M6 18a4 4 0 01-2-7.464" }],
	["path", { d: "M9 13a4.17 4.17 0 002.166-1.5 4 4 0 00.138-.196" }],
] satisfies IconNode;

export const brickWall = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M12 9v6" }],
	["path", { d: "M16 15v6" }],
	["path", { d: "M16 3v6" }],
	["path", { d: "M3 15h18" }],
	["path", { d: "M3 9h18" }],
	["path", { d: "M8 15v6" }],
	["path", { d: "M8 3v6" }],
] satisfies IconNode;

export const brickWallFire = [
	["path", { d: "M16 3v2.107" }],
	[
		"path",
		{
			d: "M17 9c1 3 2.5 3.5 3.5 4.5A5 5 0 0 1 22 17a5 5 0 0 1-10 0c0-.3 0-.6.1-.9a2 2 0 1 0 3.3-2C13 11.5 16 9 17 9",
		},
	],
	["path", { d: "M21 8.274V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.938" }],
	["path", { d: "M3 15h5.253" }],
	["path", { d: "M3 9h8.228" }],
	["path", { d: "M8 15v6" }],
	["path", { d: "M8 3v6" }],
] satisfies IconNode;

export const brickWallShield = [
	["path", { d: "M12 9v1.258" }],
	["path", { d: "M16 3v5.46" }],
	["path", { d: "M21 9.118V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h5.75" }],
	[
		"path",
		{
			d: "M22 17.5c0 2.499-1.75 3.749-3.83 4.474a.5.5 0 0 1-.335-.005c-2.085-.72-3.835-1.97-3.835-4.47V14a.5.5 0 0 1 .5-.499c1 0 2.25-.6 3.12-1.36a.6.6 0 0 1 .76-.001c.875.765 2.12 1.36 3.12 1.36a.5.5 0 0 1 .5.5z",
		},
	],
	["path", { d: "M3 15h7" }],
	["path", { d: "M3 9h12.142" }],
	["path", { d: "M8 15v6" }],
	["path", { d: "M8 3v6" }],
] satisfies IconNode;

export const bridge = [
	["path", { d: "M10 9.728V16" }],
	["path", { d: "M14 9.728V16" }],
	["path", { d: "M18 20V4" }],
	["path", { d: "m22 11-4-4A7.5 7.5 0 0 1 6 7l-4 4" }],
	["path", { d: "M22 16H2" }],
	["path", { d: "M6 20V4" }],
] satisfies IconNode;

export const briefcase = [
	["path", { d: "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" }],
	["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2" }],
] satisfies IconNode;

export const briefcaseBusiness = [
	["path", { d: "M12 12h.01" }],
	["path", { d: "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" }],
	["path", { d: "M22 13a18.15 18.15 0 0 1-20 0" }],
	["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2" }],
] satisfies IconNode;

export const briefcaseConveyorBelt = [
	["path", { d: "M10 20v2" }],
	["path", { d: "M14 20v2" }],
	["path", { d: "M18 20v2" }],
	["path", { d: "M21 20H3" }],
	["path", { d: "M6 20v2" }],
	["path", { d: "M8 16V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v12" }],
	["rect", { x: "4", y: "6", width: "16", height: "10", rx: "2" }],
] satisfies IconNode;

export const briefcaseMedical = [
	["path", { d: "M12 11v4" }],
	["path", { d: "M14 13h-4" }],
	["path", { d: "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" }],
	["path", { d: "M18 6v14" }],
	["path", { d: "M6 6v14" }],
	["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2" }],
] satisfies IconNode;

export const briefcasePlus = [
	["path", { d: "M13.354 20H4a2 2 0 01-2-2V8a2 2 0 012-2h16a2 2 0 012 2v3.354" }],
	["path", { d: "M16 11.354V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v16" }],
	["path", { d: "M16 17h6" }],
	["path", { d: "M19 14v6" }],
] satisfies IconNode;

export const bringToFront = [
	["rect", { x: "8", y: "8", width: "8", height: "8", rx: "2" }],
	["path", { d: "M4 10a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2" }],
	["path", { d: "M14 20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2" }],
] satisfies IconNode;

export const broccoli = [
	["path", { d: "M10 13a3 3 0 01-2.121-5.121" }],
	[
		"path",
		{
			d: "M15.606 14.204c-3.5 1.5-5.899 4.503-8.899 7.503A1 1 0 016 22c-2 0-4-2-4-4a1 1 0 01.293-.707c1.911-1.911 3.823-3.578 5.347-5.441",
		},
	],
	["path", { d: "M16.573 14.737A4 4 0 0114 11" }],
	[
		"path",
		{
			d: "M7.14 10.907a4 4 0 112.756-7.43A4 4 0 0116.7 4.48a2 2 0 012.82 2.82 4 4 0 011.002 6.805 4 4 0 11-7.51 1.59",
		},
	],
] satisfies IconNode;

export const broom = [
	["path", { d: "M13.5 10.5 22 2" }],
	[
		"path",
		{
			d: "M14.734 13.841a2 2 0 00-.314-2.42L12.58 9.58a2 2 0 00-2.421-.314l-7.657 4.461A1 1 0 002.3 15.3l6.403 6.403a1 1 0 001.571-.204z",
		},
	],
	["path", { d: "m5 18 2-2" }],
	["path", { d: "m7.699 10.7 5.602 5.601" }],
] satisfies IconNode;

export const broomSparkles = [
	["path", { d: "M11 2v2" }],
	["path", { d: "M12 3h-2" }],
	["path", { d: "M13.5 10.5 22 2" }],
	[
		"path",
		{
			d: "M14.734 13.841a2 2 0 00-.314-2.42L12.58 9.58a2 2 0 00-2.421-.314l-7.657 4.461A1 1 0 002.3 15.3l6.403 6.403a1 1 0 001.571-.204z",
		},
	],
	["path", { d: "M20 15v4" }],
	["path", { d: "M22 17h-4" }],
	["path", { d: "M4 4v4" }],
	["path", { d: "m5 18 2-2" }],
	["path", { d: "M6 6H2" }],
	["path", { d: "m7.699 10.7 5.602 5.601" }],
] satisfies IconNode;

export const brush = [
	["path", { d: "m11 10 3 3" }],
	["path", { d: "M6.5 21A3.5 3.5 0 1 0 3 17.5a2.62 2.62 0 0 1-.708 1.792A1 1 0 0 0 3 21z" }],
	["path", { d: "M9.969 17.031 21.378 5.624a1 1 0 0 0-3.002-3.002L6.967 14.031" }],
] satisfies IconNode;

export const brushCleaning = [
	["path", { d: "m16 22-1-4" }],
	[
		"path",
		{
			d: "M19 14a1 1 0 0 0 1-1v-1a2 2 0 0 0-2-2h-3a1 1 0 0 1-1-1V4a2 2 0 0 0-4 0v5a1 1 0 0 1-1 1H6a2 2 0 0 0-2 2v1a1 1 0 0 0 1 1",
		},
	],
	["path", { d: "M19 14H5l-1.973 6.767A1 1 0 0 0 4 22h16a1 1 0 0 0 .973-1.233z" }],
	["path", { d: "m8 22 1-4" }],
] satisfies IconNode;

export const bubbles = [
	["path", { d: "M7.001 15.085A1.5 1.5 0 0 1 9 16.5" }],
	["circle", { cx: "18.5", cy: "8.5", r: "3.5" }],
	["circle", { cx: "7.5", cy: "16.5", r: "5.5" }],
	["circle", { cx: "7.5", cy: "4.5", r: "2.5" }],
] satisfies IconNode;

export const bug = [
	["path", { d: "M12 20v-9" }],
	["path", { d: "M14 7a4 4 0 0 1 4 4v3a6 6 0 0 1-12 0v-3a4 4 0 0 1 4-4z" }],
	["path", { d: "M14.12 3.88 16 2" }],
	["path", { d: "M21 21a4 4 0 0 0-3.81-4" }],
	["path", { d: "M21 5a4 4 0 0 1-3.55 3.97" }],
	["path", { d: "M22 13h-4" }],
	["path", { d: "M3 21a4 4 0 0 1 3.81-4" }],
	["path", { d: "M3 5a4 4 0 0 0 3.55 3.97" }],
	["path", { d: "M6 13H2" }],
	["path", { d: "m8 2 1.88 1.88" }],
	["path", { d: "M9 7.13V6a3 3 0 1 1 6 0v1.13" }],
] satisfies IconNode;

export const bugOff = [
	["path", { d: "M12 20v-8" }],
	["path", { d: "M12.656 7H14a4 4 0 0 1 4 4v1.344" }],
	["path", { d: "M14.12 3.88 16 2" }],
	["path", { d: "M17.123 17.123A6 6 0 0 1 6 14v-3a4 4 0 0 1 1.72-3.287" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M21 5a4 4 0 0 1-3.55 3.97" }],
	["path", { d: "M22 13h-3.344" }],
	["path", { d: "M3 21a4 4 0 0 1 3.81-4" }],
	["path", { d: "M3 5a4 4 0 0 0 3.55 3.97" }],
	["path", { d: "M6 13H2" }],
	["path", { d: "m8 2 1.88 1.88" }],
	["path", { d: "M9.712 4.06A3 3 0 0 1 15 6v1.13" }],
] satisfies IconNode;

export const bugPlay = [
	["path", { d: "M10 19.655A6 6 0 0 1 6 14v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 3.97" }],
	[
		"path",
		{
			d: "M14 15.003a1 1 0 0 1 1.517-.859l4.997 2.997a1 1 0 0 1 0 1.718l-4.997 2.997a1 1 0 0 1-1.517-.86z",
		},
	],
	["path", { d: "M14.12 3.88 16 2" }],
	["path", { d: "M21 5a4 4 0 0 1-3.55 3.97" }],
	["path", { d: "M3 21a4 4 0 0 1 3.81-4" }],
	["path", { d: "M3 5a4 4 0 0 0 3.55 3.97" }],
	["path", { d: "M6 13H2" }],
	["path", { d: "m8 2 1.88 1.88" }],
	["path", { d: "M9 7.13V6a3 3 0 1 1 6 0v1.13" }],
] satisfies IconNode;

export const building = [
	["path", { d: "M12 10h.01" }],
	["path", { d: "M12 14h.01" }],
	["path", { d: "M12 6h.01" }],
	["path", { d: "M16 10h.01" }],
	["path", { d: "M16 14h.01" }],
	["path", { d: "M16 6h.01" }],
	["path", { d: "M8 10h.01" }],
	["path", { d: "M8 14h.01" }],
	["path", { d: "M8 6h.01" }],
	["path", { d: "M9 22v-3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3" }],
	["rect", { x: "4", y: "2", width: "16", height: "20", rx: "2" }],
] satisfies IconNode;

export const buildingComplex = [
	["path", { d: "M10 12h4" }],
	["path", { d: "M10 8h4" }],
	["path", { d: "M14 21v-3a2 2 0 0 0-4 0v3" }],
	["path", { d: "M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2" }],
	["path", { d: "M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16" }],
] satisfies IconNode;

export const buildingComplexPlus = [
	["path", { d: "M10 12h4" }],
	["path", { d: "M10 21v-3a2 2 0 013.05-1.702" }],
	["path", { d: "M10 8h4" }],
	["path", { d: "M16 19h6" }],
	["path", { d: "M18 7h2a2 2 0 012 2v4.355" }],
	["path", { d: "M19 16v6" }],
	["path", { d: "M6 10H4a2 2 0 00-2 2v7a2 2 0 002 2h8.535" }],
	["path", { d: "M6 21V5a2 2 0 012-2h8a2 2 0 012 2v7.126" }],
] satisfies IconNode;

export const bus = [
	["path", { d: "M8 6v6" }],
	["path", { d: "M15 6v6" }],
	["path", { d: "M2 12h19.6" }],
	[
		"path",
		{
			d: "M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3",
		},
	],
	["circle", { cx: "7", cy: "18", r: "2" }],
	["path", { d: "M9 18h5" }],
	["circle", { cx: "16", cy: "18", r: "2" }],
] satisfies IconNode;

export const busFront = [
	["path", { d: "M4 6 2 7" }],
	["path", { d: "M10 6h4" }],
	["path", { d: "m22 7-2-1" }],
	["rect", { width: "16", height: "16", x: "4", y: "3", rx: "2" }],
	["path", { d: "M4 11h16" }],
	["path", { d: "M8 15h.01" }],
	["path", { d: "M16 15h.01" }],
	["path", { d: "M6 19v2" }],
	["path", { d: "M18 21v-2" }],
] satisfies IconNode;

export const cable = [
	["path", { d: "M17 19a1 1 0 0 1-1-1v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a1 1 0 0 1-1 1z" }],
	["path", { d: "M17 21v-2" }],
	["path", { d: "M19 14V6.5a1 1 0 0 0-7 0v11a1 1 0 0 1-7 0V10" }],
	["path", { d: "M21 21v-2" }],
	["path", { d: "M3 5V3" }],
	["path", { d: "M4 10a2 2 0 0 1-2-2V6a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2z" }],
	["path", { d: "M7 5V3" }],
] satisfies IconNode;

export const cableCar = [
	["path", { d: "M10 3h.01" }],
	["path", { d: "M14 2h.01" }],
	["path", { d: "m2 9 20-5" }],
	["path", { d: "M12 12V6.5" }],
	["rect", { width: "16", height: "10", x: "4", y: "12", rx: "3" }],
	["path", { d: "M9 12v5" }],
	["path", { d: "M15 12v5" }],
	["path", { d: "M4 17h16" }],
] satisfies IconNode;

export const cake = [
	["path", { d: "M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8" }],
	["path", { d: "M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2-1 2-1" }],
	["path", { d: "M2 21h20" }],
	["path", { d: "M7 8v3" }],
	["path", { d: "M12 8v3" }],
	["path", { d: "M17 8v3" }],
	["path", { d: "M7 4h.01" }],
	["path", { d: "M12 4h.01" }],
	["path", { d: "M17 4h.01" }],
] satisfies IconNode;

export const cakeSlice = [
	["path", { d: "M16 13H3" }],
	["path", { d: "M16 17H3" }],
	[
		"path",
		{
			d: "m7.2 7.9-3.388 2.5A2 2 0 0 0 3 12.01V20a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-8.654c0-2-2.44-6.026-6.44-8.026a1 1 0 0 0-1.082.057L10.4 5.6",
		},
	],
	["circle", { cx: "9", cy: "7", r: "2" }],
] satisfies IconNode;

export const calculator = [
	["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2" }],
	["line", { x1: "8", x2: "16", y1: "6", y2: "6" }],
	["line", { x1: "16", x2: "16", y1: "14", y2: "18" }],
	["path", { d: "M16 10h.01" }],
	["path", { d: "M12 10h.01" }],
	["path", { d: "M8 10h.01" }],
	["path", { d: "M12 14h.01" }],
	["path", { d: "M8 14h.01" }],
	["path", { d: "M12 18h.01" }],
	["path", { d: "M8 18h.01" }],
] satisfies IconNode;

export const calendar = [
	["path", { d: "M8 2v3" }],
	["path", { d: "M16 2v3" }],
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
	["path", { d: "M3 9h18" }],
] satisfies IconNode;

export const calendar1 = [
	["path", { d: "M11 13h1v4" }],
	["path", { d: "M16 2v3" }],
	["path", { d: "M3 9h18" }],
	["path", { d: "M8 2v3" }],
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
] satisfies IconNode;

export const calendarArrowDown = [
	["path", { d: "m14 17 4 4 4-4" }],
	["path", { d: "M16 2v3" }],
	["path", { d: "M18 13v8" }],
	["path", { d: "M21 10.354V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h7.343" }],
	["path", { d: "M3 9h18" }],
	["path", { d: "M8 2v3" }],
] satisfies IconNode;

export const calendarArrowUp = [
	["path", { d: "m14 17 4-4 4 4" }],
	["path", { d: "M16 2v3" }],
	["path", { d: "M18 21v-8" }],
	["path", { d: "M21 10.343V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h9" }],
	["path", { d: "M3 9h18" }],
	["path", { d: "M8 2v3" }],
] satisfies IconNode;

export const calendarCheck = [
	["path", { d: "M8 2v3" }],
	["path", { d: "M16 2v3" }],
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
	["path", { d: "M3 9h18" }],
	["path", { d: "m9 15 2 2 4-4" }],
] satisfies IconNode;

export const calendarCheck2 = [
	["path", { d: "M 19 3 L 5 3" }],
	["path", { d: "M 21 13 L 21 5" }],
	["path", { d: "M 21 5 A2 2 0 0 0 19 3" }],
	["path", { d: "M 3 19 A2 2 0 0 0 5 21" }],
	["path", { d: "M 3 5 L 3 19" }],
	["path", { d: "M 5 3 A2 2 0 0 0 3 5" }],
	["path", { d: "m16 19 2 2 4-4" }],
	["path", { d: "M16 2v3" }],
	["path", { d: "M3 9h18" }],
	["path", { d: "M5 21 L12.5 21" }],
	["path", { d: "M8 2v3" }],
] satisfies IconNode;

export const calendarChevronsLeft = [
	["path", { d: "m11 21-3-3 3-3" }],
	["path", { d: "M16 2v3" }],
	["path", { d: "M21 9H3" }],
	["path", { d: "M3 11.5V5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2h-4" }],
	["path", { d: "m5 21-3-3 3-3" }],
	["path", { d: "M8 2v3" }],
] satisfies IconNode;

export const calendarChevronsRight = [
	["path", { d: "m13 21 3-3-3-3" }],
	["path", { d: "M16 2v3" }],
	["path", { d: "m19 21 3-3-3-3" }],
	["path", { d: "M21 11.5V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h4" }],
	["path", { d: "M3 9h18" }],
	["path", { d: "M8 2v3" }],
] satisfies IconNode;

export const calendarClock = [
	["path", { d: "M16 14v2.2l1.6 1" }],
	["path", { d: "M16 2v3" }],
	["path", { d: "M21 7.338V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h2.338" }],
	["path", { d: "M3 9h5.859" }],
	["path", { d: "M8 2v3" }],
	["circle", { cx: "16", cy: "16", r: "6" }],
] satisfies IconNode;

export const calendarCog = [
	["path", { d: "m15.228 16.852-.923-.383" }],
	["path", { d: "m15.228 19.148-.923.383" }],
	["path", { d: "M16 2v3" }],
	["path", { d: "m16.47 14.305.382.923" }],
	["path", { d: "m16.852 20.772-.383.924" }],
	["path", { d: "m19.148 15.228.383-.923" }],
	["path", { d: "m19.53 21.696-.382-.924" }],
	["path", { d: "m20.773 16.852.924-.383" }],
	["path", { d: "m20.773 19.148.924.383" }],
	["path", { d: "M21 10.5V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h5.5" }],
	["path", { d: "M3 9h18" }],
	["path", { d: "M8 2v3" }],
	["circle", { cx: "18", cy: "18", r: "3" }],
] satisfies IconNode;

export const calendarDays = [
	["path", { d: "M8 2v3" }],
	["path", { d: "M16 2v3" }],
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
	["path", { d: "M3 9h18" }],
	["path", { d: "M8 13h.01" }],
	["path", { d: "M12 13h.01" }],
	["path", { d: "M16 13h.01" }],
	["path", { d: "M8 17h.01" }],
	["path", { d: "M12 17h.01" }],
	["path", { d: "M16 17h.01" }],
] satisfies IconNode;

export const calendarFold = [
	["path", { d: "M16 2v3" }],
	[
		"path",
		{
			d: "M21 15V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h10v-5a1 1 0 011-1za2.4 2.4 0 01-.706 1.706l-3.588 3.588A2.4 2.4 0 0115 21",
		},
	],
	["path", { d: "M3 9h18" }],
	["path", { d: "M8 2v3" }],
] satisfies IconNode;

export const calendarHeart = [
	["path", { d: "M12.127 21H5a2 2 0 01-2-2V5a2 2 0 012-2h14a2 2 0 012 2v5.125" }],
	[
		"path",
		{
			d: "M14.62 17.8A2.25 2.25 0 1118 14.836a2.25 2.25 0 113.38 2.966l-2.626 2.856a.998.998 0 01-1.507 0z",
		},
	],
	["path", { d: "M16 2v3" }],
	["path", { d: "M3 9h18" }],
	["path", { d: "M8 2v3" }],
] satisfies IconNode;

export const calendarMinus = [
	["path", { d: "M16 18h6" }],
	["path", { d: "M16 2v3" }],
	["path", { d: "M21 14V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h8.3" }],
	["path", { d: "M3 9h18" }],
	["path", { d: "M8 2v3" }],
] satisfies IconNode;

export const calendarMinus2 = [
	["path", { d: "M8 2v3" }],
	["path", { d: "M16 2v3" }],
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
	["path", { d: "M3 9h18" }],
	["path", { d: "M10 15h4" }],
] satisfies IconNode;

export const calendarOff = [
	["path", { d: "M16 2v3" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M21 9h-5.5" }],
	["path", { d: "M3 9h6" }],
	["path", { d: "M3.586 3.586A2 2 0 003 5v14a2 2 0 002 2h14a2 2 0 001.414-.586" }],
	["path", { d: "M8.656 3H19a2 2 0 012 2v10.344" }],
] satisfies IconNode;

export const calendarPlus = [
	["path", { d: "M16 18h6" }],
	["path", { d: "M16 2v3" }],
	["path", { d: "M19 15v6" }],
	["path", { d: "M21 11.5V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h8.3" }],
	["path", { d: "M3 9h18" }],
	["path", { d: "M8 2v3" }],
] satisfies IconNode;

export const calendarPlus2 = [
	["path", { d: "M8 2v3" }],
	["path", { d: "M16 2v3" }],
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
	["path", { d: "M3 9h18" }],
	["path", { d: "M10 15h4" }],
	["path", { d: "M12 13v4" }],
] satisfies IconNode;

export const calendarRange = [
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
	["path", { d: "M16 2v3" }],
	["path", { d: "M3 9h18" }],
	["path", { d: "M8 2v3" }],
	["path", { d: "M17 13h-6" }],
	["path", { d: "M13 17H7" }],
	["path", { d: "M7 13h.01" }],
	["path", { d: "M17 17h.01" }],
] satisfies IconNode;

export const calendarSearch = [
	["path", { d: "M16 2v3" }],
	["path", { d: "M21 10.69V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h7.25" }],
	["path", { d: "m22 21-1.875-1.875" }],
	["path", { d: "M3 9h18" }],
	["path", { d: "M8 2v3" }],
	["circle", { cx: "18", cy: "17", r: "3" }],
] satisfies IconNode;

export const calendarSync = [
	["path", { d: "M11 10v4h4" }],
	["path", { d: "m11 14 1.535-1.605a5 5 0 018 1.5" }],
	["path", { d: "M16 2v3" }],
	["path", { d: "m21 18-1.535 1.605a5 5 0 01-8-1.5" }],
	["path", { d: "M21 22v-4h-4" }],
	["path", { d: "M21 8.517V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h3.517" }],
	["path", { d: "M3 9h4" }],
	["path", { d: "M8 2v3" }],
] satisfies IconNode;

export const calendarX = [
	["path", { d: "M8 2v3" }],
	["path", { d: "M16 2v3" }],
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
	["path", { d: "M3 9h18" }],
	["path", { d: "m14 13-4 4" }],
	["path", { d: "m10 13 4 4" }],
] satisfies IconNode;

export const calendarX2 = [
	["path", { d: "M16 2v3" }],
	["path", { d: "m17 16 5 5" }],
	["path", { d: "m17 21 5-5" }],
	["path", { d: "M21 12V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h8" }],
	["path", { d: "M3 9h18" }],
	["path", { d: "M8 2v3" }],
] satisfies IconNode;

export const calendars = [
	["path", { d: "M12 2v2" }],
	["path", { d: "M15.726 21.01A2 2 0 0 1 14 22H4a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2" }],
	["path", { d: "M18 2v2" }],
	["path", { d: "M2 13h2" }],
	["path", { d: "M8 8h14" }],
	["rect", { x: "8", y: "3", width: "14", height: "14", rx: "2" }],
] satisfies IconNode;

export const camera = [
	[
		"path",
		{
			d: "M13.997 4a2 2 0 0 1 1.76 1.05l.486.9A2 2 0 0 0 18.003 7H20a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.997a2 2 0 0 0 1.759-1.048l.489-.904A2 2 0 0 1 10.004 4z",
		},
	],
	["circle", { cx: "12", cy: "13", r: "3" }],
] satisfies IconNode;

export const cameraOff = [
	["path", { d: "M14.564 14.558a3 3 0 1 1-4.122-4.121" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M20 20H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.997a2 2 0 0 0 .819-.175" }],
	[
		"path",
		{
			d: "M9.695 4.024A2 2 0 0 1 10.004 4h3.993a2 2 0 0 1 1.76 1.05l.486.9A2 2 0 0 0 18.003 7H20a2 2 0 0 1 2 2v7.344",
		},
	],
] satisfies IconNode;

export const can = [
	["path", { d: "M21 10.5a9 2.5 0 01-18 0v8a9 2.5 0 0018 0z" }],
	["path", { d: "M21 10.5A9 2.5 25.32 004.59 3.47 9 2.5 25.32 0021 10.5" }],
	["path", { d: "M3 10.5a9 2.5 0 016.527-2.405" }],
	["path", { d: "M9 16.858a31 31 0 006 0" }],
] satisfies IconNode;

export const canSoda = [
	["path", { d: "m17 22 1.664-2.496a2 2 0 00.336-1.11V5.606a2 2 0 00-.336-1.11L17 2" }],
	["path", { d: "M18 22H6" }],
	["path", { d: "M18 2H6" }],
	["path", { d: "M5 17h14" }],
	["path", { d: "M5 7h14" }],
	["path", { d: "m7 22-1.664-2.496A2 2 0 015 18.394V5.606a2 2 0 01.336-1.11L7 2" }],
] satisfies IconNode;

export const candy = [
	["path", { d: "M10 7v10.9" }],
	["path", { d: "M14 6.1V17" }],
	[
		"path",
		{
			d: "M16 7V3a1 1 0 0 1 1.707-.707 2.5 2.5 0 0 0 2.152.717 1 1 0 0 1 1.131 1.131 2.5 2.5 0 0 0 .717 2.152A1 1 0 0 1 21 8h-4",
		},
	],
	[
		"path",
		{
			d: "M16.536 7.465a5 5 0 0 0-7.072 0l-2 2a5 5 0 0 0 0 7.07 5 5 0 0 0 7.072 0l2-2a5 5 0 0 0 0-7.07",
		},
	],
	[
		"path",
		{
			d: "M8 17v4a1 1 0 0 1-1.707.707 2.5 2.5 0 0 0-2.152-.717 1 1 0 0 1-1.131-1.131 2.5 2.5 0 0 0-.717-2.152A1 1 0 0 1 3 16h4",
		},
	],
] satisfies IconNode;

export const candyCane = [
	["path", { d: "m10.8 5 2.111 4.223" }],
	["path", { d: "M17.75 7 15 2.1" }],
	["path", { d: "m4.874 14.647 2.12 4.24" }],
	[
		"path",
		{ d: "M5.7 21a2 2 0 0 1-3.5-2l8.6-14a6 6 0 0 1 10.4 6 2 2 0 1 1-3.464-2 2 2 0 1 0-3.464-2z" },
	],
	["path", { d: "m7.906 9.712 2.005 4.411" }],
] satisfies IconNode;

export const candyOff = [
	["path", { d: "M10 10v7.9" }],
	["path", { d: "M11.802 6.145a5 5 0 0 1 6.053 6.053" }],
	["path", { d: "M14 6.1v2.243" }],
	["path", { d: "m15.5 15.571-.964.964a5 5 0 0 1-7.071 0 5 5 0 0 1 0-7.07l.964-.965" }],
	[
		"path",
		{
			d: "M16 7V3a1 1 0 0 1 1.707-.707 2.5 2.5 0 0 0 2.152.717 1 1 0 0 1 1.131 1.131 2.5 2.5 0 0 0 .717 2.152A1 1 0 0 1 21 8h-4",
		},
	],
	["path", { d: "m2 2 20 20" }],
	[
		"path",
		{
			d: "M8 17v4a1 1 0 0 1-1.707.707 2.5 2.5 0 0 0-2.152-.717 1 1 0 0 1-1.131-1.131 2.5 2.5 0 0 0-.717-2.152A1 1 0 0 1 3 16h4",
		},
	],
] satisfies IconNode;

export const cannabis = [
	["path", { d: "M12 22v-4" }],
	[
		"path",
		{
			d: "M7 12c-1.5 0-4.5 1.5-5 3 3.5 1.5 6 1 6 1-1.5 1.5-2 3.5-2 5 2.5 0 4.5-1.5 6-3 1.5 1.5 3.5 3 6 3 0-1.5-.5-3.5-2-5 0 0 2.5.5 6-1-.5-1.5-3.5-3-5-3 1.5-1 4-4 4-6-2.5 0-5.5 1.5-7 3 0-2.5-.5-5-2-7-1.5 2-2 4.5-2 7-1.5-1.5-4.5-3-7-3 0 2 2.5 5 4 6",
		},
	],
] satisfies IconNode;

export const cannabisOff = [
	["path", { d: "M12 22v-4c1.5 1.5 3.5 3 6 3 0-1.5-.5-3.5-2-5" }],
	["path", { d: "M13.988 8.327C13.902 6.054 13.365 3.82 12 2a9.3 9.3 0 0 0-1.445 2.9" }],
	["path", { d: "M17.375 11.725C18.882 10.53 21 7.841 21 6c-2.324 0-5.08 1.296-6.662 2.684" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M21.024 15.378A15 15 0 0 0 22 15c-.426-1.279-2.67-2.557-4.25-2.907" }],
	[
		"path",
		{
			d: "M6.995 6.992C5.714 6.4 4.29 6 3 6c0 2 2.5 5 4 6-1.5 0-4.5 1.5-5 3 3.5 1.5 6 1 6 1-1.5 1.5-2 3.5-2 5 2.5 0 4.5-1.5 6-3",
		},
	],
] satisfies IconNode;

export const captions = [
	["rect", { width: "18", height: "14", x: "3", y: "5", rx: "2", ry: "2" }],
	["path", { d: "M7 15h4M15 15h2M7 11h2M13 11h4" }],
] satisfies IconNode;

export const captionsOff = [
	["path", { d: "M10.5 5H19a2 2 0 0 1 2 2v8.5" }],
	["path", { d: "M17 11h-.5" }],
	["path", { d: "M19 19H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M7 11h4" }],
	["path", { d: "M7 15h2.5" }],
] satisfies IconNode;

export const car = [
	[
		"path",
		{
			d: "M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2",
		},
	],
	["circle", { cx: "7", cy: "17", r: "2" }],
	["path", { d: "M9 17h6" }],
	["circle", { cx: "17", cy: "17", r: "2" }],
] satisfies IconNode;

export const carBattery = [
	["path", { d: "M14 13h4" }],
	["path", { d: "M16 15v-4" }],
	["path", { d: "M18 5v2" }],
	["path", { d: "M6 13h4" }],
	["path", { d: "M6 5v2" }],
	["rect", { x: "2", y: "7", width: "20", height: "12", rx: "2" }],
] satisfies IconNode;

export const carFront = [
	["path", { d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8" }],
	["path", { d: "M7 14h.01" }],
	["path", { d: "M17 14h.01" }],
	["rect", { width: "18", height: "8", x: "3", y: "10", rx: "2" }],
	["path", { d: "M5 18v2" }],
	["path", { d: "M19 18v2" }],
] satisfies IconNode;

export const carTaxiFront = [
	["path", { d: "M10 2h4" }],
	["path", { d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8" }],
	["path", { d: "M7 14h.01" }],
	["path", { d: "M17 14h.01" }],
	["rect", { width: "18", height: "8", x: "3", y: "10", rx: "2" }],
	["path", { d: "M5 18v2" }],
	["path", { d: "M19 18v2" }],
] satisfies IconNode;

export const caravan = [
	["path", { d: "M18 19V9a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v8a2 2 0 0 0 2 2h2" }],
	["path", { d: "M2 9h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2" }],
	["path", { d: "M22 17v1a1 1 0 0 1-1 1H10v-9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v9" }],
	["circle", { cx: "8", cy: "19", r: "2" }],
] satisfies IconNode;

export const cardSim = [
	["path", { d: "M12 14v4" }],
	[
		"path",
		{
			d: "M14.172 2a2 2 0 0 1 1.414.586l3.828 3.828A2 2 0 0 1 20 7.828V20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z",
		},
	],
	["path", { d: "M8 14h8" }],
	["rect", { x: "8", y: "10", width: "8", height: "8", rx: "2" }],
] satisfies IconNode;

export const carrot = [
	["path", { d: "M15 16a1 1 0 0 0-7-7q-4 4-5.987 12.385a.5.5 0 0 0 .602.602Q11 20 15 16l-3-3" }],
	["path", { d: "M15 9q4 4 7 0-3-4-7 0 4-4 0-7-4 3 0 7" }],
	["path", { d: "m8 15-2.58-2.58" }],
] satisfies IconNode;

export const carton = [
	[
		"path",
		{
			d: "M13 22V10a2 2 0 01.539-1.367L16 6H8L5.539 8.633A2 2 0 005 10v10a2 2 0 002 2h10a2 2 0 002-2V10a2 2 0 00-.539-1.367L16 6V3a1 1 0 00-1-1H9a1 1 0 00-1 1v3",
		},
	],
	["path", { d: "M5 10h8" }],
] satisfies IconNode;

export const cartonOff = [
	["path", { d: "M10 10H5v10a2 2 0 002 2h10a2 2 0 002-2v-1" }],
	["path", { d: "M13 22v-9" }],
	["path", { d: "M13.902 8.245 16 6h-4.343" }],
	["path", { d: "M19 13.343V10a2 2 0 00-.539-1.367L16 6V3a1 1 0 00-1-1H9a1 1 0 00-.857.486" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M7.034 7.034 5.539 8.633A2 2 0 005 10" }],
] satisfies IconNode;

export const caseLower = [
	["path", { d: "M10 9v7" }],
	["path", { d: "M14 6v10" }],
	["circle", { cx: "17.5", cy: "12.5", r: "3.5" }],
	["circle", { cx: "6.5", cy: "12.5", r: "3.5" }],
] satisfies IconNode;

export const caseSensitive = [
	["path", { d: "m2 16 4.039-9.69a.5.5 0 0 1 .923 0L11 16" }],
	["path", { d: "M22 9v7" }],
	["path", { d: "M3.304 13h6.392" }],
	["circle", { cx: "18.5", cy: "12.5", r: "3.5" }],
] satisfies IconNode;

export const caseUpper = [
	[
		"path",
		{ d: "M15 11h4.5a1 1 0 0 1 0 5h-4a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h3a1 1 0 0 1 0 5" },
	],
	["path", { d: "m2 16 4.039-9.69a.5.5 0 0 1 .923 0L11 16" }],
	["path", { d: "M3.304 13h6.392" }],
] satisfies IconNode;

export const cassetteTape = [
	["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2" }],
	["circle", { cx: "8", cy: "10", r: "2" }],
	["path", { d: "M8 12h8" }],
	["circle", { cx: "16", cy: "10", r: "2" }],
	["path", { d: "m6 20 .7-2.9A1.4 1.4 0 0 1 8.1 16h7.8a1.4 1.4 0 0 1 1.4 1l.7 3" }],
] satisfies IconNode;

export const cast = [
	["path", { d: "M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6" }],
	["path", { d: "M2 12a9 9 0 0 1 8 8" }],
	["path", { d: "M2 16a5 5 0 0 1 4 4" }],
	["line", { x1: "2", x2: "2.01", y1: "20", y2: "20" }],
] satisfies IconNode;

export const castle = [
	["path", { d: "M10 5V3" }],
	["path", { d: "M14 5V3" }],
	["path", { d: "M15 21v-3a3 3 0 0 0-6 0v3" }],
	["path", { d: "M18 3v8" }],
	["path", { d: "M18 5H6" }],
	["path", { d: "M22 11H2" }],
	["path", { d: "M22 9v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9" }],
	["path", { d: "M6 3v8" }],
] satisfies IconNode;

export const cat = [
	[
		"path",
		{
			d: "M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5Z",
		},
	],
	["path", { d: "M8 14v.5" }],
	["path", { d: "M16 14v.5" }],
	["path", { d: "M11.25 16.25h1.5L12 17l-.75-.75Z" }],
] satisfies IconNode;

export const cctv = [
	[
		"path",
		{ d: "M16.75 12h3.632a1 1 0 0 1 .894 1.447l-2.034 4.069a1 1 0 0 1-1.708.134l-2.124-2.97" },
	],
	[
		"path",
		{
			d: "M17.106 9.053a1 1 0 0 1 .447 1.341l-3.106 6.211a1 1 0 0 1-1.342.447L3.61 12.3a2.92 2.92 0 0 1-1.3-3.91L3.69 5.6a2.92 2.92 0 0 1 3.92-1.3z",
		},
	],
	["path", { d: "M2 19h3.76a2 2 0 0 0 1.8-1.1L9 15" }],
	["path", { d: "M2 21v-4" }],
	["path", { d: "M7 9h.01" }],
] satisfies IconNode;

export const cctvOff = [
	[
		"path",
		{
			d: "m12.309 6.652 4.797 2.401a1 1 0 0 1 .447 1.341l-.501 1.001.605.605h2.725a1 1 0 0 1 .894 1.447l-.724 1.448",
		},
	],
	[
		"path",
		{
			d: "m15.166 15.166-.719 1.439a1 1 0 0 1-1.342.447L3.61 12.3a2.92 2.92 0 0 1-1.3-3.91L3.69 5.6a2.9 2.9 0 0 1 .873-1.037",
		},
	],
	["path", { d: "M2 19h3.76a2 2 0 0 0 1.8-1.1l1.441-2.902" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M2 21v-4" }],
	["path", { d: "M7 9h.01" }],
] satisfies IconNode;

export const certificate = [
	["path", { d: "M12 10H6" }],
	[
		"path",
		{
			d: "m20.69 15.479 1.29 4.88a.5.5 0 01-.698.591l-1.843-.849a1 1 0 00-.879.001l-1.846.85a.5.5 0 01-.692-.593l1.29-4.88",
		},
	],
	["path", { d: "M22 6.675V6a2 2 0 00-2-2H4a2 2 0 00-2 2v12a2 2 0 002 2h8" }],
	["path", { d: "M6 14h4" }],
	["circle", { cx: "19", cy: "13", r: "3" }],
] satisfies IconNode;

export const chartArea = [
	["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
	[
		"path",
		{
			d: "M7 11.207a.5.5 0 0 1 .146-.353l2-2a.5.5 0 0 1 .708 0l3.292 3.292a.5.5 0 0 0 .708 0l4.292-4.292a.5.5 0 0 1 .854.353V16a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z",
		},
	],
] satisfies IconNode;

export const chartBar = [
	["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
	["path", { d: "M7 16h8" }],
	["path", { d: "M7 11h12" }],
	["path", { d: "M7 6h3" }],
] satisfies IconNode;

export const chartBarBig = [
	["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
	["rect", { x: "7", y: "13", width: "9", height: "4", rx: "1" }],
	["rect", { x: "7", y: "5", width: "12", height: "4", rx: "1" }],
] satisfies IconNode;

export const chartBarDecreasing = [
	["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
	["path", { d: "M7 11h8" }],
	["path", { d: "M7 16h3" }],
	["path", { d: "M7 6h12" }],
] satisfies IconNode;

export const chartBarIncreasing = [
	["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
	["path", { d: "M7 11h8" }],
	["path", { d: "M7 16h12" }],
	["path", { d: "M7 6h3" }],
] satisfies IconNode;

export const chartBarStacked = [
	["path", { d: "M11 13v4" }],
	["path", { d: "M15 5v4" }],
	["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
	["rect", { x: "7", y: "13", width: "9", height: "4", rx: "1" }],
	["rect", { x: "7", y: "5", width: "12", height: "4", rx: "1" }],
] satisfies IconNode;

export const chartCandlestick = [
	["path", { d: "M9 5v4" }],
	["rect", { width: "4", height: "6", x: "7", y: "9", rx: "1" }],
	["path", { d: "M9 15v2" }],
	["path", { d: "M17 3v2" }],
	["rect", { width: "4", height: "8", x: "15", y: "5", rx: "1" }],
	["path", { d: "M17 13v3" }],
	["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
] satisfies IconNode;

export const chartColumn = [
	["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
	["path", { d: "M18 17V9" }],
	["path", { d: "M13 17V5" }],
	["path", { d: "M8 17v-3" }],
] satisfies IconNode;

export const chartColumnBig = [
	["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
	["rect", { x: "15", y: "5", width: "4", height: "12", rx: "1" }],
	["rect", { x: "7", y: "8", width: "4", height: "9", rx: "1" }],
] satisfies IconNode;

export const chartColumnDecreasing = [
	["path", { d: "M13 17V9" }],
	["path", { d: "M18 17v-3" }],
	["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
	["path", { d: "M8 17V5" }],
] satisfies IconNode;

export const chartColumnIncreasing = [
	["path", { d: "M13 17V9" }],
	["path", { d: "M18 17V5" }],
	["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
	["path", { d: "M8 17v-3" }],
] satisfies IconNode;

export const chartColumnStacked = [
	["path", { d: "M11 13H7" }],
	["path", { d: "M19 9h-4" }],
	["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
	["rect", { x: "15", y: "5", width: "4", height: "12", rx: "1" }],
	["rect", { x: "7", y: "8", width: "4", height: "9", rx: "1" }],
] satisfies IconNode;

export const chartGantt = [
	["path", { d: "M10 6h8" }],
	["path", { d: "M12 16h6" }],
	["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
	["path", { d: "M8 11h7" }],
] satisfies IconNode;

export const chartLine = [
	["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
	["path", { d: "m19 9-5 5-4-4-3 3" }],
] satisfies IconNode;

export const chartNetwork = [
	["path", { d: "m13.11 7.664 1.78 2.672" }],
	["path", { d: "m14.162 12.788-3.324 1.424" }],
	["path", { d: "m20 4-6.06 1.515" }],
	["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
	["circle", { cx: "12", cy: "6", r: "2" }],
	["circle", { cx: "16", cy: "12", r: "2" }],
	["circle", { cx: "9", cy: "15", r: "2" }],
] satisfies IconNode;

export const chartNoAxesColumn = [
	["path", { d: "M5 21v-6" }],
	["path", { d: "M12 21V3" }],
	["path", { d: "M19 21V9" }],
] satisfies IconNode;

export const chartNoAxesColumnDecreasing = [
	["path", { d: "M5 21V3" }],
	["path", { d: "M12 21V9" }],
	["path", { d: "M19 21v-6" }],
] satisfies IconNode;

export const chartNoAxesColumnIncreasing = [
	["path", { d: "M5 21v-6" }],
	["path", { d: "M12 21V9" }],
	["path", { d: "M19 21V3" }],
] satisfies IconNode;

export const chartNoAxesCombined = [
	["path", { d: "M12 16v5" }],
	["path", { d: "M16 14.639V21" }],
	["path", { d: "M20 10.656V21" }],
	["path", { d: "m22 3-8.646 8.646a.5.5 0 0 1-.708 0L9.354 8.354a.5.5 0 0 0-.707 0L2 15" }],
	["path", { d: "M4 18.463V21" }],
	["path", { d: "M8 14.656V21" }],
] satisfies IconNode;

export const chartNoAxesGantt = [
	["path", { d: "M6 5h12" }],
	["path", { d: "M4 12h10" }],
	["path", { d: "M12 19h8" }],
] satisfies IconNode;

export const chartPie = [
	[
		"path",
		{
			d: "M21 12c.552 0 1.005-.449.95-.998a10 10 0 0 0-8.953-8.951c-.55-.055-.998.398-.998.95v8a1 1 0 0 0 1 1z",
		},
	],
	["path", { d: "M21.21 15.89A10 10 0 1 1 8 2.83" }],
] satisfies IconNode;

export const chartScatter = [
	["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor" }],
	["circle", { cx: "18.5", cy: "5.5", r: ".5", fill: "currentColor" }],
	["circle", { cx: "11.5", cy: "11.5", r: ".5", fill: "currentColor" }],
	["circle", { cx: "7.5", cy: "16.5", r: ".5", fill: "currentColor" }],
	["circle", { cx: "17.5", cy: "14.5", r: ".5", fill: "currentColor" }],
	["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
] satisfies IconNode;

export const chartSpline = [
	["path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }],
	["path", { d: "M7 16c.5-2 1.5-7 4-7 2 0 2 3 4 3 2.5 0 4.5-5 5-7" }],
] satisfies IconNode;

export const check = [["path", { d: "M20 6 9 17l-5-5" }]] satisfies IconNode;

export const checkCheck = [
	["path", { d: "M18 6 7 17l-5-5" }],
	["path", { d: "m22 10-7.5 7.5L13 16" }],
] satisfies IconNode;

export const checkLine = [
	["path", { d: "M20 4L9 15" }],
	["path", { d: "M21 19L3 19" }],
	["path", { d: "M9 15L4 10" }],
] satisfies IconNode;

export const chefHat = [
	[
		"path",
		{
			d: "M17 21a1 1 0 0 0 1-1v-5.35c0-.457.316-.844.727-1.041a4 4 0 0 0-2.134-7.589 5 5 0 0 0-9.186 0 4 4 0 0 0-2.134 7.588c.411.198.727.585.727 1.041V20a1 1 0 0 0 1 1Z",
		},
	],
	["path", { d: "M6 17h12" }],
] satisfies IconNode;

export const cherry = [
	["path", { d: "M2 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z" }],
	["path", { d: "M12 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z" }],
	["path", { d: "M7 14c3.22-2.91 4.29-8.75 5-12 1.66 2.38 4.94 9 5 12" }],
	["path", { d: "M22 9c-4.29 0-7.14-2.33-10-7 5.71 0 10 4.67 10 7Z" }],
] satisfies IconNode;

export const chessBishop = [
	["path", { d: "M5 20a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z" }],
	[
		"path",
		{
			d: "M15 18c1.5-.615 3-2.461 3-4.923C18 8.769 14.5 4.462 12 2 9.5 4.462 6 8.77 6 13.077 6 15.539 7.5 17.385 9 18",
		},
	],
	["path", { d: "m16 7-2.5 2.5" }],
	["path", { d: "M9 2h6" }],
] satisfies IconNode;

export const chessKing = [
	["path", { d: "M4 20a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z" }],
	[
		"path",
		{
			d: "m6.7 18-1-1C4.35 15.682 3 14.09 3 12a5 5 0 0 1 4.95-5c1.584 0 2.7.455 4.05 1.818C13.35 7.455 14.466 7 16.05 7A5 5 0 0 1 21 12c0 2.082-1.359 3.673-2.7 5l-1 1",
		},
	],
	["path", { d: "M10 4h4" }],
	["path", { d: "M12 2v6.818" }],
] satisfies IconNode;

export const chessKnight = [
	["path", { d: "M5 20a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z" }],
	[
		"path",
		{
			d: "M16.5 18c1-2 2.5-5 2.5-9a7 7 0 0 0-7-7H6.635a1 1 0 0 0-.768 1.64L7 5l-2.32 5.802a2 2 0 0 0 .95 2.526l2.87 1.456",
		},
	],
	["path", { d: "m15 5 1.425-1.425" }],
	["path", { d: "m17 8 1.53-1.53" }],
	["path", { d: "M9.713 12.185 7 18" }],
] satisfies IconNode;

export const chessPawn = [
	["path", { d: "M5 20a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z" }],
	["path", { d: "m14.5 10 1.5 8" }],
	["path", { d: "M7 10h10" }],
	["path", { d: "m8 18 1.5-8" }],
	["circle", { cx: "12", cy: "6", r: "4" }],
] satisfies IconNode;

export const chessQueen = [
	["path", { d: "m10.68 5.499-.996 4.982a.65.65 0 01-1.131.295L5.885 7.663" }],
	["path", { d: "m13.32 5.5.995 4.98a.65.65 0 001.131.296l2.668-3.113" }],
	["path", { d: "M20.428 8.952 17.5 18" }],
	["path", { d: "M4 20a2 2 0 012-2h12a2 2 0 012 2v1a1 1 0 01-1 1H5a1 1 0 01-1-1z" }],
	["path", { d: "M6.5 18 3.571 8.952" }],
	["circle", { cx: "12", cy: "4", r: "2" }],
	["circle", { cx: "20", cy: "7", r: "2" }],
	["circle", { cx: "4", cy: "7", r: "2" }],
] satisfies IconNode;

export const chessRook = [
	["path", { d: "M5 20a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z" }],
	["path", { d: "M10 2v2" }],
	["path", { d: "M14 2v2" }],
	["path", { d: "m17 18-1-9" }],
	["path", { d: "M6 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2" }],
	["path", { d: "M6 4h12" }],
	["path", { d: "m7 18 1-9" }],
] satisfies IconNode;

export const chevronDown = [["path", { d: "m6 9 6 6 6-6" }]] satisfies IconNode;

export const chevronFirst = [
	["path", { d: "m17 18-6-6 6-6" }],
	["path", { d: "M7 6v12" }],
] satisfies IconNode;

export const chevronLast = [
	["path", { d: "m7 18 6-6-6-6" }],
	["path", { d: "M17 6v12" }],
] satisfies IconNode;

export const chevronLeft = [["path", { d: "m15 18-6-6 6-6" }]] satisfies IconNode;

export const chevronRight = [["path", { d: "m9 18 6-6-6-6" }]] satisfies IconNode;

export const chevronUp = [["path", { d: "m18 15-6-6-6 6" }]] satisfies IconNode;

export const chevronsDown = [
	["path", { d: "m7 6 5 5 5-5" }],
	["path", { d: "m7 13 5 5 5-5" }],
] satisfies IconNode;

export const chevronsDownUp = [
	["path", { d: "m7 20 5-5 5 5" }],
	["path", { d: "m7 4 5 5 5-5" }],
] satisfies IconNode;

export const chevronsLeft = [
	["path", { d: "m11 17-5-5 5-5" }],
	["path", { d: "m18 17-5-5 5-5" }],
] satisfies IconNode;

export const chevronsLeftRight = [
	["path", { d: "m9 7-5 5 5 5" }],
	["path", { d: "m15 7 5 5-5 5" }],
] satisfies IconNode;

export const chevronsLeftRightEllipsis = [
	["path", { d: "M12 12h.01" }],
	["path", { d: "M16 12h.01" }],
	["path", { d: "m17 7 5 5-5 5" }],
	["path", { d: "m7 7-5 5 5 5" }],
	["path", { d: "M8 12h.01" }],
] satisfies IconNode;

export const chevronsRight = [
	["path", { d: "m6 17 5-5-5-5" }],
	["path", { d: "m13 17 5-5-5-5" }],
] satisfies IconNode;

export const chevronsRightLeft = [
	["path", { d: "m20 17-5-5 5-5" }],
	["path", { d: "m4 17 5-5-5-5" }],
] satisfies IconNode;

export const chevronsUp = [
	["path", { d: "m17 11-5-5-5 5" }],
	["path", { d: "m17 18-5-5-5 5" }],
] satisfies IconNode;

export const chevronsUpDown = [
	["path", { d: "m7 15 5 5 5-5" }],
	["path", { d: "m7 9 5-5 5 5" }],
] satisfies IconNode;

export const church = [
	["path", { d: "M10 9h4" }],
	["path", { d: "M12 7v5" }],
	["path", { d: "M14 21v-3a2 2 0 0 0-4 0v3" }],
	[
		"path",
		{
			d: "m18 9 3.52 2.147a1 1 0 0 1 .48.854V19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-6.999a1 1 0 0 1 .48-.854L6 9",
		},
	],
	["path", { d: "M6 21V7a1 1 0 0 1 .376-.782l5-3.999a1 1 0 0 1 1.249.001l5 4A1 1 0 0 1 18 7v14" }],
] satisfies IconNode;

export const cigarette = [
	["path", { d: "M17 12H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h14" }],
	["path", { d: "M18 8c0-2.5-2-2.5-2-5" }],
	["path", { d: "M21 16a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1" }],
	["path", { d: "M22 8c0-2.5-2-2.5-2-5" }],
	["path", { d: "M7 12v4" }],
] satisfies IconNode;

export const cigaretteOff = [
	["path", { d: "M12 12H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h13" }],
	["path", { d: "M18 8c0-2.5-2-2.5-2-5" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M21 12a1 1 0 0 1 1 1v2a1 1 0 0 1-.5.866" }],
	["path", { d: "M22 8c0-2.5-2-2.5-2-5" }],
	["path", { d: "M7 12v4" }],
] satisfies IconNode;

export const circle = [["circle", { cx: "12", cy: "12", r: "10" }]] satisfies IconNode;

export const circleAlert = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["line", { x1: "12", x2: "12", y1: "8", y2: "12" }],
	["line", { x1: "12", x2: "12.01", y1: "16", y2: "16" }],
] satisfies IconNode;

export const circleArrowDown = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M12 8v8" }],
	["path", { d: "m8 12 4 4 4-4" }],
] satisfies IconNode;

export const circleArrowLeft = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "m12 8-4 4 4 4" }],
	["path", { d: "M16 12H8" }],
] satisfies IconNode;

export const circleArrowOutDownLeft = [
	["path", { d: "M2 12a10 10 0 1 1 10 10" }],
	["path", { d: "m2 22 10-10" }],
	["path", { d: "M8 22H2v-6" }],
] satisfies IconNode;

export const circleArrowOutDownRight = [
	["path", { d: "M12 22a10 10 0 1 1 10-10" }],
	["path", { d: "M22 22 12 12" }],
	["path", { d: "M22 16v6h-6" }],
] satisfies IconNode;

export const circleArrowOutUpLeft = [
	["path", { d: "M2 8V2h6" }],
	["path", { d: "m2 2 10 10" }],
	["path", { d: "M12 2A10 10 0 1 1 2 12" }],
] satisfies IconNode;

export const circleArrowOutUpRight = [
	["path", { d: "M22 12A10 10 0 1 1 12 2" }],
	["path", { d: "M22 2 12 12" }],
	["path", { d: "M16 2h6v6" }],
] satisfies IconNode;

export const circleArrowRight = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "m12 16 4-4-4-4" }],
	["path", { d: "M8 12h8" }],
] satisfies IconNode;

export const circleArrowUp = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "m16 12-4-4-4 4" }],
	["path", { d: "M12 16V8" }],
] satisfies IconNode;

export const circleCheck = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "m16 9-5.5 5.5L8 12" }],
] satisfies IconNode;

export const circleCheckBig = [
	["path", { d: "M21.801 10A10 10 0 1 1 17 3.335" }],
	["path", { d: "m9 11 3 3L22 4" }],
] satisfies IconNode;

export const circleChevronDown = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "m16 10-4 4-4-4" }],
] satisfies IconNode;

export const circleChevronLeft = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "m14 16-4-4 4-4" }],
] satisfies IconNode;

export const circleChevronRight = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "m10 8 4 4-4 4" }],
] satisfies IconNode;

export const circleChevronUp = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "m8 14 4-4 4 4" }],
] satisfies IconNode;

export const circleChevronsDown = [
	["path", { d: "M9 14L12 17L15 14" }],
	["path", { d: "M9 8L12 11L15 8" }],
	["circle", { cx: "12", cy: "12", r: "10" }],
] satisfies IconNode;

export const circleChevronsLeft = [
	["path", { d: "M10 9L7 12L10 15" }],
	["path", { d: "M16 9L13 12L16 15" }],
	["circle", { cx: "12", cy: "12", r: "10" }],
] satisfies IconNode;

export const circleChevronsRight = [
	["path", { d: "M14 15L17 12L14 9" }],
	["path", { d: "M8 15L11 12L8 9" }],
	["circle", { cx: "12", cy: "12", r: "10" }],
] satisfies IconNode;

export const circleChevronsUp = [
	["path", { d: "M15 10L12 7L9 10" }],
	["path", { d: "M15 16L12 13L9 16" }],
	["circle", { cx: "12", cy: "12", r: "10" }],
] satisfies IconNode;

export const circleDashed = [
	["path", { d: "M10.1 2.182a10 10 0 0 1 3.8 0" }],
	["path", { d: "M13.9 21.818a10 10 0 0 1-3.8 0" }],
	["path", { d: "M17.609 3.721a10 10 0 0 1 2.69 2.7" }],
	["path", { d: "M2.182 13.9a10 10 0 0 1 0-3.8" }],
	["path", { d: "M20.279 17.609a10 10 0 0 1-2.7 2.69" }],
	["path", { d: "M21.818 10.1a10 10 0 0 1 0 3.8" }],
	["path", { d: "M3.721 6.391a10 10 0 0 1 2.7-2.69" }],
	["path", { d: "M6.391 20.279a10 10 0 0 1-2.69-2.7" }],
] satisfies IconNode;

export const circleDashedCheck = [
	["path", { d: "M10.1 2.182a10 10 0 013.8 0" }],
	["path", { d: "M13.9 21.818a10 10 0 01-3.8 0" }],
	["path", { d: "m16 9-5.5 5.5L8 12" }],
	["path", { d: "M17.609 3.721a10 10 0 012.69 2.7" }],
	["path", { d: "M2.182 13.9a10 10 0 010-3.8" }],
	["path", { d: "M20.279 17.609a10 10 0 01-2.7 2.69" }],
	["path", { d: "M21.818 10.1a10 10 0 010 3.8" }],
	["path", { d: "M3.721 6.391a10 10 0 012.7-2.69" }],
	["path", { d: "M6.391 20.279a10 10 0 01-2.69-2.7" }],
] satisfies IconNode;

export const circleDivide = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["line", { x1: "8", x2: "16", y1: "12", y2: "12" }],
	["line", { x1: "12", x2: "12", y1: "16", y2: "16" }],
	["line", { x1: "12", x2: "12", y1: "8", y2: "8" }],
] satisfies IconNode;

export const circleDollarSign = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" }],
	["path", { d: "M12 18V6" }],
] satisfies IconNode;

export const circleDot = [
	["circle", { cx: "12", cy: "12", r: "1" }],
	["circle", { cx: "12", cy: "12", r: "10" }],
] satisfies IconNode;

export const circleDotDashed = [
	["path", { d: "M10.1 2.18a9.93 9.93 0 0 1 3.8 0" }],
	["path", { d: "M17.6 3.71a9.95 9.95 0 0 1 2.69 2.7" }],
	["path", { d: "M21.82 10.1a9.93 9.93 0 0 1 0 3.8" }],
	["path", { d: "M20.29 17.6a9.95 9.95 0 0 1-2.7 2.69" }],
	["path", { d: "M13.9 21.82a9.94 9.94 0 0 1-3.8 0" }],
	["path", { d: "M6.4 20.29a9.95 9.95 0 0 1-2.69-2.7" }],
	["path", { d: "M2.18 13.9a9.93 9.93 0 0 1 0-3.8" }],
	["path", { d: "M3.71 6.4a9.95 9.95 0 0 1 2.7-2.69" }],
	["circle", { cx: "12", cy: "12", r: "1" }],
] satisfies IconNode;

export const circleEllipsis = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M17 12h.01" }],
	["path", { d: "M12 12h.01" }],
	["path", { d: "M7 12h.01" }],
] satisfies IconNode;

export const circleEqual = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M7 10h10" }],
	["path", { d: "M7 14h10" }],
] satisfies IconNode;

export const circleEuro = [
	["path", { d: "M15 9.4a4 4 0 1 0 0 5.2" }],
	["path", { d: "M7 12h5" }],
	["circle", { cx: "12", cy: "12", r: "10" }],
] satisfies IconNode;

export const circleFadingArrowUp = [
	["path", { d: "M12 2a10 10 0 0 1 7.38 16.75" }],
	["path", { d: "m16 12-4-4-4 4" }],
	["path", { d: "M12 16V8" }],
	["path", { d: "M2.5 8.875a10 10 0 0 0-.5 3" }],
	["path", { d: "M2.83 16a10 10 0 0 0 2.43 3.4" }],
	["path", { d: "M4.636 5.235a10 10 0 0 1 .891-.857" }],
	["path", { d: "M8.644 21.42a10 10 0 0 0 7.631-.38" }],
] satisfies IconNode;

export const circleFadingPlay = [
	["path", { d: "M12 2a10 10 0 0 1 7.38 16.75" }],
	[
		"path",
		{
			d: "M9 9.003a1 1 0 0 1 1.517-.859l4.997 2.997a1 1 0 0 1 0 1.718l-4.997 2.997A1 1 0 0 1 9 14.996z",
		},
	],
	["path", { d: "M2.5 8.875a10 10 0 0 0-.5 3" }],
	["path", { d: "M2.83 16a10 10 0 0 0 2.43 3.4" }],
	["path", { d: "M4.636 5.235a10 10 0 0 1 .891-.857" }],
	["path", { d: "M8.644 21.42a10 10 0 0 0 7.631-.38" }],
] satisfies IconNode;

export const circleFadingPlus = [
	["path", { d: "M12 2a10 10 0 0 1 7.38 16.75" }],
	["path", { d: "M12 8v8" }],
	["path", { d: "M16 12H8" }],
	["path", { d: "M2.5 8.875a10 10 0 0 0-.5 3" }],
	["path", { d: "M2.83 16a10 10 0 0 0 2.43 3.4" }],
	["path", { d: "M4.636 5.235a10 10 0 0 1 .891-.857" }],
	["path", { d: "M8.644 21.42a10 10 0 0 0 7.631-.38" }],
] satisfies IconNode;

export const circleGauge = [
	["path", { d: "M15.6 2.7a10 10 0 1 0 5.7 5.7" }],
	["circle", { cx: "12", cy: "12", r: "2" }],
	["path", { d: "M13.4 10.6 19 5" }],
] satisfies IconNode;

export const circleMinus = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M8 12h8" }],
] satisfies IconNode;

export const circleOff = [
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M8.35 2.69A10 10 0 0 1 21.3 15.65" }],
	["path", { d: "M19.08 19.08A10 10 0 1 1 4.92 4.92" }],
] satisfies IconNode;

export const circleParking = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M9 17V7h4a3 3 0 0 1 0 6H9" }],
] satisfies IconNode;

export const circleParkingOff = [
	["path", { d: "M12.656 7H13a3 3 0 0 1 2.984 3.307" }],
	["path", { d: "M13 13H9" }],
	["path", { d: "M19.071 19.071A1 1 0 0 1 4.93 4.93" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M8.357 2.687a10 10 0 0 1 12.956 12.956" }],
	["path", { d: "M9 17V9" }],
] satisfies IconNode;

export const circlePause = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["line", { x1: "10", x2: "10", y1: "15", y2: "9" }],
	["line", { x1: "14", x2: "14", y1: "15", y2: "9" }],
] satisfies IconNode;

export const circlePercent = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "m15 9-6 6" }],
	["path", { d: "M9 9h.01" }],
	["path", { d: "M15 15h.01" }],
] satisfies IconNode;

export const circlePile = [
	["circle", { cx: "12", cy: "19", r: "2" }],
	["circle", { cx: "12", cy: "5", r: "2" }],
	["circle", { cx: "16", cy: "12", r: "2" }],
	["circle", { cx: "20", cy: "19", r: "2" }],
	["circle", { cx: "4", cy: "19", r: "2" }],
	["circle", { cx: "8", cy: "12", r: "2" }],
] satisfies IconNode;

export const circlePlay = [
	[
		"path",
		{
			d: "M9 9.003a1 1 0 0 1 1.517-.859l4.997 2.997a1 1 0 0 1 0 1.718l-4.997 2.997A1 1 0 0 1 9 14.996z",
		},
	],
	["circle", { cx: "12", cy: "12", r: "10" }],
] satisfies IconNode;

export const circlePlus = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M8 12h8" }],
	["path", { d: "M12 8v8" }],
] satisfies IconNode;

export const circlePoundSterling = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M10 16V9.5a1 1 0 0 1 5 0" }],
	["path", { d: "M8 12h4" }],
	["path", { d: "M8 16h7" }],
] satisfies IconNode;

export const circlePower = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M12 7v4" }],
	["path", { d: "M7.998 9.003a5 5 0 1 0 8-.005" }],
] satisfies IconNode;

export const circleQuestionMark = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" }],
	["path", { d: "M12 17h.01" }],
] satisfies IconNode;

export const circleSlash = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["line", { x1: "9", x2: "15", y1: "15", y2: "9" }],
] satisfies IconNode;

export const circleSlash2 = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M22 2 2 22" }],
] satisfies IconNode;

export const circleSmall = [["circle", { cx: "12", cy: "12", r: "6" }]] satisfies IconNode;

export const circleStar = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	[
		"path",
		{
			d: "M11.051 7.616a1 1 0 0 1 1.909.024l.737 1.452a1 1 0 0 0 .737.535l1.634.256a1 1 0 0 1 .588 1.806l-1.172 1.168a1 1 0 0 0-.282.866l.259 1.613a1 1 0 0 1-1.541 1.134l-1.465-.75a1 1 0 0 0-.912 0l-1.465.75a1 1 0 0 1-1.539-1.133l.258-1.613a1 1 0 0 0-.282-.867l-1.156-1.152a1 1 0 0 1 .572-1.822l1.633-.256a1 1 0 0 0 .737-.535z",
		},
	],
] satisfies IconNode;

export const circleStop = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["rect", { x: "9", y: "9", width: "6", height: "6", rx: "1" }],
] satisfies IconNode;

export const circleUser = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["circle", { cx: "12", cy: "10", r: "3" }],
	["path", { d: "M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662" }],
] satisfies IconNode;

export const circleUserRound = [
	["path", { d: "M17.925 20.056a6 6 0 0 0-11.851.001" }],
	["circle", { cx: "12", cy: "11", r: "4" }],
	["circle", { cx: "12", cy: "12", r: "10" }],
] satisfies IconNode;

export const circleX = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "m15 9-6 6" }],
	["path", { d: "m9 9 6 6" }],
] satisfies IconNode;

export const circuitBoard = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M11 9h4a2 2 0 0 0 2-2V3" }],
	["circle", { cx: "9", cy: "9", r: "2" }],
	["path", { d: "M7 21v-4a2 2 0 0 1 2-2h4" }],
	["circle", { cx: "15", cy: "15", r: "2" }],
] satisfies IconNode;

export const citrus = [
	[
		"path",
		{ d: "M21.66 17.67a1.08 1.08 0 0 1-.04 1.6A12 12 0 0 1 4.73 2.38a1.1 1.1 0 0 1 1.61-.04z" },
	],
	["path", { d: "M19.65 15.66A8 8 0 0 1 8.35 4.34" }],
	["path", { d: "m14 10-5.5 5.5" }],
	["path", { d: "M14 17.85V10H6.15" }],
] satisfies IconNode;

export const clapperboard = [
	["path", { d: "m12.296 3.464 3.02 3.956" }],
	["path", { d: "M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3z" }],
	["path", { d: "M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" }],
	["path", { d: "m6.18 5.276 3.1 3.899" }],
] satisfies IconNode;

export const clefAlto = [
	["path", { d: "M10 4v16" }],
	[
		"path",
		{
			d: "M14 4.764a3 3 0 1 1-.152 4.327A4 4 0 0 1 10 12a4 4 0 0 1 3.848 2.909A3 3 0 1 1 14 19.236",
		},
	],
	["path", { d: "M6 4v16" }],
] satisfies IconNode;

export const clefBass = [
	["path", { d: "M19 11h.01" }],
	["path", { d: "M19 6h.01" }],
	["path", { d: "M5 8c0-4 4-4 4-4 6 0 6 6 6 6 0 7-10 11-10 11" }],
	["circle", { cx: "7", cy: "8", r: "2" }],
] satisfies IconNode;

export const clefTreble = [
	[
		"path",
		{
			d: "M10.586 21.414a2 2 0 0 0 3.378-1.791L11.036 4.377a2 2 0 1 1 3.378 1.037C12.414 7.414 7 8 7 13a5 5 0 0 0 5 5 5 4 0 0 0 5-4 3 3 0 0 0-3-3 3 2 0 0 0-3 2",
		},
	],
] satisfies IconNode;

export const clipboard = [
	["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1" }],
	["path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" }],
] satisfies IconNode;

export const clipboardCheck = [
	["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1" }],
	["path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" }],
	["path", { d: "m9 14 2 2 4-4" }],
] satisfies IconNode;

export const clipboardClock = [
	["path", { d: "M16 14v2.2l1.6 1" }],
	["path", { d: "M16 4h2a2 2 0 0 1 2 2v.832" }],
	["path", { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2" }],
	["circle", { cx: "16", cy: "16", r: "6" }],
	["rect", { x: "8", y: "2", width: "8", height: "4", rx: "1" }],
] satisfies IconNode;

export const clipboardCopy = [
	["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1" }],
	["path", { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" }],
	["path", { d: "M16 4h2a2 2 0 0 1 2 2v4" }],
	["path", { d: "M21 14H11" }],
	["path", { d: "m15 10-4 4 4 4" }],
] satisfies IconNode;

export const clipboardList = [
	["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1" }],
	["path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" }],
	["path", { d: "M12 11h4" }],
	["path", { d: "M12 16h4" }],
	["path", { d: "M8 11h.01" }],
	["path", { d: "M8 16h.01" }],
] satisfies IconNode;

export const clipboardMinus = [
	["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1" }],
	["path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" }],
	["path", { d: "M9 14h6" }],
] satisfies IconNode;

export const clipboardPaste = [
	["path", { d: "M11 14h10" }],
	["path", { d: "M16 4h2a2 2 0 0 1 2 2v1.344" }],
	["path", { d: "m17 18 4-4-4-4" }],
	["path", { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 1.793-1.113" }],
	["rect", { x: "8", y: "2", width: "8", height: "4", rx: "1" }],
] satisfies IconNode;

export const clipboardPen = [
	["path", { d: "M16 4h2a2 2 0 0 1 2 2v2" }],
	[
		"path",
		{
			d: "M21.34 15.664a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
		},
	],
	["path", { d: "M8 22H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" }],
	["rect", { x: "8", y: "2", width: "8", height: "4", rx: "1" }],
] satisfies IconNode;

export const clipboardPenLine = [
	["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1" }],
	["path", { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-.5" }],
	["path", { d: "M16 4h2a2 2 0 0 1 1.73 1" }],
	["path", { d: "M8 18h1" }],
	[
		"path",
		{
			d: "M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
		},
	],
] satisfies IconNode;

export const clipboardPlus = [
	["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1" }],
	["path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" }],
	["path", { d: "M9 14h6" }],
	["path", { d: "M12 17v-6" }],
] satisfies IconNode;

export const clipboardType = [
	["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1" }],
	["path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" }],
	["path", { d: "M9 12v-1h6v1" }],
	["path", { d: "M11 17h2" }],
	["path", { d: "M12 11v6" }],
] satisfies IconNode;

export const clipboardX = [
	["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1" }],
	["path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" }],
	["path", { d: "m14.5 11.5-5 5" }],
	["path", { d: "m9.5 11.5 5 5" }],
] satisfies IconNode;

export const clock = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M12 6v6l4 2" }],
] satisfies IconNode;

export const clock1 = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M12 6v6l2-4" }],
] satisfies IconNode;

export const clock10 = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M12 6v6l-4-2" }],
] satisfies IconNode;

export const clock11 = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M12 6v6l-2-4" }],
] satisfies IconNode;

export const clock12 = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M12 6v6" }],
] satisfies IconNode;

export const clock2 = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M12 6v6l4-2" }],
] satisfies IconNode;

export const clock3 = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M12 6v6h4" }],
] satisfies IconNode;

export const clock4 = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M12 6v6l4 2" }],
] satisfies IconNode;

export const clock5 = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M12 6v6l2 4" }],
] satisfies IconNode;

export const clock6 = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M12 6v10" }],
] satisfies IconNode;

export const clock7 = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M12 6v6l-2 4" }],
] satisfies IconNode;

export const clock8 = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M12 6v6l-4 2" }],
] satisfies IconNode;

export const clock9 = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M12 6v6H8" }],
] satisfies IconNode;

export const clockAlert = [
	["path", { d: "M12 6v6l4 2" }],
	["path", { d: "M20 12v5" }],
	["path", { d: "M20 21h.01" }],
	["path", { d: "M21.25 8.2A10 10 0 1 0 16 21.16" }],
] satisfies IconNode;

export const clockArrowDown = [
	["path", { d: "M12 6v6l2 1" }],
	["path", { d: "M12.337 21.994a10 10 0 1 1 9.588-8.767" }],
	["path", { d: "m14 18 4 4 4-4" }],
	["path", { d: "M18 14v8" }],
] satisfies IconNode;

export const clockArrowLeft = [
	["path", { d: "M12 6v6l1.5.8" }],
	["path", { d: "M12.338 21.994a10 10 0 1 1 9.587-8.767" }],
	["path", { d: "M14 18h8" }],
	["path", { d: "m18 22-4-4 4-4" }],
] satisfies IconNode;

export const clockArrowRight = [
	["path", { d: "M12 6v6l2 1" }],
	["path", { d: "M13.5 21.885A10 10 0 1 1 22 12" }],
	["path", { d: "M14 18h8" }],
	["path", { d: "m18 22 4-4-4-4" }],
] satisfies IconNode;

export const clockArrowUp = [
	["path", { d: "M12 6v6l1.56.78" }],
	["path", { d: "M13.227 21.925a10 10 0 1 1 8.767-9.588" }],
	["path", { d: "m14 18 4-4 4 4" }],
	["path", { d: "M18 22v-8" }],
] satisfies IconNode;

export const clockCheck = [
	["path", { d: "M21.95 13a10 10 0 1 0-8.685 8.92" }],
	["path", { d: "M12 6v6l4 2" }],
	["path", { d: "m16 19 2 2 4-4" }],
] satisfies IconNode;

export const clockFading = [
	["path", { d: "M12 2a10 10 0 0 1 7.38 16.75" }],
	["path", { d: "M12 6v6l4 2" }],
	["path", { d: "M2.5 8.875a10 10 0 0 0-.5 3" }],
	["path", { d: "M2.83 16a10 10 0 0 0 2.43 3.4" }],
	["path", { d: "M4.636 5.235a10 10 0 0 1 .891-.857" }],
	["path", { d: "M8.644 21.42a10 10 0 0 0 7.631-.38" }],
] satisfies IconNode;

export const clockPlus = [
	["path", { d: "M12 6v6l3.644 1.822" }],
	["path", { d: "M16 19h6" }],
	["path", { d: "M19 16v6" }],
	["path", { d: "M21.92 13.267a10 10 0 1 0-8.653 8.653" }],
] satisfies IconNode;

export const closedCaption = [
	["path", { d: "M10 9.17a3 3 0 1 0 0 5.66" }],
	["path", { d: "M17 9.17a3 3 0 1 0 0 5.66" }],
	["rect", { x: "2", y: "5", width: "20", height: "14", rx: "2" }],
] satisfies IconNode;

export const cloud = [
	["path", { d: "M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z" }],
] satisfies IconNode;

export const cloudAlert = [
	["path", { d: "M12 12v4" }],
	["path", { d: "M12 20h.01" }],
	["path", { d: "M8.128 16.949A7 7 0 1 1 15.71 8h1.79a1 1 0 0 1 0 9h-1.642" }],
] satisfies IconNode;

export const cloudBackup = [
	["path", { d: "M21 15.251A4.5 4.5 0 0 0 17.5 8h-1.79A7 7 0 1 0 3 13.607" }],
	["path", { d: "M7 11v4h4" }],
	["path", { d: "M8 19a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5 4.82 4.82 0 0 0-3.41 1.41L7 15" }],
] satisfies IconNode;

export const cloudCheck = [
	["path", { d: "m17 15-5.5 5.5L9 18" }],
	["path", { d: "M5.516 16.07A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 3.501 7.327" }],
] satisfies IconNode;

export const cloudCog = [
	["path", { d: "m10.852 19.772-.383.924" }],
	["path", { d: "m13.148 14.228.383-.923" }],
	["path", { d: "M13.148 19.772a3 3 0 1 0-2.296-5.544l-.383-.923" }],
	["path", { d: "m13.53 20.696-.382-.924a3 3 0 1 1-2.296-5.544" }],
	["path", { d: "m14.772 15.852.923-.383" }],
	["path", { d: "m14.772 18.148.923.383" }],
	["path", { d: "M4.2 15.1a7 7 0 1 1 9.93-9.858A7 7 0 0 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.2" }],
	["path", { d: "m9.228 15.852-.923-.383" }],
	["path", { d: "m9.228 18.148-.923.383" }],
] satisfies IconNode;

export const cloudDownload = [
	["path", { d: "M12 13v8l-4-4" }],
	["path", { d: "m12 21 4-4" }],
	["path", { d: "M4.393 15.269A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.436 8.284" }],
] satisfies IconNode;

export const cloudDrizzle = [
	["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" }],
	["path", { d: "M8 19v1" }],
	["path", { d: "M8 14v1" }],
	["path", { d: "M16 19v1" }],
	["path", { d: "M16 14v1" }],
	["path", { d: "M12 21v1" }],
	["path", { d: "M12 16v1" }],
] satisfies IconNode;

export const cloudFog = [
	["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" }],
	["path", { d: "M16 17H7" }],
	["path", { d: "M17 21H9" }],
] satisfies IconNode;

export const cloudHail = [
	["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" }],
	["path", { d: "M16 14v2" }],
	["path", { d: "M8 14v2" }],
	["path", { d: "M16 20h.01" }],
	["path", { d: "M8 20h.01" }],
	["path", { d: "M12 16v2" }],
	["path", { d: "M12 22h.01" }],
] satisfies IconNode;

export const cloudLightning = [
	["path", { d: "M6 16.326A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 .5 8.973" }],
	["path", { d: "m13 12-3 5h4l-3 5" }],
] satisfies IconNode;

export const cloudMoon = [
	["path", { d: "M13 16a3 3 0 0 1 0 6H7a5 5 0 1 1 4.9-6z" }],
	[
		"path",
		{
			d: "M18.376 14.512a6 6 0 0 0 3.461-4.127c.148-.625-.659-.97-1.248-.714a4 4 0 0 1-5.259-5.26c.255-.589-.09-1.395-.716-1.248a6 6 0 0 0-4.594 5.36",
		},
	],
] satisfies IconNode;

export const cloudMoonRain = [
	["path", { d: "M11 20v2" }],
	[
		"path",
		{
			d: "M18.376 14.512a6 6 0 0 0 3.461-4.127c.148-.625-.659-.97-1.248-.714a4 4 0 0 1-5.259-5.26c.255-.589-.09-1.395-.716-1.248a6 6 0 0 0-4.594 5.36",
		},
	],
	["path", { d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24" }],
	["path", { d: "M7 19v2" }],
] satisfies IconNode;

export const cloudOff = [
	["path", { d: "M10.94 5.274A7 7 0 0 1 15.71 10h1.79a4.5 4.5 0 0 1 4.222 6.057" }],
	["path", { d: "M18.796 18.81A4.5 4.5 0 0 1 17.5 19H9A7 7 0 0 1 5.79 5.78" }],
	["path", { d: "m2 2 20 20" }],
] satisfies IconNode;

export const cloudRain = [
	["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" }],
	["path", { d: "M16 14v6" }],
	["path", { d: "M8 14v6" }],
	["path", { d: "M12 16v6" }],
] satisfies IconNode;

export const cloudRainWind = [
	["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" }],
	["path", { d: "m9.2 22 3-7" }],
	["path", { d: "m9 13-3 7" }],
	["path", { d: "m17 13-3 7" }],
] satisfies IconNode;

export const cloudSnow = [
	["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" }],
	["path", { d: "M8 15h.01" }],
	["path", { d: "M8 19h.01" }],
	["path", { d: "M12 17h.01" }],
	["path", { d: "M12 21h.01" }],
	["path", { d: "M16 15h.01" }],
	["path", { d: "M16 19h.01" }],
] satisfies IconNode;

export const cloudSun = [
	["path", { d: "M12 2v2" }],
	["path", { d: "m4.93 4.93 1.41 1.41" }],
	["path", { d: "M20 12h2" }],
	["path", { d: "m19.07 4.93-1.41 1.41" }],
	["path", { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128" }],
	["path", { d: "M13 22H7a5 5 0 1 1 4.9-6H13a3 3 0 0 1 0 6Z" }],
] satisfies IconNode;

export const cloudSunRain = [
	["path", { d: "M12 2v2" }],
	["path", { d: "m4.93 4.93 1.41 1.41" }],
	["path", { d: "M20 12h2" }],
	["path", { d: "m19.07 4.93-1.41 1.41" }],
	["path", { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128" }],
	["path", { d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24" }],
	["path", { d: "M11 20v2" }],
	["path", { d: "M7 19v2" }],
] satisfies IconNode;

export const cloudSync = [
	["path", { d: "m17 18-1.535 1.605a5 5 0 0 1-8-1.5" }],
	["path", { d: "M17 22v-4h-4" }],
	["path", { d: "M20.996 15.251A4.5 4.5 0 0 0 17.495 8h-1.79a7 7 0 1 0-12.709 5.607" }],
	["path", { d: "M7 10v4h4" }],
	["path", { d: "m7 14 1.535-1.605a5 5 0 0 1 8 1.5" }],
] satisfies IconNode;

export const cloudUpload = [
	["path", { d: "M12 13v8" }],
	["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" }],
	["path", { d: "m8 17 4-4 4 4" }],
] satisfies IconNode;

export const cloudy = [
	["path", { d: "M17.5 12a1 1 0 1 1 0 9H9.006a7 7 0 1 1 6.702-9z" }],
	["path", { d: "M21.832 9A3 3 0 0 0 19 7h-2.207a5.5 5.5 0 0 0-10.72.61" }],
] satisfies IconNode;

export const clover = [
	["path", { d: "M16.17 7.83 2 22" }],
	[
		"path",
		{
			d: "M4.02 12a2.827 2.827 0 1 1 3.81-4.17A2.827 2.827 0 1 1 12 4.02a2.827 2.827 0 1 1 4.17 3.81A2.827 2.827 0 1 1 19.98 12a2.827 2.827 0 1 1-3.81 4.17A2.827 2.827 0 1 1 12 19.98a2.827 2.827 0 1 1-4.17-3.81A1 1 0 1 1 4 12",
		},
	],
	["path", { d: "m7.83 7.83 8.34 8.34" }],
] satisfies IconNode;

export const club = [
	[
		"path",
		{ d: "M17.28 9.05a5.5 5.5 0 1 0-10.56 0A5.5 5.5 0 1 0 12 17.66a5.5 5.5 0 1 0 5.28-8.6Z" },
	],
	["path", { d: "M12 17.66L12 22" }],
] satisfies IconNode;

export const code = [
	["path", { d: "m16 18 6-6-6-6" }],
	["path", { d: "m8 6-6 6 6 6" }],
] satisfies IconNode;

export const codeXml = [
	["path", { d: "m18 16 4-4-4-4" }],
	["path", { d: "m6 8-4 4 4 4" }],
	["path", { d: "m14.5 4-5 16" }],
] satisfies IconNode;

export const coffee = [
	["path", { d: "M10 2v2" }],
	["path", { d: "M14 2v2" }],
	[
		"path",
		{
			d: "M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1",
		},
	],
	["path", { d: "M6 2v2" }],
] satisfies IconNode;

export const cog = [
	["path", { d: "M11 10.27 7 3.34" }],
	["path", { d: "m11 13.73-4 6.93" }],
	["path", { d: "M12 22v-2" }],
	["path", { d: "M12 2v2" }],
	["path", { d: "M14 12h8" }],
	["path", { d: "m17 20.66-1-1.73" }],
	["path", { d: "m17 3.34-1 1.73" }],
	["path", { d: "M2 12h2" }],
	["path", { d: "m20.66 17-1.73-1" }],
	["path", { d: "m20.66 7-1.73 1" }],
	["path", { d: "m3.34 17 1.73-1" }],
	["path", { d: "m3.34 7 1.73 1" }],
	["circle", { cx: "12", cy: "12", r: "2" }],
	["circle", { cx: "12", cy: "12", r: "8" }],
] satisfies IconNode;

export const coins = [
	["path", { d: "M13.744 17.736a6 6 0 1 1-7.48-7.48" }],
	["path", { d: "M15 6h1v4" }],
	["path", { d: "m6.134 14.768.866-.5 2 3.464" }],
	["circle", { cx: "16", cy: "8", r: "6" }],
] satisfies IconNode;

export const columns2 = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M12 3v18" }],
] satisfies IconNode;

export const columns3 = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M9 3v18" }],
	["path", { d: "M15 3v18" }],
] satisfies IconNode;

export const columns3Cog = [
	["path", { d: "M10.6 21H5a2 2 0 01-2-2V5a2 2 0 012-2h14a2 2 0 012 2v5.6" }],
	["path", { d: "m14.305 19.53.923-.382" }],
	["path", { d: "M15 3v7.6" }],
	["path", { d: "m15.229 16.852-.924-.383" }],
	["path", { d: "m16.852 15.228-.383-.923" }],
	["path", { d: "m16.852 20.772-.383.924" }],
	["path", { d: "m19.148 15.228.383-.923" }],
	["path", { d: "m19.53 21.696-.382-.924" }],
	["path", { d: "m20.773 16.852.922-.383" }],
	["path", { d: "m20.773 19.148.922.383" }],
	["path", { d: "M9 3v18" }],
	["circle", { cx: "18", cy: "18", r: "3" }],
] satisfies IconNode;

export const columns4 = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M7.5 3v18" }],
	["path", { d: "M12 3v18" }],
	["path", { d: "M16.5 3v18" }],
] satisfies IconNode;

export const combine = [
	["path", { d: "M14 3a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1" }],
	["path", { d: "M19 3a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1" }],
	["path", { d: "m7 15 3 3" }],
	["path", { d: "m7 21 3-3H5a2 2 0 0 1-2-2v-2" }],
	["rect", { x: "14", y: "14", width: "7", height: "7", rx: "1" }],
	["rect", { x: "3", y: "3", width: "7", height: "7", rx: "1" }],
] satisfies IconNode;

export const command = [
	["path", { d: "M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3" }],
] satisfies IconNode;

export const compass = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	[
		"path",
		{
			d: "m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z",
		},
	],
] satisfies IconNode;

export const component = [
	[
		"path",
		{
			d: "M15.536 11.293a1 1 0 0 0 0 1.414l2.376 2.377a1 1 0 0 0 1.414 0l2.377-2.377a1 1 0 0 0 0-1.414l-2.377-2.377a1 1 0 0 0-1.414 0z",
		},
	],
	[
		"path",
		{
			d: "M2.297 11.293a1 1 0 0 0 0 1.414l2.377 2.377a1 1 0 0 0 1.414 0l2.377-2.377a1 1 0 0 0 0-1.414L6.088 8.916a1 1 0 0 0-1.414 0z",
		},
	],
	[
		"path",
		{
			d: "M8.916 17.912a1 1 0 0 0 0 1.415l2.377 2.376a1 1 0 0 0 1.414 0l2.377-2.376a1 1 0 0 0 0-1.415l-2.377-2.376a1 1 0 0 0-1.414 0z",
		},
	],
	[
		"path",
		{
			d: "M8.916 4.674a1 1 0 0 0 0 1.414l2.377 2.376a1 1 0 0 0 1.414 0l2.377-2.376a1 1 0 0 0 0-1.414l-2.377-2.377a1 1 0 0 0-1.414 0z",
		},
	],
] satisfies IconNode;

export const computer = [
	["path", { d: "M12 18h6" }],
	["path", { d: "M6 18h.01" }],
	["path", { d: "M8 6h1" }],
	["rect", { x: "2", y: "14", width: "20", height: "8", rx: "2" }],
	["rect", { x: "4", y: "2", width: "16", height: "12", rx: "2" }],
] satisfies IconNode;

export const conciergeBell = [
	["path", { d: "M3 20a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1Z" }],
	["path", { d: "M20 16a8 8 0 1 0-16 0" }],
	["path", { d: "M12 4v4" }],
	["path", { d: "M10 4h4" }],
] satisfies IconNode;

export const cone = [
	["path", { d: "m20.9 18.55-8-15.98a1 1 0 0 0-1.8 0l-8 15.98" }],
	["ellipse", { cx: "12", cy: "19", rx: "9", ry: "3" }],
] satisfies IconNode;

export const construction = [
	["rect", { x: "2", y: "6", width: "20", height: "8", rx: "1" }],
	["path", { d: "M17 14v7" }],
	["path", { d: "M7 14v7" }],
	["path", { d: "M17 3v3" }],
	["path", { d: "M7 3v3" }],
	["path", { d: "M10 14 2.3 6.3" }],
	["path", { d: "m14 6 7.7 7.7" }],
	["path", { d: "m8 6 8 8" }],
] satisfies IconNode;

export const contact = [
	["path", { d: "M16 2v2" }],
	["path", { d: "M7 21v-2a2 2 0 012-2h6a2 2 0 012 2v2" }],
	["path", { d: "M8 2v2" }],
	["circle", { cx: "12", cy: "10", r: "3" }],
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
] satisfies IconNode;

export const contactRound = [
	["path", { d: "M16 2v2" }],
	["path", { d: "M17.915 21a6 6 0 10-12 0" }],
	["path", { d: "M8 2v2" }],
	["circle", { cx: "12", cy: "11", r: "4" }],
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
] satisfies IconNode;

export const container = [
	[
		"path",
		{
			d: "M22 7.7c0-.6-.4-1.2-.8-1.5l-6.3-3.9a1.72 1.72 0 0 0-1.7 0l-10.3 6c-.5.2-.9.8-.9 1.4v6.6c0 .5.4 1.2.8 1.5l6.3 3.9a1.72 1.72 0 0 0 1.7 0l10.3-6c.5-.3.9-1 .9-1.5Z",
		},
	],
	["path", { d: "M10 21.9V14L2.1 9.1" }],
	["path", { d: "m10 14 11.9-6.9" }],
	["path", { d: "M14 19.8v-8.1" }],
	["path", { d: "M18 17.5V9.4" }],
] satisfies IconNode;

export const contrast = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M12 18a6 6 0 0 0 0-12v12z" }],
] satisfies IconNode;

export const cookie = [
	["path", { d: "M11 17h.01" }],
	[
		"path",
		{
			d: "M11.496 2c.324-.016.558.292.529.615a4 4 0 004.235 4.368.713.713 0 01.758.757 4 4 0 004.366 4.237c.323-.03.63.204.614.527a10 10 0 01-2.915 6.566A1 1 0 114.93 4.918 10 10 0 0111.496 2",
		},
	],
	["path", { d: "M12 12h.01" }],
	["path", { d: "M16 16h.01" }],
	["path", { d: "M16 3h.01" }],
	["path", { d: "M21 4h.01" }],
	["path", { d: "M21 8h.01" }],
	["path", { d: "M7 14h.01" }],
	["path", { d: "M9 8h.01" }],
] satisfies IconNode;

export const cookingPot = [
	["path", { d: "M2 12h20" }],
	["path", { d: "M20 12v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8" }],
	["path", { d: "m4 8 16-4" }],
	["path", { d: "m8.86 6.78-.45-1.81a2 2 0 0 1 1.45-2.43l1.94-.48a2 2 0 0 1 2.43 1.46l.45 1.8" }],
] satisfies IconNode;

export const copy = [
	["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2" }],
	["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" }],
] satisfies IconNode;

export const copyCheck = [
	["path", { d: "m12 15 2 2 4-4" }],
	["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2" }],
	["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" }],
] satisfies IconNode;

export const copyMinus = [
	["line", { x1: "12", x2: "18", y1: "15", y2: "15" }],
	["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2" }],
	["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" }],
] satisfies IconNode;

export const copyPlus = [
	["line", { x1: "15", x2: "15", y1: "12", y2: "18" }],
	["line", { x1: "12", x2: "18", y1: "15", y2: "15" }],
	["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2" }],
	["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" }],
] satisfies IconNode;

export const copySlash = [
	["line", { x1: "12", x2: "18", y1: "18", y2: "12" }],
	["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2" }],
	["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" }],
] satisfies IconNode;

export const copyX = [
	["path", { d: "M4 16a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2" }],
	["rect", { x: "8", y: "8", width: "14", height: "14", rx: "2" }],
	["path", { d: "m12.5 12.5 5 5" }],
	["path", { d: "m12.5 17.5 5-5" }],
] satisfies IconNode;

export const copyleft = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M9.17 14.83a4 4 0 1 0 0-5.66" }],
] satisfies IconNode;

export const copyright = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M14.83 14.83a4 4 0 1 1 0-5.66" }],
] satisfies IconNode;

export const cornerDownLeft = [
	["path", { d: "M20 4v7a4 4 0 0 1-4 4H4" }],
	["path", { d: "m9 10-5 5 5 5" }],
] satisfies IconNode;

export const cornerDownRight = [
	["path", { d: "m15 10 5 5-5 5" }],
	["path", { d: "M4 4v7a4 4 0 0 0 4 4h12" }],
] satisfies IconNode;

export const cornerLeftDown = [
	["path", { d: "m14 15-5 5-5-5" }],
	["path", { d: "M20 4h-7a4 4 0 0 0-4 4v12" }],
] satisfies IconNode;

export const cornerLeftUp = [
	["path", { d: "M14 9 9 4 4 9" }],
	["path", { d: "M20 20h-7a4 4 0 0 1-4-4V4" }],
] satisfies IconNode;

export const cornerRightDown = [
	["path", { d: "m10 15 5 5 5-5" }],
	["path", { d: "M4 4h7a4 4 0 0 1 4 4v12" }],
] satisfies IconNode;

export const cornerRightUp = [
	["path", { d: "m10 9 5-5 5 5" }],
	["path", { d: "M4 20h7a4 4 0 0 0 4-4V4" }],
] satisfies IconNode;

export const cornerUpLeft = [
	["path", { d: "M20 20v-7a4 4 0 0 0-4-4H4" }],
	["path", { d: "M9 14 4 9l5-5" }],
] satisfies IconNode;

export const cornerUpRight = [
	["path", { d: "m15 14 5-5-5-5" }],
	["path", { d: "M4 20v-7a4 4 0 0 1 4-4h12" }],
] satisfies IconNode;

export const cpu = [
	["path", { d: "M12 20v2" }],
	["path", { d: "M12 2v2" }],
	["path", { d: "M17 20v2" }],
	["path", { d: "M17 2v2" }],
	["path", { d: "M2 12h2" }],
	["path", { d: "M2 17h2" }],
	["path", { d: "M2 7h2" }],
	["path", { d: "M20 12h2" }],
	["path", { d: "M20 17h2" }],
	["path", { d: "M20 7h2" }],
	["path", { d: "M7 20v2" }],
	["path", { d: "M7 2v2" }],
	["rect", { x: "4", y: "4", width: "16", height: "16", rx: "2" }],
	["rect", { x: "8", y: "8", width: "8", height: "8", rx: "1" }],
] satisfies IconNode;

export const cpuAi = [
	["path", { d: "M12 20v2" }],
	["path", { d: "M12 2v2" }],
	["path", { d: "M16 9v6" }],
	["path", { d: "M17 20v2" }],
	["path", { d: "M17 2v2" }],
	["path", { d: "M2 12h2" }],
	["path", { d: "M2 17h2" }],
	["path", { d: "M2 7h2" }],
	["path", { d: "M20 12h2" }],
	["path", { d: "M20 17h2" }],
	["path", { d: "M20 7h2" }],
	["path", { d: "M7 20v2" }],
	["path", { d: "M7 2v2" }],
	["path", { d: "M8 13h4" }],
	["path", { d: "M8 15v-4a2 2 0 014 0v4" }],
	["rect", { x: "4", y: "4", width: "16", height: "16", rx: "2" }],
] satisfies IconNode;

export const creativeCommons = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M10 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1" }],
	["path", { d: "M17 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1" }],
] satisfies IconNode;

export const creditCard = [
	["rect", { width: "20", height: "14", x: "2", y: "5", rx: "2" }],
	["line", { x1: "2", x2: "22", y1: "10", y2: "10" }],
	["path", { d: "M6 14h2" }],
] satisfies IconNode;

export const creditCardCheck = [
	["path", { d: "M12.5 19H4a2 2 0 01-2-2V7a2 2 0 012-2h16a2 2 0 012 2v4" }],
	["path", { d: "M2 10h20" }],
	["path", { d: "M6 14h2" }],
	["path", { d: "m16 17 2 2 4-4" }],
] satisfies IconNode;

export const creditCardMinus = [
	["path", { d: "M22 13V7a2 2 0 00-2-2H4a2 2 0 00-2 2v10a2 2 0 002 2h8.536" }],
	["path", { d: "M22 10H2" }],
	["path", { d: "M6 14h2" }],
	["path", { d: "M16 17h6" }],
] satisfies IconNode;

export const creditCardPlus = [
	["path", { d: "M22 11.354V7a2 2 0 00-2-2H4a2 2 0 00-2 2v10a2 2 0 002 2h8.536" }],
	["path", { d: "M22 10H2" }],
	["path", { d: "M6 14h2" }],
	["path", { d: "M16 17h6" }],
	["path", { d: "M19 14v6" }],
] satisfies IconNode;

export const creditCardReader = [
	["path", { d: "M15 16v1" }],
	[
		"path",
		{
			d: "M16.963 7.734A1 1 0 0015.999 7H8.003a1 1 0 00-.964.734L4.073 18.467A2 2 0 006 21h12a2 2 0 001.927-2.532z",
		},
	],
	["path", { d: "M2.678 8.5A2 2 0 012 7V5a2 2 0 012-2h16a2 2 0 012 2v2a2 2 0 01-.676 1.499" }],
	["path", { d: "m9 21 2-14" }],
] satisfies IconNode;

export const creditCardX = [
	["path", { d: "M12.5 19H4a2 2 0 01-2-2V7a2 2 0 012-2h16a2 2 0 012 2v3.5" }],
	["path", { d: "M2 10h20" }],
	["path", { d: "M6 14h2" }],
	["path", { d: "m16.5 14.5 5 5" }],
	["path", { d: "m21.5 14.5-5 5" }],
] satisfies IconNode;

export const croissant = [
	["path", { d: "M10.2 18H4.774a1.5 1.5 0 0 1-1.352-.97 11 11 0 0 1 .132-6.487" }],
	["path", { d: "M18 10.2V4.774a1.5 1.5 0 0 0-.97-1.352 11 11 0 0 0-6.486.132" }],
	["path", { d: "M18 5a4 3 0 0 1 4 3 2 2 0 0 1-2 2 10 10 0 0 0-5.139 1.42" }],
	["path", { d: "M5 18a3 4 0 0 0 3 4 2 2 0 0 0 2-2 10 10 0 0 1 1.42-5.14" }],
	[
		"path",
		{
			d: "M8.709 2.554a10 10 0 0 0-6.155 6.155 1.5 1.5 0 0 0 .676 1.626l9.807 5.42a2 2 0 0 0 2.718-2.718l-5.42-9.807a1.5 1.5 0 0 0-1.626-.676",
		},
	],
] satisfies IconNode;

export const crop = [
	["path", { d: "M6 2v14a2 2 0 0 0 2 2h14" }],
	["path", { d: "M18 22V8a2 2 0 0 0-2-2H2" }],
] satisfies IconNode;

export const cross = [
	[
		"path",
		{
			d: "M4 9a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h4a1 1 0 0 1 1 1v4a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-4a1 1 0 0 1 1-1h4a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-4a1 1 0 0 1-1-1V4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4a1 1 0 0 1-1 1z",
		},
	],
] satisfies IconNode;

export const crosshair = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["line", { x1: "22", x2: "18", y1: "12", y2: "12" }],
	["line", { x1: "6", x2: "2", y1: "12", y2: "12" }],
	["line", { x1: "12", x2: "12", y1: "6", y2: "2" }],
	["line", { x1: "12", x2: "12", y1: "22", y2: "18" }],
] satisfies IconNode;

export const crown = [
	[
		"path",
		{
			d: "M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z",
		},
	],
	["path", { d: "M5 21h14" }],
] satisfies IconNode;

export const cuboid = [
	["path", { d: "M10 22v-8" }],
	["path", { d: "M2.336 8.89 10 14l11.715-7.029" }],
	[
		"path",
		{
			d: "M22 14a2 2 0 0 1-.971 1.715l-10 6a2 2 0 0 1-2.138-.05l-6-4A2 2 0 0 1 2 16v-6a2 2 0 0 1 .971-1.715l10-6a2 2 0 0 1 2.138.05l6 4A2 2 0 0 1 22 8z",
		},
	],
] satisfies IconNode;

export const cupSoda = [
	["path", { d: "m6 8 1.75 12.28a2 2 0 0 0 2 1.72h4.54a2 2 0 0 0 2-1.72L18 8" }],
	["path", { d: "M5 8h14" }],
	["path", { d: "M7 15a6.47 6.47 0 0 1 5 0 6.47 6.47 0 0 0 5 0" }],
	["path", { d: "m12 8 1-6h2" }],
] satisfies IconNode;

export const cupcake = [
	["path", { d: "M12 22v-9" }],
	["path", { d: "M14 4h1a3 3 0 013 3l-.004.125A4 4 0 0121 11v2" }],
	["path", { d: "m15.5 22 1.5-9" }],
	[
		"path",
		{
			d: "M21 13a1 1 0 01.919 1.394l-2.74 6.394A2 2 0 0117.34 22H6.659a2 2 0 01-1.838-1.212l-2.74-6.394A1 1 0 013 13z",
		},
	],
	["path", { d: "M3 13v-2a4 4 0 013.003-3.875L6 7a3 3 0 013-3h1" }],
	["path", { d: "M8.5 22 7 13" }],
	["circle", { cx: "12", cy: "4", r: "2" }],
] satisfies IconNode;

export const currency = [
	["circle", { cx: "12", cy: "12", r: "8" }],
	["line", { x1: "3", x2: "6", y1: "3", y2: "6" }],
	["line", { x1: "21", x2: "18", y1: "3", y2: "6" }],
	["line", { x1: "3", x2: "6", y1: "21", y2: "18" }],
	["line", { x1: "21", x2: "18", y1: "21", y2: "18" }],
] satisfies IconNode;

export const cylinder = [
	["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3" }],
	["path", { d: "M3 5v14a9 3 0 0 0 18 0V5" }],
] satisfies IconNode;

export const dam = [
	["path", { d: "M11 11.31c1.17.56 1.54 1.69 3.5 1.69 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1" }],
	["path", { d: "M11.75 18c.35.5 1.45 1 2.75 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1" }],
	["path", { d: "M2 10h4" }],
	["path", { d: "M2 14h4" }],
	["path", { d: "M2 18h4" }],
	["path", { d: "M2 6h4" }],
	["path", { d: "M7 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1L10 4a1 1 0 0 0-1-1z" }],
] satisfies IconNode;

export const database = [
	["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3" }],
	["path", { d: "M3 5V19A9 3 0 0 0 21 19V5" }],
	["path", { d: "M3 12A9 3 0 0 0 21 12" }],
] satisfies IconNode;

export const databaseArrowDown = [
	["path", { d: "m16 19 3 3 3-3" }],
	["path", { d: "M19 16v6" }],
	["path", { d: "M21 12.536V5" }],
	["path", { d: "M3 12A9 3 0 0 0 15.182 14.806" }],
	["path", { d: "M3 5V19A9 3 0 0 0 13.318 21.968" }],
	["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3" }],
] satisfies IconNode;

export const databaseArrowUp = [
	["path", { d: "M19 22v-6" }],
	["path", { d: "M21 12.536V5" }],
	["path", { d: "m22 19-3-3-3 3" }],
	["path", { d: "M3 12A9 3 0 0 0 14.457 14.886" }],
	["path", { d: "M3 5V19A9 3 0 0 0 13.318 21.968" }],
	["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3" }],
] satisfies IconNode;

export const databaseBackup = [
	["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3" }],
	["path", { d: "M3 12a9 3 0 0 0 5 2.69" }],
	["path", { d: "M21 9.3V5" }],
	["path", { d: "M3 5v14a9 3 0 0 0 6.47 2.88" }],
	["path", { d: "M12 12v4h4" }],
	["path", { d: "M13 20a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L12 16" }],
] satisfies IconNode;

export const databaseCheck = [
	["path", { d: "m16 19 2 2 4-4" }],
	["path", { d: "M21 13.127V5" }],
	["path", { d: "M3 12A9 3 0 0 0 21 12" }],
	["path", { d: "M3 5V19A9 3 0 0 0 13.318 21.968" }],
	["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3" }],
] satisfies IconNode;

export const databaseMinus = [
	["path", { d: "M21 15V5" }],
	["path", { d: "M22 19h-6" }],
	["path", { d: "M3 12A9 3 0 0 0 21 12" }],
	["path", { d: "M3 5V19A9 3 0 0 0 13.318 21.968" }],
	["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3" }],
] satisfies IconNode;

export const databasePlus = [
	["path", { d: "M19 16v6" }],
	["path", { d: "M21 12.536V5" }],
	["path", { d: "M22 19h-6" }],
	["path", { d: "M3 12A9 3 0 0 0 15.1824 14.8061" }],
	["path", { d: "M3 5V19A9 3 0 0 0 13.318 21.968" }],
	["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3" }],
] satisfies IconNode;

export const databaseSearch = [
	["path", { d: "M21 11.693V5" }],
	["path", { d: "m22 22-1.875-1.875" }],
	["path", { d: "M3 12a9 3 0 0 0 8.697 2.998" }],
	["path", { d: "M3 5v14a9 3 0 0 0 9.28 2.999" }],
	["circle", { cx: "18", cy: "18", r: "3" }],
	["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3" }],
] satisfies IconNode;

export const databaseX = [
	["path", { d: "m17 17 5 5" }],
	["path", { d: "M19.323 13.744A9 3 0 0 0 21 12" }],
	["path", { d: "M21 13.127V5" }],
	["path", { d: "m22 17-5 5" }],
	["path", { d: "M3 12A9 3 0 0 0 13.563 14.954" }],
	["path", { d: "M3 5V19A9 3 0 0 0 13 21.981" }],
	["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3" }],
] satisfies IconNode;

export const databaseZap = [
	["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3" }],
	["path", { d: "M3 5V19A9 3 0 0 0 15 21.84" }],
	["path", { d: "M21 5V8" }],
	["path", { d: "M21 12L18 17H22L19 22" }],
	["path", { d: "M3 12A9 3 0 0 0 14.59 14.87" }],
] satisfies IconNode;

export const decimalsArrowLeft = [
	["path", { d: "m13 21-3-3 3-3" }],
	["path", { d: "M20 18H10" }],
	["path", { d: "M3 11h.01" }],
	["rect", { x: "6", y: "3", width: "5", height: "8", rx: "2.5" }],
] satisfies IconNode;

export const decimalsArrowRight = [
	["path", { d: "M10 18h10" }],
	["path", { d: "m17 21 3-3-3-3" }],
	["path", { d: "M3 11h.01" }],
	["rect", { x: "15", y: "3", width: "5", height: "8", rx: "2.5" }],
	["rect", { x: "6", y: "3", width: "5", height: "8", rx: "2.5" }],
] satisfies IconNode;

export const deleteNode = [
	[
		"path",
		{
			d: "M10 5a2 2 0 0 0-1.344.519l-6.328 5.74a1 1 0 0 0 0 1.481l6.328 5.741A2 2 0 0 0 10 19h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z",
		},
	],
	["path", { d: "m12 9 6 6" }],
	["path", { d: "m18 9-6 6" }],
] satisfies IconNode;

export const dessert = [
	[
		"path",
		{
			d: "M10.162 3.167A10 10 0 0 0 2 13a2 2 0 0 0 4 0v-1a2 2 0 0 1 4 0v4a2 2 0 0 0 4 0v-4a2 2 0 0 1 4 0v1a2 2 0 0 0 4-.006 10 10 0 0 0-8.161-9.826",
		},
	],
	["path", { d: "M20.804 14.869a9 9 0 0 1-17.608 0" }],
	["circle", { cx: "12", cy: "4", r: "2" }],
] satisfies IconNode;

export const diameter = [
	["circle", { cx: "19", cy: "19", r: "2" }],
	["circle", { cx: "5", cy: "5", r: "2" }],
	["path", { d: "M6.48 3.66a10 10 0 0 1 13.86 13.86" }],
	["path", { d: "m6.41 6.41 11.18 11.18" }],
	["path", { d: "M3.66 6.48a10 10 0 0 0 13.86 13.86" }],
] satisfies IconNode;

export const diamond = [
	[
		"path",
		{
			d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41l-7.59-7.59a2.41 2.41 0 0 0-3.41 0Z",
		},
	],
] satisfies IconNode;

export const diamondMinus = [
	[
		"path",
		{
			d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0z",
		},
	],
	["path", { d: "M8 12h8" }],
] satisfies IconNode;

export const diamondPercent = [
	[
		"path",
		{
			d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0Z",
		},
	],
	["path", { d: "M9.2 9.2h.01" }],
	["path", { d: "m14.5 9.5-5 5" }],
	["path", { d: "M14.7 14.8h.01" }],
] satisfies IconNode;

export const diamondPlus = [
	["path", { d: "M12 8v8" }],
	[
		"path",
		{
			d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0z",
		},
	],
	["path", { d: "M8 12h8" }],
] satisfies IconNode;

export const dice1 = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
	["path", { d: "M12 12h.01" }],
] satisfies IconNode;

export const dice2 = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
	["path", { d: "M15 9h.01" }],
	["path", { d: "M9 15h.01" }],
] satisfies IconNode;

export const dice3 = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
	["path", { d: "M16 8h.01" }],
	["path", { d: "M12 12h.01" }],
	["path", { d: "M8 16h.01" }],
] satisfies IconNode;

export const dice4 = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
	["path", { d: "M16 8h.01" }],
	["path", { d: "M8 8h.01" }],
	["path", { d: "M8 16h.01" }],
	["path", { d: "M16 16h.01" }],
] satisfies IconNode;

export const dice5 = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
	["path", { d: "M16 8h.01" }],
	["path", { d: "M8 8h.01" }],
	["path", { d: "M8 16h.01" }],
	["path", { d: "M16 16h.01" }],
	["path", { d: "M12 12h.01" }],
] satisfies IconNode;

export const dice6 = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
	["path", { d: "M16 8h.01" }],
	["path", { d: "M16 12h.01" }],
	["path", { d: "M16 16h.01" }],
	["path", { d: "M8 8h.01" }],
	["path", { d: "M8 12h.01" }],
	["path", { d: "M8 16h.01" }],
] satisfies IconNode;

export const dices = [
	["rect", { width: "12", height: "12", x: "2", y: "10", rx: "2", ry: "2" }],
	["path", { d: "m17.92 14 3.5-3.5a2.24 2.24 0 0 0 0-3l-5-4.92a2.24 2.24 0 0 0-3 0L10 6" }],
	["path", { d: "M6 18h.01" }],
	["path", { d: "M10 14h.01" }],
	["path", { d: "M15 6h.01" }],
	["path", { d: "M18 9h.01" }],
] satisfies IconNode;

export const diff = [
	["path", { d: "M12 3v14" }],
	["path", { d: "M5 10h14" }],
	["path", { d: "M5 21h14" }],
] satisfies IconNode;

export const disc = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["circle", { cx: "12", cy: "12", r: "2" }],
] satisfies IconNode;

export const disc2 = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["circle", { cx: "12", cy: "12", r: "4" }],
	["path", { d: "M12 12h.01" }],
] satisfies IconNode;

export const disc3 = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M6 12c0-1.7.7-3.2 1.8-4.2" }],
	["circle", { cx: "12", cy: "12", r: "2" }],
	["path", { d: "M18 12c0 1.7-.7 3.2-1.8 4.2" }],
] satisfies IconNode;

export const discAlbum = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["circle", { cx: "12", cy: "12", r: "5" }],
	["path", { d: "M12 12h.01" }],
] satisfies IconNode;

export const divide = [
	["circle", { cx: "12", cy: "6", r: "1" }],
	["line", { x1: "5", x2: "19", y1: "12", y2: "12" }],
	["circle", { cx: "12", cy: "18", r: "1" }],
] satisfies IconNode;

export const dna = [
	["path", { d: "m10 16 1.5 1.5" }],
	["path", { d: "m14 8-1.5-1.5" }],
	["path", { d: "M15 2c-1.798 1.998-2.518 3.995-2.807 5.993" }],
	["path", { d: "m16.5 10.5 1 1" }],
	["path", { d: "m17 6-2.891-2.891" }],
	["path", { d: "M2 15c6.667-6 13.333 0 20-6" }],
	["path", { d: "m20 9 .891.891" }],
	["path", { d: "M3.109 14.109 4 15" }],
	["path", { d: "m6.5 12.5 1 1" }],
	["path", { d: "m7 18 2.891 2.891" }],
	["path", { d: "M9 22c1.798-1.998 2.518-3.995 2.807-5.993" }],
] satisfies IconNode;

export const dnaOff = [
	["path", { d: "M15 2c-1.35 1.5-2.092 3-2.5 4.5L14 8" }],
	["path", { d: "m17 6-2.891-2.891" }],
	["path", { d: "M2 15c3.333-3 6.667-3 10-3" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "m20 9 .891.891" }],
	["path", { d: "M22 9c-1.5 1.35-3 2.092-4.5 2.5l-1-1" }],
	["path", { d: "M3.109 14.109 4 15" }],
	["path", { d: "m6.5 12.5 1 1" }],
	["path", { d: "m7 18 2.891 2.891" }],
	["path", { d: "M9 22c1.35-1.5 2.092-3 2.5-4.5L10 16" }],
] satisfies IconNode;

export const dock = [
	["path", { d: "M2 8h20" }],
	["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2" }],
	["path", { d: "M6 16h12" }],
] satisfies IconNode;

export const dog = [
	["path", { d: "M11.25 16.25h1.5L12 17z" }],
	["path", { d: "M16 14v.5" }],
	[
		"path",
		{
			d: "M4.42 11.247A13.152 13.152 0 0 0 4 14.556C4 18.728 7.582 21 12 21s8-2.272 8-6.444a11.702 11.702 0 0 0-.493-3.309",
		},
	],
	["path", { d: "M8 14v.5" }],
	[
		"path",
		{
			d: "M8.5 8.5c-.384 1.05-1.083 2.028-2.344 2.5-1.931.722-3.576-.297-3.656-1-.113-.994 1.177-6.53 4-7 1.923-.321 3.651.845 3.651 2.235A7.497 7.497 0 0 1 14 5.277c0-1.39 1.844-2.598 3.767-2.277 2.823.47 4.113 6.006 4 7-.08.703-1.725 1.722-3.656 1-1.261-.472-1.855-1.45-2.239-2.5",
		},
	],
] satisfies IconNode;

export const dollarSign = [
	["line", { x1: "12", x2: "12", y1: "2", y2: "22" }],
	["path", { d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" }],
] satisfies IconNode;

export const dome = [
	["path", { d: "M10 21v-3a2 2 0 014 0v3" }],
	["path", { d: "M12 2v2" }],
	["path", { d: "M18 12v9" }],
	["path", { d: "M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2v-6a1 1 0 011-1h18a1 1 0 011 1z" }],
	["path", { d: "M4 12a8 8 0 0116 0" }],
	["path", { d: "M6 12v9" }],
] satisfies IconNode;

export const donut = [
	[
		"path",
		{
			d: "M20.5 10a2.5 2.5 0 0 1-2.4-3H18a2.95 2.95 0 0 1-2.6-4.4 10 10 0 1 0 6.3 7.1c-.3.2-.8.3-1.2.3",
		},
	],
	["circle", { cx: "12", cy: "12", r: "3" }],
] satisfies IconNode;

export const doorClosed = [
	["path", { d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16" }],
	["path", { d: "M2 21h20" }],
	["path", { d: "M9 12h.01" }],
] satisfies IconNode;

export const doorClosedCog = [
	["path", { d: "m14.305 19.53.923-.382" }],
	["path", { d: "m15.229 16.852-.924-.383" }],
	["path", { d: "m16.852 15.228-.383-.923" }],
	["path", { d: "m16.852 20.773-.383.924" }],
	["path", { d: "M19 10.35V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16" }],
	["path", { d: "m19.148 15.228.383-.923" }],
	["path", { d: "m19.53 21.697-.382-.924" }],
	["path", { d: "M2 21h8.58" }],
	["path", { d: "m20.773 16.852.922-.383" }],
	["path", { d: "m20.773 19.148.922.383" }],
	["path", { d: "M9 12h.01" }],
	["circle", { cx: "18", cy: "18", r: "3" }],
] satisfies IconNode;

export const doorClosedLocked = [
	["path", { d: "M19 8V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16" }],
	["path", { d: "M2 21h8" }],
	["path", { d: "M20 16v-2a2 2 0 00-4 0v2" }],
	["path", { d: "M9 12h.01" }],
	["rect", { x: "14", y: "16", width: "8", height: "5", rx: "1" }],
] satisfies IconNode;

export const doorClosedPackage = [
	["path", { d: "M18 13v3" }],
	["path", { d: "M19 9V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16" }],
	["path", { d: "M2 21h8" }],
	["path", { d: "M9 12h.01" }],
	["rect", { x: "14", y: "13", width: "8", height: "8", rx: "1" }],
] satisfies IconNode;

export const doorOpen = [
	["path", { d: "M10 21H2" }],
	["path", { d: "M10 3H7a2 2 0 00-2 2v16" }],
	["path", { d: "M14 12h.01" }],
	["path", { d: "M19 21V5a2 2 0 00-1.675-1.974l-6.163-1.013A1 1 0 0010 3v18a1 1 0 001.124.992z" }],
	["path", { d: "M22 21h-3" }],
] satisfies IconNode;

export const doorStairwell = [
	["path", { d: "M12 17v-3a1 1 0 011-1h6" }],
	["path", { d: "M19 17h-9a1 1 0 00-1 1v3" }],
	["path", { d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16" }],
	["path", { d: "M19 9h-3a1 1 0 00-1 1v3" }],
	["path", { d: "M22 21H2" }],
] satisfies IconNode;

export const dot = [["circle", { cx: "12", cy: "12", r: "1" }]] satisfies IconNode;

export const download = [
	["path", { d: "M12 15V3" }],
	["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }],
	["path", { d: "m7 10 5 5 5-5" }],
] satisfies IconNode;

export const draftingCompass = [
	["path", { d: "m12.99 6.74 1.93 3.44" }],
	["path", { d: "M19.136 12a10 10 0 0 1-14.271 0" }],
	["path", { d: "m21 21-2.16-3.84" }],
	["path", { d: "m3 21 8.02-14.26" }],
	["circle", { cx: "12", cy: "5", r: "2" }],
] satisfies IconNode;

export const drama = [
	["path", { d: "M10 11h.01" }],
	["path", { d: "M14 6h.01" }],
	["path", { d: "M18 6h.01" }],
	["path", { d: "M6.5 13.1h.01" }],
	["path", { d: "M22 5c0 9-4 12-6 12s-6-3-6-12c0-2 2-3 6-3s6 1 6 3" }],
	["path", { d: "M17.4 9.9c-.8.8-2 .8-2.8 0" }],
	[
		"path",
		{
			d: "M10.1 7.1C9 7.2 7.7 7.7 6 8.6c-3.5 2-4.7 3.9-3.7 5.6 4.5 7.8 9.5 8.4 11.2 7.4.9-.5 1.9-2.1 1.9-4.7",
		},
	],
	["path", { d: "M9.1 16.5c.3-1.1 1.4-1.7 2.4-1.4" }],
] satisfies IconNode;

export const drill = [
	["path", { d: "M10 18a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a3 3 0 0 1-3-3 1 1 0 0 1 1-1z" }],
	[
		"path",
		{
			d: "M13 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1l-.81 3.242a1 1 0 0 1-.97.758H8",
		},
	],
	["path", { d: "M14 4h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3" }],
	["path", { d: "M18 6h4" }],
	["path", { d: "m5 10-2 8" }],
	["path", { d: "m7 18 2-8" }],
] satisfies IconNode;

export const drone = [
	["path", { d: "M10 10 7 7" }],
	["path", { d: "m10 14-3 3" }],
	["path", { d: "m14 10 3-3" }],
	["path", { d: "m14 14 3 3" }],
	["path", { d: "M14.205 4.139a4 4 0 1 1 5.439 5.863" }],
	["path", { d: "M19.637 14a4 4 0 1 1-5.432 5.868" }],
	["path", { d: "M4.367 10a4 4 0 1 1 5.438-5.862" }],
	["path", { d: "M9.795 19.862a4 4 0 1 1-5.429-5.873" }],
	["rect", { x: "10", y: "8", width: "4", height: "8", rx: "1" }],
] satisfies IconNode;

export const droplet = [
	[
		"path",
		{
			d: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z",
		},
	],
] satisfies IconNode;

export const dropletOff = [
	[
		"path",
		{
			d: "M18.715 13.186C18.29 11.858 17.384 10.607 16 9.5c-2-1.6-3.5-4-4-6.5a10.7 10.7 0 0 1-.884 2.586",
		},
	],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M8.795 8.797A11 11 0 0 1 8 9.5C6 11.1 5 13 5 15a7 7 0 0 0 13.222 3.208" }],
] satisfies IconNode;

export const droplets = [
	[
		"path",
		{
			d: "M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z",
		},
	],
	[
		"path",
		{
			d: "M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97",
		},
	],
] satisfies IconNode;

export const drum = [
	["path", { d: "m2 2 8 8" }],
	["path", { d: "m22 2-8 8" }],
	["ellipse", { cx: "12", cy: "9", rx: "10", ry: "5" }],
	["path", { d: "M7 13.4v7.9" }],
	["path", { d: "M12 14v8" }],
	["path", { d: "M17 13.4v7.9" }],
	["path", { d: "M2 9v8a10 5 0 0 0 20 0V9" }],
] satisfies IconNode;

export const drumstick = [
	["path", { d: "M15.4 15.63a7.875 6 135 1 1 6.23-6.23 4.5 3.43 135 0 0-6.23 6.23" }],
	["path", { d: "m8.29 12.71-2.6 2.6a2.5 2.5 0 1 0-1.65 4.65A2.5 2.5 0 1 0 8.7 18.3l2.59-2.59" }],
] satisfies IconNode;

export const dumbbell = [
	[
		"path",
		{
			d: "M17.596 12.768a2 2 0 1 0 2.829-2.829l-1.768-1.767a2 2 0 0 0 2.828-2.829l-2.828-2.828a2 2 0 0 0-2.829 2.828l-1.767-1.768a2 2 0 1 0-2.829 2.829z",
		},
	],
	["path", { d: "m2.5 21.5 1.4-1.4" }],
	["path", { d: "m20.1 3.9 1.4-1.4" }],
	[
		"path",
		{
			d: "M5.343 21.485a2 2 0 1 0 2.829-2.828l1.767 1.768a2 2 0 1 0 2.829-2.829l-6.364-6.364a2 2 0 1 0-2.829 2.829l1.768 1.767a2 2 0 0 0-2.828 2.829z",
		},
	],
	["path", { d: "m9.6 14.4 4.8-4.8" }],
] satisfies IconNode;

export const ear = [
	["path", { d: "M6 8.5a6.5 6.5 0 1 1 13 0c0 6-6 6-6 10a3.5 3.5 0 1 1-7 0" }],
	["path", { d: "M15 8.5a2.5 2.5 0 0 0-5 0v1a2 2 0 1 1 0 4" }],
] satisfies IconNode;

export const earOff = [
	["path", { d: "M6 18.5a3.5 3.5 0 1 0 7 0c0-1.57.92-2.52 2.04-3.46" }],
	["path", { d: "M6 8.5c0-.75.13-1.47.36-2.14" }],
	["path", { d: "M8.8 3.15A6.5 6.5 0 0 1 19 8.5c0 1.63-.44 2.81-1.09 3.76" }],
	["path", { d: "M12.5 6A2.5 2.5 0 0 1 15 8.5M10 13a2 2 0 0 0 1.82-1.18" }],
	["line", { x1: "2", x2: "22", y1: "2", y2: "22" }],
] satisfies IconNode;

export const earth = [
	["path", { d: "M21.54 15H17a2 2 0 0 0-2 2v4.54" }],
	[
		"path",
		{ d: "M7 3.34V5a3 3 0 0 0 3 3a2 2 0 0 1 2 2c0 1.1.9 2 2 2a2 2 0 0 0 2-2c0-1.1.9-2 2-2h3.17" },
	],
	["path", { d: "M11 21.95V18a2 2 0 0 0-2-2a2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05" }],
	["circle", { cx: "12", cy: "12", r: "10" }],
] satisfies IconNode;

export const earthLock = [
	["path", { d: "M7 3.34V5a3 3 0 0 0 3 3" }],
	["path", { d: "M11 21.95V18a2 2 0 0 0-2-2 2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05" }],
	["path", { d: "M21.54 15H17a2 2 0 0 0-2 2v4.54" }],
	["path", { d: "M12 2a10 10 0 1 0 9.54 13" }],
	["path", { d: "M20 6V4a2 2 0 1 0-4 0v2" }],
	["rect", { width: "8", height: "5", x: "14", y: "6", rx: "1" }],
] satisfies IconNode;

export const eclipse = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M12 2a7 7 0 1 0 10 10" }],
] satisfies IconNode;

export const egg = [
	["path", { d: "M12 2C8 2 4 8 4 14a8 8 0 0 0 16 0c0-6-4-12-8-12" }],
] satisfies IconNode;

export const eggFried = [
	["circle", { cx: "11.5", cy: "12.5", r: "3.5" }],
	[
		"path",
		{
			d: "M3 8c0-3.5 2.5-6 6.5-6 5 0 4.83 3 7.5 5s5 2 5 6c0 4.5-2.5 6.5-7 6.5-2.5 0-2.5 2.5-6 2.5s-7-2-7-5.5c0-3 1.5-3 1.5-5C3.5 10 3 9 3 8Z",
		},
	],
] satisfies IconNode;

export const eggOff = [
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M20 14.347V14c0-6-4-12-8-12-1.078 0-2.157.436-3.157 1.19" }],
	["path", { d: "M6.206 6.21C4.871 8.4 4 11.2 4 14a8 8 0 0 0 14.568 4.568" }],
] satisfies IconNode;

export const eighthNote = [
	["path", { d: "m19 6-5.2-3.9a.5.5 0 0 0-.8.4V18" }],
	["circle", { cx: "9", cy: "18", r: "4" }],
] satisfies IconNode;

export const eighthNotes = [
	["path", { d: "M21 16V3a1 1 0 0 0-1.28-.96l-10 2.917a1 1 0 0 0-.72.96V19" }],
	["circle", { cx: "18", cy: "16", r: "3" }],
	["circle", { cx: "6", cy: "19", r: "3" }],
] satisfies IconNode;

export const eject = [
	[
		"path",
		{ d: "M4 13a1 1 0 0 1-.72-1.695l7.257-7.668a2 2 0 0 1 2.926 0l7.256 7.668A1 1 0 0 1 20 13z" },
	],
	["rect", { x: "3", y: "17", width: "18", height: "4", rx: "1" }],
] satisfies IconNode;

export const ellipse = [["ellipse", { cx: "12", cy: "12", rx: "10", ry: "6" }]] satisfies IconNode;

export const ellipsis = [
	["circle", { cx: "12", cy: "12", r: "1" }],
	["circle", { cx: "19", cy: "12", r: "1" }],
	["circle", { cx: "5", cy: "12", r: "1" }],
] satisfies IconNode;

export const ellipsisVertical = [
	["circle", { cx: "12", cy: "12", r: "1" }],
	["circle", { cx: "12", cy: "5", r: "1" }],
	["circle", { cx: "12", cy: "19", r: "1" }],
] satisfies IconNode;

export const engine = [
	["path", { d: "M10 3h6" }],
	["path", { d: "M13 3v4" }],
	["path", { d: "M2 10v6" }],
	["path", { d: "M2 13h4" }],
	[
		"path",
		{
			d: "M6 16a2 2 0 002 2h1a2 2 0 011.6.8l.3.4a2 2 0 001.6.8h2.264a2 2 0 001.789-1.106l1.67-3.341a1 1 0 01.895-.553H21a1 1 0 001-1v-4a1 1 0 00-1-1h-3.5a1 1 0 01-.8-.4l-.9-1.2A1 1 0 0015 7h-4a1 1 0 00-.8.4l-.9 1.2a1 1 0 01-.8.4H7a1 1 0 00-1 1z",
		},
	],
] satisfies IconNode;

export const equal = [
	["line", { x1: "5", x2: "19", y1: "9", y2: "9" }],
	["line", { x1: "5", x2: "19", y1: "15", y2: "15" }],
] satisfies IconNode;

export const equalApproximately = [
	["path", { d: "M5 15a6.5 6.5 0 0 1 7 0 6.5 6.5 0 0 0 7 0" }],
	["path", { d: "M5 9a6.5 6.5 0 0 1 7 0 6.5 6.5 0 0 0 7 0" }],
] satisfies IconNode;

export const equalApproximatelyNot = [
	["path", { d: "M5 15a6.5 6.5 0 0 1 7 0 6.5 6.5 0 0 0 7 0" }],
	["path", { d: "M5 9a6.5 6.5 0 0 1 7 0 6.5 6.5 0 0 0 7 0" }],
	["line", { x1: "19", x2: "5", y1: "5", y2: "19" }],
] satisfies IconNode;

export const equalNot = [
	["line", { x1: "5", x2: "19", y1: "9", y2: "9" }],
	["line", { x1: "5", x2: "19", y1: "15", y2: "15" }],
	["line", { x1: "19", x2: "5", y1: "5", y2: "19" }],
] satisfies IconNode;

export const eraser = [
	[
		"path",
		{
			d: "M21 21H8a2 2 0 0 1-1.42-.587l-3.994-3.999a2 2 0 0 1 0-2.828l10-10a2 2 0 0 1 2.829 0l5.999 6a2 2 0 0 1 0 2.828L12.834 21",
		},
	],
	["path", { d: "m5.082 11.09 8.828 8.828" }],
] satisfies IconNode;

export const ethernetPort = [
	["path", { d: "M10 8v1" }],
	["path", { d: "M14 8v1" }],
	["path", { d: "M18 8v1" }],
	[
		"path",
		{
			d: "M19 17a2 2 0 00-1.765 1.059l-.47.882A2 2 0 0115 20H9a2 2 0 01-1.765-1.059l-.47-.882A2 2 0 005 17H4a2 2 0 01-2-2V6a2 2 0 012-2h16a2 2 0 012 2v9a2 2 0 01-2 2z",
		},
	],
	["path", { d: "M6 8v1" }],
] satisfies IconNode;

export const euro = [
	["path", { d: "M4 10h12" }],
	["path", { d: "M4 14h9" }],
	[
		"path",
		{ d: "M19 6a7.7 7.7 0 0 0-5.2-2A7.9 7.9 0 0 0 6 12c0 4.4 3.5 8 7.8 8 2 0 3.8-.8 5.2-2" },
	],
] satisfies IconNode;

export const evCharger = [
	["path", { d: "M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 4 0v-6.998a2 2 0 0 0-.59-1.42L18 5" }],
	["path", { d: "M14 21V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v16" }],
	["path", { d: "M2 21h13" }],
	["path", { d: "M3 7h11" }],
	["path", { d: "m9 11-2 3h3l-2 3" }],
] satisfies IconNode;

export const expand = [
	["path", { d: "m15 15 6 6" }],
	["path", { d: "m15 9 6-6" }],
	["path", { d: "M21 16v5h-5" }],
	["path", { d: "M21 8V3h-5" }],
	["path", { d: "M3 16v5h5" }],
	["path", { d: "m3 21 6-6" }],
	["path", { d: "M3 8V3h5" }],
	["path", { d: "M9 9 3 3" }],
] satisfies IconNode;

export const externalLink = [
	["path", { d: "M15 3h6v6" }],
	["path", { d: "M10 14 21 3" }],
	["path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" }],
] satisfies IconNode;

export const eye = [
	[
		"path",
		{
			d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
		},
	],
	["circle", { cx: "12", cy: "12", r: "3" }],
] satisfies IconNode;

export const eyeClosed = [
	["path", { d: "m15 18-.722-3.25" }],
	["path", { d: "M2 8a10.645 10.645 0 0 0 20 0" }],
	["path", { d: "m20 15-1.726-2.05" }],
	["path", { d: "m4 15 1.726-2.05" }],
	["path", { d: "m9 18 .722-3.25" }],
] satisfies IconNode;

export const eyeDashed = [
	["path", { d: "M13.054 18.946a11 11 0 0 1-2.11 0" }],
	["path", { d: "M13.054 5.054a11 11 0 0 0-2.11-.001" }],
	["path", { d: "M17.072 6.274a11 11 0 0 1 1.753 1.173" }],
	["path", { d: "M18.825 16.552a11 11 0 0 1-1.753 1.174" }],
	["path", { d: "M2.514 13.303a11 11 0 0 1-.452-.954 1 1 0 0 1 0-.697 11 11 0 0 1 .45-.955" }],
	["path", { d: "M21.485 10.697a11 11 0 0 1 .453.955 1 1 0 0 1 0 .697 11 11 0 0 1-.453.954" }],
	["path", { d: "M5.173 7.448a11 11 0 0 1 1.753-1.174" }],
	["path", { d: "M6.926 17.726a11 11 0 0 1-1.753-1.174" }],
	["circle", { cx: "12", cy: "12", r: "3" }],
] satisfies IconNode;

export const eyeOff = [
	[
		"path",
		{
			d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
		},
	],
	["path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242" }],
	[
		"path",
		{
			d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
		},
	],
	["path", { d: "m2 2 20 20" }],
] satisfies IconNode;

export const faceAngry = [
	["path", { d: "M15 12v-1.584" }],
	["path", { d: "M17 10a5 5 0 00-3 1" }],
	["path", { d: "M7 10a5 5 0 013 1" }],
	["path", { d: "M9 12v-1.584" }],
	["path", { d: "M9 17a5 5 0 016.001 0" }],
	["circle", { cx: "12", cy: "12", r: "10" }],
] satisfies IconNode;

export const faceExpressionless = [
	["path", { d: "M14 10h2" }],
	["path", { d: "M8 10h2" }],
	["path", { d: "M8 16h8" }],
	["circle", { cx: "12", cy: "12", r: "10" }],
] satisfies IconNode;

export const faceGrinning = [
	["path", { d: "M15 10V9" }],
	[
		"path",
		{ d: "M7.084 14.302a5.12 5.12 0 009.833 0 .24.24 0 00-.235-.302H7.32a.24.24 0 00-.235.302" },
	],
	["path", { d: "M9 10V9" }],
	["circle", { cx: "12", cy: "12", r: "10" }],
] satisfies IconNode;

export const faceNeutral = [
	["path", { d: "M15 10V9" }],
	["path", { d: "M8 16h8" }],
	["path", { d: "M9 10V9" }],
	["circle", { cx: "12", cy: "12", r: "10" }],
] satisfies IconNode;

export const faceSlightlyFrowning = [
	["path", { d: "M15 10V9" }],
	["path", { d: "M9 10V9" }],
	["path", { d: "M9 16a5 5 0 016 0" }],
	["circle", { cx: "12", cy: "12", r: "10" }],
] satisfies IconNode;

export const faceSlightlySmiling = [
	["path", { d: "M15 10V9" }],
	["path", { d: "M16.472 15a6 6 0 01-8.943 0" }],
	["path", { d: "M9 10V9" }],
	["circle", { cx: "12", cy: "12", r: "10" }],
] satisfies IconNode;

export const faceSlightlySmilingPlus = [
	["path", { d: "M13.267 2.08a10 10 0 108.653 8.653" }],
	["path", { d: "M15 10V9" }],
	["path", { d: "M16 5h6" }],
	["path", { d: "M16.472 15a6 6 0 01-8.943 0" }],
	["path", { d: "M19 2v6" }],
	["path", { d: "M9 10V9" }],
] satisfies IconNode;

export const factory = [
	["path", { d: "M12 16h.01" }],
	["path", { d: "M16 16h.01" }],
	[
		"path",
		{
			d: "M3 19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.5a.5.5 0 0 0-.769-.422l-4.462 2.844A.5.5 0 0 1 15 10.5v-2a.5.5 0 0 0-.769-.422L9.77 10.922A.5.5 0 0 1 9 10.5V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2z",
		},
	],
	["path", { d: "M8 16h.01" }],
] satisfies IconNode;

export const fan = [
	[
		"path",
		{
			d: "M10.827 16.379a6.082 6.082 0 0 1-8.618-7.002l5.412 1.45a6.082 6.082 0 0 1 7.002-8.618l-1.45 5.412a6.082 6.082 0 0 1 8.618 7.002l-5.412-1.45a6.082 6.082 0 0 1-7.002 8.618l1.45-5.412Z",
		},
	],
	["path", { d: "M12 12v.01" }],
] satisfies IconNode;

export const fastForward = [
	["path", { d: "M12 6a2 2 0 0 1 3.414-1.414l6 6a2 2 0 0 1 0 2.828l-6 6A2 2 0 0 1 12 18z" }],
	["path", { d: "M2 6a2 2 0 0 1 3.414-1.414l6 6a2 2 0 0 1 0 2.828l-6 6A2 2 0 0 1 2 18z" }],
] satisfies IconNode;

export const faucet = [
	["path", { d: "M10.083 5.428 5.57 4.083a2 2 0 10.001 3.834l4.512-1.345" }],
	["path", { d: "M12 8v3" }],
	["path", { d: "m13.917 5.428 4.511-1.345a2 2 0 110 3.834l-4.51-1.345" }],
	["path", { d: "M18 17v-4.006" }],
	["path", { d: "M22 11v8" }],
	[
		"path",
		{
			d: "M22 12h-3a1 1 0 00-1 .994h-2.539a4 4 0 00-6.915-.012L7 13a5 5 0 00-5 5v1a1 1 0 001 1h2a1 1 0 001-1v-1a1 1 0 01.995-1l1.552.018a4 4 0 006.907 0L18 17a1 1 0 001 1h3",
		},
	],
	["circle", { cx: "12", cy: "6", r: "2" }],
] satisfies IconNode;

export const feather = [
	[
		"path",
		{
			d: "M14.086 18.412A2 2 0 0112.67 19H5v-7.672a2 2 0 01.586-1.414L11.75 3.75a6 6 0 118.49 8.49z",
		},
	],
	["path", { d: "M16 8 2 22" }],
	["path", { d: "M17.488 15H9" }],
] satisfies IconNode;

export const fence = [
	["path", { d: "M4 3 2 5v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z" }],
	["path", { d: "M6 8h4" }],
	["path", { d: "M6 18h4" }],
	["path", { d: "m12 3-2 2v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z" }],
	["path", { d: "M14 8h4" }],
	["path", { d: "M14 18h4" }],
	["path", { d: "m20 3-2 2v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z" }],
] satisfies IconNode;

export const ferrisWheel = [
	["circle", { cx: "12", cy: "12", r: "2" }],
	["path", { d: "M12 2v4" }],
	["path", { d: "m6.8 15-3.5 2" }],
	["path", { d: "m20.7 7-3.5 2" }],
	["path", { d: "M6.8 9 3.3 7" }],
	["path", { d: "m20.7 17-3.5-2" }],
	["path", { d: "m9 22 3-8 3 8" }],
	["path", { d: "M8 22h8" }],
	["path", { d: "M18 18.7a9 9 0 1 0-12 0" }],
] satisfies IconNode;

export const file = [
	[
		"path",
		{
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
] satisfies IconNode;

export const fileArchive = [
	[
		"path",
		{
			d: "M13.659 22H18a2 2 0 0 0 2-2V8a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 14 2H6a2 2 0 0 0-2 2v11.5",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M8 12v-1" }],
	["path", { d: "M8 18v-2" }],
	["path", { d: "M8 7V6" }],
	["circle", { cx: "8", cy: "20", r: "2" }],
] satisfies IconNode;

export const fileAxis3d = [
	[
		"path",
		{
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "m8 18 4-4" }],
	["path", { d: "M8 10v8h8" }],
] satisfies IconNode;

export const fileBadge = [
	[
		"path",
		{
			d: "M13 22h5a2 2 0 0 0 2-2V8a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 14 2H6a2 2 0 0 0-2 2v3.3",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	[
		"path",
		{
			d: "m7.69 16.479 1.29 4.88a.5.5 0 0 1-.698.591l-1.843-.849a1 1 0 0 0-.879.001l-1.846.85a.5.5 0 0 1-.692-.593l1.29-4.88",
		},
	],
	["circle", { cx: "6", cy: "14", r: "3" }],
] satisfies IconNode;

export const fileBox = [
	["path", { d: "M14 2v5a1 1 0 001 1h5" }],
	[
		"path",
		{
			d: "M14.692 22H18a2 2 0 002-2V8a2.4 2.4 0 00-.706-1.706l-3.588-3.588A2.4 2.4 0 0014 2H6a2 2 0 00-2 2v3.804",
		},
	],
	["path", { d: "M2.264 13.752 7 16.5l4.737-2.748" }],
	[
		"path",
		{
			d: "M2.995 13.014A2 2 0 002 14.744v3.516a2 2 0 00.996 1.73l3 1.74a2 2 0 002.008 0l3-1.74A2 2 0 0012 18.26v-3.517a2 2 0 00-.995-1.73l-3-1.742a2 2 0 00-1.892-.064z",
		},
	],
	["path", { d: "M7 16.5V22" }],
] satisfies IconNode;

export const fileBraces = [
	[
		"path",
		{
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M10 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1" }],
	["path", { d: "M14 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1" }],
] satisfies IconNode;

export const fileBracesCorner = [
	[
		"path",
		{
			d: "M14 22h4a2 2 0 0 0 2-2V8a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 14 2H6a2 2 0 0 0-2 2v6",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M5 14a1 1 0 0 0-1 1v2a1 1 0 0 1-1 1 1 1 0 0 1 1 1v2a1 1 0 0 0 1 1" }],
	["path", { d: "M9 22a1 1 0 0 0 1-1v-2a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-2a1 1 0 0 0-1-1" }],
] satisfies IconNode;

export const fileChartColumn = [
	[
		"path",
		{
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M8 18v-1" }],
	["path", { d: "M12 18v-6" }],
	["path", { d: "M16 18v-3" }],
] satisfies IconNode;

export const fileChartColumnIncreasing = [
	[
		"path",
		{
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M8 18v-2" }],
	["path", { d: "M12 18v-4" }],
	["path", { d: "M16 18v-6" }],
] satisfies IconNode;

export const fileChartLine = [
	[
		"path",
		{
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "m16 13-3.5 3.5-2-2L8 17" }],
] satisfies IconNode;

export const fileChartPie = [
	[
		"path",
		{
			d: "M15.941 22H18a2 2 0 0 0 2-2V8a2.4 2.4 0 0 0-.706-1.704l-3.588-3.588A2.4 2.4 0 0 0 14 2H6a2 2 0 0 0-2 2v3.512",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M4.017 11.512a6 6 0 1 0 8.466 8.475" }],
	[
		"path",
		{
			d: "M9 16a1 1 0 0 1-1-1v-4c0-.552.45-1.008.995-.917a6 6 0 0 1 4.922 4.922c.091.544-.365.995-.917.995z",
		},
	],
] satisfies IconNode;

export const fileCheck = [
	[
		"path",
		{
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "m9 15 2 2 4-4" }],
] satisfies IconNode;

export const fileCheckCorner = [
	[
		"path",
		{
			d: "M10.5 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v6",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "m14 20 2 2 4-4" }],
] satisfies IconNode;

export const fileClock = [
	[
		"path",
		{
			d: "M16 22h2a2 2 0 0 0 2-2V8a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 14 2H6a2 2 0 0 0-2 2v2.85",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M8 14v2.2l1.6 1" }],
	["circle", { cx: "8", cy: "16", r: "6" }],
] satisfies IconNode;

export const fileCode = [
	[
		"path",
		{
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M10 12.5 8 15l2 2.5" }],
	["path", { d: "m14 12.5 2 2.5-2 2.5" }],
] satisfies IconNode;

export const fileCodeCorner = [
	[
		"path",
		{
			d: "M4 12.15V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2h-3.35",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "m5 16-3 3 3 3" }],
	["path", { d: "m9 22 3-3-3-3" }],
] satisfies IconNode;

export const fileCog = [
	["path", { d: "M15 8a1 1 0 0 1-1-1V2a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8z" }],
	["path", { d: "M20 8v12a2 2 0 0 1-2 2h-4.182" }],
	["path", { d: "m3.305 19.53.923-.382" }],
	["path", { d: "M4 10.592V4a2 2 0 0 1 2-2h8" }],
	["path", { d: "m4.228 16.852-.924-.383" }],
	["path", { d: "m5.852 15.228-.383-.923" }],
	["path", { d: "m5.852 20.772-.383.924" }],
	["path", { d: "m8.148 15.228.383-.923" }],
	["path", { d: "m8.53 21.696-.382-.924" }],
	["path", { d: "m9.773 16.852.922-.383" }],
	["path", { d: "m9.773 19.148.922.383" }],
	["circle", { cx: "7", cy: "18", r: "3" }],
] satisfies IconNode;

export const fileDiff = [
	[
		"path",
		{
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M9 10h6" }],
	["path", { d: "M12 13V7" }],
	["path", { d: "M9 17h6" }],
] satisfies IconNode;

export const fileDigit = [
	[
		"path",
		{
			d: "M4 12V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M10 16h2v6" }],
	["path", { d: "M10 22h4" }],
	["rect", { x: "2", y: "16", width: "4", height: "6", rx: "2" }],
] satisfies IconNode;

export const fileDown = [
	[
		"path",
		{
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M12 18v-6" }],
	["path", { d: "m9 15 3 3 3-3" }],
] satisfies IconNode;

export const fileExclamationPoint = [
	[
		"path",
		{
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M12 9v4" }],
	["path", { d: "M12 17h.01" }],
] satisfies IconNode;

export const fileHeadphone = [
	[
		"path",
		{
			d: "M4 6.835V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2h-.343",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	[
		"path",
		{ d: "M2 19a2 2 0 0 1 4 0v1a2 2 0 0 1-4 0v-4a6 6 0 0 1 12 0v4a2 2 0 0 1-4 0v-1a2 2 0 0 1 4 0" },
	],
] satisfies IconNode;

export const fileHeart = [
	[
		"path",
		{
			d: "M13 22h5a2 2 0 0 0 2-2V8a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 14 2H6a2 2 0 0 0-2 2v7",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	[
		"path",
		{
			d: "M3.62 18.8A2.25 2.25 0 1 1 7 15.836a2.25 2.25 0 1 1 3.38 2.966l-2.626 2.856a1 1 0 0 1-1.507 0z",
		},
	],
] satisfies IconNode;

export const fileImage = [
	[
		"path",
		{
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["circle", { cx: "10", cy: "12", r: "2" }],
	["path", { d: "m20 17-1.296-1.296a2.41 2.41 0 0 0-3.408 0L9 22" }],
] satisfies IconNode;

export const fileInput = [
	[
		"path",
		{
			d: "M4 11V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-1",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M2 15h10" }],
	["path", { d: "m9 18 3-3-3-3" }],
] satisfies IconNode;

export const fileKey = [
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M4 12v6" }],
	["path", { d: "M4 14h2" }],
	[
		"path",
		{
			d: "M9.65 22H18a2 2 0 0 0 2-2V8a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 14 2H6a2 2 0 0 0-2 2v4",
		},
	],
	["circle", { cx: "4", cy: "20", r: "2" }],
] satisfies IconNode;

export const fileLock = [
	[
		"path",
		{
			d: "M4 9.8V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2h-3",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M9 17v-2a2 2 0 0 0-4 0v2" }],
	["rect", { width: "8", height: "5", x: "3", y: "17", rx: "1" }],
] satisfies IconNode;

export const fileMinus = [
	[
		"path",
		{
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M9 15h6" }],
] satisfies IconNode;

export const fileMinusCorner = [
	[
		"path",
		{
			d: "M20 14V8a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M14 18h6" }],
] satisfies IconNode;

export const fileMusic = [
	[
		"path",
		{
			d: "M11.65 22H18a2 2 0 0 0 2-2V8a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 14 2H6a2 2 0 0 0-2 2v10.35",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M8 20v-7l3 1.474" }],
	["circle", { cx: "6", cy: "20", r: "2" }],
] satisfies IconNode;

export const fileOutput = [
	[
		"path",
		{
			d: "M4.226 20.925A2 2 0 0 0 6 22h12a2 2 0 0 0 2-2V8a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 14 2H6a2 2 0 0 0-2 2v3.127",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "m5 11-3 3" }],
	["path", { d: "m5 17-3-3h10" }],
] satisfies IconNode;

export const filePen = [
	[
		"path",
		{
			d: "M12.659 22H18a2 2 0 0 0 2-2V8a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 14 2H6a2 2 0 0 0-2 2v9.34",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	[
		"path",
		{
			d: "M10.378 12.622a1 1 0 0 1 3 3.003L8.36 20.637a2 2 0 0 1-.854.506l-2.867.837a.5.5 0 0 1-.62-.62l.836-2.869a2 2 0 0 1 .506-.853z",
		},
	],
] satisfies IconNode;

export const filePenLine = [
	[
		"path",
		{
			d: "M14.364 13.634a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506l4.013-4.009a1 1 0 0 0-3.004-3.004z",
		},
	],
	["path", { d: "M14.487 7.858A1 1 0 0 1 14 7V2" }],
	[
		"path",
		{
			d: "M20 19.645V20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l2.516 2.516",
		},
	],
	["path", { d: "M8 18h1" }],
] satisfies IconNode;

export const filePlay = [
	[
		"path",
		{
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	[
		"path",
		{
			d: "M15.033 13.44a.647.647 0 0 1 0 1.12l-4.065 2.352a.645.645 0 0 1-.968-.56v-4.704a.645.645 0 0 1 .967-.56z",
		},
	],
] satisfies IconNode;

export const filePlus = [
	[
		"path",
		{
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M9 15h6" }],
	["path", { d: "M12 18v-6" }],
] satisfies IconNode;

export const filePlusCorner = [
	[
		"path",
		{
			d: "M11.35 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v5.35",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M14 19h6" }],
	["path", { d: "M17 16v6" }],
] satisfies IconNode;

export const fileQuestionMark = [
	[
		"path",
		{
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M12 17h.01" }],
	["path", { d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3" }],
] satisfies IconNode;

export const fileScan = [
	[
		"path",
		{
			d: "M20 10V8a2.4 2.4 0 0 0-.706-1.704l-3.588-3.588A2.4 2.4 0 0 0 14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4.35",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M16 14a2 2 0 0 0-2 2" }],
	["path", { d: "M16 22a2 2 0 0 1-2-2" }],
	["path", { d: "M20 14a2 2 0 0 1 2 2" }],
	["path", { d: "M20 22a2 2 0 0 0 2-2" }],
] satisfies IconNode;

export const fileSearch = [
	[
		"path",
		{
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["circle", { cx: "11.5", cy: "14.5", r: "2.5" }],
	["path", { d: "M13.3 16.3 15 18" }],
] satisfies IconNode;

export const fileSearchCorner = [
	[
		"path",
		{
			d: "M11.1 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.589 3.588A2.4 2.4 0 0 1 20 8v3.25",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "m21 22-2.88-2.88" }],
	["circle", { cx: "16", cy: "17", r: "3" }],
] satisfies IconNode;

export const fileSignal = [
	[
		"path",
		{
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M8 15h.01" }],
	["path", { d: "M11.5 13.5a2.5 2.5 0 0 1 0 3" }],
	["path", { d: "M15 12a5 5 0 0 1 0 6" }],
] satisfies IconNode;

export const fileSliders = [
	[
		"path",
		{
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M8 12h8" }],
	["path", { d: "M10 11v2" }],
	["path", { d: "M8 17h8" }],
	["path", { d: "M14 16v2" }],
] satisfies IconNode;

export const fileSpreadsheet = [
	[
		"path",
		{
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M8 13h2" }],
	["path", { d: "M14 13h2" }],
	["path", { d: "M8 17h2" }],
	["path", { d: "M14 17h2" }],
] satisfies IconNode;

export const fileStack = [
	["path", { d: "M11 21a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1" }],
	["path", { d: "M16 16a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1" }],
	[
		"path",
		{
			d: "M21 6a2 2 0 0 0-.586-1.414l-2-2A2 2 0 0 0 17 2h-3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1z",
		},
	],
] satisfies IconNode;

export const fileSymlink = [
	[
		"path",
		{
			d: "M4 11V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "m10 18 3-3-3-3" }],
] satisfies IconNode;

export const fileTerminal = [
	[
		"path",
		{
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "m8 16 2-2-2-2" }],
	["path", { d: "M12 18h4" }],
] satisfies IconNode;

export const fileText = [
	[
		"path",
		{
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M10 9H8" }],
	["path", { d: "M16 13H8" }],
	["path", { d: "M16 17H8" }],
] satisfies IconNode;

export const fileType = [
	[
		"path",
		{
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M11 18h2" }],
	["path", { d: "M12 12v6" }],
	["path", { d: "M9 13v-.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v.5" }],
] satisfies IconNode;

export const fileTypeCorner = [
	[
		"path",
		{
			d: "M12 22h6a2 2 0 0 0 2-2V8a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 14 2H6a2 2 0 0 0-2 2v6",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M3 16v-1.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5V16" }],
	["path", { d: "M6 22h2" }],
	["path", { d: "M7 14v8" }],
] satisfies IconNode;

export const fileUp = [
	[
		"path",
		{
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M12 12v6" }],
	["path", { d: "m15 15-3-3-3 3" }],
] satisfies IconNode;

export const fileUser = [
	[
		"path",
		{
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M16 22a4 4 0 0 0-8 0" }],
	["circle", { cx: "12", cy: "15", r: "3" }],
] satisfies IconNode;

export const fileVideoCamera = [
	[
		"path",
		{
			d: "M4 12V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	[
		"path",
		{ d: "m10 17.843 3.033-1.755a.64.64 0 0 1 .967.56v4.704a.65.65 0 0 1-.967.56L10 20.157" },
	],
	["rect", { width: "7", height: "6", x: "3", y: "16", rx: "1" }],
] satisfies IconNode;

export const fileVolume = [
	[
		"path",
		{
			d: "M4 11.55V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2h-1.95",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M12 15a5 5 0 0 1 0 6" }],
	[
		"path",
		{
			d: "M8 14.502a.5.5 0 0 0-.826-.381l-1.893 1.631a1 1 0 0 1-.651.243H3.5a.5.5 0 0 0-.5.501v3.006a.5.5 0 0 0 .5.501h1.129a1 1 0 0 1 .652.243l1.893 1.633a.5.5 0 0 0 .826-.38z",
		},
	],
] satisfies IconNode;

export const fileX = [
	[
		"path",
		{
			d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "m14.5 12.5-5 5" }],
	["path", { d: "m9.5 12.5 5 5" }],
] satisfies IconNode;

export const fileXCorner = [
	[
		"path",
		{
			d: "M11 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v5",
		},
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "m15 17 5 5" }],
	["path", { d: "m20 17-5 5" }],
] satisfies IconNode;

export const files = [
	["path", { d: "M15 2h-4a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8" }],
	["path", { d: "M16.706 2.706A2.4 2.4 0 0 0 15 2v5a1 1 0 0 0 1 1h5a2.4 2.4 0 0 0-.706-1.706z" }],
	["path", { d: "M5 7a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h8a2 2 0 0 0 1.732-1" }],
] satisfies IconNode;

export const film = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M7 3v18" }],
	["path", { d: "M3 7.5h4" }],
	["path", { d: "M3 12h18" }],
	["path", { d: "M3 16.5h4" }],
	["path", { d: "M17 3v18" }],
	["path", { d: "M17 7.5h4" }],
	["path", { d: "M17 16.5h4" }],
] satisfies IconNode;

export const fingerprintPattern = [
	["path", { d: "M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4" }],
	["path", { d: "M14 13.12c0 2.38 0 6.38-1 8.88" }],
	["path", { d: "M17.29 21.02c.12-.6.43-2.3.5-3.02" }],
	["path", { d: "M2 12a10 10 0 0 1 18-6" }],
	["path", { d: "M2 16h.01" }],
	["path", { d: "M21.8 16c.2-2 .131-5.354 0-6" }],
	["path", { d: "M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2" }],
	["path", { d: "M8.65 22c.21-.66.45-1.32.57-2" }],
	["path", { d: "M9 6.8a6 6 0 0 1 9 5.2v2" }],
] satisfies IconNode;

export const fireExtinguisher = [
	["path", { d: "M15 6.5V3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3.5" }],
	["path", { d: "M9 18h8" }],
	["path", { d: "M18 3h-3" }],
	["path", { d: "M11 3a6 6 0 0 0-6 6v11" }],
	["path", { d: "M5 13h4" }],
	["path", { d: "M17 10a4 4 0 0 0-8 0v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2Z" }],
] satisfies IconNode;

export const fish = [
	[
		"path",
		{
			d: "M6.5 12c.94-3.46 4.94-6 8.5-6 3.56 0 6.06 2.54 7 6-.94 3.47-3.44 6-7 6s-7.56-2.53-8.5-6Z",
		},
	],
	["path", { d: "M18 12v.5" }],
	["path", { d: "M16 17.93a9.77 9.77 0 0 1 0-11.86" }],
	[
		"path",
		{
			d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33",
		},
	],
	["path", { d: "M10.46 7.26C10.2 5.88 9.17 4.24 8 3h5.8a2 2 0 0 1 1.98 1.67l.23 1.4" }],
	["path", { d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98" }],
] satisfies IconNode;

export const fishOff = [
	[
		"path",
		{
			d: "M18 12.47v.03m0-.5v.47m-.475 5.056A6.744 6.744 0 0 1 15 18c-3.56 0-7.56-2.53-8.5-6 .348-1.28 1.114-2.433 2.121-3.38m3.444-2.088A8.802 8.802 0 0 1 15 6c3.56 0 6.06 2.54 7 6-.309 1.14-.786 2.177-1.413 3.058",
		},
	],
	[
		"path",
		{
			d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33m7.48-4.372A9.77 9.77 0 0 1 16 6.07m0 11.86a9.77 9.77 0 0 1-1.728-3.618",
		},
	],
	[
		"path",
		{
			d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98M8.53 3h5.27a2 2 0 0 1 1.98 1.67l.23 1.4M2 2l20 20",
		},
	],
] satisfies IconNode;

export const fishSymbol = [["path", { d: "M2 16s9-15 20-4C11 23 2 8 2 8" }]] satisfies IconNode;

export const fishingHook = [
	["path", { d: "m17.586 11.414-5.93 5.93a1 1 0 0 1-8-8l3.137-3.137a.707.707 0 0 1 1.207.5V10" }],
	["path", { d: "M20.414 8.586 22 7" }],
	["circle", { cx: "19", cy: "10", r: "2" }],
] satisfies IconNode;

export const fishingRod = [
	["path", { d: "M4 11h1" }],
	["path", { d: "M8 15a2 2 0 0 1-4 0V3a1 1 0 0 1 1-1h.5C14 2 20 9 20 18v4" }],
	["circle", { cx: "18", cy: "18", r: "2" }],
] satisfies IconNode;

export const flag = [
	[
		"path",
		{
			d: "M4 22V4a1 1 0 0 1 .4-.8A6 6 0 0 1 8 2c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10a1 1 0 0 1-.4.8A6 6 0 0 1 16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.528",
		},
	],
] satisfies IconNode;

export const flagOff = [
	["path", { d: "M16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.528" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M4 22V4" }],
	["path", { d: "M7.656 2H8c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10.347" }],
] satisfies IconNode;

export const flagTriangleLeft = [
	["path", { d: "M18 22V2.8a.8.8 0 0 0-1.17-.71L5.45 7.78a.8.8 0 0 0 0 1.44L18 15.5" }],
] satisfies IconNode;

export const flagTriangleRight = [
	["path", { d: "M6 22V2.8a.8.8 0 0 1 1.17-.71l11.38 5.69a.8.8 0 0 1 0 1.44L6 15.5" }],
] satisfies IconNode;

export const flame = [
	[
		"path",
		{
			d: "M12 3q1 4 4 6.5t3 5.5a1 1 0 0 1-14 0 5 5 0 0 1 1-3 1 1 0 0 0 5 0c0-2-1.5-3-1.5-5q0-2 2.5-4",
		},
	],
] satisfies IconNode;

export const flameKindling = [
	[
		"path",
		{
			d: "M12 2c1 3 2.5 3.5 3.5 4.5A5 5 0 0 1 17 10a5 5 0 1 1-10 0c0-.3 0-.6.1-.9a2 2 0 1 0 3.3-2C8 4.5 11 2 12 2Z",
		},
	],
	["path", { d: "m5 22 14-4" }],
	["path", { d: "m5 18 14 4" }],
] satisfies IconNode;

export const flashlight = [
	["path", { d: "M12 13v1" }],
	[
		"path",
		{
			d: "M17 2a1 1 0 0 1 1 1v4a3 3 0 0 1-.6 1.8l-.6.8A4 4 0 0 0 16 12v8a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2v-8a4 4 0 0 0-.8-2.4l-.6-.8A3 3 0 0 1 6 7V3a1 1 0 0 1 1-1z",
		},
	],
	["path", { d: "M6 6h12" }],
] satisfies IconNode;

export const flashlightOff = [
	["path", { d: "M11.652 6H18" }],
	["path", { d: "M12 13v1" }],
	[
		"path",
		{ d: "M16 16v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-8a4 4 0 0 0-.8-2.4l-.6-.8A3 3 0 0 1 6 7V6" },
	],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M7.649 2H17a1 1 0 0 1 1 1v4a3 3 0 0 1-.6 1.8l-.6.8a4 4 0 0 0-.55 1.007" }],
] satisfies IconNode;

export const flaskConical = [
	[
		"path",
		{
			d: "M14 2v6a2 2 0 0 0 .245.96l5.51 10.08A2 2 0 0 1 18 22H6a2 2 0 0 1-1.755-2.96l5.51-10.08A2 2 0 0 0 10 8V2",
		},
	],
	["path", { d: "M6.453 15h11.094" }],
	["path", { d: "M8.5 2h7" }],
] satisfies IconNode;

export const flaskConicalOff = [
	["path", { d: "M10 2v2.343" }],
	["path", { d: "M14 2v6.343" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M20 20a2 2 0 0 1-2 2H6a2 2 0 0 1-1.755-2.96l5.227-9.563" }],
	["path", { d: "M6.453 15H15" }],
	["path", { d: "M8.5 2h7" }],
] satisfies IconNode;

export const flaskRound = [
	["path", { d: "M10 2v6.292a7 7 0 1 0 4 0V2" }],
	["path", { d: "M5 15h14" }],
	["path", { d: "M8.5 2h7" }],
] satisfies IconNode;

export const flower = [
	["circle", { cx: "12", cy: "12", r: "3" }],
	[
		"path",
		{
			d: "M12 16.5A4.5 4.5 0 1 1 7.5 12 4.5 4.5 0 1 1 12 7.5a4.5 4.5 0 1 1 4.5 4.5 4.5 4.5 0 1 1-4.5 4.5",
		},
	],
	["path", { d: "M12 7.5V9" }],
	["path", { d: "M7.5 12H9" }],
	["path", { d: "M16.5 12H15" }],
	["path", { d: "M12 16.5V15" }],
	["path", { d: "m8 8 1.88 1.88" }],
	["path", { d: "M14.12 9.88 16 8" }],
	["path", { d: "m8 16 1.88-1.88" }],
	["path", { d: "M14.12 14.12 16 16" }],
] satisfies IconNode;

export const flower2 = [
	[
		"path",
		{
			d: "M12 5a3 3 0 1 1 3 3m-3-3a3 3 0 1 0-3 3m3-3v1M9 8a3 3 0 1 0 3 3M9 8h1m5 0a3 3 0 1 1-3 3m3-3h-1m-2 3v-1",
		},
	],
	["circle", { cx: "12", cy: "8", r: "2" }],
	["path", { d: "M12 10v12" }],
	["path", { d: "M12 22c4.2 0 7-1.667 7-5-4.2 0-7 1.667-7 5Z" }],
	["path", { d: "M12 22c-4.2 0-7-1.667-7-5 4.2 0 7 1.667 7 5Z" }],
] satisfies IconNode;

export const focus = [
	["circle", { cx: "12", cy: "12", r: "3" }],
	["path", { d: "M3 7V5a2 2 0 0 1 2-2h2" }],
	["path", { d: "M17 3h2a2 2 0 0 1 2 2v2" }],
	["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2" }],
	["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2" }],
] satisfies IconNode;

export const foldHorizontal = [
	["path", { d: "M2 12h6" }],
	["path", { d: "M22 12h-6" }],
	["path", { d: "M12 2v2" }],
	["path", { d: "M12 8v2" }],
	["path", { d: "M12 14v2" }],
	["path", { d: "M12 20v2" }],
	["path", { d: "m19 9-3 3 3 3" }],
	["path", { d: "m5 15 3-3-3-3" }],
] satisfies IconNode;

export const foldVertical = [
	["path", { d: "M12 22v-6" }],
	["path", { d: "M12 8V2" }],
	["path", { d: "M4 12H2" }],
	["path", { d: "M10 12H8" }],
	["path", { d: "M16 12h-2" }],
	["path", { d: "M22 12h-2" }],
	["path", { d: "m15 19-3-3-3 3" }],
	["path", { d: "m15 5-3 3-3-3" }],
] satisfies IconNode;

export const folder = [
	[
		"path",
		{
			d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
		},
	],
] satisfies IconNode;

export const folderArchive = [
	["circle", { cx: "15", cy: "19", r: "2" }],
	[
		"path",
		{
			d: "M20.9 19.8A2 2 0 0 0 22 18V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h5.1",
		},
	],
	["path", { d: "M15 11v-1" }],
	["path", { d: "M15 17v-2" }],
] satisfies IconNode;

export const folderBookmark = [
	[
		"path",
		{
			d: "M12 6v7.751a.25.25 0 00.407.195l2.28-1.834a.5.5 0 01.627 0l2.28 1.834a.25.25 0 00.406-.195V6",
		},
	],
	[
		"path",
		{
			d: "M20 20a2 2 0 002-2V8a2 2 0 00-2-2h-7.9a2 2 0 01-1.69-.9L9.6 3.9A2 2 0 007.93 3H4a2 2 0 00-2 2v13a2 2 0 002 2z",
		},
	],
] satisfies IconNode;

export const folderCheck = [
	[
		"path",
		{
			d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
		},
	],
	["path", { d: "m9 13 2 2 4-4" }],
] satisfies IconNode;

export const folderClock = [
	["path", { d: "M16 14v2.2l1.6 1" }],
	[
		"path",
		{
			d: "M7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2",
		},
	],
	["circle", { cx: "16", cy: "16", r: "6" }],
] satisfies IconNode;

export const folderClosed = [
	[
		"path",
		{
			d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
		},
	],
	["path", { d: "M2 10h20" }],
] satisfies IconNode;

export const folderCode = [
	["path", { d: "M10 10.5 8 13l2 2.5" }],
	["path", { d: "m14 10.5 2 2.5-2 2.5" }],
	[
		"path",
		{
			d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2z",
		},
	],
] satisfies IconNode;

export const folderCog = [
	[
		"path",
		{
			d: "M10.3 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.98a2 2 0 0 1 1.69.9l.66 1.2A2 2 0 0 0 12 6h8a2 2 0 0 1 2 2v3.3",
		},
	],
	["path", { d: "m14.305 19.53.923-.382" }],
	["path", { d: "m15.228 16.852-.923-.383" }],
	["path", { d: "m16.852 15.228-.383-.923" }],
	["path", { d: "m16.852 20.772-.383.924" }],
	["path", { d: "m19.148 15.228.383-.923" }],
	["path", { d: "m19.53 21.696-.382-.924" }],
	["path", { d: "m20.772 16.852.924-.383" }],
	["path", { d: "m20.772 19.148.924.383" }],
	["circle", { cx: "18", cy: "18", r: "3" }],
] satisfies IconNode;

export const folderDot = [
	[
		"path",
		{
			d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
		},
	],
	["circle", { cx: "12", cy: "13", r: "1" }],
] satisfies IconNode;

export const folderDown = [
	[
		"path",
		{
			d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
		},
	],
	["path", { d: "M12 10v6" }],
	["path", { d: "m15 13-3 3-3-3" }],
] satisfies IconNode;

export const folderGit = [
	["circle", { cx: "12", cy: "13", r: "2" }],
	[
		"path",
		{
			d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
		},
	],
	["path", { d: "M14 13h3" }],
	["path", { d: "M7 13h3" }],
] satisfies IconNode;

export const folderGit2 = [
	["path", { d: "M18 19a5 5 0 0 1-5-5v8" }],
	[
		"path",
		{
			d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v5",
		},
	],
	["circle", { cx: "13", cy: "12", r: "2" }],
	["circle", { cx: "20", cy: "19", r: "2" }],
] satisfies IconNode;

export const folderHeart = [
	[
		"path",
		{
			d: "M10.638 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v3.417",
		},
	],
	[
		"path",
		{
			d: "M14.62 18.8A2.25 2.25 0 1 1 18 15.836a2.25 2.25 0 1 1 3.38 2.966l-2.626 2.856a.998.998 0 0 1-1.507 0z",
		},
	],
] satisfies IconNode;

export const folderInput = [
	[
		"path",
		{
			d: "M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1",
		},
	],
	["path", { d: "M2 13h10" }],
	["path", { d: "m9 16 3-3-3-3" }],
] satisfies IconNode;

export const folderKanban = [
	[
		"path",
		{
			d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
		},
	],
	["path", { d: "M8 10v4" }],
	["path", { d: "M12 10v2" }],
	["path", { d: "M16 10v6" }],
] satisfies IconNode;

export const folderKey = [
	[
		"path",
		{
			d: "M13 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v1.36",
		},
	],
	["path", { d: "M19 12v6" }],
	["path", { d: "M19 14h2" }],
	["circle", { cx: "19", cy: "20", r: "2" }],
] satisfies IconNode;

export const folderLock = [
	["rect", { width: "8", height: "5", x: "14", y: "17", rx: "1" }],
	[
		"path",
		{
			d: "M10 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v2.5",
		},
	],
	["path", { d: "M20 17v-2a2 2 0 1 0-4 0v2" }],
] satisfies IconNode;

export const folderMinus = [
	["path", { d: "M9 13h6" }],
	[
		"path",
		{
			d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
		},
	],
] satisfies IconNode;

export const folderOpen = [
	[
		"path",
		{
			d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
		},
	],
] satisfies IconNode;

export const folderOpenDot = [
	[
		"path",
		{
			d: "m6 14 1.45-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.55 6a2 2 0 0 1-1.94 1.5H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H18a2 2 0 0 1 2 2v2",
		},
	],
	["circle", { cx: "14", cy: "15", r: "1" }],
] satisfies IconNode;

export const folderOutput = [
	[
		"path",
		{
			d: "M2 7.5V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-1.5",
		},
	],
	["path", { d: "M2 13h10" }],
	["path", { d: "m5 10-3 3 3 3" }],
] satisfies IconNode;

export const folderPen = [
	[
		"path",
		{
			d: "M2 11.5V5a2 2 0 0 1 2-2h3.9c.7 0 1.3.3 1.7.9l.8 1.2c.4.6 1 .9 1.7.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-9.5",
		},
	],
	[
		"path",
		{
			d: "M11.378 13.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
		},
	],
] satisfies IconNode;

export const folderPlus = [
	["path", { d: "M12 10v6" }],
	["path", { d: "M9 13h6" }],
	[
		"path",
		{
			d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
		},
	],
] satisfies IconNode;

export const folderRoot = [
	[
		"path",
		{
			d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
		},
	],
	["circle", { cx: "12", cy: "13", r: "2" }],
	["path", { d: "M12 15v5" }],
] satisfies IconNode;

export const folderSearch = [
	[
		"path",
		{
			d: "M10.7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v4.1",
		},
	],
	["path", { d: "m21 21-1.9-1.9" }],
	["circle", { cx: "17", cy: "17", r: "3" }],
] satisfies IconNode;

export const folderSearch2 = [
	["circle", { cx: "11.5", cy: "12.5", r: "2.5" }],
	[
		"path",
		{
			d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
		},
	],
	["path", { d: "M13.3 14.3 15 16" }],
] satisfies IconNode;

export const folderSymlink = [
	[
		"path",
		{
			d: "M2 9.35V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7",
		},
	],
	["path", { d: "m8 16 3-3-3-3" }],
] satisfies IconNode;

export const folderSync = [
	[
		"path",
		{
			d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v.5",
		},
	],
	["path", { d: "M12 10v4h4" }],
	["path", { d: "m12 14 1.535-1.605a5 5 0 0 1 8 1.5" }],
	["path", { d: "M22 22v-4h-4" }],
	["path", { d: "m22 18-1.535 1.605a5 5 0 0 1-8-1.5" }],
] satisfies IconNode;

export const folderTree = [
	[
		"path",
		{
			d: "M20 10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2.5a1 1 0 0 1-.8-.4l-.9-1.2A1 1 0 0 0 15 3h-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z",
		},
	],
	[
		"path",
		{
			d: "M20 21a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-2.9a1 1 0 0 1-.88-.55l-.42-.85a1 1 0 0 0-.92-.6H13a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z",
		},
	],
	["path", { d: "M3 5a2 2 0 0 0 2 2h3" }],
	["path", { d: "M3 3v13a2 2 0 0 0 2 2h3" }],
] satisfies IconNode;

export const folderUp = [
	[
		"path",
		{
			d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
		},
	],
	["path", { d: "M12 10v6" }],
	["path", { d: "m9 13 3-3 3 3" }],
] satisfies IconNode;

export const folderUser = [
	[
		"path",
		{
			d: "M10.254 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2V9.255",
		},
	],
	["path", { d: "M22 22a4 4 0 0 0-8 0" }],
	["circle", { cx: "18", cy: "15", r: "3" }],
] satisfies IconNode;

export const folderUsers = [
	[
		"path",
		{
			d: "M5.254 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2V9.255",
		},
	],
	["circle", { cx: "13", cy: "15", r: "3" }],
	["path", { d: "M17 22a4 4 0 0 0-8 0" }],
	["path", { d: "M22 22A4 4 0 0 0 20.24 18.686 1 1 0 0 1 20.1 17.143 3 3 0 0 0 19.5 12.402" }],
] satisfies IconNode;

export const folderX = [
	[
		"path",
		{
			d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
		},
	],
	["path", { d: "m9.5 10.5 5 5" }],
	["path", { d: "m14.5 10.5-5 5" }],
] satisfies IconNode;

export const folders = [
	[
		"path",
		{
			d: "M20 5a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h2.5a1.5 1.5 0 0 1 1.2.6l.6.8a1.5 1.5 0 0 0 1.2.6z",
		},
	],
	["path", { d: "M3 8.268a2 2 0 0 0-1 1.738V19a2 2 0 0 0 2 2h11a2 2 0 0 0 1.732-1" }],
] satisfies IconNode;

export const footprints = [
	[
		"path",
		{
			d: "M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z",
		},
	],
	[
		"path",
		{
			d: "M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z",
		},
	],
	["path", { d: "M16 17h4" }],
	["path", { d: "M4 13h4" }],
] satisfies IconNode;

export const forklift = [
	["path", { d: "M12 12H5a2 2 0 0 0-2 2v5" }],
	["path", { d: "M15 19h7" }],
	["path", { d: "M16 19V2" }],
	[
		"path",
		{ d: "M6 12V7a2 2 0 0 1 2-2h2.172a2 2 0 0 1 1.414.586l3.828 3.828A2 2 0 0 1 16 10.828" },
	],
	["path", { d: "M7 19h4" }],
	["circle", { cx: "13", cy: "19", r: "2" }],
	["circle", { cx: "5", cy: "19", r: "2" }],
] satisfies IconNode;

export const form = [
	["path", { d: "M4 14h6" }],
	["path", { d: "M4 2h10" }],
	["rect", { x: "4", y: "18", width: "16", height: "4", rx: "1" }],
	["rect", { x: "4", y: "6", width: "16", height: "4", rx: "1" }],
] satisfies IconNode;

export const forward = [
	["path", { d: "m15 17 5-5-5-5" }],
	["path", { d: "M4 18v-2a4 4 0 0 1 4-4h12" }],
] satisfies IconNode;

export const frame = [
	["line", { x1: "22", x2: "2", y1: "6", y2: "6" }],
	["line", { x1: "22", x2: "2", y1: "18", y2: "18" }],
	["line", { x1: "6", x2: "6", y1: "2", y2: "22" }],
	["line", { x1: "18", x2: "18", y1: "2", y2: "22" }],
] satisfies IconNode;

export const fuel = [
	["path", { d: "M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 4 0v-6.998a2 2 0 0 0-.59-1.42L18 5" }],
	["path", { d: "M14 21V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v16" }],
	["path", { d: "M2 21h13" }],
	["path", { d: "M3 9h11" }],
] satisfies IconNode;

export const fullscreen = [
	["path", { d: "M3 7V5a2 2 0 0 1 2-2h2" }],
	["path", { d: "M17 3h2a2 2 0 0 1 2 2v2" }],
	["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2" }],
	["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2" }],
	["rect", { width: "10", height: "8", x: "7", y: "8", rx: "1" }],
] satisfies IconNode;

export const funnel = [
	[
		"path",
		{
			d: "M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z",
		},
	],
] satisfies IconNode;

export const funnelPlus = [
	[
		"path",
		{
			d: "M13.354 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14v6a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341l1.218-1.348",
		},
	],
	["path", { d: "M16 6h6" }],
	["path", { d: "M19 3v6" }],
] satisfies IconNode;

export const funnelX = [
	[
		"path",
		{
			d: "M12.531 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14v6a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341l.427-.473",
		},
	],
	["path", { d: "m16.5 3.5 5 5" }],
	["path", { d: "m21.5 3.5-5 5" }],
] satisfies IconNode;

export const galaxy = [
	[
		"path",
		{
			d: "M16.005 15.108a5.041 6.52 28.25 00-8.008-6.217 5.041 6.52 28.25 008.008 6.217A11.884 7.288-60.76 014.029 7.001",
		},
	],
	["path", { d: "M17 21h.01" }],
	["path", { d: "M7 3h.01" }],
	["path", { d: "M7.997 8.891a11.885 7.288-60.756 0111.977 8.107" }],
	["circle", { cx: "12", cy: "12", r: "1", fill: "currentColor" }],
] satisfies IconNode;

export const galleryHorizontal = [
	["path", { d: "M2 3v18" }],
	["rect", { width: "12", height: "18", x: "6", y: "3", rx: "2" }],
	["path", { d: "M22 3v18" }],
] satisfies IconNode;

export const galleryHorizontalEnd = [
	["path", { d: "M2 7v10" }],
	["path", { d: "M6 5v14" }],
	["rect", { width: "12", height: "18", x: "10", y: "3", rx: "2" }],
] satisfies IconNode;

export const galleryThumbnails = [
	["rect", { width: "18", height: "14", x: "3", y: "3", rx: "2" }],
	["path", { d: "M4 21h1" }],
	["path", { d: "M9 21h1" }],
	["path", { d: "M14 21h1" }],
	["path", { d: "M19 21h1" }],
] satisfies IconNode;

export const galleryVertical = [
	["path", { d: "M3 2h18" }],
	["rect", { width: "18", height: "12", x: "3", y: "6", rx: "2" }],
	["path", { d: "M3 22h18" }],
] satisfies IconNode;

export const galleryVerticalEnd = [
	["path", { d: "M7 2h10" }],
	["path", { d: "M5 6h14" }],
	["rect", { width: "18", height: "12", x: "3", y: "10", rx: "2" }],
] satisfies IconNode;

export const gamepad = [
	["line", { x1: "6", x2: "10", y1: "12", y2: "12" }],
	["line", { x1: "8", x2: "8", y1: "10", y2: "14" }],
	["line", { x1: "15", x2: "15.01", y1: "13", y2: "13" }],
	["line", { x1: "18", x2: "18.01", y1: "11", y2: "11" }],
	["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2" }],
] satisfies IconNode;

export const gamepad2 = [
	["line", { x1: "6", x2: "10", y1: "11", y2: "11" }],
	["line", { x1: "8", x2: "8", y1: "9", y2: "13" }],
	["line", { x1: "15", x2: "15.01", y1: "12", y2: "12" }],
	["line", { x1: "18", x2: "18.01", y1: "10", y2: "10" }],
	[
		"path",
		{
			d: "M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z",
		},
	],
] satisfies IconNode;

export const gamepadDirectional = [
	[
		"path",
		{
			d: "M11.146 15.854a1.207 1.207 0 0 1 1.708 0l1.56 1.56A2 2 0 0 1 15 18.828V21a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-2.172a2 2 0 0 1 .586-1.414z",
		},
	],
	[
		"path",
		{
			d: "M18.828 15a2 2 0 0 1-1.414-.586l-1.56-1.56a1.207 1.207 0 0 1 0-1.708l1.56-1.56A2 2 0 0 1 18.828 9H21a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1z",
		},
	],
	[
		"path",
		{
			d: "M6.586 14.414A2 2 0 0 1 5.172 15H3a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h2.172a2 2 0 0 1 1.414.586l1.56 1.56a1.207 1.207 0 0 1 0 1.708z",
		},
	],
	[
		"path",
		{
			d: "M9 3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2.172a2 2 0 0 1-.586 1.414l-1.56 1.56a1.207 1.207 0 0 1-1.708 0l-1.56-1.56A2 2 0 0 1 9 5.172z",
		},
	],
] satisfies IconNode;

export const gapHorizontal = [
	["path", { d: "M12 2v2" }],
	["path", { d: "M12 8v2" }],
	["path", { d: "M12 14v2" }],
	["path", { d: "M12 20v2" }],
	["path", { d: "M21 3h-3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3" }],
	["path", { d: "M3 3h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3" }],
] satisfies IconNode;

export const gapVertical = [
	["path", { d: "M2 12h2" }],
	["path", { d: "M8 12h2" }],
	["path", { d: "M14 12h2" }],
	["path", { d: "M20 12h2" }],
	["path", { d: "M3 21v-3a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3" }],
	["path", { d: "M3 3v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3" }],
] satisfies IconNode;

export const gauge = [
	["path", { d: "m12 14 4-4" }],
	["path", { d: "M3.34 19a10 10 0 1 1 17.32 0" }],
] satisfies IconNode;

export const gavel = [
	["path", { d: "m14 13-8.381 8.38a1 1 0 0 1-3.001-3l8.384-8.381" }],
	["path", { d: "m16 16 6-6" }],
	["path", { d: "m21.5 10.5-8-8" }],
	["path", { d: "m8 8 6-6" }],
	["path", { d: "m8.5 7.5 8 8" }],
] satisfies IconNode;

export const gem = [
	["path", { d: "M10.5 3 8 9l4 13 4-13-2.5-6" }],
	[
		"path",
		{
			d: "M17 3a2 2 0 0 1 1.6.8l3 4a2 2 0 0 1 .013 2.382l-7.99 10.986a2 2 0 0 1-3.247 0l-7.99-10.986A2 2 0 0 1 2.4 7.8l2.998-3.997A2 2 0 0 1 7 3z",
		},
	],
	["path", { d: "M2 9h20" }],
] satisfies IconNode;

export const georgianLari = [
	["path", { d: "M11.5 21a7.5 7.5 0 1 1 7.35-9" }],
	["path", { d: "M13 12V3" }],
	["path", { d: "M4 21h16" }],
	["path", { d: "M9 12V3" }],
] satisfies IconNode;

export const germ = [
	["path", { d: "m11 2 .925 1.848" }],
	["path", { d: "M13 15h.01" }],
	["path", { d: "m16 21-1-2.472" }],
	["path", { d: "m19 2-1 1.804" }],
	["path", { d: "m2 19 2.746-1.373" }],
	["path", { d: "m22 16-2.474-2.13" }],
	["path", { d: "m22 5-1.804 1" }],
	["path", { d: "m3 10 2 2" }],
	["path", { d: "M9 16h.01" }],
	["path", { d: "M9 20v2" }],
	[
		"path",
		{
			d: "M9.33 7.035c-.51 1.478-1.786 2.93-3.09 3.794A5 5 0 009 20a12.1 12.1 0 0011.902-9.916A6 6 0 009.33 7.035",
		},
	],
	["circle", { cx: "15", cy: "9", r: "2" }],
] satisfies IconNode;

export const germOff = [
	["path", { d: "m11 2 .925 1.848" }],
	["path", { d: "M13 15h.01" }],
	["path", { d: "M13.424 7.768a2 2 0 112.808 2.808" }],
	["path", { d: "m16 21-1-2.472" }],
	["path", { d: "M16.988 16.988A12 12 0 019 20a5 5 0 01-2.759-9.171 8.8 8.8 0 002.307-2.28" }],
	["path", { d: "m19 2-1 1.804" }],
	["path", { d: "m2 19 2.746-1.373" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "m22 16-2.474-2.13a12 12 0 001.376-3.786 6 6 0 00-10.313-5.151" }],
	["path", { d: "m22 5-1.804 1" }],
	["path", { d: "m3 10 2 2" }],
	["path", { d: "M9 16h.01" }],
	["path", { d: "M9 20v2" }],
] satisfies IconNode;

export const ghost = [
	["path", { d: "M15 10v1" }],
	[
		"path",
		{
			d: "M7.528 20.472a1.6 1.6 0 012.277 0l1.057 1.056a1.6 1.6 0 002.276 0l1.057-1.056a1.6 1.6 0 012.277 0l1.114 1.114a1.4 1.4 0 002.414-1V10a8 8 0 00-16 0v10.586a1.4 1.4 0 002.414 1z",
		},
	],
	["path", { d: "M9 10v1" }],
] satisfies IconNode;

export const gift = [
	["path", { d: "M12 7v14" }],
	["path", { d: "M20 11v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8" }],
	["path", { d: "M7.5 7a1 1 0 0 1 0-5A4.8 8 0 0 1 12 7a4.8 8 0 0 1 4.5-5 1 1 0 0 1 0 5" }],
	["rect", { x: "3", y: "7", width: "18", height: "4", rx: "1" }],
] satisfies IconNode;

export const gitBranch = [
	["path", { d: "M15 6a9 9 0 0 0-9 9V3" }],
	["circle", { cx: "18", cy: "6", r: "3" }],
	["circle", { cx: "6", cy: "18", r: "3" }],
] satisfies IconNode;

export const gitBranchMinus = [
	["path", { d: "M15 6a9 9 0 0 0-9 9V3" }],
	["path", { d: "M21 18h-6" }],
	["circle", { cx: "18", cy: "6", r: "3" }],
	["circle", { cx: "6", cy: "18", r: "3" }],
] satisfies IconNode;

export const gitBranchPlus = [
	["path", { d: "M6 3v12" }],
	["path", { d: "M18 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" }],
	["path", { d: "M6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" }],
	["path", { d: "M15 6a9 9 0 0 0-9 9" }],
	["path", { d: "M18 15v6" }],
	["path", { d: "M21 18h-6" }],
] satisfies IconNode;

export const gitCommitHorizontal = [
	["circle", { cx: "12", cy: "12", r: "3" }],
	["line", { x1: "3", x2: "9", y1: "12", y2: "12" }],
	["line", { x1: "15", x2: "21", y1: "12", y2: "12" }],
] satisfies IconNode;

export const gitCommitVertical = [
	["path", { d: "M12 3v6" }],
	["circle", { cx: "12", cy: "12", r: "3" }],
	["path", { d: "M12 15v6" }],
] satisfies IconNode;

export const gitCompare = [
	["circle", { cx: "18", cy: "18", r: "3" }],
	["circle", { cx: "6", cy: "6", r: "3" }],
	["path", { d: "M13 6h3a2 2 0 0 1 2 2v7" }],
	["path", { d: "M11 18H8a2 2 0 0 1-2-2V9" }],
] satisfies IconNode;

export const gitCompareArrows = [
	["circle", { cx: "5", cy: "6", r: "3" }],
	["path", { d: "M12 6h5a2 2 0 0 1 2 2v7" }],
	["path", { d: "m15 9-3-3 3-3" }],
	["circle", { cx: "19", cy: "18", r: "3" }],
	["path", { d: "M12 18H7a2 2 0 0 1-2-2V9" }],
	["path", { d: "m9 15 3 3-3 3" }],
] satisfies IconNode;

export const gitFork = [
	["circle", { cx: "12", cy: "18", r: "3" }],
	["circle", { cx: "6", cy: "6", r: "3" }],
	["circle", { cx: "18", cy: "6", r: "3" }],
	["path", { d: "M18 9v2c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1V9" }],
	["path", { d: "M12 12v3" }],
] satisfies IconNode;

export const gitGraph = [
	["circle", { cx: "5", cy: "6", r: "3" }],
	["path", { d: "M5 9v6" }],
	["circle", { cx: "5", cy: "18", r: "3" }],
	["path", { d: "M12 3v18" }],
	["circle", { cx: "19", cy: "6", r: "3" }],
	["path", { d: "M16 15.7A9 9 0 0 0 19 9" }],
] satisfies IconNode;

export const gitMerge = [
	["circle", { cx: "18", cy: "18", r: "3" }],
	["circle", { cx: "6", cy: "6", r: "3" }],
	["path", { d: "M6 21V9a9 9 0 0 0 9 9" }],
] satisfies IconNode;

export const gitMergeConflict = [
	["path", { d: "M12 6h4a2 2 0 0 1 2 2v7" }],
	["path", { d: "M6 12v9" }],
	["path", { d: "m8.5 3.5-5 5" }],
	["path", { d: "m8.5 8.5-5-5" }],
	["circle", { cx: "18", cy: "18", r: "3" }],
] satisfies IconNode;

export const gitPullRequest = [
	["circle", { cx: "18", cy: "18", r: "3" }],
	["circle", { cx: "6", cy: "6", r: "3" }],
	["path", { d: "M13 6h3a2 2 0 0 1 2 2v7" }],
	["line", { x1: "6", x2: "6", y1: "9", y2: "21" }],
] satisfies IconNode;

export const gitPullRequestArrow = [
	["circle", { cx: "5", cy: "6", r: "3" }],
	["path", { d: "M5 9v12" }],
	["circle", { cx: "19", cy: "18", r: "3" }],
	["path", { d: "m15 9-3-3 3-3" }],
	["path", { d: "M12 6h5a2 2 0 0 1 2 2v7" }],
] satisfies IconNode;

export const gitPullRequestClosed = [
	["path", { d: "m15.5 3.5 5 5" }],
	["path", { d: "m15.5 8.5 5-5" }],
	["path", { d: "M18 11.62V15" }],
	["path", { d: "M6 9v12" }],
	["circle", { cx: "18", cy: "18", r: "3" }],
	["circle", { cx: "6", cy: "6", r: "3" }],
] satisfies IconNode;

export const gitPullRequestCreate = [
	["circle", { cx: "6", cy: "6", r: "3" }],
	["path", { d: "M6 9v12" }],
	["path", { d: "M13 6h3a2 2 0 0 1 2 2v3" }],
	["path", { d: "M18 15v6" }],
	["path", { d: "M21 18h-6" }],
] satisfies IconNode;

export const gitPullRequestCreateArrow = [
	["circle", { cx: "5", cy: "6", r: "3" }],
	["path", { d: "M5 9v12" }],
	["path", { d: "m15 9-3-3 3-3" }],
	["path", { d: "M12 6h5a2 2 0 0 1 2 2v3" }],
	["path", { d: "M19 15v6" }],
	["path", { d: "M22 18h-6" }],
] satisfies IconNode;

export const gitPullRequestDraft = [
	["circle", { cx: "18", cy: "18", r: "3" }],
	["circle", { cx: "6", cy: "6", r: "3" }],
	["path", { d: "M18 6V5" }],
	["path", { d: "M18 11v-1" }],
	["line", { x1: "6", x2: "6", y1: "9", y2: "21" }],
] satisfies IconNode;

export const glassWater = [
	[
		"path",
		{
			d: "M5.116 4.104A1 1 0 0 1 6.11 3h11.78a1 1 0 0 1 .994 1.105L17.19 20.21A2 2 0 0 1 15.2 22H8.8a2 2 0 0 1-2-1.79z",
		},
	],
	["path", { d: "M6 12a5 5 0 0 1 6 0 5 5 0 0 0 6 0" }],
] satisfies IconNode;

export const glasses = [
	["circle", { cx: "6", cy: "15", r: "4" }],
	["circle", { cx: "18", cy: "15", r: "4" }],
	["path", { d: "M14 15a2 2 0 0 0-2-2 2 2 0 0 0-2 2" }],
	["path", { d: "M2.5 13 5 7c.7-1.3 1.4-2 3-2" }],
	["path", { d: "M21.5 13 19 7c-.7-1.3-1.5-2-3-2" }],
] satisfies IconNode;

export const globe = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" }],
	["path", { d: "M2 12h20" }],
] satisfies IconNode;

export const globeCheck = [
	["path", { d: "m15 6 2 2 4-4" }],
	["path", { d: "M2 12h20A10 10 0 1 1 12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 4-10" }],
] satisfies IconNode;

export const globeCode = [
	["path", { d: "M15.5 10 13 7.5 15.5 5" }],
	["path", { d: "M15.861 14A14.5 14.5 0 0112 22a14.48 14.48 0 010-20 10 10 0 109.888 11.5" }],
	["path", { d: "M19.5 5 22 7.5 19.5 10" }],
	["path", { d: "M2 12h8.5" }],
] satisfies IconNode;

export const globeLock = [
	["path", { d: "M15.686 15A14.5 14.5 0 0 1 12 22a14.5 14.5 0 0 1 0-20 10 10 0 1 0 9.542 13" }],
	["path", { d: "M2 12h8.5" }],
	["path", { d: "M20 6V4a2 2 0 1 0-4 0v2" }],
	["rect", { width: "8", height: "5", x: "14", y: "6", rx: "1" }],
] satisfies IconNode;

export const globeOff = [
	["path", { d: "M10.114 4.462A14.5 14.5 0 0 1 12 2a10 10 0 0 1 9.313 13.643" }],
	["path", { d: "M15.557 15.556A14.5 14.5 0 0 1 12 22 10 10 0 0 1 4.929 4.929" }],
	["path", { d: "M15.892 10.234A14.5 14.5 0 0 0 12 2a10 10 0 0 0-3.643.687" }],
	["path", { d: "M17.656 12H22" }],
	["path", { d: "M19.071 19.071A10 10 0 0 1 12 22 14.5 14.5 0 0 1 8.44 8.45" }],
	["path", { d: "M2 12h10" }],
	["path", { d: "m2 2 20 20" }],
] satisfies IconNode;

export const globeX = [
	["path", { d: "m16 3 5 5" }],
	["path", { d: "M2 12h20A10 10 0 1 1 12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 4-10" }],
	["path", { d: "m21 3-5 5" }],
] satisfies IconNode;

export const goal = [
	["path", { d: "M12 13V2l8 4-8 4" }],
	["path", { d: "M20.561 10.222a9 9 0 1 1-12.55-5.29" }],
	["path", { d: "M8.002 9.997a5 5 0 1 0 8.9 2.02" }],
] satisfies IconNode;

export const gpu = [
	["path", { d: "M2 17h18a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H2" }],
	["path", { d: "M2 21V3" }],
	["path", { d: "M7 17v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3" }],
	["circle", { cx: "16", cy: "11", r: "2" }],
	["circle", { cx: "8", cy: "11", r: "2" }],
] satisfies IconNode;

export const graduationCap = [
	[
		"path",
		{
			d: "M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z",
		},
	],
	["path", { d: "M22 10v6" }],
	["path", { d: "M6 12.5V16a6 3 0 0 0 12 0v-3.5" }],
] satisfies IconNode;

export const grape = [
	["path", { d: "M22 5V2l-5.89 5.89" }],
	["circle", { cx: "16.6", cy: "15.89", r: "3" }],
	["circle", { cx: "8.11", cy: "7.4", r: "3" }],
	["circle", { cx: "12.35", cy: "11.65", r: "3" }],
	["circle", { cx: "13.91", cy: "5.85", r: "3" }],
	["circle", { cx: "18.15", cy: "10.09", r: "3" }],
	["circle", { cx: "6.56", cy: "13.2", r: "3" }],
	["circle", { cx: "10.8", cy: "17.44", r: "3" }],
	["circle", { cx: "5", cy: "19", r: "3" }],
] satisfies IconNode;

export const graphHub = [
	["circle", { cx: "12", cy: "7", r: "4" }],
	["circle", { cx: "4", cy: "19", r: "2" }],
	["circle", { cx: "12", cy: "19", r: "2" }],
	["circle", { cx: "20", cy: "19", r: "2" }],
	["path", { d: "M8 7a4 4 0 0 0-4 4v6" }],
	["path", { d: "M12 11v6" }],
	["path", { d: "M16 7a4 4 0 0 1 4 4v6" }],
] satisfies IconNode;

export const graphStar = [
	["path", { d: "m12.342 9.316 1.764-3.527" }],
	["path", { d: "m12.59 14.545 2.35 3.759" }],
	["path", { d: "m13.982 12.332 4.03.447" }],
	["path", { d: "M5.414 17.586 8.88 14.12" }],
	["path", { d: "M9.025 9.742 5.317 5.505" }],
	["circle", { cx: "11", cy: "12", r: "3" }],
	["circle", { cx: "15", cy: "4", r: "2" }],
	["circle", { cx: "16", cy: "20", r: "2" }],
	["circle", { cx: "20", cy: "13", r: "2" }],
	["circle", { cx: "4", cy: "19", r: "2" }],
	["circle", { cx: "4", cy: "4", r: "2" }],
] satisfies IconNode;

export const grid2x2 = [
	["path", { d: "M12 3v18" }],
	["path", { d: "M3 12h18" }],
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
] satisfies IconNode;

export const grid2x2Check = [
	[
		"path",
		{
			d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
		},
	],
	["path", { d: "m16 19 2 2 4-4" }],
] satisfies IconNode;

export const grid2x2Plus = [
	[
		"path",
		{
			d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
		},
	],
	["path", { d: "M16 19h6" }],
	["path", { d: "M19 22v-6" }],
] satisfies IconNode;

export const grid2x2X = [
	[
		"path",
		{
			d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
		},
	],
	["path", { d: "m16.5 16.5 5 5" }],
	["path", { d: "m16.5 21.5 5-5" }],
] satisfies IconNode;

export const grid3x2 = [
	["path", { d: "M15 3v18" }],
	["path", { d: "M3 12h18" }],
	["path", { d: "M9 3v18" }],
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
] satisfies IconNode;

export const grid3x3 = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M3 9h18" }],
	["path", { d: "M3 15h18" }],
	["path", { d: "M9 3v18" }],
	["path", { d: "M15 3v18" }],
] satisfies IconNode;

export const grip = [
	["circle", { cx: "12", cy: "5", r: "1" }],
	["circle", { cx: "19", cy: "5", r: "1" }],
	["circle", { cx: "5", cy: "5", r: "1" }],
	["circle", { cx: "12", cy: "12", r: "1" }],
	["circle", { cx: "19", cy: "12", r: "1" }],
	["circle", { cx: "5", cy: "12", r: "1" }],
	["circle", { cx: "12", cy: "19", r: "1" }],
	["circle", { cx: "19", cy: "19", r: "1" }],
	["circle", { cx: "5", cy: "19", r: "1" }],
] satisfies IconNode;

export const gripHorizontal = [
	["circle", { cx: "12", cy: "9", r: "1" }],
	["circle", { cx: "19", cy: "9", r: "1" }],
	["circle", { cx: "5", cy: "9", r: "1" }],
	["circle", { cx: "12", cy: "15", r: "1" }],
	["circle", { cx: "19", cy: "15", r: "1" }],
	["circle", { cx: "5", cy: "15", r: "1" }],
] satisfies IconNode;

export const gripVertical = [
	["circle", { cx: "9", cy: "12", r: "1" }],
	["circle", { cx: "9", cy: "5", r: "1" }],
	["circle", { cx: "9", cy: "19", r: "1" }],
	["circle", { cx: "15", cy: "12", r: "1" }],
	["circle", { cx: "15", cy: "5", r: "1" }],
	["circle", { cx: "15", cy: "19", r: "1" }],
] satisfies IconNode;

export const groceries = [
	["path", { d: "M10 15h4" }],
	[
		"path",
		{
			d: "M19.424 11.095a2.5 2.5 0 00.471-2.309 2 2 0 00.424-3.286 2 2 0 00-2.143-3.322 2 2 0 00-.676.502 2 2 0 00-3.287.424 2.5 2.5 0 00-3.189 2.06A3 3 0 0012 11l4-4",
		},
	],
	["path", { d: "M4 12.006A1 1 0 014.994 11H19a1 1 0 011 1v7a2 2 0 01-2 2H6a2 2 0 01-2-2z" }],
	["path", { d: "M7 11a4 4 0 01-4-4V5a1 1 0 011-1h2a4 4 0 013.584 2.222" }],
] satisfies IconNode;

export const group = [
	["path", { d: "M3 7V5c0-1.1.9-2 2-2h2" }],
	["path", { d: "M17 3h2c1.1 0 2 .9 2 2v2" }],
	["path", { d: "M21 17v2c0 1.1-.9 2-2 2h-2" }],
	["path", { d: "M7 21H5c-1.1 0-2-.9-2-2v-2" }],
	["rect", { width: "7", height: "5", x: "7", y: "7", rx: "1" }],
	["rect", { width: "7", height: "5", x: "10", y: "12", rx: "1" }],
] satisfies IconNode;

export const guitar = [
	["path", { d: "m11.9 12.1 4.514-4.514" }],
	[
		"path",
		{
			d: "M20.1 2.3a1 1 0 0 0-1.4 0l-1.114 1.114A2 2 0 0 0 17 4.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 17.828 7h1.344a2 2 0 0 0 1.414-.586L21.7 5.3a1 1 0 0 0 0-1.4z",
		},
	],
	["path", { d: "m6 16 2 2" }],
	[
		"path",
		{
			d: "M8.23 9.85A3 3 0 0 1 11 8a5 5 0 0 1 5 5 3 3 0 0 1-1.85 2.77l-.92.38A2 2 0 0 0 12 18a4 4 0 0 1-4 4 6 6 0 0 1-6-6 4 4 0 0 1 4-4 2 2 0 0 0 1.85-1.23z",
		},
	],
] satisfies IconNode;

export const guitarElectric = [
	["path", { d: "m12.172 11.828 4.242-4.242" }],
	[
		"path",
		{
			d: "M16.414 7.586A2 2 0 0017 6.172V5a2 2 0 011.177-1.823L20.59 2.09a1 1 0 011.32 1.32l-1.088 2.412A2 2 0 0119 7h-1a2 2 0 00-1.586.586",
		},
	],
	["path", { d: "m6 16 2 2" }],
	[
		"path",
		{
			d: "M8.23 9.85a3 3 0 011.28-1.454 1 1 0 011.496.815 4 4 0 003.783 3.783 1 1 0 01.815 1.496 3 3 0 01-1.454 1.28l-.92.38A2 2 0 0012 18a4 4 0 01-4 4 6 6 0 01-6-6 4 4 0 014-4 2 2 0 001.85-1.23z",
		},
	],
] satisfies IconNode;

export const halfNote = [
	["circle", { cx: "12", cy: "18", r: "4" }],
	["path", { d: "M16 18V2" }],
] satisfies IconNode;

export const ham = [
	["path", { d: "M13.144 21.144A7.274 10.445 45 1 0 2.856 10.856" }],
	[
		"path",
		{ d: "M13.144 21.144A7.274 4.365 45 0 0 2.856 10.856a7.274 4.365 45 0 0 10.288 10.288" },
	],
	[
		"path",
		{
			d: "M16.565 10.435 18.6 8.4a2.501 2.501 0 1 0 1.65-4.65 2.5 2.5 0 1 0-4.66 1.66l-2.024 2.025",
		},
	],
	["path", { d: "m8.5 16.5-1-1" }],
] satisfies IconNode;

export const hamburger = [
	["path", { d: "M12 16H4a2 2 0 1 1 0-4h16a2 2 0 1 1 0 4h-4.25" }],
	["path", { d: "M5 12a2 2 0 0 1-2-2 9 7 0 0 1 18 0 2 2 0 0 1-2 2" }],
	["path", { d: "M5 16a2 2 0 0 0-2 2 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 2 2 0 0 0-2-2q0 0 0 0" }],
	["path", { d: "m6.67 12 6.13 4.6a2 2 0 0 0 2.8-.4l3.15-4.2" }],
] satisfies IconNode;

export const hammer = [
	["path", { d: "m15 12-9.373 9.373a1 1 0 0 1-3.001-3L12 9" }],
	["path", { d: "m18 15 4-4" }],
	[
		"path",
		{
			d: "m21.5 11.5-1.914-1.914A2 2 0 0 1 19 8.172v-.344a2 2 0 0 0-.586-1.414l-1.657-1.657A6 6 0 0 0 12.516 3H9l1.243 1.243A6 6 0 0 1 12 8.485V10l2 2h1.172a2 2 0 0 1 1.414.586L18.5 14.5",
		},
	],
] satisfies IconNode;

export const hand = [
	["path", { d: "M18 11V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2" }],
	["path", { d: "M14 10V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2" }],
	["path", { d: "M10 10.5V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v8" }],
	[
		"path",
		{
			d: "M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
		},
	],
] satisfies IconNode;

export const handCoins = [
	["path", { d: "M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17" }],
	[
		"path",
		{
			d: "m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
		},
	],
	["path", { d: "m2 16 6 6" }],
	["circle", { cx: "16", cy: "9", r: "2.9" }],
	["circle", { cx: "6", cy: "5", r: "3" }],
] satisfies IconNode;

export const handFist = [
	[
		"path",
		{
			d: "M12.035 17.012a3 3 0 0 0-3-3l-.311-.002a.72.72 0 0 1-.505-1.229l1.195-1.195A2 2 0 0 1 10.828 11H12a2 2 0 0 0 0-4H9.243a3 3 0 0 0-2.122.879l-2.707 2.707A4.83 4.83 0 0 0 3 14a8 8 0 0 0 8 8h2a8 8 0 0 0 8-8V7a2 2 0 1 0-4 0v2a2 2 0 1 0 4 0",
		},
	],
	["path", { d: "M13.888 9.662A2 2 0 0 0 17 8V5A2 2 0 1 0 13 5" }],
	["path", { d: "M9 5A2 2 0 1 0 5 5V10" }],
	["path", { d: "M9 7V4A2 2 0 1 1 13 4V7.268" }],
] satisfies IconNode;

export const handGrab = [
	["path", { d: "M18 11.5V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1.4" }],
	["path", { d: "M14 10V8a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2" }],
	["path", { d: "M10 9.9V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v5" }],
	["path", { d: "M6 14a2 2 0 0 0-2-2a2 2 0 0 0-2 2" }],
	["path", { d: "M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-4a8 8 0 0 1-8-8 2 2 0 1 1 4 0" }],
] satisfies IconNode;

export const handHeart = [
	["path", { d: "M11 14h2a2 2 0 0 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 16" }],
	[
		"path",
		{
			d: "m14.45 13.39 5.05-4.694C20.196 8 21 6.85 21 5.75a2.75 2.75 0 0 0-4.797-1.837.276.276 0 0 1-.406 0A2.75 2.75 0 0 0 11 5.75c0 1.2.802 2.248 1.5 2.946L16 11.95",
		},
	],
	["path", { d: "m2 15 6 6" }],
	[
		"path",
		{ d: "m7 20 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a1 1 0 0 0-2.75-2.91" },
	],
] satisfies IconNode;

export const handHelping = [
	["path", { d: "M11 12h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 14" }],
	[
		"path",
		{
			d: "m7 18 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
		},
	],
	["path", { d: "m2 13 6 6" }],
] satisfies IconNode;

export const handMetal = [
	["path", { d: "M18 12.5V10a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1.4" }],
	["path", { d: "M14 11V9a2 2 0 1 0-4 0v2" }],
	["path", { d: "M10 10.5V5a2 2 0 1 0-4 0v9" }],
	[
		"path",
		{
			d: "m7 15-1.76-1.76a2 2 0 0 0-2.83 2.82l3.6 3.6C7.5 21.14 9.2 22 12 22h2a8 8 0 0 0 8-8V7a2 2 0 1 0-4 0v5",
		},
	],
] satisfies IconNode;

export const handPlatter = [
	["path", { d: "M12 3V2" }],
	[
		"path",
		{
			d: "m15.4 17.4 3.2-2.8a2 2 0 1 1 2.8 2.9l-3.6 3.3c-.7.8-1.7 1.2-2.8 1.2h-4c-1.1 0-2.1-.4-2.8-1.2l-1.302-1.464A1 1 0 0 0 6.151 19H5",
		},
	],
	["path", { d: "M2 14h12a2 2 0 0 1 0 4h-2" }],
	["path", { d: "M4 10h16" }],
	["path", { d: "M5 10a7 7 0 0 1 14 0" }],
	["path", { d: "M5 14v6a1 1 0 0 1-1 1H2" }],
] satisfies IconNode;

export const handbag = [
	[
		"path",
		{
			d: "M2.048 18.566A2 2 0 0 0 4 21h16a2 2 0 0 0 1.952-2.434l-2-9A2 2 0 0 0 18 8H6a2 2 0 0 0-1.952 1.566z",
		},
	],
	["path", { d: "M8 11V6a4 4 0 0 1 8 0v5" }],
] satisfies IconNode;

export const handleBottomRight = [
	["path", { d: "M21 8 8 21" }],
	["path", { d: "m21 15-6 6" }],
] satisfies IconNode;

export const handshake = [
	["path", { d: "m11 17 2 2a1 1 0 1 0 3-3" }],
	[
		"path",
		{
			d: "m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4",
		},
	],
	["path", { d: "m21 3 1 11h-2" }],
	["path", { d: "M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3" }],
	["path", { d: "M3 4h8" }],
] satisfies IconNode;

export const hardDrive = [
	["path", { d: "M10 16h.01" }],
	[
		"path",
		{
			d: "M2.212 11.577a2 2 0 0 0-.212.896V18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5.527a2 2 0 0 0-.212-.896L18.55 5.11A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
		},
	],
	["path", { d: "M21.946 12.013H2.054" }],
	["path", { d: "M6 16h.01" }],
] satisfies IconNode;

export const hardDriveDownload = [
	["path", { d: "M12 2v8" }],
	["path", { d: "m16 6-4 4-4-4" }],
	["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2" }],
	["path", { d: "M6 18h.01" }],
	["path", { d: "M10 18h.01" }],
] satisfies IconNode;

export const hardDriveUpload = [
	["path", { d: "m16 6-4-4-4 4" }],
	["path", { d: "M12 2v8" }],
	["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2" }],
	["path", { d: "M6 18h.01" }],
	["path", { d: "M10 18h.01" }],
] satisfies IconNode;

export const hardHat = [
	["path", { d: "M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5" }],
	["path", { d: "M14 6a6 6 0 0 1 6 6v3" }],
	["path", { d: "M4 15v-3a6 6 0 0 1 6-6" }],
	["rect", { x: "2", y: "15", width: "20", height: "4", rx: "1" }],
] satisfies IconNode;

export const hash = [
	["line", { x1: "4", x2: "20", y1: "9", y2: "9" }],
	["line", { x1: "4", x2: "20", y1: "15", y2: "15" }],
	["line", { x1: "10", x2: "8", y1: "3", y2: "21" }],
	["line", { x1: "16", x2: "14", y1: "3", y2: "21" }],
] satisfies IconNode;

export const hatGlasses = [
	["path", { d: "M14 18a2 2 0 0 0-4 0" }],
	[
		"path",
		{
			d: "m19 11-2.11-6.657a2 2 0 0 0-2.752-1.148l-1.276.61A2 2 0 0 1 12 4H8.5a2 2 0 0 0-1.925 1.456L5 11",
		},
	],
	["path", { d: "M2 11h20" }],
	["circle", { cx: "17", cy: "18", r: "3" }],
	["circle", { cx: "7", cy: "18", r: "3" }],
] satisfies IconNode;

export const haze = [
	["path", { d: "m5.2 6.2 1.4 1.4" }],
	["path", { d: "M2 13h2" }],
	["path", { d: "M20 13h2" }],
	["path", { d: "m17.4 7.6 1.4-1.4" }],
	["path", { d: "M22 17H2" }],
	["path", { d: "M22 21H2" }],
	["path", { d: "M16 13a4 4 0 0 0-8 0" }],
	["path", { d: "M12 5V2.5" }],
] satisfies IconNode;

export const hd = [
	["path", { d: "M10 12H6" }],
	["path", { d: "M10 15V9" }],
	[
		"path",
		{
			d: "M14 14.5a.5.5 0 0 0 .5.5h1a2.5 2.5 0 0 0 2.5-2.5v-1A2.5 2.5 0 0 0 15.5 9h-1a.5.5 0 0 0-.5.5z",
		},
	],
	["path", { d: "M6 15V9" }],
	["rect", { x: "2", y: "5", width: "20", height: "14", rx: "2" }],
] satisfies IconNode;

export const hdmiPort = [
	[
		"path",
		{
			d: "M22 9a1 1 0 00-1-1H3a1 1 0 00-1 1v4a1 1 0 001 1h.5a2 2 0 011.6.8l.3.4A2 2 0 007 16h10a2 2 0 001.6-.8l.3-.4a2 2 0 011.6-.8h.5a1 1 0 001-1z",
		},
	],
	["path", { d: "M8 12h8" }],
] satisfies IconNode;

export const heading = [
	["path", { d: "M6 12h12" }],
	["path", { d: "M6 20V4" }],
	["path", { d: "M18 20V4" }],
] satisfies IconNode;

export const heading1 = [
	["path", { d: "M4 12h8" }],
	["path", { d: "M4 18V6" }],
	["path", { d: "M12 18V6" }],
	["path", { d: "m17 12 3-2v8" }],
] satisfies IconNode;

export const heading2 = [
	["path", { d: "M4 12h8" }],
	["path", { d: "M4 18V6" }],
	["path", { d: "M12 18V6" }],
	["path", { d: "M21 18h-4c0-4 4-3 4-6 0-1.5-2-2.5-4-1" }],
] satisfies IconNode;

export const heading3 = [
	["path", { d: "M4 12h8" }],
	["path", { d: "M4 18V6" }],
	["path", { d: "M12 18V6" }],
	["path", { d: "M17.5 10.5c1.7-1 3.5 0 3.5 1.5a2 2 0 0 1-2 2" }],
	["path", { d: "M17 17.5c2 1.5 4 .3 4-1.5a2 2 0 0 0-2-2" }],
] satisfies IconNode;

export const heading4 = [
	["path", { d: "M12 18V6" }],
	["path", { d: "M17 10v3a1 1 0 0 0 1 1h3" }],
	["path", { d: "M21 10v8" }],
	["path", { d: "M4 12h8" }],
	["path", { d: "M4 18V6" }],
] satisfies IconNode;

export const heading5 = [
	["path", { d: "M4 12h8" }],
	["path", { d: "M4 18V6" }],
	["path", { d: "M12 18V6" }],
	["path", { d: "M17 13v-3h4" }],
	["path", { d: "M17 17.7c.4.2.8.3 1.3.3 1.5 0 2.7-1.1 2.7-2.5S19.8 13 18.3 13H17" }],
] satisfies IconNode;

export const heading6 = [
	["path", { d: "M4 12h8" }],
	["path", { d: "M4 18V6" }],
	["path", { d: "M12 18V6" }],
	["circle", { cx: "19", cy: "16", r: "2" }],
	["path", { d: "M20 10c-2 2-3 3.5-3 6" }],
] satisfies IconNode;

export const headphoneOff = [
	["path", { d: "M21 14h-1.343" }],
	["path", { d: "M9.128 3.47A9 9 0 0 1 21 12v3.343" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M20.414 20.414A2 2 0 0 1 19 21h-1a2 2 0 0 1-2-2v-3" }],
	["path", { d: "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 2.636-6.364" }],
] satisfies IconNode;

export const headphones = [
	[
		"path",
		{
			d: "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3",
		},
	],
] satisfies IconNode;

export const headset = [
	[
		"path",
		{
			d: "M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z",
		},
	],
	["path", { d: "M21 16v2a4 4 0 0 1-4 4h-5" }],
] satisfies IconNode;

export const heart = [
	[
		"path",
		{
			d: "M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5",
		},
	],
] satisfies IconNode;

export const heartCrack = [
	[
		"path",
		{
			d: "M12.409 5.824c-.702.792-1.15 1.496-1.415 2.166l2.153 2.156a.5.5 0 0 1 0 .707l-2.293 2.293a.5.5 0 0 0 0 .707L12 15",
		},
	],
	[
		"path",
		{
			d: "M13.508 20.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5a5.5 5.5 0 0 1 9.591-3.677.6.6 0 0 0 .818.001A5.5 5.5 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5z",
		},
	],
] satisfies IconNode;

export const heartHandshake = [
	[
		"path",
		{
			d: "M19.414 14.414C21 12.828 22 11.5 22 9.5a5.5 5.5 0 0 0-9.591-3.676.6.6 0 0 1-.818.001A5.5 5.5 0 0 0 2 9.5c0 2.3 1.5 4 3 5.5l5.535 5.362a2 2 0 0 0 2.879.052 2.12 2.12 0 0 0-.004-3 2.124 2.124 0 1 0 3-3 2.124 2.124 0 0 0 3.004 0 2 2 0 0 0 0-2.828l-1.881-1.882a2.41 2.41 0 0 0-3.409 0l-1.71 1.71a2 2 0 0 1-2.828 0 2 2 0 0 1 0-2.828l2.823-2.762",
		},
	],
] satisfies IconNode;

export const heartMinus = [
	[
		"path",
		{
			d: "m14.876 18.99-1.368 1.323a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5a5.2 5.2 0 0 1-.244 1.572",
		},
	],
	["path", { d: "M15 15h6" }],
] satisfies IconNode;

export const heartOff = [
	[
		"path",
		{
			d: "M10.5 4.893a5.5 5.5 0 0 1 1.091.931.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 1.872-1.002 3.356-2.187 4.655",
		},
	],
	[
		"path",
		{
			d: "m16.967 16.967-3.459 3.346a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5a5.5 5.5 0 0 1 2.747-4.761",
		},
	],
	["path", { d: "m2 2 20 20" }],
] satisfies IconNode;

export const heartPlus = [
	[
		"path",
		{
			d: "m14.479 19.374-.971.939a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5a5.2 5.2 0 0 1-.219 1.49",
		},
	],
	["path", { d: "M15 15h6" }],
	["path", { d: "M18 12v6" }],
] satisfies IconNode;

export const heartPulse = [
	[
		"path",
		{
			d: "M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5",
		},
	],
	["path", { d: "M3.22 13H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27" }],
] satisfies IconNode;

export const heartX = [
	["path", { d: "m15.5 12.5 5 5" }],
	["path", { d: "m20.5 12.5-5 5" }],
	[
		"path",
		{
			d: "M21.955 8.774a5.5 5.5 0 0 0-9.546-2.95.6.6 0 0 1-.818 0A5.5 5.5 0 0 0 2 9.5c0 2.3 1.5 4 3 5.5l5.508 5.332a2 2 0 0 0 2.57.352",
		},
	],
] satisfies IconNode;

export const heater = [
	["path", { d: "M11 8c2-3-2-3 0-6" }],
	["path", { d: "M15.5 8c2-3-2-3 0-6" }],
	["path", { d: "M6 10h.01" }],
	["path", { d: "M6 14h.01" }],
	["path", { d: "M10 16v-4" }],
	["path", { d: "M14 16v-4" }],
	["path", { d: "M18 16v-4" }],
	["path", { d: "M20 6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3" }],
	["path", { d: "M5 20v2" }],
	["path", { d: "M19 20v2" }],
] satisfies IconNode;

export const helicopter = [
	["path", { d: "M11 17v4" }],
	["path", { d: "M14 3v8a2 2 0 0 0 2 2h5.865" }],
	["path", { d: "M17 17v4" }],
	["path", { d: "M18 17a4 4 0 0 0 4-4 8 6 0 0 0-8-6 6 5 0 0 0-6 5v3a2 2 0 0 0 2 2z" }],
	["path", { d: "M2 10v5" }],
	["path", { d: "M6 3h16" }],
	["path", { d: "M7 21h14" }],
	["path", { d: "M8 13H2" }],
] satisfies IconNode;

export const hexagon = [
	[
		"path",
		{
			d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
		},
	],
] satisfies IconNode;

export const highlighter = [
	["path", { d: "m9 11-6 6v3h9l3-3" }],
	["path", { d: "m22 12-4.6 4.6a2 2 0 0 1-2.8 0l-5.2-5.2a2 2 0 0 1 0-2.8L14 4" }],
] satisfies IconNode;

export const hikingStick = [
	["path", { d: "M13.5 10.5 2 22" }],
	[
		"path",
		{
			d: "M16.352 11.648a1.205 1.205 0 01-1.704 0l-2.296-2.296a1.205 1.205 0 010-1.704l.72-.72a2 2 0 011.022-.546l.599-.12a2 2 0 001.569-1.57l.12-.598a2 2 0 01.546-1.022l.72-.72a1.205 1.205 0 011.704 0l2.296 2.296a1.205 1.205 0 010 1.704l-6.02 6.02a1 1 0 103 3l.201-.201A7.4 7.4 0 0021 9.93V7",
		},
	],
	["path", { d: "m6 21-3-3" }],
] satisfies IconNode;

export const hop = [
	[
		"path",
		{ d: "M10.82 16.12c1.69.6 3.91.79 5.18.85.55.03 1-.42.97-.97-.06-1.27-.26-3.5-.85-5.18" },
	],
	[
		"path",
		{
			d: "M11.5 6.5c1.64 0 5-.38 6.71-1.07.52-.2.55-.82.12-1.17A10 10 0 0 0 4.26 18.33c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.88.88 0 0 0 .73-.74c.3-2.14-.15-3.5-.61-4.88",
		},
	],
	[
		"path",
		{ d: "M15.62 16.95c.2.85.62 2.76.5 4.28a.77.77 0 0 1-.9.7 16.64 16.64 0 0 1-4.08-1.36" },
	],
	[
		"path",
		{ d: "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .96-.96 17.68 17.68 0 0 0-.9-4.87" },
	],
	[
		"path",
		{ d: "M16.94 15.62c.86.2 2.77.62 4.29.5a.77.77 0 0 0 .7-.9 16.64 16.64 0 0 0-1.36-4.08" },
	],
	[
		"path",
		{ d: "M17.99 5.52a20.82 20.82 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-2.33.2-5.3-.32-8.27-1.57" },
	],
	["path", { d: "M4.93 4.93 3 3a.7.7 0 0 1 0-1" }],
	[
		"path",
		{
			d: "M9.58 12.18c1.24 2.98 1.77 5.95 1.57 8.28a.8.8 0 0 1-1.13.68 20.82 20.82 0 0 1-4.5-3.15",
		},
	],
] satisfies IconNode;

export const hopOff = [
	["path", { d: "M10.82 16.12c1.69.6 3.91.79 5.18.85.28.01.53-.09.7-.27" }],
	[
		"path",
		{ d: "M11.14 20.57c.52.24 2.44 1.12 4.08 1.37.46.06.86-.25.9-.71.12-1.52-.3-3.43-.5-4.28" },
	],
	["path", { d: "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .7-.26" }],
	[
		"path",
		{ d: "M17.99 5.52a20.83 20.83 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-1.17.1-2.5.02-3.9-.25" },
	],
	["path", { d: "M20.57 11.14c.24.52 1.12 2.44 1.37 4.08.04.3-.08.59-.31.75" }],
	[
		"path",
		{
			d: "M4.93 4.93a10 10 0 0 0-.67 13.4c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.85.85 0 0 0 .48-.24",
		},
	],
	[
		"path",
		{ d: "M5.52 17.99c1.05.95 2.91 2.42 4.5 3.15a.8.8 0 0 0 1.13-.68c.2-2.34-.33-5.3-1.57-8.28" },
	],
	["path", { d: "M8.35 2.68a10 10 0 0 1 9.98 1.58c.43.35.4.96-.12 1.17-1.5.6-4.3.98-6.07 1.05" }],
	["path", { d: "m2 2 20 20" }],
] satisfies IconNode;

export const hospital = [
	["path", { d: "M12 7v4" }],
	["path", { d: "M14 21v-3a2 2 0 0 0-4 0v3" }],
	["path", { d: "M14 9h-4" }],
	["path", { d: "M18 11h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h2" }],
	["path", { d: "M18 21V5a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16" }],
] satisfies IconNode;

export const hotel = [
	["path", { d: "M10 22v-6.57" }],
	["path", { d: "M12 11h.01" }],
	["path", { d: "M12 7h.01" }],
	["path", { d: "M14 15.43V22" }],
	["path", { d: "M15 16a5 5 0 0 0-6 0" }],
	["path", { d: "M16 11h.01" }],
	["path", { d: "M16 7h.01" }],
	["path", { d: "M8 11h.01" }],
	["path", { d: "M8 7h.01" }],
	["rect", { x: "4", y: "2", width: "16", height: "20", rx: "2" }],
] satisfies IconNode;

export const hourglass = [
	["path", { d: "M5 22h14" }],
	["path", { d: "M5 2h14" }],
	["path", { d: "M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22" }],
	["path", { d: "M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2" }],
] satisfies IconNode;

export const hourglassCog = [
	["path", { d: "m14.305 19.53.923-.382" }],
	["path", { d: "m15.228 16.852-.923-.383" }],
	["path", { d: "m16.852 15.228-.383-.923" }],
	["path", { d: "m16.852 20.772-.383.924" }],
	["path", { d: "M17 2v4.172a2 2 0 0 1-.586 1.414l-8.828 8.828A2 2 0 0 0 7 17.828V22" }],
	["path", { d: "m19.148 15.228.383-.923" }],
	["path", { d: "m19.53 21.696-.382-.924" }],
	["path", { d: "m20.772 16.852.924-.383" }],
	["path", { d: "m20.772 19.148.924.383" }],
	["path", { d: "M5 22h6.159" }],
	["path", { d: "M5 2h14" }],
	["path", { d: "M7 2v4.172a2 2 0 0 0 .586 1.414l5.188 5.188" }],
	["circle", { cx: "18", cy: "18", r: "3" }],
] satisfies IconNode;

export const house = [
	["path", { d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" }],
	[
		"path",
		{
			d: "M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
		},
	],
] satisfies IconNode;

export const houseCog = [
	[
		"path",
		{
			d: "M10.584 21H5a2 2 0 01-2-2v-9a2 2 0 01.709-1.527l7-6a2 2 0 012.582 0l7 6A2 2 0 0121 10.001v.583",
		},
	],
	["path", { d: "M14 12H10a1 1 0 00-1 1v8" }],
	["path", { d: "m14.305 19.53.923-.382" }],
	["path", { d: "m15.229 16.852-.924-.383" }],
	["path", { d: "m16.852 15.228-.383-.923" }],
	["path", { d: "m16.852 20.773-.383.924" }],
	["path", { d: "m19.148 15.228.383-.923" }],
	["path", { d: "m19.53 21.697-.382-.924" }],
	["path", { d: "m20.773 16.852.922-.383" }],
	["path", { d: "m20.773 19.148.922.383" }],
	["circle", { cx: "18", cy: "18", r: "3" }],
] satisfies IconNode;

export const houseHeart = [
	[
		"path",
		{
			d: "M8.62 13.8A2.25 2.25 0 1 1 12 10.836a2.25 2.25 0 1 1 3.38 2.966l-2.626 2.856a.998.998 0 0 1-1.507 0z",
		},
	],
	[
		"path",
		{
			d: "M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
		},
	],
] satisfies IconNode;

export const housePlug = [
	["path", { d: "M10 12V8.964" }],
	["path", { d: "M14 12V8.964" }],
	["path", { d: "M15 12a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-2a1 1 0 0 1 1-1z" }],
	[
		"path",
		{
			d: "M8.5 21H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-2",
		},
	],
] satisfies IconNode;

export const housePlus = [
	[
		"path",
		{
			d: "M12.35 21H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 .71-1.53l7-6a2 2 0 0 1 2.58 0l7 6A2 2 0 0 1 21 10v2.35",
		},
	],
	["path", { d: "M14.8 12.4A1 1 0 0 0 14 12h-4a1 1 0 0 0-1 1v8" }],
	["path", { d: "M15 18h6" }],
	["path", { d: "M18 15v6" }],
] satisfies IconNode;

export const houseWifi = [
	["path", { d: "M9.5 13.866a4 4 0 0 1 5 .01" }],
	["path", { d: "M12 17h.01" }],
	[
		"path",
		{
			d: "M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
		},
	],
	["path", { d: "M7 10.754a8 8 0 0 1 10 0" }],
] satisfies IconNode;

export const houses = [
	[
		"path",
		{
			d: "m12.681 4.24.834-.715a1.45 1.45 0 011.88 0l5.09 4.364A1.45 1.45 0 0121 9v6.546a1.45 1.45 0 01-1 1.381",
		},
	],
	[
		"path",
		{
			d: "M15.485 11.889A1.45 1.45 0 0116 13v6.546A1.454 1.454 0 0114.546 21H4.364a1.454 1.454 0 01-1.454-1.454V13a1.45 1.45 0 01.515-1.111l5.09-4.364a1.45 1.45 0 011.88 0z",
		},
	],
	["path", { d: "M7.41 20.546v-4a1 1 0 011-1h2a1 1 0 011 1v4" }],
] satisfies IconNode;

export const iceCreamBowl = [
	[
		"path",
		{ d: "M12 17c5 0 8-2.69 8-6H4c0 3.31 3 6 8 6m-4 4h8m-4-3v3M5.14 11a3.5 3.5 0 1 1 6.71 0" },
	],
	["path", { d: "M12.14 11a3.5 3.5 0 1 1 6.71 0" }],
	["path", { d: "M15.5 6.5a3.5 3.5 0 1 0-7 0" }],
] satisfies IconNode;

export const iceCreamCone = [
	["path", { d: "m7 11 4.08 10.35a1 1 0 0 0 1.84 0L17 11" }],
	["path", { d: "M17 7A5 5 0 0 0 7 7" }],
	["path", { d: "M17 7a2 2 0 0 1 0 4H7a2 2 0 0 1 0-4" }],
] satisfies IconNode;

export const idCard = [
	["path", { d: "M13 19a4 4 0 00-8 0" }],
	["path", { d: "M16 10h2" }],
	["path", { d: "M16 14h2" }],
	["circle", { cx: "9", cy: "12", r: "3" }],
	["rect", { x: "2", y: "5", width: "20", height: "14", rx: "2" }],
] satisfies IconNode;

export const idCardLanyard = [
	["path", { d: "M13.5 8h-3" }],
	["path", { d: "m15 2-1 2h3a2 2 0 012 2v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6a2 2 0 012-2h3" }],
	["path", { d: "M16 22a4 4 0 00-8 0" }],
	["path", { d: "m9 2 3 6" }],
	["circle", { cx: "12", cy: "15", r: "3" }],
] satisfies IconNode;

export const image = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
	["circle", { cx: "9", cy: "9", r: "2" }],
	["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" }],
] satisfies IconNode;

export const imageDown = [
	[
		"path",
		{
			d: "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21",
		},
	],
	["path", { d: "m14 19 3 3v-5.5" }],
	["path", { d: "m17 22 3-3" }],
	["circle", { cx: "9", cy: "9", r: "2" }],
] satisfies IconNode;

export const imageMinus = [
	["path", { d: "M21 9v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7" }],
	["line", { x1: "16", x2: "22", y1: "5", y2: "5" }],
	["circle", { cx: "9", cy: "9", r: "2" }],
	["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" }],
] satisfies IconNode;

export const imageOff = [
	["line", { x1: "2", x2: "22", y1: "2", y2: "22" }],
	["path", { d: "M10.41 10.41a2 2 0 1 1-2.83-2.83" }],
	["line", { x1: "13.5", x2: "6", y1: "13.5", y2: "21" }],
	["line", { x1: "18", x2: "21", y1: "12", y2: "15" }],
	["path", { d: "M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59" }],
	["path", { d: "M21 15V5a2 2 0 0 0-2-2H9" }],
] satisfies IconNode;

export const imagePlay = [
	[
		"path",
		{
			d: "M15 15.003a1 1 0 0 1 1.517-.859l4.997 2.997a1 1 0 0 1 0 1.718l-4.997 2.997a1 1 0 0 1-1.517-.86z",
		},
	],
	["path", { d: "M21 12.17V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6" }],
	["path", { d: "m6 21 5-5" }],
	["circle", { cx: "9", cy: "9", r: "2" }],
] satisfies IconNode;

export const imagePlus = [
	["path", { d: "M16 5h6" }],
	["path", { d: "M19 2v6" }],
	["path", { d: "M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5" }],
	["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" }],
	["circle", { cx: "9", cy: "9", r: "2" }],
] satisfies IconNode;

export const imageUp = [
	[
		"path",
		{
			d: "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21",
		},
	],
	["path", { d: "m14 19.5 3-3 3 3" }],
	["path", { d: "M17 22v-5.5" }],
	["circle", { cx: "9", cy: "9", r: "2" }],
] satisfies IconNode;

export const imageUpscale = [
	["path", { d: "M16 3h5v5" }],
	["path", { d: "M17 21h2a2 2 0 0 0 2-2" }],
	["path", { d: "M21 12v3" }],
	["path", { d: "m21 3-5 5" }],
	["path", { d: "M3 7V5a2 2 0 0 1 2-2" }],
	["path", { d: "m5 21 4.144-4.144a1.21 1.21 0 0 1 1.712 0L13 19" }],
	["path", { d: "M9 3h3" }],
	["rect", { x: "3", y: "11", width: "10", height: "10", rx: "1" }],
] satisfies IconNode;

export const images = [
	["path", { d: "m22 11-1.296-1.296a2.4 2.4 0 0 0-3.408 0L11 16" }],
	["path", { d: "M4 8a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2" }],
	["circle", { cx: "13", cy: "7", r: "1", fill: "currentColor" }],
	["rect", { x: "8", y: "2", width: "14", height: "14", rx: "2" }],
] satisfies IconNode;

export const importNode = [
	["path", { d: "M12 3v12" }],
	["path", { d: "m8 11 4 4 4-4" }],
	["path", { d: "M8 5H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4" }],
] satisfies IconNode;

export const inbox = [
	["polyline", { points: "22 12 16 12 14 15 10 15 8 12 2 12" }],
	[
		"path",
		{
			d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
		},
	],
] satisfies IconNode;

export const indianRupee = [
	["path", { d: "M6 3h12" }],
	["path", { d: "M6 8h12" }],
	["path", { d: "m6 13 8.5 8" }],
	["path", { d: "M6 13h3" }],
	["path", { d: "M9 13c6.667 0 6.667-10 0-10" }],
] satisfies IconNode;

export const infinity = [
	["path", { d: "M6 16c5 0 7-8 12-8a4 4 0 0 1 0 8c-5 0-7-8-12-8a4 4 0 1 0 0 8" }],
] satisfies IconNode;

export const info = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "M12 16v-4" }],
	["path", { d: "M12 8h.01" }],
] satisfies IconNode;

export const inspectionPanel = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M7 7h.01" }],
	["path", { d: "M17 7h.01" }],
	["path", { d: "M7 17h.01" }],
	["path", { d: "M17 17h.01" }],
] satisfies IconNode;

export const italic = [
	["line", { x1: "19", x2: "10", y1: "4", y2: "4" }],
	["line", { x1: "14", x2: "5", y1: "20", y2: "20" }],
	["line", { x1: "15", x2: "9", y1: "4", y2: "20" }],
] satisfies IconNode;

export const iterationCcw = [
	["path", { d: "m16 14 4 4-4 4" }],
	["path", { d: "M20 10a8 8 0 1 0-8 8h8" }],
] satisfies IconNode;

export const iterationCw = [
	["path", { d: "M4 10a8 8 0 1 1 8 8H4" }],
	["path", { d: "m8 22-4-4 4-4" }],
] satisfies IconNode;

export const ivBag = [
	["path", { d: "M12 18v2a2 2 0 002 2h6" }],
	["path", { d: "M6 11c.72.5 1.44 1 3 1 3 0 3-2 6-2 1.56 0 2.28.5 3 1" }],
	[
		"path",
		{
			d: "M9.293 3c.453 0 .887-.18 1.207-.5s.754-.5 1.207-.5h.586c.453 0 .887.18 1.207.5s.754.5 1.207.5H16a2 2 0 012 2v11a2 2 0 01-2 2H8a2 2 0 01-2-2V5a2 2 0 012-2z",
		},
	],
] satisfies IconNode;

export const japaneseYen = [
	["path", { d: "M12 9.5V21m0-11.5L6 3m6 6.5L18 3" }],
	["path", { d: "M6 15h12" }],
	["path", { d: "M6 11h12" }],
] satisfies IconNode;

export const joystick = [
	["path", { d: "M21 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2Z" }],
	["path", { d: "M6 15v-2" }],
	["path", { d: "M12 15V9" }],
	["circle", { cx: "12", cy: "6", r: "3" }],
] satisfies IconNode;

export const kanban = [
	["path", { d: "M5 3v14" }],
	["path", { d: "M12 3v8" }],
	["path", { d: "M19 3v18" }],
] satisfies IconNode;

export const kayak = [
	["path", { d: "M18 17a1 1 0 0 0-1 1v1a2 2 0 1 0 2-2z" }],
	[
		"path",
		{
			d: "M20.97 3.61a.45.45 0 0 0-.58-.58C10.2 6.6 6.6 10.2 3.03 20.39a.45.45 0 0 0 .58.58C13.8 17.4 17.4 13.8 20.97 3.61",
		},
	],
	["path", { d: "m6.707 6.707 10.586 10.586" }],
	["path", { d: "M7 5a2 2 0 1 0-2 2h1a1 1 0 0 0 1-1z" }],
] satisfies IconNode;

export const kazakhTenge = [
	["path", { d: "M12 8v12" }],
	["path", { d: "M6 4h12" }],
	["path", { d: "M6 8h12" }],
] satisfies IconNode;

export const key = [
	["path", { d: "m2 21 9.6-9.6" }],
	["path", { d: "m7.5 15.5 2.3 2.3a1 1 0 0 1 0 1.4l-2.1 2.1a1 1 0 0 1-1.4 0L4 19" }],
	["circle", { cx: "15.5", cy: "7.5", r: "5.5" }],
] satisfies IconNode;

export const keyRound = [
	[
		"path",
		{
			d: "M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z",
		},
	],
	["circle", { cx: "16.5", cy: "7.5", r: ".5", fill: "currentColor" }],
] satisfies IconNode;

export const keySquare = [
	[
		"path",
		{
			d: "M12.4 2.7a2.5 2.5 0 0 1 3.4 0l5.5 5.5a2.5 2.5 0 0 1 0 3.4l-3.7 3.7a2.5 2.5 0 0 1-3.4 0L8.7 9.8a2.5 2.5 0 0 1 0-3.4z",
		},
	],
	["path", { d: "m14 7 3 3" }],
	[
		"path",
		{
			d: "m9.4 10.6-6.814 6.814A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814",
		},
	],
] satisfies IconNode;

export const keyboard = [
	["path", { d: "M10 8h.01" }],
	["path", { d: "M12 12h.01" }],
	["path", { d: "M14 8h.01" }],
	["path", { d: "M16 12h.01" }],
	["path", { d: "M18 8h.01" }],
	["path", { d: "M6 8h.01" }],
	["path", { d: "M7 16h10" }],
	["path", { d: "M8 12h.01" }],
	["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2" }],
] satisfies IconNode;

export const keyboardMusic = [
	["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2" }],
	["path", { d: "M6 8h4" }],
	["path", { d: "M14 8h.01" }],
	["path", { d: "M18 8h.01" }],
	["path", { d: "M2 12h20" }],
	["path", { d: "M6 12v4" }],
	["path", { d: "M10 12v4" }],
	["path", { d: "M14 12v4" }],
	["path", { d: "M18 12v4" }],
] satisfies IconNode;

export const keyboardOff = [
	["path", { d: "M 20 4 A2 2 0 0 1 22 6" }],
	["path", { d: "M 22 6 L 22 16.41" }],
	["path", { d: "M 7 16 L 16 16" }],
	["path", { d: "M 9.69 4 L 20 4" }],
	["path", { d: "M14 8h.01" }],
	["path", { d: "M18 8h.01" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M20 20H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2" }],
	["path", { d: "M6 8h.01" }],
	["path", { d: "M8 12h.01" }],
] satisfies IconNode;

export const lambda = [
	["path", { d: "M11.38 10 5 20" }],
	["path", { d: "M19 18a2 2 0 01-2 2c-4.87-.003-5.052-16-10-16a2 2 0 00-2 2" }],
] satisfies IconNode;

export const lamp = [
	["path", { d: "M12 12v6" }],
	[
		"path",
		{
			d: "M4.077 10.615A1 1 0 0 0 5 12h14a1 1 0 0 0 .923-1.385l-3.077-7.384A2 2 0 0 0 15 2H9a2 2 0 0 0-1.846 1.23Z",
		},
	],
	["path", { d: "M8 20a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1z" }],
] satisfies IconNode;

export const lampCeiling = [
	["path", { d: "M12 2v5" }],
	["path", { d: "M14.829 15.998a3 3 0 1 1-5.658 0" }],
	[
		"path",
		{
			d: "M20.92 14.606A1 1 0 0 1 20 16H4a1 1 0 0 1-.92-1.394l3-7A1 1 0 0 1 7 7h10a1 1 0 0 1 .92.606z",
		},
	],
] satisfies IconNode;

export const lampDesk = [
	[
		"path",
		{
			d: "M10.293 2.293a1 1 0 0 1 1.414 0l2.5 2.5 5.994 1.227a1 1 0 0 1 .506 1.687l-7 7a1 1 0 0 1-1.687-.506l-1.227-5.994-2.5-2.5a1 1 0 0 1 0-1.414z",
		},
	],
	["path", { d: "m14.207 4.793-3.414 3.414" }],
	["path", { d: "M3 20a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z" }],
	["path", { d: "m9.086 6.5-4.793 4.793a1 1 0 0 0-.18 1.17L7 18" }],
] satisfies IconNode;

export const lampFloor = [
	["path", { d: "M12 10v12" }],
	[
		"path",
		{
			d: "M17.929 7.629A1 1 0 0 1 17 9H7a1 1 0 0 1-.928-1.371l2-5A1 1 0 0 1 9 2h6a1 1 0 0 1 .928.629z",
		},
	],
	["path", { d: "M9 22h6" }],
] satisfies IconNode;

export const lampWallDown = [
	[
		"path",
		{
			d: "M19.929 18.629A1 1 0 0 1 19 20H9a1 1 0 0 1-.928-1.371l2-5A1 1 0 0 1 11 13h6a1 1 0 0 1 .928.629z",
		},
	],
	["path", { d: "M6 3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" }],
	["path", { d: "M8 6h4a2 2 0 0 1 2 2v5" }],
] satisfies IconNode;

export const lampWallUp = [
	[
		"path",
		{
			d: "M19.929 9.629A1 1 0 0 1 19 11H9a1 1 0 0 1-.928-1.371l2-5A1 1 0 0 1 11 4h6a1 1 0 0 1 .928.629z",
		},
	],
	["path", { d: "M6 15a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1z" }],
	["path", { d: "M8 18h4a2 2 0 0 0 2-2v-5" }],
] satisfies IconNode;

export const landPlot = [
	["path", { d: "m12 8 6-3-6-3v10" }],
	[
		"path",
		{
			d: "m8 11.99-5.5 3.14a1 1 0 0 0 0 1.74l8.5 4.86a2 2 0 0 0 2 0l8.5-4.86a1 1 0 0 0 0-1.74L16 12",
		},
	],
	["path", { d: "m6.49 12.85 11.02 6.3" }],
	["path", { d: "M17.51 12.85 6.5 19.15" }],
] satisfies IconNode;

export const landmark = [
	["path", { d: "M10 18v-7" }],
	[
		"path",
		{ d: "M11.119 2.205a2 2 0 0 1 1.762 0l7.84 3.846A.5.5 0 0 1 20.5 7h-17a.5.5 0 0 1-.22-.949z" },
	],
	["path", { d: "M14 18v-7" }],
	["path", { d: "M18 18v-7" }],
	["path", { d: "M3 22h18" }],
	["path", { d: "M6 18v-7" }],
] satisfies IconNode;

export const languages = [
	["path", { d: "m5 8 6 6" }],
	["path", { d: "m4 14 6-6 2-3" }],
	["path", { d: "M2 5h12" }],
	["path", { d: "M7 2h1" }],
	["path", { d: "m22 22-5-10-5 10" }],
	["path", { d: "M14 18h6" }],
] satisfies IconNode;

export const laptop = [
	[
		"path",
		{
			d: "M18 5a2 2 0 0 1 2 2v8.526a2 2 0 0 0 .212.897l1.068 2.127a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45l1.068-2.127A2 2 0 0 0 4 15.526V7a2 2 0 0 1 2-2z",
		},
	],
	["path", { d: "M20.054 15.987H3.946" }],
] satisfies IconNode;

export const laptopMinimal = [
	["rect", { width: "18", height: "12", x: "3", y: "4", rx: "2", ry: "2" }],
	["line", { x1: "2", x2: "22", y1: "20", y2: "20" }],
] satisfies IconNode;

export const laptopMinimalCheck = [
	["path", { d: "M2 20h20" }],
	["path", { d: "m9 10 2 2 4-4" }],
	["rect", { x: "3", y: "4", width: "18", height: "12", rx: "2" }],
] satisfies IconNode;

export const lasso = [
	["path", { d: "M3.704 14.467a10 8 0 1 1 3.115 2.375" }],
	["path", { d: "M7 22a5 5 0 0 1-2-3.994" }],
	["circle", { cx: "5", cy: "16", r: "2" }],
] satisfies IconNode;

export const lassoSelect = [
	["path", { d: "M7 22a5 5 0 0 1-2-4" }],
	["path", { d: "M7 16.93c.96.43 1.96.74 2.99.91" }],
	[
		"path",
		{ d: "M3.34 14A6.8 6.8 0 0 1 2 10c0-4.42 4.48-8 10-8s10 3.58 10 8a7.19 7.19 0 0 1-.33 2" },
	],
	["path", { d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" }],
	[
		"path",
		{
			d: "M14.33 22h-.09a.35.35 0 0 1-.24-.32v-10a.34.34 0 0 1 .33-.34c.08 0 .15.03.21.08l7.34 6a.33.33 0 0 1-.21.59h-4.49l-2.57 3.85a.35.35 0 0 1-.28.14z",
		},
	],
] satisfies IconNode;

export const layerArrowDown = [
	["path", { d: "M12 10v10" }],
	["path", { d: "M22 10a1 1 0 01-.59.92l-5.077 2.308" }],
	[
		"path",
		{
			d: "M22.017 10.005a1 1 0 00-.597-.916l-8.59-3.91a2 2 0 00-1.66.001L2.6 9.08a1 1 0 00-.02 1.831l5.093 2.316",
		},
	],
	["path", { d: "m9 17 3 3 3-3" }],
] satisfies IconNode;

export const layerArrowUp = [
	["path", { d: "M12 14V4" }],
	[
		"path",
		{
			d: "M7.674 10.774 2.58 13.09a1 1 0 000 1.822l8.6 3.91a2 2 0 001.65 0l8.58-3.9a1 1 0 00.59-.92 1 1 0 00-.59-.922l-5.078-2.308",
		},
	],
	["path", { d: "m9 7 3-3 3 3" }],
] satisfies IconNode;

export const layers = [
	[
		"path",
		{
			d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z",
		},
	],
	["path", { d: "M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12" }],
	["path", { d: "M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17" }],
] satisfies IconNode;

export const layers2 = [
	[
		"path",
		{
			d: "M13 13.74a2 2 0 0 1-2 0L2.5 8.87a1 1 0 0 1 0-1.74L11 2.26a2 2 0 0 1 2 0l8.5 4.87a1 1 0 0 1 0 1.74z",
		},
	],
	[
		"path",
		{
			d: "m20 14.285 1.5.845a1 1 0 0 1 0 1.74L13 21.74a2 2 0 0 1-2 0l-8.5-4.87a1 1 0 0 1 0-1.74l1.5-.845",
		},
	],
] satisfies IconNode;

export const layersArrowDown = [
	["path", { d: "M12 7v15" }],
	["path", { d: "M2 12a1 1 0 00.58.91l5.093 2.316" }],
	["path", { d: "M22 12a1 1 0 01-.59.92l-5.077 2.308" }],
	[
		"path",
		{
			d: "M8 10.37 2.6 7.91a1 1 0 010-1.831l8.57-3.9a2 2 0 011.66.001l8.59 3.91a1 1 0 010 1.831l-5.392 2.45",
		},
	],
	["path", { d: "m9 19 3 3 3-3" }],
] satisfies IconNode;

export const layersArrowUp = [
	["path", { d: "M12 12V2" }],
	["path", { d: "M2 17.002a1 1 0 00.58.91l8.6 3.91a2 2 0 001.65 0l8.58-3.9a1 1 0 00.59-.92" }],
	[
		"path",
		{
			d: "M7.674 8.774 2.58 11.09a1 1 0 000 1.822l8.6 3.91a2 2 0 001.65 0l8.58-3.9a1 1 0 00.59-.92 1 1 0 00-.59-.922l-5.078-2.308",
		},
	],
	["path", { d: "m9 5 3-3 3 3" }],
] satisfies IconNode;

export const layersMinus = [
	[
		"path",
		{
			d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 .83.18 2 2 0 0 0 .83-.18l8.58-3.9a1 1 0 0 0 0-1.832z",
		},
	],
	["path", { d: "M16 17h6" }],
	["path", { d: "M2.003 11.995a1 1 0 0 0 .597.915l8.58 3.91a2 2 0 0 0 .83.18" }],
	[
		"path",
		{ d: "M2.003 16.995a1 1 0 0 0 .597.915l8.58 3.91a2 2 0 0 0 .83.18 2 2 0 0 0 .83-.18l2.11-.96" },
	],
	["path", { d: "M22.018 12.004a1 1 0 0 1-.598.916l-.177.08" }],
] satisfies IconNode;

export const layersPlus = [
	[
		"path",
		{
			d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 .83.18 2 2 0 0 0 .83-.18l8.58-3.9a1 1 0 0 0 0-1.831z",
		},
	],
	["path", { d: "M16 17h6" }],
	["path", { d: "M19 14v6" }],
	["path", { d: "M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 .825.178" }],
	["path", { d: "M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l2.116-.962" }],
] satisfies IconNode;

export const layoutArrowDown = [
	["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1" }],
	["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1" }],
	["path", { d: "M18 3v18" }],
	["path", { d: "m21 18-3 3-3-3" }],
] satisfies IconNode;

export const layoutArrowRight = [
	["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1" }],
	["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1" }],
	["path", { d: "M3 18h18" }],
	["path", { d: "m18 21 3-3-3-3" }],
] satisfies IconNode;

export const layoutDashboard = [
	["rect", { width: "7", height: "9", x: "3", y: "3", rx: "1" }],
	["rect", { width: "7", height: "5", x: "14", y: "3", rx: "1" }],
	["rect", { width: "7", height: "9", x: "14", y: "12", rx: "1" }],
	["rect", { width: "7", height: "5", x: "3", y: "16", rx: "1" }],
] satisfies IconNode;

export const layoutFreeform = [
	["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1" }],
	["rect", { width: "7", height: "7", x: "14", y: "4", rx: "1" }],
	["rect", { width: "7", height: "7", x: "4", y: "14", rx: "1" }],
] satisfies IconNode;

export const layoutGrid = [
	["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1" }],
	["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1" }],
	["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1" }],
	["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1" }],
] satisfies IconNode;

export const layoutGridCircles = [
	["circle", { cx: "17.5", cy: "17.5", r: "3.5" }],
	["circle", { cx: "17.5", cy: "6.5", r: "3.5" }],
	["circle", { cx: "6.5", cy: "17.5", r: "3.5" }],
	["circle", { cx: "6.5", cy: "6.5", r: "3.5" }],
] satisfies IconNode;

export const layoutList = [
	["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1" }],
	["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1" }],
	["path", { d: "M14 4h7" }],
	["path", { d: "M14 9h7" }],
	["path", { d: "M14 15h7" }],
	["path", { d: "M14 20h7" }],
] satisfies IconNode;

export const layoutPanelLeft = [
	["rect", { width: "7", height: "18", x: "3", y: "3", rx: "1" }],
	["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1" }],
	["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1" }],
] satisfies IconNode;

export const layoutPanelTop = [
	["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1" }],
	["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1" }],
	["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1" }],
] satisfies IconNode;

export const layoutTemplate = [
	["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1" }],
	["rect", { width: "9", height: "7", x: "3", y: "14", rx: "1" }],
	["rect", { width: "5", height: "7", x: "16", y: "14", rx: "1" }],
] satisfies IconNode;

export const leaf = [
	[
		"path",
		{
			d: "M11 20a10 10 0 0010-10 25.9 25.9 0 00-1.04-7.281 1 1 0 00-1.755-.325C15.833 5.5 13 5.5 9.8 6.1A7 7 0 0011 20",
		},
	],
	["path", { d: "M2 21a5 5 0 012.911-4.544C7.613 15.212 8.351 15.24 11 13" }],
] satisfies IconNode;

export const leafyGreen = [
	[
		"path",
		{
			d: "M2 22c1.25-.987 2.27-1.975 3.9-2.2a5.56 5.56 0 0 1 3.8 1.5 4 4 0 0 0 6.187-2.353 3.5 3.5 0 0 0 3.69-5.116A3.5 3.5 0 0 0 20.95 8 3.5 3.5 0 1 0 16 3.05a3.5 3.5 0 0 0-5.831 1.373 3.5 3.5 0 0 0-5.116 3.69 4 4 0 0 0-2.348 6.155C3.499 15.42 4.409 16.712 4.2 18.1 3.926 19.743 3.014 20.732 2 22",
		},
	],
	["path", { d: "M2 22 17 7" }],
] satisfies IconNode;

export const lectern = [
	[
		"path",
		{
			d: "M15 13h4a2 2 0 001.901-1.38l1.057-4.333A1 1 0 0021 6H3a1 1 0 00-.958 1.287L3.1 11.621A2 2 0 005.001 13h4",
		},
	],
	["path", { d: "M15 22V11a1 1 0 00-1-1h-4a1 1 0 00-1 1v11" }],
	["path", { d: "M18 22H6" }],
	["path", { d: "M18 6V3a1 1 0 00-1-1h-3" }],
] satisfies IconNode;

export const lens = [
	["path", { d: "M15.725 7.296h.01" }],
	["path", { d: "M6 12a6 6 0 016-6" }],
	["circle", { cx: "12", cy: "12", r: "10" }],
] satisfies IconNode;

export const lensConcave = [
	[
		"path",
		{
			d: "M7 2a1 1 0 0 0-.8 1.6 14 14 0 0 1 0 16.8A1 1 0 0 0 7 22h10a1 1 0 0 0 .8-1.6 14 14 0 0 1 0-16.8A1 1 0 0 0 17 2z",
		},
	],
] satisfies IconNode;

export const lensConvex = [
	[
		"path",
		{
			d: "M13.433 2a1 1 0 0 1 .824.448 18 18 0 0 1 0 19.104 1 1 0 0 1-.824.448h-2.866a1 1 0 0 1-.824-.448 18 18 0 0 1 0-19.104A1 1 0 0 1 10.567 2z",
		},
	],
] satisfies IconNode;

export const letterSpacing = [
	["path", { d: "M15 14H9" }],
	["path", { d: "M21 3v18" }],
	["path", { d: "M3 3v18" }],
	["path", { d: "m8 16 3.453-7.648a.6.6 0 011.094.001L16 16" }],
] satisfies IconNode;

export const letters = [
	["path", { d: "M15 8H9" }],
	["path", { d: "M21 15.354a4 4 0 100 5.292" }],
	["path", { d: "M3 18h4a2 2 0 010 4H3.5a.5.5 0 01-.5-.5v-7a.5.5 0 01.5-.5H6a2 2 0 010 4" }],
	["path", { d: "m8 10 3.453-7.648a.6.6 0 011.094 0L16 10" }],
] satisfies IconNode;

export const library = [
	["path", { d: "m16 6 4 14" }],
	["path", { d: "M12 6v14" }],
	["path", { d: "M8 8v12" }],
	["path", { d: "M4 4v16" }],
] satisfies IconNode;

export const libraryBig = [
	["rect", { width: "8", height: "18", x: "3", y: "3", rx: "1" }],
	["path", { d: "M7 3v18" }],
	[
		"path",
		{
			d: "M20.4 18.9c.2.5-.1 1.1-.6 1.3l-1.9.7c-.5.2-1.1-.1-1.3-.6L11.1 5.1c-.2-.5.1-1.1.6-1.3l1.9-.7c.5-.2 1.1.1 1.3.6Z",
		},
	],
] satisfies IconNode;

export const lifeBuoy = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["path", { d: "m4.93 4.93 4.24 4.24" }],
	["path", { d: "m14.83 9.17 4.24-4.24" }],
	["path", { d: "m14.83 14.83 4.24 4.24" }],
	["path", { d: "m9.17 14.83-4.24 4.24" }],
	["circle", { cx: "12", cy: "12", r: "4" }],
] satisfies IconNode;

export const ligature = [
	["path", { d: "M14 12h2v8" }],
	["path", { d: "M14 20h4" }],
	["path", { d: "M6 12h4" }],
	["path", { d: "M6 20h4" }],
	["path", { d: "M8 20V8a4 4 0 0 1 7.464-2" }],
] satisfies IconNode;

export const lightbulb = [
	[
		"path",
		{
			d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5",
		},
	],
	["path", { d: "M9 18h6" }],
	["path", { d: "M10 22h4" }],
] satisfies IconNode;

export const lightbulbOff = [
	["path", { d: "M16.8 11.2c.8-.9 1.2-2 1.2-3.2a6 6 0 0 0-9.3-5" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M6.3 6.3a4.67 4.67 0 0 0 1.2 5.2c.7.7 1.3 1.5 1.5 2.5" }],
	["path", { d: "M9 18h6" }],
	["path", { d: "M10 22h4" }],
] satisfies IconNode;

export const lighthouse = [
	["path", { d: "M12 3V2" }],
	["path", { d: "M16.066 16.865 7 22l2-11V6a3 3 0 016 0v5l2 11" }],
	["path", { d: "m19.792 4.5.866-.5" }],
	["path", { d: "m19.797 13.5.866.5" }],
	["path", { d: "M21 9h1" }],
	["path", { d: "M3 9H2" }],
	["path", { d: "m4.203 13.5-.866.5" }],
	["path", { d: "M4.208 4.5 3.342 4" }],
	["path", { d: "M5.5 22h13" }],
	["path", { d: "m7.932 16.875 7.377-4.178" }],
	["path", { d: "M8 11h8" }],
	["path", { d: "M8 7h8" }],
] satisfies IconNode;

export const lineDotBottomVertical = [
	["path", { d: "M12 3v12" }],
	["circle", { cx: "12", cy: "18", r: "3" }],
] satisfies IconNode;

export const lineDotLeftHorizontal = [
	["path", { d: "M9 12h12" }],
	["circle", { cx: "6", cy: "12", r: "3" }],
] satisfies IconNode;

export const lineDotRightHorizontal = [
	["path", { d: "M 3 12 L 15 12" }],
	["circle", { cx: "18", cy: "12", r: "3" }],
] satisfies IconNode;

export const lineDotTopVertical = [
	["path", { d: "M12 9v12" }],
	["circle", { cx: "12", cy: "6", r: "3" }],
] satisfies IconNode;

export const lineHeight = [
	["path", { d: "M15 14H9" }],
	["path", { d: "M21 21H3" }],
	["path", { d: "M21 3H3" }],
	["path", { d: "m8 16 3.453-7.648a.6.6 0 011.094.001L16 16" }],
] satisfies IconNode;

export const lineSquiggle = [
	[
		"path",
		{ d: "M7 3.5c5-2 7 2.5 3 4C1.5 10 2 15 5 16c5 2 9-10 14-7s.5 13.5-4 12c-5-2.5.5-11 6-2" },
	],
] satisfies IconNode;

export const lineStyle = [
	["path", { d: "M11 5h2" }],
	["path", { d: "M15 12h6" }],
	["path", { d: "M19 5h2" }],
	["path", { d: "M3 12h6" }],
	["path", { d: "M3 19h18" }],
	["path", { d: "M3 5h2" }],
] satisfies IconNode;

export const link = [
	["path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" }],
	["path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" }],
] satisfies IconNode;

export const link2 = [
	["path", { d: "M9 17H7A5 5 0 0 1 7 7h2" }],
	["path", { d: "M15 7h2a5 5 0 1 1 0 10h-2" }],
	["line", { x1: "8", x2: "16", y1: "12", y2: "12" }],
] satisfies IconNode;

export const link2Off = [
	["path", { d: "M9 17H7A5 5 0 0 1 7 7" }],
	["path", { d: "M15 7h2a5 5 0 0 1 4 8" }],
	["line", { x1: "8", x2: "12", y1: "12", y2: "12" }],
	["line", { x1: "2", x2: "22", y1: "2", y2: "22" }],
] satisfies IconNode;

export const list = [
	["path", { d: "M3 5h.01" }],
	["path", { d: "M3 12h.01" }],
	["path", { d: "M3 19h.01" }],
	["path", { d: "M8 5h13" }],
	["path", { d: "M8 12h13" }],
	["path", { d: "M8 19h13" }],
] satisfies IconNode;

export const listCheck = [
	["path", { d: "M16 5H3" }],
	["path", { d: "M16 12H3" }],
	["path", { d: "M11 19H3" }],
	["path", { d: "m15 18 2 2 4-4" }],
] satisfies IconNode;

export const listChecks = [
	["path", { d: "M13 5h8" }],
	["path", { d: "M13 12h8" }],
	["path", { d: "M13 19h8" }],
	["path", { d: "m3 17 2 2 4-4" }],
	["path", { d: "m3 7 2 2 4-4" }],
] satisfies IconNode;

export const listChevronsDownUp = [
	["path", { d: "M3 5h8" }],
	["path", { d: "M3 12h8" }],
	["path", { d: "M3 19h8" }],
	["path", { d: "m15 5 3 3 3-3" }],
	["path", { d: "m15 19 3-3 3 3" }],
] satisfies IconNode;

export const listChevronsUpDown = [
	["path", { d: "M3 5h8" }],
	["path", { d: "M3 12h8" }],
	["path", { d: "M3 19h8" }],
	["path", { d: "m15 8 3-3 3 3" }],
	["path", { d: "m15 16 3 3 3-3" }],
] satisfies IconNode;

export const listClock = [
	["path", { d: "M16 13v2.2l1.6 1" }],
	["path", { d: "M3 12h3.458" }],
	["path", { d: "M3 19h3.832" }],
	["path", { d: "M3 5h18" }],
	["circle", { cx: "16", cy: "15", r: "6" }],
] satisfies IconNode;

export const listCollapse = [
	["path", { d: "M10 5h11" }],
	["path", { d: "M10 12h11" }],
	["path", { d: "M10 19h11" }],
	["path", { d: "m3 10 3-3-3-3" }],
	["path", { d: "m3 20 3-3-3-3" }],
] satisfies IconNode;

export const listEnd = [
	["path", { d: "M16 5H3" }],
	["path", { d: "M16 12H3" }],
	["path", { d: "M9 19H3" }],
	["path", { d: "m16 16-3 3 3 3" }],
	["path", { d: "M21 5v12a2 2 0 0 1-2 2h-6" }],
] satisfies IconNode;

export const listFilter = [
	["path", { d: "M2 5h20" }],
	["path", { d: "M6 12h12" }],
	["path", { d: "M9 19h6" }],
] satisfies IconNode;

export const listFilterPlus = [
	["path", { d: "M12 5H2" }],
	["path", { d: "M6 12h12" }],
	["path", { d: "M9 19h6" }],
	["path", { d: "M16 5h6" }],
	["path", { d: "M19 8V2" }],
] satisfies IconNode;

export const listIndentDecrease = [
	["path", { d: "M21 5H11" }],
	["path", { d: "M21 12H11" }],
	["path", { d: "M21 19H11" }],
	["path", { d: "m7 8-4 4 4 4" }],
] satisfies IconNode;

export const listIndentIncrease = [
	["path", { d: "M21 5H11" }],
	["path", { d: "M21 12H11" }],
	["path", { d: "M21 19H11" }],
	["path", { d: "m3 8 4 4-4 4" }],
] satisfies IconNode;

export const listMinus = [
	["path", { d: "M16 5H3" }],
	["path", { d: "M11 12H3" }],
	["path", { d: "M16 19H3" }],
	["path", { d: "M21 12h-6" }],
] satisfies IconNode;

export const listMusic = [
	["path", { d: "M16 5H3" }],
	["path", { d: "M11 12H3" }],
	["path", { d: "M11 19H3" }],
	["path", { d: "M21 16V5" }],
	["circle", { cx: "18", cy: "16", r: "3" }],
] satisfies IconNode;

export const listOrdered = [
	["path", { d: "M11 5h10" }],
	["path", { d: "M11 12h10" }],
	["path", { d: "M11 19h10" }],
	["path", { d: "M4 4h1v5" }],
	["path", { d: "M4 9h2" }],
	["path", { d: "M6.5 20H3.4c0-1 2.6-1.925 2.6-3.5a1.5 1.5 0 0 0-2.6-1.02" }],
] satisfies IconNode;

export const listPlus = [
	["path", { d: "M16 5H3" }],
	["path", { d: "M11 12H3" }],
	["path", { d: "M16 19H3" }],
	["path", { d: "M18 9v6" }],
	["path", { d: "M21 12h-6" }],
] satisfies IconNode;

export const listRestart = [
	["path", { d: "M21 5H3" }],
	["path", { d: "M7 12H3" }],
	["path", { d: "M7 19H3" }],
	["path", { d: "M12 18a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L11 14" }],
	["path", { d: "M11 10v4h4" }],
] satisfies IconNode;

export const listSortAscending = [
	["path", { d: "M3 19h18" }],
	["path", { d: "M15 12H3" }],
	["path", { d: "M9 5H3" }],
] satisfies IconNode;

export const listSortDescending = [
	["path", { d: "M15 12H3" }],
	["path", { d: "M3 5h18" }],
	["path", { d: "M9 19H3" }],
] satisfies IconNode;

export const listStart = [
	["path", { d: "M3 5h6" }],
	["path", { d: "M3 12h13" }],
	["path", { d: "M3 19h13" }],
	["path", { d: "m16 8-3-3 3-3" }],
	["path", { d: "M21 19V7a2 2 0 0 0-2-2h-6" }],
] satisfies IconNode;

export const listTodo = [
	["path", { d: "M13 5h8" }],
	["path", { d: "M13 12h8" }],
	["path", { d: "M13 19h8" }],
	["path", { d: "m3 17 2 2 4-4" }],
	["rect", { x: "3", y: "4", width: "6", height: "6", rx: "1" }],
] satisfies IconNode;

export const listTree = [
	["path", { d: "M8 5h13" }],
	["path", { d: "M13 12h8" }],
	["path", { d: "M13 19h8" }],
	["path", { d: "M3 10a2 2 0 0 0 2 2h3" }],
	["path", { d: "M3 5v12a2 2 0 0 0 2 2h3" }],
] satisfies IconNode;

export const listVideo = [
	["path", { d: "M21 5H3" }],
	["path", { d: "M10 12H3" }],
	["path", { d: "M10 19H3" }],
	[
		"path",
		{
			d: "M15 12.003a1 1 0 0 1 1.517-.859l4.997 2.997a1 1 0 0 1 0 1.718l-4.997 2.997a1 1 0 0 1-1.517-.86z",
		},
	],
] satisfies IconNode;

export const listX = [
	["path", { d: "M16 5H3" }],
	["path", { d: "M11 12H3" }],
	["path", { d: "M16 19H3" }],
	["path", { d: "m15.5 9.5 5 5" }],
	["path", { d: "m20.5 9.5-5 5" }],
] satisfies IconNode;

export const loader = [
	["path", { d: "M12 2v4" }],
	["path", { d: "m16.2 7.8 2.9-2.9" }],
	["path", { d: "M18 12h4" }],
	["path", { d: "m16.2 16.2 2.9 2.9" }],
	["path", { d: "M12 18v4" }],
	["path", { d: "m4.9 19.1 2.9-2.9" }],
	["path", { d: "M2 12h4" }],
	["path", { d: "m4.9 4.9 2.9 2.9" }],
] satisfies IconNode;

export const loaderCircle = [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56" }]] satisfies IconNode;

export const loaderPinwheel = [
	["path", { d: "M22 12a1 1 0 0 1-10 0 1 1 0 0 0-10 0" }],
	["path", { d: "M7 20.7a1 1 0 1 1 5-8.7 1 1 0 1 0 5-8.6" }],
	["path", { d: "M7 3.3a1 1 0 1 1 5 8.6 1 1 0 1 0 5 8.6" }],
	["circle", { cx: "12", cy: "12", r: "10" }],
] satisfies IconNode;

export const locate = [
	["line", { x1: "2", x2: "5", y1: "12", y2: "12" }],
	["line", { x1: "19", x2: "22", y1: "12", y2: "12" }],
	["line", { x1: "12", x2: "12", y1: "2", y2: "5" }],
	["line", { x1: "12", x2: "12", y1: "19", y2: "22" }],
	["circle", { cx: "12", cy: "12", r: "7" }],
] satisfies IconNode;

export const locateFixed = [
	["line", { x1: "2", x2: "5", y1: "12", y2: "12" }],
	["line", { x1: "19", x2: "22", y1: "12", y2: "12" }],
	["line", { x1: "12", x2: "12", y1: "2", y2: "5" }],
	["line", { x1: "12", x2: "12", y1: "19", y2: "22" }],
	["circle", { cx: "12", cy: "12", r: "7" }],
	["circle", { cx: "12", cy: "12", r: "3" }],
] satisfies IconNode;

export const locateOff = [
	["path", { d: "M12 19v3" }],
	["path", { d: "M12 2v3" }],
	["path", { d: "M18.89 13.24a7 7 0 0 0-8.13-8.13" }],
	["path", { d: "M19 12h3" }],
	["path", { d: "M2 12h3" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M7.05 7.05a7 7 0 0 0 9.9 9.9" }],
] satisfies IconNode;

export const lock = [
	["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2" }],
	["path", { d: "M7 11V7a5 5 0 0 1 10 0v4" }],
] satisfies IconNode;

export const lockKeyhole = [
	["circle", { cx: "12", cy: "16", r: "1" }],
	["rect", { x: "3", y: "10", width: "18", height: "12", rx: "2" }],
	["path", { d: "M7 10V7a5 5 0 0 1 10 0v3" }],
] satisfies IconNode;

export const lockKeyholeOpen = [
	["circle", { cx: "12", cy: "16", r: "1" }],
	["rect", { width: "18", height: "12", x: "3", y: "10", rx: "2" }],
	["path", { d: "M7 10V7a5 5 0 0 1 9.33-2.5" }],
] satisfies IconNode;

export const lockOpen = [
	["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2" }],
	["path", { d: "M7 11V7a5 5 0 0 1 9.9-1" }],
] satisfies IconNode;

export const logIn = [
	["path", { d: "m10 17 5-5-5-5" }],
	["path", { d: "M15 12H3" }],
	["path", { d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" }],
] satisfies IconNode;

export const logOut = [
	["path", { d: "m16 17 5-5-5-5" }],
	["path", { d: "M21 12H9" }],
	["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" }],
] satisfies IconNode;

export const logs = [
	["path", { d: "M3 5h1" }],
	["path", { d: "M3 12h1" }],
	["path", { d: "M3 19h1" }],
	["path", { d: "M8 5h1" }],
	["path", { d: "M8 12h1" }],
	["path", { d: "M8 19h1" }],
	["path", { d: "M13 5h8" }],
	["path", { d: "M13 12h8" }],
	["path", { d: "M13 19h8" }],
] satisfies IconNode;

export const lollipop = [
	["circle", { cx: "11", cy: "11", r: "8" }],
	["path", { d: "m21 21-4.3-4.3" }],
	["path", { d: "M11 11a2 2 0 0 0 4 0 4 4 0 0 0-8 0 6 6 0 0 0 12 0" }],
] satisfies IconNode;

export const luggage = [
	["path", { d: "M6 20a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2" }],
	["path", { d: "M8 18V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v14" }],
	["path", { d: "M10 20h4" }],
	["circle", { cx: "16", cy: "20", r: "2" }],
	["circle", { cx: "8", cy: "20", r: "2" }],
] satisfies IconNode;

export const magnet = [
	["path", { d: "m12 15 4 4" }],
	[
		"path",
		{
			d: "M2.352 10.648a1.205 1.205 0 0 0 0 1.704l2.296 2.296a1.205 1.205 0 0 0 1.704 0l6.029-6.029a1 1 0 1 1 3 3l-6.029 6.029a1.205 1.205 0 0 0 0 1.704l2.296 2.296a1.205 1.205 0 0 0 1.704 0l6.365-6.367A1 1 0 0 0 8.716 4.282z",
		},
	],
	["path", { d: "m5 8 4 4" }],
] satisfies IconNode;

export const mail = [
	["path", { d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" }],
	["rect", { x: "2", y: "4", width: "20", height: "16", rx: "2" }],
] satisfies IconNode;

export const mailBadge = [
	["path", { d: "M22 7.7V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8.25" }],
	["path", { d: "M12 12.996a1.94 1.94 0 0 1-1.03-.296L2 7" }],
	[
		"path",
		{
			d: "m20.69 16.479 1.29 4.88a.5.5 0 0 1-.698.591l-1.843-.849a1 1 0 0 0-.879.001l-1.846.85a.5.5 0 0 1-.692-.593l1.29-4.88",
		},
	],
	["circle", { cx: "19", cy: "14", r: "3" }],
] satisfies IconNode;

export const mailCheck = [
	["path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8" }],
	["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" }],
	["path", { d: "m16 19 2 2 4-4" }],
] satisfies IconNode;

export const mailClock = [
	["path", { d: "M16 14v2.2l1.6 1" }],
	["path", { d: "m22 7-.759.484" }],
	["path", { d: "M6.835 20H4a2 2 0 01-2-2V6a2 2 0 012-2h16a2 2 0 012 2v2" }],
	["path", { d: "M7.605 10.567 2 7" }],
	["circle", { cx: "16", cy: "16", r: "6" }],
] satisfies IconNode;

export const mailDot = [
	["path", { d: "M12.674 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4.675" }],
	["path", { d: "m2 7 9 5.701a2 2 0 0 0 2 0l1.084-.686" }],
	["circle", { cx: "19", cy: "7", r: "3" }],
] satisfies IconNode;

export const mailMinus = [
	["path", { d: "M22 15V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8" }],
	["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" }],
	["path", { d: "M16 19h6" }],
] satisfies IconNode;

export const mailOpen = [
	[
		"path",
		{
			d: "M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z",
		},
	],
	["path", { d: "m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10" }],
] satisfies IconNode;

export const mailPen = [
	[
		"path",
		{
			d: "M15.363 17.634a2 2 0 00-.506.854l-.837 2.87a.5.5 0 00.62.62l2.87-.837a2 2 0 00.854-.506l3.013-3.009a1 1 0 10-3.004-3.004z",
		},
	],
	["path", { d: "M22 10.38V6a2 2 0 00-2-2H4a2 2 0 00-2 2v12a2 2 0 002 2h6.25" }],
	["path", { d: "m22 7-8.991 5.727a2 2 0 01-2.009 0L2 7" }],
] satisfies IconNode;

export const mailPlus = [
	["path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8" }],
	["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" }],
	["path", { d: "M19 16v6" }],
	["path", { d: "M16 19h6" }],
] satisfies IconNode;

export const mailQuestionMark = [
	["path", { d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5" }],
	["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" }],
	["path", { d: "M18 15.28c.2-.4.5-.8.9-1a2.1 2.1 0 0 1 2.6.4c.3.4.5.8.5 1.3 0 1.3-2 2-2 2" }],
	["path", { d: "M20 22v.01" }],
] satisfies IconNode;

export const mailSearch = [
	["path", { d: "M22 12.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h7.5" }],
	["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" }],
	["path", { d: "M18 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" }],
	["circle", { cx: "18", cy: "18", r: "3" }],
	["path", { d: "m22 22-1.5-1.5" }],
] satisfies IconNode;

export const mailWarning = [
	["path", { d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5" }],
	["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" }],
	["path", { d: "M20 14v4" }],
	["path", { d: "M20 22v.01" }],
] satisfies IconNode;

export const mailX = [
	["path", { d: "M22 12.532V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8.792" }],
	["path", { d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" }],
	["path", { d: "m16.5 16.5 5 5" }],
	["path", { d: "m21.5 16.5-5 5" }],
] satisfies IconNode;

export const mailbox = [
	["path", { d: "M22 17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.5C2 7 4 5 6.5 5H18c2.2 0 4 1.8 4 4v8Z" }],
	["polyline", { points: "15,9 18,9 18,11" }],
	["path", { d: "M6.5 5C9 5 11 7 11 9.5V17a2 2 0 0 1-2 2" }],
	["line", { x1: "6", x2: "7", y1: "10", y2: "10" }],
] satisfies IconNode;

export const mails = [
	["path", { d: "M17 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 1-1.732" }],
	["path", { d: "m22 5.5-6.419 4.179a2 2 0 0 1-2.162 0L7 5.5" }],
	["rect", { x: "7", y: "3", width: "15", height: "12", rx: "2" }],
] satisfies IconNode;

export const map = [
	[
		"path",
		{
			d: "M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z",
		},
	],
	["path", { d: "M15 5.764v15" }],
	["path", { d: "M9 3.236v15" }],
] satisfies IconNode;

export const mapMinus = [
	[
		"path",
		{
			d: "m11 19-1.106-.552a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0l4.212 2.106a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619V14",
		},
	],
	["path", { d: "M15 5.764V14" }],
	["path", { d: "M21 18h-6" }],
	["path", { d: "M9 3.236v15" }],
] satisfies IconNode;

export const mapPin = [
	[
		"path",
		{
			d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
		},
	],
	["circle", { cx: "12", cy: "10", r: "3" }],
] satisfies IconNode;

export const mapPinCheck = [
	[
		"path",
		{
			d: "M19.43 12.935c.357-.967.57-1.955.57-2.935a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32.197 32.197 0 0 0 .813-.728",
		},
	],
	["circle", { cx: "12", cy: "10", r: "3" }],
	["path", { d: "m16 18 2 2 4-4" }],
] satisfies IconNode;

export const mapPinCheckInside = [
	[
		"path",
		{
			d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
		},
	],
	["path", { d: "m9 10 2 2 4-4" }],
] satisfies IconNode;

export const mapPinHouse = [
	[
		"path",
		{
			d: "M15 22a1 1 0 0 1-1-1v-4a1 1 0 0 1 .445-.832l3-2a1 1 0 0 1 1.11 0l3 2A1 1 0 0 1 22 17v4a1 1 0 0 1-1 1z",
		},
	],
	["path", { d: "M18 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 .601.2" }],
	["path", { d: "M18 22v-3" }],
	["circle", { cx: "10", cy: "10", r: "3" }],
] satisfies IconNode;

export const mapPinMinus = [
	[
		"path",
		{
			d: "M18.977 14C19.6 12.701 20 11.343 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738",
		},
	],
	["circle", { cx: "12", cy: "10", r: "3" }],
	["path", { d: "M16 18h6" }],
] satisfies IconNode;

export const mapPinMinusInside = [
	[
		"path",
		{
			d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
		},
	],
	["path", { d: "M9 10h6" }],
] satisfies IconNode;

export const mapPinOff = [
	["path", { d: "M12.75 7.09a3 3 0 0 1 2.16 2.16" }],
	[
		"path",
		{
			d: "M17.072 17.072c-1.634 2.17-3.527 3.912-4.471 4.727a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 1.432-4.568",
		},
	],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M8.475 2.818A8 8 0 0 1 20 10c0 1.183-.31 2.377-.81 3.533" }],
	["path", { d: "M9.13 9.13a3 3 0 0 0 3.74 3.74" }],
] satisfies IconNode;

export const mapPinPen = [
	["path", { d: "M17.97 9.304A8 8 0 0 0 2 10c0 4.69 4.887 9.562 7.022 11.468" }],
	[
		"path",
		{
			d: "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
		},
	],
	["circle", { cx: "10", cy: "10", r: "3" }],
] satisfies IconNode;

export const mapPinPlus = [
	[
		"path",
		{
			d: "M19.914 11.105A7.298 7.298 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738",
		},
	],
	["circle", { cx: "12", cy: "10", r: "3" }],
	["path", { d: "M16 18h6" }],
	["path", { d: "M19 15v6" }],
] satisfies IconNode;

export const mapPinPlusInside = [
	[
		"path",
		{
			d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
		},
	],
	["path", { d: "M12 7v6" }],
	["path", { d: "M9 10h6" }],
] satisfies IconNode;

export const mapPinSearch = [
	[
		"path",
		{
			d: "M 12.248 21.969 a 1 1 0 0 1 -0.849 -0.17 C 9.539 20.193 4 14.993 4 10 a 8 8 0 0 1 16 0 C 20 10.42 19.961 10.841 19.888 11.262",
		},
	],
	["path", { d: "m22 22-1.88-1.88" }],
	["circle", { cx: "12", cy: "10", r: "3" }],
	["circle", { cx: "18", cy: "18", r: "3" }],
] satisfies IconNode;

export const mapPinX = [
	[
		"path",
		{
			d: "M19.752 11.901A7.78 7.78 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 19 19 0 0 0 .09-.077",
		},
	],
	["circle", { cx: "12", cy: "10", r: "3" }],
	["path", { d: "m21.5 15.5-5 5" }],
	["path", { d: "m21.5 20.5-5-5" }],
] satisfies IconNode;

export const mapPinXInside = [
	[
		"path",
		{
			d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
		},
	],
	["path", { d: "m14.5 7.5-5 5" }],
	["path", { d: "m9.5 7.5 5 5" }],
] satisfies IconNode;

export const mapPinned = [
	[
		"path",
		{
			d: "M18 8c0 3.613-3.869 7.429-5.393 8.795a1 1 0 01-1.214 0C9.87 15.429 6 11.613 6 8a6 6 0 0112 0",
		},
	],
	[
		"path",
		{
			d: "M4.474 15h-.197a1 1 0 00-.969.753l-1.097 4.35a1.5 1.5 0 001.444 1.898L20.344 22a1.5 1.5 0 001.446-1.897l-1.098-4.35a1 1 0 00-.969-.753h-.197",
		},
	],
	["circle", { cx: "12", cy: "8", r: "2" }],
] satisfies IconNode;

export const mapPlus = [
	[
		"path",
		{
			d: "m11 19-1.106-.552a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0l4.212 2.106a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619V12",
		},
	],
	["path", { d: "M15 5.764V12" }],
	["path", { d: "M18 15v6" }],
	["path", { d: "M21 18h-6" }],
	["path", { d: "M9 3.236v15" }],
] satisfies IconNode;

export const mars = [
	["path", { d: "M16 3h5v5" }],
	["path", { d: "m21 3-6.75 6.75" }],
	["circle", { cx: "10", cy: "14", r: "6" }],
] satisfies IconNode;

export const marsStroke = [
	["path", { d: "m14 6 4 4" }],
	["path", { d: "M17 3h4v4" }],
	["path", { d: "m21 3-7.75 7.75" }],
	["circle", { cx: "9", cy: "15", r: "6" }],
] satisfies IconNode;

export const martini = [
	["path", { d: "M12 12 4.207 4.207A.707.707 0 0 1 4.707 3h14.586a.707.707 0 0 1 .5 1.207z" }],
	["path", { d: "M12 12v10" }],
	["path", { d: "M7 22h10" }],
] satisfies IconNode;

export const maximize = [
	["path", { d: "M8 3H5a2 2 0 0 0-2 2v3" }],
	["path", { d: "M21 8V5a2 2 0 0 0-2-2h-3" }],
	["path", { d: "M3 16v3a2 2 0 0 0 2 2h3" }],
	["path", { d: "M16 21h3a2 2 0 0 0 2-2v-3" }],
] satisfies IconNode;

export const maximize2 = [
	["path", { d: "M15 3h6v6" }],
	["path", { d: "m21 3-7 7" }],
	["path", { d: "m3 21 7-7" }],
	["path", { d: "M9 21H3v-6" }],
] satisfies IconNode;

export const medal = [
	[
		"path",
		{
			d: "M7.21 15 2.66 7.14a2 2 0 0 1 .13-2.2L4.4 2.8A2 2 0 0 1 6 2h12a2 2 0 0 1 1.6.8l1.6 2.14a2 2 0 0 1 .14 2.2L16.79 15",
		},
	],
	["path", { d: "M11 12 5.12 2.2" }],
	["path", { d: "m13 12 5.88-9.8" }],
	["path", { d: "M8 7h8" }],
	["circle", { cx: "12", cy: "17", r: "5" }],
	["path", { d: "M12 18v-2h-.5" }],
] satisfies IconNode;

export const megaphone = [
	[
		"path",
		{
			d: "M11 6a13 13 0 0 0 8.4-2.8A1 1 0 0 1 21 4v12a1 1 0 0 1-1.6.8A13 13 0 0 0 11 14H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z",
		},
	],
	["path", { d: "M6 14a12 12 0 0 0 2.4 7.2 2 2 0 0 0 3.2-2.4A8 8 0 0 1 10 14" }],
	["path", { d: "M8 6v8" }],
] satisfies IconNode;

export const megaphoneOff = [
	["path", { d: "M11.636 6A13 13 0 0 0 19.4 3.2 1 1 0 0 1 21 4v11.344" }],
	["path", { d: "M14.378 14.357A13 13 0 0 0 11 14H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h1" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M6 14a12 12 0 0 0 2.4 7.2 2 2 0 0 0 3.2-2.4A8 8 0 0 1 10 14" }],
	["path", { d: "M8 8v6" }],
] satisfies IconNode;

export const memoryStick = [
	["path", { d: "M12 12v-2" }],
	["path", { d: "M12 18v-2" }],
	["path", { d: "M16 12v-2" }],
	["path", { d: "M16 18v-2" }],
	["path", { d: "M2 11h1.5" }],
	["path", { d: "M20 18v-2" }],
	["path", { d: "M20.5 11H22" }],
	["path", { d: "M4 18v-2" }],
	["path", { d: "M8 12v-2" }],
	["path", { d: "M8 18v-2" }],
	["rect", { x: "2", y: "6", width: "20", height: "10", rx: "2" }],
] satisfies IconNode;

export const menu = [
	["path", { d: "M4 5h16" }],
	["path", { d: "M4 12h16" }],
	["path", { d: "M4 19h16" }],
] satisfies IconNode;

export const merge = [
	["path", { d: "m8 6 4-4 4 4" }],
	["path", { d: "M12 2v10.3a4 4 0 0 1-1.172 2.872L4 22" }],
	["path", { d: "m20 22-5-5" }],
] satisfies IconNode;

export const messageCircle = [
	[
		"path",
		{
			d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
		},
	],
] satisfies IconNode;

export const messageCircleCheck = [
	[
		"path",
		{
			d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
		},
	],
	["path", { d: "m16 9-5.5 5.5L8 12" }],
] satisfies IconNode;

export const messageCircleCode = [
	["path", { d: "m10 9-3 3 3 3" }],
	["path", { d: "m14 15 3-3-3-3" }],
	[
		"path",
		{
			d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
		},
	],
] satisfies IconNode;

export const messageCircleDashed = [
	["path", { d: "M10.1 2.182a10 10 0 0 1 3.8 0" }],
	["path", { d: "M13.9 21.818a10 10 0 0 1-3.8 0" }],
	["path", { d: "M17.609 3.72a10 10 0 0 1 2.69 2.7" }],
	["path", { d: "M2.182 13.9a10 10 0 0 1 0-3.8" }],
	["path", { d: "M20.28 17.61a10 10 0 0 1-2.7 2.69" }],
	["path", { d: "M21.818 10.1a10 10 0 0 1 0 3.8" }],
	["path", { d: "M3.721 6.391a10 10 0 0 1 2.7-2.69" }],
	["path", { d: "m6.163 21.117-2.906.85a1 1 0 0 1-1.236-1.169l.965-2.98" }],
] satisfies IconNode;

export const messageCircleDashedCheck = [
	["path", { d: "M10.1 2.182a10 10 0 013.8 0" }],
	["path", { d: "M13.9 21.818a10 10 0 01-3.8 0" }],
	["path", { d: "M17.609 3.72a10 10 0 012.69 2.7" }],
	["path", { d: "M2.182 13.9a10 10 0 010-3.8" }],
	["path", { d: "M20.28 17.61a10 10 0 01-2.7 2.69" }],
	["path", { d: "M21.818 10.1a10 10 0 010 3.8" }],
	["path", { d: "M3.721 6.391a10 10 0 012.7-2.69" }],
	["path", { d: "m6.163 21.117-2.906.85a1 1 0 01-1.236-1.169l.965-2.98" }],
	["path", { d: "m16 9-5.5 5.5L8 12" }],
] satisfies IconNode;

export const messageCircleHeart = [
	[
		"path",
		{
			d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
		},
	],
	[
		"path",
		{
			d: "M7.828 13.07A3 3 0 0 1 12 8.764a3 3 0 0 1 5.004 2.224 3 3 0 0 1-.832 2.083l-3.447 3.62a1 1 0 0 1-1.45-.001z",
		},
	],
] satisfies IconNode;

export const messageCircleMore = [
	[
		"path",
		{
			d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
		},
	],
	["path", { d: "M8 12h.01" }],
	["path", { d: "M12 12h.01" }],
	["path", { d: "M16 12h.01" }],
] satisfies IconNode;

export const messageCircleOff = [
	["path", { d: "m2 2 20 20" }],
	[
		"path",
		{
			d: "M4.93 4.929a10 10 0 0 0-1.938 11.412 2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 0 0 11.302-1.989",
		},
	],
	["path", { d: "M8.35 2.69A10 10 0 0 1 21.3 15.65" }],
] satisfies IconNode;

export const messageCirclePlus = [
	[
		"path",
		{
			d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
		},
	],
	["path", { d: "M8 12h8" }],
	["path", { d: "M12 8v8" }],
] satisfies IconNode;

export const messageCircleQuestionMark = [
	[
		"path",
		{
			d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
		},
	],
	["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" }],
	["path", { d: "M12 17h.01" }],
] satisfies IconNode;

export const messageCircleReply = [
	[
		"path",
		{
			d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
		},
	],
	["path", { d: "m10 15-3-3 3-3" }],
	["path", { d: "M7 12h8a2 2 0 0 1 2 2v1" }],
] satisfies IconNode;

export const messageCircleText = [
	[
		"path",
		{
			d: "M3.086 17.509a2 2 0 00-.094-1.167 10 10 0 114.777 4.719 2 2 0 00-1.099-.092l-3.413.998a1 1 0 01-1.236-1.168z",
		},
	],
	["path", { d: "M8 12h9" }],
	["path", { d: "M8 16h5" }],
	["path", { d: "M8 8h7" }],
] satisfies IconNode;

export const messageCircleWarning = [
	[
		"path",
		{
			d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
		},
	],
	["path", { d: "M12 8v4" }],
	["path", { d: "M12 16h.01" }],
] satisfies IconNode;

export const messageCircleX = [
	[
		"path",
		{
			d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
		},
	],
	["path", { d: "m15 9-6 6" }],
	["path", { d: "m9 9 6 6" }],
] satisfies IconNode;

export const messageSquare = [
	[
		"path",
		{
			d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
		},
	],
] satisfies IconNode;

export const messageSquareCheck = [
	[
		"path",
		{
			d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.7.7 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
		},
	],
	["path", { d: "m9 11 2 2 4-4" }],
] satisfies IconNode;

export const messageSquareCode = [
	[
		"path",
		{
			d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
		},
	],
	["path", { d: "m10 8-3 3 3 3" }],
	["path", { d: "m14 14 3-3-3-3" }],
] satisfies IconNode;

export const messageSquareDashed = [
	["path", { d: "M14 3h2" }],
	["path", { d: "M16 19h-2" }],
	["path", { d: "M2 12v-2" }],
	["path", { d: "M2 16v5.286a.71.71 0 0 0 1.212.502l1.149-1.149" }],
	["path", { d: "M20 19a2 2 0 0 0 2-2v-1" }],
	["path", { d: "M22 10v2" }],
	["path", { d: "M22 6V5a2 2 0 0 0-2-2" }],
	["path", { d: "M4 3a2 2 0 0 0-2 2v1" }],
	["path", { d: "M8 19h2" }],
	["path", { d: "M8 3h2" }],
] satisfies IconNode;

export const messageSquareDiff = [
	[
		"path",
		{
			d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
		},
	],
	["path", { d: "M10 15h4" }],
	["path", { d: "M10 9h4" }],
	["path", { d: "M12 7v4" }],
] satisfies IconNode;

export const messageSquareDot = [
	[
		"path",
		{
			d: "M12.7 3H4a2 2 0 0 0-2 2v16.286a.71.71 0 0 0 1.212.502l2.202-2.202A2 2 0 0 1 6.828 19H20a2 2 0 0 0 2-2v-4.7",
		},
	],
	["circle", { cx: "19", cy: "6", r: "3" }],
] satisfies IconNode;

export const messageSquareHeart = [
	[
		"path",
		{
			d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
		},
	],
	[
		"path",
		{
			d: "M7.5 9.5c0 .687.265 1.383.697 1.844l3.009 3.264a1.14 1.14 0 0 0 .407.314 1 1 0 0 0 .783-.004 1.14 1.14 0 0 0 .398-.31l3.008-3.264A2.77 2.77 0 0 0 16.5 9.5 2.5 2.5 0 0 0 12 8a2.5 2.5 0 0 0-4.5 1.5",
		},
	],
] satisfies IconNode;

export const messageSquareLock = [
	[
		"path",
		{
			d: "M22 8.5V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v16.286a.71.71 0 0 0 1.212.502l2.202-2.202A2 2 0 0 1 6.828 19H10",
		},
	],
	["path", { d: "M20 15v-2a2 2 0 0 0-4 0v2" }],
	["rect", { x: "14", y: "15", width: "8", height: "5", rx: "1" }],
] satisfies IconNode;

export const messageSquareMore = [
	[
		"path",
		{
			d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
		},
	],
	["path", { d: "M12 11h.01" }],
	["path", { d: "M16 11h.01" }],
	["path", { d: "M8 11h.01" }],
] satisfies IconNode;

export const messageSquareOff = [
	[
		"path",
		{
			d: "M19 19H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.7.7 0 0 1 2 21.286V5a2 2 0 0 1 1.184-1.826",
		},
	],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M8.656 3H20a2 2 0 0 1 2 2v11.344" }],
] satisfies IconNode;

export const messageSquarePlus = [
	[
		"path",
		{
			d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
		},
	],
	["path", { d: "M12 8v6" }],
	["path", { d: "M9 11h6" }],
] satisfies IconNode;

export const messageSquareQuote = [
	["path", { d: "M14 14a2 2 0 0 0 2-2V8h-2" }],
	[
		"path",
		{
			d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
		},
	],
	["path", { d: "M8 14a2 2 0 0 0 2-2V8H8" }],
] satisfies IconNode;

export const messageSquareReply = [
	[
		"path",
		{
			d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
		},
	],
	["path", { d: "m10 8-3 3 3 3" }],
	["path", { d: "M17 14v-1a2 2 0 0 0-2-2H7" }],
] satisfies IconNode;

export const messageSquareShare = [
	[
		"path",
		{
			d: "M12 3H4a2 2 0 0 0-2 2v16.286a.71.71 0 0 0 1.212.502l2.202-2.202A2 2 0 0 1 6.828 19H20a2 2 0 0 0 2-2v-4",
		},
	],
	["path", { d: "M16 3h6v6" }],
	["path", { d: "m16 9 6-6" }],
] satisfies IconNode;

export const messageSquareText = [
	[
		"path",
		{
			d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
		},
	],
	["path", { d: "M7 11h10" }],
	["path", { d: "M7 15h6" }],
	["path", { d: "M7 7h8" }],
] satisfies IconNode;

export const messageSquareWarning = [
	[
		"path",
		{
			d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
		},
	],
	["path", { d: "M12 15h.01" }],
	["path", { d: "M12 7v4" }],
] satisfies IconNode;

export const messageSquareX = [
	[
		"path",
		{
			d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
		},
	],
	["path", { d: "m14.5 8.5-5 5" }],
	["path", { d: "m9.5 8.5 5 5" }],
] satisfies IconNode;

export const messagesCircle = [
	[
		"path",
		{
			d: "M19.95 10.05a7 7 0 011.412 7.872 1 1 0 00-.058.787l.675 2.089a1 1 0 01-1.236 1.168l-2.155-.631a1 1 0 00-.745.06 7 7 0 01-7.793-1.445",
		},
	],
	[
		"path",
		{
			d: "M2.696 12.708a1 1 0 00-.058-.785 7 7 0 113.518 3.473 1 1 0 00-.744-.061l-2.155.63a1 1 0 01-1.236-1.167z",
		},
	],
] satisfies IconNode;

export const messagesSquare = [
	[
		"path",
		{
			d: "M16 10a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 14.286V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z",
		},
	],
	[
		"path",
		{
			d: "M20 9a2 2 0 0 1 2 2v10.286a.71.71 0 0 1-1.212.502l-2.202-2.202A2 2 0 0 0 17.172 19H10a2 2 0 0 1-2-2v-1",
		},
	],
] satisfies IconNode;

export const metronome = [
	["path", { d: "M12 11.4V9.1" }],
	["path", { d: "m12 17 6.59-6.59" }],
	[
		"path",
		{
			d: "m15.05 5.7-.218-.691a3 3 0 0 0-5.663 0L4.418 19.695A1 1 0 0 0 5.37 21h13.253a1 1 0 0 0 .951-1.31L18.45 16.2",
		},
	],
	["circle", { cx: "20", cy: "9", r: "2" }],
] satisfies IconNode;

export const mic = [
	["path", { d: "M12 19v3" }],
	["path", { d: "M19 10v2a7 7 0 0 1-14 0v-2" }],
	["rect", { x: "9", y: "2", width: "6", height: "13", rx: "3" }],
] satisfies IconNode;

export const micAudioLines = [
	["path", { d: "M10 3v2.341" }],
	["path", { d: "M12 17v4" }],
	["path", { d: "M14 5v.341" }],
	["path", { d: "M18 5v13" }],
	["path", { d: "M2 10v3" }],
	["path", { d: "M22 10v3" }],
	["path", { d: "M6 6v11" }],
	["path", { d: "M9 21h6" }],
	["rect", { width: "4", height: "8", x: "10", y: "9", rx: "2" }],
] satisfies IconNode;

export const micOff = [
	["path", { d: "M12 19v3" }],
	["path", { d: "M15 9.34V5a3 3 0 0 0-5.68-1.33" }],
	["path", { d: "M16.95 16.95A7 7 0 0 1 5 12v-2" }],
	["path", { d: "M18.89 13.23A7 7 0 0 0 19 12v-2" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M9 9v3a3 3 0 0 0 5.12 2.12" }],
] satisfies IconNode;

export const micSignal = [
	["path", { d: "M12 17v4" }],
	["path", { d: "M18 11a6 6 0 00-3-5.197" }],
	["path", { d: "M2 11a10 10 0 015-8.662" }],
	["path", { d: "M22 11a10 10 0 00-5-8.662" }],
	["path", { d: "M6 11a6 6 0 013-5.197" }],
	["path", { d: "M9 21h6" }],
	["rect", { x: "10", y: "9", width: "4", height: "8", rx: "2" }],
] satisfies IconNode;

export const micVocal = [
	["path", { d: "m11 7.601-5.994 8.19a1 1 0 0 0 .1 1.298l.817.818a1 1 0 0 0 1.314.087L15.09 12" }],
	[
		"path",
		{
			d: "M16.5 21.174C15.5 20.5 14.372 20 13 20c-2.058 0-3.928 2.356-6 2-2.072-.356-2.775-3.369-1.5-4.5",
		},
	],
	["circle", { cx: "16", cy: "7", r: "5" }],
] satisfies IconNode;

export const microchip = [
	["path", { d: "M10 12h4" }],
	["path", { d: "M10 17h4" }],
	["path", { d: "M10 7h4" }],
	["path", { d: "M18 12h2" }],
	["path", { d: "M18 18h2" }],
	["path", { d: "M18 6h2" }],
	["path", { d: "M4 12h2" }],
	["path", { d: "M4 18h2" }],
	["path", { d: "M4 6h2" }],
	["rect", { x: "6", y: "2", width: "12", height: "20", rx: "2" }],
] satisfies IconNode;

export const microscope = [
	["path", { d: "M6 18h8" }],
	["path", { d: "M3 22h18" }],
	["path", { d: "M14 22a7 7 0 1 0 0-14h-1" }],
	["path", { d: "M9 14h2" }],
	["path", { d: "M9 12a2 2 0 0 1-2-2V6h6v4a2 2 0 0 1-2 2Z" }],
	["path", { d: "M12 6V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3" }],
] satisfies IconNode;

export const microwave = [
	["rect", { width: "20", height: "15", x: "2", y: "4", rx: "2" }],
	["rect", { width: "8", height: "7", x: "6", y: "8", rx: "1" }],
	["path", { d: "M18 8v7" }],
	["path", { d: "M6 19v2" }],
	["path", { d: "M18 19v2" }],
] satisfies IconNode;

export const midiPort = [
	["path", { d: "M12 18h.01" }],
	["path", { d: "M15 2.458V5a1 1 0 01-1 1h-4a1 1 0 01-1-1V2.458" }],
	["path", { d: "M16 16h.01" }],
	["path", { d: "M18 12h.01" }],
	["path", { d: "M6 12h.01" }],
	["path", { d: "M8 16h.01" }],
	["circle", { cx: "12", cy: "12", r: "10" }],
] satisfies IconNode;

export const milestone = [
	["path", { d: "M12 13v8" }],
	["path", { d: "M12 3v3" }],
	[
		"path",
		{
			d: "M18.172 6a2 2 0 0 1 1.414.586l2.06 2.06a1.207 1.207 0 0 1 0 1.708l-2.06 2.06a2 2 0 0 1-1.414.586H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1z",
		},
	],
] satisfies IconNode;

export const milk = [
	["path", { d: "M8 2h8" }],
	[
		"path",
		{
			d: "M9 2v2.789a4 4 0 0 1-.672 2.219l-.656.984A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-9.789a4 4 0 0 0-.672-2.219l-.656-.984A4 4 0 0 1 15 4.788V2",
		},
	],
	["path", { d: "M7 15a6.472 6.472 0 0 1 5 0 6.47 6.47 0 0 0 5 0" }],
] satisfies IconNode;

export const milkOff = [
	["path", { d: "M8 2h8" }],
	[
		"path",
		{
			d: "M9 2v1.343M15 2v2.789a4 4 0 0 0 .672 2.219l.656.984a4 4 0 0 1 .672 2.22v1.131M7.8 7.8l-.128.192A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-3",
		},
	],
	["path", { d: "M7 15a6.47 6.47 0 0 1 5 0 6.472 6.472 0 0 0 3.435.435" }],
	["line", { x1: "2", x2: "22", y1: "2", y2: "22" }],
] satisfies IconNode;

export const minimize = [
	["path", { d: "M8 3v3a2 2 0 0 1-2 2H3" }],
	["path", { d: "M21 8h-3a2 2 0 0 1-2-2V3" }],
	["path", { d: "M3 16h3a2 2 0 0 1 2 2v3" }],
	["path", { d: "M16 21v-3a2 2 0 0 1 2-2h3" }],
] satisfies IconNode;

export const minimize2 = [
	["path", { d: "m14 10 7-7" }],
	["path", { d: "M20 10h-6V4" }],
	["path", { d: "m3 21 7-7" }],
	["path", { d: "M4 14h6v6" }],
] satisfies IconNode;

export const minus = [["path", { d: "M5 12h14" }]] satisfies IconNode;

export const mirrorRectangular = [
	["path", { d: "M11 6 8 9" }],
	["path", { d: "m16 7-8 8" }],
	["rect", { x: "4", y: "2", width: "16", height: "20", rx: "2" }],
] satisfies IconNode;

export const mirrorRound = [
	["path", { d: "M10 6.6 8.6 8" }],
	["path", { d: "M12 18v4" }],
	["path", { d: "M15 7.5 9.5 13" }],
	["path", { d: "M7 22h10" }],
	["circle", { cx: "12", cy: "10", r: "8" }],
] satisfies IconNode;

export const monitor = [
	["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2" }],
	["line", { x1: "8", x2: "16", y1: "21", y2: "21" }],
	["line", { x1: "12", x2: "12", y1: "17", y2: "21" }],
] satisfies IconNode;

export const monitorCheck = [
	["path", { d: "m9 10 2 2 4-4" }],
	["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2" }],
	["path", { d: "M12 17v4" }],
	["path", { d: "M8 21h8" }],
] satisfies IconNode;

export const monitorCloud = [
	["path", { d: "M11 13a3 3 0 1 1 2.83-4H14a2 2 0 0 1 0 4z" }],
	["path", { d: "M12 17v4" }],
	["path", { d: "M8 21h8" }],
	["rect", { x: "2", y: "3", width: "20", height: "14", rx: "2" }],
] satisfies IconNode;

export const monitorCog = [
	["path", { d: "M12 17v4" }],
	["path", { d: "m14.305 7.53.923-.382" }],
	["path", { d: "m15.228 4.852-.923-.383" }],
	["path", { d: "m16.852 3.228-.383-.924" }],
	["path", { d: "m16.852 8.772-.383.923" }],
	["path", { d: "m19.148 3.228.383-.924" }],
	["path", { d: "m19.53 9.696-.382-.924" }],
	["path", { d: "m20.772 4.852.924-.383" }],
	["path", { d: "m20.772 7.148.924.383" }],
	["path", { d: "M22 13v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7" }],
	["path", { d: "M8 21h8" }],
	["circle", { cx: "18", cy: "6", r: "3" }],
] satisfies IconNode;

export const monitorDot = [
	["path", { d: "M12 17v4" }],
	["path", { d: "M22 12.307V15a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8.693" }],
	["path", { d: "M8 21h8" }],
	["circle", { cx: "19", cy: "6", r: "3" }],
] satisfies IconNode;

export const monitorDown = [
	["path", { d: "M12 13V7" }],
	["path", { d: "m15 10-3 3-3-3" }],
	["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2" }],
	["path", { d: "M12 17v4" }],
	["path", { d: "M8 21h8" }],
] satisfies IconNode;

export const monitorOff = [
	["path", { d: "M12 17v4" }],
	["path", { d: "M17 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 1.184-1.826" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M8 21h8" }],
	["path", { d: "M8.656 3H20a2 2 0 0 1 2 2v10a2 2 0 0 1-.293 1.042" }],
] satisfies IconNode;

export const monitorPause = [
	["path", { d: "M10 13V7" }],
	["path", { d: "M14 13V7" }],
	["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2" }],
	["path", { d: "M12 17v4" }],
	["path", { d: "M8 21h8" }],
] satisfies IconNode;

export const monitorPc = [
	["path", { d: "M10 15H4a2 2 0 01-2-2V7a2 2 0 012-2h6" }],
	["path", { d: "M10 19H5" }],
	["path", { d: "M14 11h8" }],
	["path", { d: "M14 7h8" }],
	["path", { d: "M18 17h.01" }],
	["path", { d: "M9 19v-4" }],
	["rect", { x: "14", y: "3", width: "8", height: "18", rx: "1" }],
] satisfies IconNode;

export const monitorPlay = [
	[
		"path",
		{
			d: "M15.033 9.44a.647.647 0 0 1 0 1.12l-4.065 2.352a.645.645 0 0 1-.968-.56V7.648a.645.645 0 0 1 .967-.56z",
		},
	],
	["path", { d: "M12 17v4" }],
	["path", { d: "M8 21h8" }],
	["rect", { x: "2", y: "3", width: "20", height: "14", rx: "2" }],
] satisfies IconNode;

export const monitorSmartphone = [
	["path", { d: "M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8" }],
	["path", { d: "M10 19v-3.96 3.15" }],
	["path", { d: "M7 19h5" }],
	["rect", { width: "6", height: "10", x: "16", y: "12", rx: "2" }],
] satisfies IconNode;

export const monitorSpeaker = [
	["path", { d: "M5.5 20H8" }],
	["path", { d: "M17 9h.01" }],
	["rect", { width: "10", height: "16", x: "12", y: "4", rx: "2" }],
	["path", { d: "M8 6H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4" }],
	["circle", { cx: "17", cy: "15", r: "1" }],
] satisfies IconNode;

export const monitorStop = [
	["path", { d: "M12 17v4" }],
	["path", { d: "M8 21h8" }],
	["rect", { x: "2", y: "3", width: "20", height: "14", rx: "2" }],
	["rect", { x: "9", y: "7", width: "6", height: "6", rx: "1" }],
] satisfies IconNode;

export const monitorUp = [
	["path", { d: "m9 10 3-3 3 3" }],
	["path", { d: "M12 13V7" }],
	["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2" }],
	["path", { d: "M12 17v4" }],
	["path", { d: "M8 21h8" }],
] satisfies IconNode;

export const monitorX = [
	["path", { d: "m14.5 12.5-5-5" }],
	["path", { d: "m9.5 12.5 5-5" }],
	["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2" }],
	["path", { d: "M12 17v4" }],
	["path", { d: "M8 21h8" }],
] satisfies IconNode;

export const moon = [
	[
		"path",
		{
			d: "M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401",
		},
	],
] satisfies IconNode;

export const moonStar = [
	["path", { d: "M18 5h4" }],
	["path", { d: "M20 3v4" }],
	[
		"path",
		{
			d: "M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401",
		},
	],
] satisfies IconNode;

export const mop = [
	["path", { d: "M10 22c2.761 0 5-1.79 5-4-4.42 0-4.08-5-8.5-5a1 1 0 100 9za3 3 0 01-3-3" }],
	["path", { d: "M12.5 11.5 22 2" }],
	[
		"path",
		{
			d: "m6.98 13.02 2.665-2.664a1.21 1.21 0 011.71 0l2.29 2.288a1.21 1.21 0 010 1.712l-2.088 2.087",
		},
	],
] satisfies IconNode;

export const mopSparkles = [
	["path", { d: "M10 22a3 3 0 01-3-3" }],
	["path", { d: "M10 22c2.761 0 5-1.79 5-4-4.42 0-4.08-5-8.5-5a4.501 4.501 0 000 9z" }],
	["path", { d: "M10 3H8" }],
	["path", { d: "M12.5 11.5 22 2" }],
	["path", { d: "M20 13v4" }],
	["path", { d: "M22 15h-4" }],
	["path", { d: "M4 5v4" }],
	["path", { d: "M6 7H2" }],
	[
		"path",
		{
			d: "m6.98 13.02 2.665-2.664a1.21 1.21 0 011.71 0l2.29 2.288a1.21 1.21 0 010 1.712l-2.088 2.087",
		},
	],
	["path", { d: "M9 2v2" }],
] satisfies IconNode;

export const mosque = [
	["path", { d: "M12.268 2a2 2 0 003.465 2" }],
	["path", { d: "M14 5 L14 8" }],
	["path", { d: "M16 22v-3a2 2 0 00-4 0v3" }],
	[
		"path",
		{
			d: "M21 13c-.662-1.497-1.666-2.753-2.9-3.63C16.825 8.47 15.422 8 14 8s-2.826.47-4.1 1.37C8.668 10.248 7.663 11.504 7 13z",
		},
	],
	["path", { d: "M3 9h4" }],
	["path", { d: "M7 22V6a5 5 0 00-2-4 5 5 0 00-2 4v14a2 2 0 002 2h14a2 2 0 002-2v-7" }],
] satisfies IconNode;

export const motorbike = [
	["path", { d: "m18 14-1-3" }],
	["path", { d: "m3 9 6 2a2 2 0 0 1 2-2h2a2 2 0 0 1 1.99 1.81" }],
	["path", { d: "M8 17h3a1 1 0 0 0 1-1 6 6 0 0 1 6-6 1 1 0 0 0 1-1v-.75A5 5 0 0 0 17 5" }],
	["circle", { cx: "19", cy: "17", r: "3" }],
	["circle", { cx: "5", cy: "17", r: "3" }],
] satisfies IconNode;

export const mountain = [["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z" }]] satisfies IconNode;

export const mountainSnow = [
	["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z" }],
	["path", { d: "M4.14 15.08c2.62-1.57 5.24-1.43 7.86.42 2.74 1.94 5.49 2 8.23.19" }],
] satisfies IconNode;

export const mouse = [
	["rect", { x: "5", y: "2", width: "14", height: "20", rx: "7" }],
	["path", { d: "M12 6v4" }],
] satisfies IconNode;

export const mouseLeft = [
	["path", { d: "M12 7.318V10" }],
	["path", { d: "M5 10v5a7 7 0 0 0 14 0V9c0-3.527-2.608-6.515-6-7" }],
	["circle", { cx: "7", cy: "4", r: "2" }],
] satisfies IconNode;

export const mouseOff = [
	["path", { d: "M12 6v.343" }],
	["path", { d: "M18.218 18.218A7 7 0 0 1 5 15V9a7 7 0 0 1 .782-3.218" }],
	["path", { d: "M19 13.343V9A7 7 0 0 0 8.56 2.902" }],
	["path", { d: "M22 22 2 2" }],
] satisfies IconNode;

export const mousePointer = [
	["path", { d: "M12.586 12.586 19 19" }],
	[
		"path",
		{
			d: "M3.688 3.037a.497.497 0 0 0-.651.651l6.5 15.999a.501.501 0 0 0 .947-.062l1.569-6.083a2 2 0 0 1 1.448-1.479l6.124-1.579a.5.5 0 0 0 .063-.947z",
		},
	],
] satisfies IconNode;

export const mousePointer2 = [
	[
		"path",
		{
			d: "M4.037 4.688a.495.495 0 0 1 .651-.651l16 6.5a.5.5 0 0 1-.063.947l-6.124 1.58a2 2 0 0 0-1.438 1.435l-1.579 6.126a.5.5 0 0 1-.947.063z",
		},
	],
] satisfies IconNode;

export const mousePointer2Off = [
	[
		"path",
		{
			d: "m15.55 8.45 5.138 2.087a.5.5 0 0 1-.063.947l-6.124 1.58a2 2 0 0 0-1.438 1.435l-1.579 6.126a.5.5 0 0 1-.947.063L8.45 15.551",
		},
	],
	["path", { d: "M22 2 2 22" }],
	["path", { d: "m6.816 11.528-2.779-6.84a.495.495 0 0 1 .651-.651l6.84 2.779" }],
] satisfies IconNode;

export const mousePointerBan = [
	[
		"path",
		{
			d: "M2.034 2.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.944L8.204 7.545a1 1 0 0 0-.66.66l-1.066 3.443a.5.5 0 0 1-.944.033z",
		},
	],
	["circle", { cx: "16", cy: "16", r: "6" }],
	["path", { d: "m11.8 11.8 8.4 8.4" }],
] satisfies IconNode;

export const mousePointerClick = [
	["path", { d: "M14 4.1 12 6" }],
	["path", { d: "m5.1 8-2.9-.8" }],
	["path", { d: "m6 12-1.9 2" }],
	["path", { d: "M7.2 2.2 8 5.1" }],
	[
		"path",
		{
			d: "M9.037 9.69a.498.498 0 0 1 .653-.653l11 4.5a.5.5 0 0 1-.074.949l-4.349 1.041a1 1 0 0 0-.74.739l-1.04 4.35a.5.5 0 0 1-.95.074z",
		},
	],
] satisfies IconNode;

export const mouseRight = [
	["path", { d: "M12 7.318V10" }],
	["path", { d: "M19 10v5a7 7 0 0 1-14 0V9c0-3.527 2.608-6.515 6-7" }],
	["circle", { cx: "17", cy: "4", r: "2" }],
] satisfies IconNode;

export const mouth = [
	["path", { d: "M2 12a50.5 50.5 0 0020 0 1 1 0 00-1-1" }],
	[
		"path",
		{
			d: "M2.457 11.159a1 1 0 00-.307 1.369 11.59 11.59 0 0019.7 0 1 1 0 00-.308-1.368c-2.426-1.568-3.65-2.284-5.479-3.644a2.6 2.6 0 00-3.373.208 1 1 0 01-1.38 0 2.62 2.62 0 00-3.373-.208c-1.83 1.36-3.053 2.076-5.48 3.643",
		},
	],
] satisfies IconNode;

export const mouthOff = [
	[
		"path",
		{
			d: "M13.074 7.417a2.6 2.6 0 012.989.099c1.829 1.36 3.053 2.076 5.479 3.644a1 1 0 01.308 1.368 11.6 11.6 0 01-1.617 2.05",
		},
	],
	["path", { d: "M2 12a50.5 50.5 0 0010.99.99" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M21 11a1 1 0 011 1 51 51 0 01-3.734.61" }],
	[
		"path",
		{
			d: "M7.695 7.695c-1.7 1.247-2.92 1.967-5.238 3.464a1 1 0 00-.307 1.369 11.6 11.6 0 0014.766 4.388",
		},
	],
] satisfies IconNode;

export const move = [
	["path", { d: "M12 2v20" }],
	["path", { d: "m15 19-3 3-3-3" }],
	["path", { d: "m19 9 3 3-3 3" }],
	["path", { d: "M2 12h20" }],
	["path", { d: "m5 9-3 3 3 3" }],
	["path", { d: "m9 5 3-3 3 3" }],
] satisfies IconNode;

export const move3d = [
	["path", { d: "M5 3v16h16" }],
	["path", { d: "m5 19 6-6" }],
	["path", { d: "m2 6 3-3 3 3" }],
	["path", { d: "m18 16 3 3-3 3" }],
] satisfies IconNode;

export const moveDiagonal = [
	["path", { d: "M11 19H5v-6" }],
	["path", { d: "M13 5h6v6" }],
	["path", { d: "M19 5 5 19" }],
] satisfies IconNode;

export const moveDiagonal2 = [
	["path", { d: "M19 13v6h-6" }],
	["path", { d: "M5 11V5h6" }],
	["path", { d: "m5 5 14 14" }],
] satisfies IconNode;

export const moveDown = [
	["path", { d: "M8 18L12 22L16 18" }],
	["path", { d: "M12 2V22" }],
] satisfies IconNode;

export const moveDownLeft = [
	["path", { d: "M11 19H5V13" }],
	["path", { d: "M19 5L5 19" }],
] satisfies IconNode;

export const moveDownRight = [
	["path", { d: "M19 13V19H13" }],
	["path", { d: "M5 5L19 19" }],
] satisfies IconNode;

export const moveHorizontal = [
	["path", { d: "m18 8 4 4-4 4" }],
	["path", { d: "M2 12h20" }],
	["path", { d: "m6 8-4 4 4 4" }],
] satisfies IconNode;

export const moveLeft = [
	["path", { d: "M6 8L2 12L6 16" }],
	["path", { d: "M2 12H22" }],
] satisfies IconNode;

export const moveRight = [
	["path", { d: "M18 8L22 12L18 16" }],
	["path", { d: "M2 12H22" }],
] satisfies IconNode;

export const moveUp = [
	["path", { d: "M8 6L12 2L16 6" }],
	["path", { d: "M12 2V22" }],
] satisfies IconNode;

export const moveUpLeft = [
	["path", { d: "M5 11V5H11" }],
	["path", { d: "M5 5L19 19" }],
] satisfies IconNode;

export const moveUpRight = [
	["path", { d: "M13 5H19V11" }],
	["path", { d: "M19 5L5 19" }],
] satisfies IconNode;

export const moveVertical = [
	["path", { d: "M12 2v20" }],
	["path", { d: "m8 18 4 4 4-4" }],
	["path", { d: "m8 6 4-4 4 4" }],
] satisfies IconNode;

export const navigation = [
	["polygon", { points: "3 11 22 2 13 21 11 13 3 11" }],
] satisfies IconNode;

export const navigation2 = [
	["polygon", { points: "12 2 19 21 12 17 5 21 12 2" }],
] satisfies IconNode;

export const navigation2Off = [
	["path", { d: "M9.31 9.31 5 21l7-4 7 4-1.17-3.17" }],
	["path", { d: "M14.53 8.88 12 2l-1.17 3.17" }],
	["line", { x1: "2", x2: "22", y1: "2", y2: "22" }],
] satisfies IconNode;

export const navigationOff = [
	["path", { d: "M8.43 8.43 3 11l8 2 2 8 2.57-5.43" }],
	["path", { d: "M17.39 11.73 22 2l-9.73 4.61" }],
	["line", { x1: "2", x2: "22", y1: "2", y2: "22" }],
] satisfies IconNode;

export const nepaliRupee = [
	["path", { d: "M18 16.173 A4.74 4.74 0 0 0 13.496 8.005" }],
	["path", { d: "M4 3 L20 3" }],
	["path", { d: "M5 13 L13.5 21" }],
	["path", { d: "M5 13 L9 13" }],
	["path", { d: "M8 13 C15.5 13 14.667 3 8 3" }],
] satisfies IconNode;

export const network = [
	["rect", { x: "16", y: "16", width: "6", height: "6", rx: "1" }],
	["rect", { x: "2", y: "16", width: "6", height: "6", rx: "1" }],
	["rect", { x: "9", y: "2", width: "6", height: "6", rx: "1" }],
	["path", { d: "M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3" }],
	["path", { d: "M12 12V8" }],
] satisfies IconNode;

export const newspaper = [
	["path", { d: "M15 18h-5" }],
	["path", { d: "M18 14h-8" }],
	[
		"path",
		{
			d: "M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-4 0v-9a2 2 0 0 1 2-2h2",
		},
	],
	["rect", { width: "8", height: "4", x: "10", y: "6", rx: "1" }],
] satisfies IconNode;

export const nfc = [
	["path", { d: "M6 8.32a7.43 7.43 0 0 1 0 7.36" }],
	["path", { d: "M9.46 6.21a11.76 11.76 0 0 1 0 11.58" }],
	["path", { d: "M12.91 4.1a15.91 15.91 0 0 1 .01 15.8" }],
	["path", { d: "M16.37 2a20.16 20.16 0 0 1 0 20" }],
] satisfies IconNode;

export const nonBinary = [
	["path", { d: "M12 2v10" }],
	["path", { d: "m8.5 4 7 4" }],
	["path", { d: "m8.5 8 7-4" }],
	["circle", { cx: "12", cy: "17", r: "5" }],
] satisfies IconNode;

export const notebook = [
	["path", { d: "M2 6h4" }],
	["path", { d: "M2 10h4" }],
	["path", { d: "M2 14h4" }],
	["path", { d: "M2 18h4" }],
	["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2" }],
	["path", { d: "M16 2v20" }],
] satisfies IconNode;

export const notebookDot = [
	["path", { d: "M16 11.75V22" }],
	["path", { d: "M2 10h4" }],
	["path", { d: "M2 14h4" }],
	["path", { d: "M2 18h4" }],
	["path", { d: "M2 6h4" }],
	["path", { d: "M20 11.75V20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h5.65" }],
	["circle", { cx: "18", cy: "5", r: "3" }],
] satisfies IconNode;

export const notebookPen = [
	["path", { d: "M13.4 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7.4" }],
	["path", { d: "M2 6h4" }],
	["path", { d: "M2 10h4" }],
	["path", { d: "M2 14h4" }],
	["path", { d: "M2 18h4" }],
	[
		"path",
		{
			d: "M21.378 5.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
		},
	],
] satisfies IconNode;

export const notebookTabs = [
	["path", { d: "M2 6h4" }],
	["path", { d: "M2 10h4" }],
	["path", { d: "M2 14h4" }],
	["path", { d: "M2 18h4" }],
	["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2" }],
	["path", { d: "M15 2v20" }],
	["path", { d: "M15 7h5" }],
	["path", { d: "M15 12h5" }],
	["path", { d: "M15 17h5" }],
] satisfies IconNode;

export const notebookText = [
	["path", { d: "M2 6h4" }],
	["path", { d: "M2 10h4" }],
	["path", { d: "M2 14h4" }],
	["path", { d: "M2 18h4" }],
	["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2" }],
	["path", { d: "M9.5 8h5" }],
	["path", { d: "M9.5 12H16" }],
	["path", { d: "M9.5 16H14" }],
] satisfies IconNode;

export const notepadText = [
	["path", { d: "M8 2v4" }],
	["path", { d: "M12 2v4" }],
	["path", { d: "M16 2v4" }],
	["rect", { width: "16", height: "18", x: "4", y: "4", rx: "2" }],
	["path", { d: "M8 10h6" }],
	["path", { d: "M8 14h8" }],
	["path", { d: "M8 18h5" }],
] satisfies IconNode;

export const notepadTextDashed = [
	["path", { d: "M8 2v4" }],
	["path", { d: "M12 2v4" }],
	["path", { d: "M16 2v4" }],
	["path", { d: "M16 4h2a2 2 0 0 1 2 2v2" }],
	["path", { d: "M20 12v2" }],
	["path", { d: "M20 18v2a2 2 0 0 1-2 2h-1" }],
	["path", { d: "M13 22h-2" }],
	["path", { d: "M7 22H6a2 2 0 0 1-2-2v-2" }],
	["path", { d: "M4 14v-2" }],
	["path", { d: "M4 8V6a2 2 0 0 1 2-2h2" }],
	["path", { d: "M8 10h6" }],
	["path", { d: "M8 14h8" }],
	["path", { d: "M8 18h5" }],
] satisfies IconNode;

export const nut = [
	[
		"path",
		{
			d: "M16.847 5.847 20 9a7.23 7.23 0 011.551 7.516C21.241 17.352 21 17.932 21 19v1a1 1 0 01-1 1h-1c-1.069 0-1.648.242-2.485.552A7.2 7.2 0 019.002 20l-3.155-3.153",
		},
	],
	[
		"path",
		{
			d: "M18.21 5.43c-1.71.69-5.07 1.07-6.71 1.07.46 1.38.91 2.74.61 4.88a.88.88 0 01-.73.74c-1.78.28-3.54-.17-4.88-.62 0 1.64-.38 5-1.07 6.71-.21.52-.82.55-1.17.12A10 10 0 0118.33 4.26c.43.35.4.97-.12 1.17",
		},
	],
	["path", { d: "M4.93 4.93 3 3a.7.7 0 010-1" }],
] satisfies IconNode;

export const nutOff = [
	[
		"path",
		{
			d: "M11.868 11.868a.88.88 0 01-.488.252c-1.78.28-3.54-.17-4.88-.62 0 1.272-.229 3.578-.653 5.347a10 10 0 01-.417 1.363c-.21.52-.82.55-1.17.12a10 10 0 01.677-13.393",
		},
	],
	["path", { d: "M12.14 6.485a27.4 27.4 0 004.707-.638L20 9a7.23 7.23 0 011.706 7.05" }],
	["path", { d: "m2 2 20 20" }],
	[
		"path",
		{
			d: "M20.707 20.707A1 1 0 0120 21h-1c-1.069 0-1.648.242-2.485.552A7.2 7.2 0 019.002 20l-3.155-3.153",
		},
	],
	["path", { d: "M8.356 2.7a10 10 0 019.974 1.56c.43.35.4.97-.12 1.17a10 10 0 01-1.363.417" }],
] satisfies IconNode;

export const octagon = [
	[
		"path",
		{
			d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
		},
	],
] satisfies IconNode;

export const octagonAlert = [
	["path", { d: "M12 16h.01" }],
	["path", { d: "M12 8v4" }],
	[
		"path",
		{
			d: "M15.312 2a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586l-4.688-4.688A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2z",
		},
	],
] satisfies IconNode;

export const octagonMinus = [
	[
		"path",
		{
			d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
		},
	],
	["path", { d: "M8 12h8" }],
] satisfies IconNode;

export const octagonPause = [
	["path", { d: "M10 15V9" }],
	["path", { d: "M14 15V9" }],
	[
		"path",
		{
			d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
		},
	],
] satisfies IconNode;

export const octagonX = [
	["path", { d: "m15 9-6 6" }],
	[
		"path",
		{
			d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
		},
	],
	["path", { d: "m9 9 6 6" }],
] satisfies IconNode;

export const omega = [
	[
		"path",
		{
			d: "M3 20h4.5a.5.5 0 0 0 .5-.5v-.282a.52.52 0 0 0-.247-.437 8 8 0 1 1 8.494-.001.52.52 0 0 0-.247.438v.282a.5.5 0 0 0 .5.5H21",
		},
	],
] satisfies IconNode;

export const option = [
	["path", { d: "M14 3h7" }],
	["path", { d: "M3 3h5.28a1 1 0 0 1 .948.684l5.544 16.632a1 1 0 0 0 .949.684H21" }],
] satisfies IconNode;

export const orbit = [
	["path", { d: "M20.341 6.484A10 10 0 0 1 10.266 21.85" }],
	["path", { d: "M3.659 17.516A10 10 0 0 1 13.74 2.152" }],
	["circle", { cx: "12", cy: "12", r: "3" }],
	["circle", { cx: "19", cy: "5", r: "2" }],
	["circle", { cx: "5", cy: "19", r: "2" }],
] satisfies IconNode;

export const origami = [
	["path", { d: "M12 12V4a1 1 0 0 1 1-1h6.297a1 1 0 0 1 .651 1.759l-4.696 4.025" }],
	[
		"path",
		{ d: "m12 21-7.414-7.414A2 2 0 0 1 4 12.172V6.415a1.002 1.002 0 0 1 1.707-.707L20 20.009" },
	],
	[
		"path",
		{
			d: "m12.214 3.381 8.414 14.966a1 1 0 0 1-.167 1.199l-1.168 1.163a1 1 0 0 1-.706.291H6.351a1 1 0 0 1-.625-.219L3.25 18.8a1 1 0 0 1 .631-1.781l4.165.027",
		},
	],
] satisfies IconNode;

export const packageNode = [
	[
		"path",
		{
			d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
		},
	],
	["path", { d: "M12 22V12" }],
	["polyline", { points: "3.29 7 12 12 20.71 7" }],
	["path", { d: "m7.5 4.27 9 5.15" }],
] satisfies IconNode;

export const package2 = [
	["path", { d: "M12 3v6" }],
	[
		"path",
		{
			d: "M16.76 3a2 2 0 0 1 1.8 1.1l2.23 4.479a2 2 0 0 1 .21.891V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9.472a2 2 0 0 1 .211-.894L5.45 4.1A2 2 0 0 1 7.24 3z",
		},
	],
	["path", { d: "M3.054 9.013h17.893" }],
] satisfies IconNode;

export const packageCheck = [
	["path", { d: "M12 22V12" }],
	["path", { d: "m16 17 2 2 4-4" }],
	[
		"path",
		{
			d: "M21 11.127V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.729l7 4a2 2 0 0 0 2 .001l1.32-.753",
		},
	],
	["path", { d: "M3.29 7 12 12l8.71-5" }],
	["path", { d: "m7.5 4.27 8.997 5.148" }],
] satisfies IconNode;

export const packageMinus = [
	["path", { d: "M12 22V12" }],
	["path", { d: "M16 17h6" }],
	[
		"path",
		{
			d: "M21 13V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.729l7 4a2 2 0 0 0 2 .001l1.675-.955",
		},
	],
	["path", { d: "M3.29 7 12 12l8.71-5" }],
	["path", { d: "m7.5 4.27 8.997 5.148" }],
] satisfies IconNode;

export const packageOpen = [
	["path", { d: "M12 22v-9" }],
	[
		"path",
		{
			d: "M15.17 2.21a1.67 1.67 0 0 1 1.63 0L21 4.57a1.93 1.93 0 0 1 0 3.36L8.82 14.79a1.655 1.655 0 0 1-1.64 0L3 12.43a1.93 1.93 0 0 1 0-3.36z",
		},
	],
	[
		"path",
		{
			d: "M20 13v3.87a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13",
		},
	],
	[
		"path",
		{
			d: "M21 12.43a1.93 1.93 0 0 0 0-3.36L8.83 2.2a1.64 1.64 0 0 0-1.63 0L3 4.57a1.93 1.93 0 0 0 0 3.36l12.18 6.86a1.636 1.636 0 0 0 1.63 0z",
		},
	],
] satisfies IconNode;

export const packagePlus = [
	["path", { d: "M12 22V12" }],
	["path", { d: "M16 17h6" }],
	["path", { d: "M19 14v6" }],
	[
		"path",
		{
			d: "M21 10.535V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.729l7 4a2 2 0 0 0 2 .001l1.675-.955",
		},
	],
	["path", { d: "M3.29 7 12 12l8.71-5" }],
	["path", { d: "m7.5 4.27 8.997 5.148" }],
] satisfies IconNode;

export const packageSearch = [
	["path", { d: "M12 22V12" }],
	["path", { d: "M20.27 18.27 22 20" }],
	[
		"path",
		{
			d: "M21 10.498V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.729l7 4a2 2 0 0 0 2 .001l.98-.559",
		},
	],
	["path", { d: "M3.29 7 12 12l8.71-5" }],
	["path", { d: "m7.5 4.27 8.997 5.148" }],
	["circle", { cx: "18.5", cy: "16.5", r: "2.5" }],
] satisfies IconNode;

export const packageX = [
	["path", { d: "M12 22V12" }],
	["path", { d: "m16.5 14.5 5 5" }],
	["path", { d: "m16.5 19.5 5-5" }],
	[
		"path",
		{
			d: "M21 10.5V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.729l7 4a2 2 0 0 0 2 .001l.13-.074",
		},
	],
	["path", { d: "M3.29 7 12 12l8.71-5" }],
	["path", { d: "m7.5 4.27 8.997 5.148" }],
] satisfies IconNode;

export const paintBucket = [
	["path", { d: "M11 7 6 2" }],
	["path", { d: "M18.992 12H2.041" }],
	[
		"path",
		{
			d: "M21.145 18.38A3.34 3.34 0 0 1 20 16.5a3.3 3.3 0 0 1-1.145 1.88c-.575.46-.855 1.02-.855 1.595A2 2 0 0 0 20 22a2 2 0 0 0 2-2.025c0-.58-.285-1.13-.855-1.595",
		},
	],
	[
		"path",
		{
			d: "m8.5 4.5 2.148-2.148a1.205 1.205 0 0 1 1.704 0l7.296 7.296a1.205 1.205 0 0 1 0 1.704l-7.592 7.592a3.615 3.615 0 0 1-5.112 0l-3.888-3.888a3.615 3.615 0 0 1 0-5.112L5.67 7.33",
		},
	],
] satisfies IconNode;

export const paintRoller = [
	["rect", { width: "16", height: "6", x: "2", y: "2", rx: "2" }],
	["path", { d: "M10 16v-2a2 2 0 0 1 2-2h8a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" }],
	["rect", { width: "4", height: "6", x: "8", y: "16", rx: "1" }],
] satisfies IconNode;

export const paintbrush = [
	["path", { d: "m14.622 17.897-10.68-2.913" }],
	[
		"path",
		{
			d: "M18.376 2.622a1 1 0 1 1 3.002 3.002L17.36 9.643a.5.5 0 0 0 0 .707l.944.944a2.41 2.41 0 0 1 0 3.408l-.944.944a.5.5 0 0 1-.707 0L8.354 7.348a.5.5 0 0 1 0-.707l.944-.944a2.41 2.41 0 0 1 3.408 0l.944.944a.5.5 0 0 0 .707 0z",
		},
	],
	[
		"path",
		{
			d: "M9 8c-1.804 2.71-3.97 3.46-6.583 3.948a.507.507 0 0 0-.302.819l7.32 8.883a1 1 0 0 0 1.185.204C12.735 20.405 16 16.792 16 15",
		},
	],
] satisfies IconNode;

export const paintbrushVertical = [
	["path", { d: "M10 2v2" }],
	["path", { d: "M14 2v4" }],
	["path", { d: "M17 2a1 1 0 0 1 1 1v9H6V3a1 1 0 0 1 1-1z" }],
	[
		"path",
		{
			d: "M6 12a1 1 0 0 0-1 1v1a2 2 0 0 0 2 2h2a1 1 0 0 1 1 1v2.9a2 2 0 1 0 4 0V17a1 1 0 0 1 1-1h2a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1",
		},
	],
] satisfies IconNode;

export const palette = [
	[
		"path",
		{
			d: "M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z",
		},
	],
	["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor" }],
	["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor" }],
	["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor" }],
	["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor" }],
] satisfies IconNode;

export const panda = [
	["path", { d: "M11.25 17.25h1.5L12 18z" }],
	["path", { d: "m15 12 2 2" }],
	["path", { d: "M17.902 6.599a8 8 0 0 0-.5-.5" }],
	[
		"path",
		{
			d: "M2 14.5C2 19.47 6.48 22 12 22s10-2.53 10-7.5a10 10 0 0 0-1.3-4.83 4.5 4.5 0 1 0-7.05-5.5 8 8 0 0 0-3.3 0 4.5 4.5 0 1 0-7.04 5.5A10 10 0 0 0 2 14.5",
		},
	],
	["path", { d: "M6.099 6.599a8 8 0 0 1 .5-.5" }],
	["path", { d: "m9 12-2 2" }],
] satisfies IconNode;

export const panelBottom = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M3 15h18" }],
] satisfies IconNode;

export const panelBottomClose = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M3 15h18" }],
	["path", { d: "m15 8-3 3-3-3" }],
] satisfies IconNode;

export const panelBottomDashed = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M14 15h1" }],
	["path", { d: "M19 15h2" }],
	["path", { d: "M3 15h2" }],
	["path", { d: "M9 15h1" }],
] satisfies IconNode;

export const panelBottomOpen = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M3 15h18" }],
	["path", { d: "m9 10 3-3 3 3" }],
] satisfies IconNode;

export const panelLeft = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M9 3v18" }],
] satisfies IconNode;

export const panelLeftClose = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M9 3v18" }],
	["path", { d: "m16 15-3-3 3-3" }],
] satisfies IconNode;

export const panelLeftDashed = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M9 14v1" }],
	["path", { d: "M9 19v2" }],
	["path", { d: "M9 3v2" }],
	["path", { d: "M9 9v1" }],
] satisfies IconNode;

export const panelLeftOpen = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M9 3v18" }],
	["path", { d: "m14 9 3 3-3 3" }],
] satisfies IconNode;

export const panelLeftRightDashed = [
	["path", { d: "M15 10V9" }],
	["path", { d: "M15 15v-1" }],
	["path", { d: "M15 21v-2" }],
	["path", { d: "M15 5V3" }],
	["path", { d: "M9 10V9" }],
	["path", { d: "M9 15v-1" }],
	["path", { d: "M9 21v-2" }],
	["path", { d: "M9 5V3" }],
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
] satisfies IconNode;

export const panelRight = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M15 3v18" }],
] satisfies IconNode;

export const panelRightClose = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M15 3v18" }],
	["path", { d: "m8 9 3 3-3 3" }],
] satisfies IconNode;

export const panelRightDashed = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M15 14v1" }],
	["path", { d: "M15 19v2" }],
	["path", { d: "M15 3v2" }],
	["path", { d: "M15 9v1" }],
] satisfies IconNode;

export const panelRightOpen = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M15 3v18" }],
	["path", { d: "m10 15-3-3 3-3" }],
] satisfies IconNode;

export const panelTop = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M3 9h18" }],
] satisfies IconNode;

export const panelTopBottomDashed = [
	["path", { d: "M14 15h1" }],
	["path", { d: "M14 9h1" }],
	["path", { d: "M19 15h2" }],
	["path", { d: "M19 9h2" }],
	["path", { d: "M3 15h2" }],
	["path", { d: "M3 9h2" }],
	["path", { d: "M9 15h1" }],
	["path", { d: "M9 9h1" }],
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
] satisfies IconNode;

export const panelTopClose = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M3 9h18" }],
	["path", { d: "m9 16 3-3 3 3" }],
] satisfies IconNode;

export const panelTopDashed = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M14 9h1" }],
	["path", { d: "M19 9h2" }],
	["path", { d: "M3 9h2" }],
	["path", { d: "M9 9h1" }],
] satisfies IconNode;

export const panelTopOpen = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M3 9h18" }],
	["path", { d: "m15 14-3 3-3-3" }],
] satisfies IconNode;

export const panelsLeftBottom = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M9 3v18" }],
	["path", { d: "M9 15h12" }],
] satisfies IconNode;

export const panelsRightBottom = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M3 15h12" }],
	["path", { d: "M15 3v18" }],
] satisfies IconNode;

export const panelsTopLeft = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M3 9h18" }],
	["path", { d: "M9 21V9" }],
] satisfies IconNode;

export const paperBag = [
	[
		"path",
		{
			d: "M5.364 3.848C4 6 3 9.652 3 12.652V19a2 2 0 002 2h14a2 2 0 002-2v-5c0-2.334-1.816-4.668-2.622-7.002",
		},
	],
	[
		"path",
		{
			d: "M7 3h11.379a2 2 0 011.789 1.106l.723 1.447A1 1 0 0119.997 7h-8.525a2 2 0 01-1.789-1.106L8.79 4.105a2 2 0 10-3.579 1.789l2.261 4.522A5 5 0 018 12.652V21",
		},
	],
] satisfies IconNode;

export const paperclip = [
	[
		"path",
		{
			d: "m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551",
		},
	],
] satisfies IconNode;

export const parasol = [
	["path", { d: "M12.5 11.134 18.196 21" }],
	[
		"path",
		{
			d: "M20.425 5.299a10 10 0 0 0-16.941 9.78c.183.563.843.774 1.355.478L20.16 6.711c.512-.296.66-.973.264-1.413",
		},
	],
	["path", { d: "M21 21H3" }],
] satisfies IconNode;

export const parentheses = [
	["path", { d: "M8 21s-4-3-4-9 4-9 4-9" }],
	["path", { d: "M16 3s4 3 4 9-4 9-4 9" }],
] satisfies IconNode;

export const park = [
	["path", { d: "M12 18h10" }],
	["path", { d: "M13.248 9.998A4.5 4.5 0 0 0 11.75 8.6V8a1 1 0 0 0-7.5 0 4.9 4.9 0 0 0 2.25 9H8" }],
	["path", { d: "m15 14-2 6" }],
	["path", { d: "m19 14 2 6" }],
	["path", { d: "M21 14h-8" }],
	["path", { d: "M8 20v-5.922a2 2 0 0 0-.586-1.414L6.5 11.75" }],
	["path", { d: "M9.205 12.795 8 14" }],
	["circle", { cx: "19", cy: "6", r: "2" }],
] satisfies IconNode;

export const parkingMeter = [
	["path", { d: "M11 15h2" }],
	["path", { d: "M12 12v3" }],
	["path", { d: "M12 19v3" }],
	[
		"path",
		{
			d: "M15.282 19a1 1 0 0 0 .948-.68l2.37-6.988a7 7 0 1 0-13.2 0l2.37 6.988a1 1 0 0 0 .948.68z",
		},
	],
	["path", { d: "M9 9a3 3 0 1 1 6 0" }],
] satisfies IconNode;

export const partyPopper = [
	["path", { d: "M5.8 11.3 2 22l10.7-3.79" }],
	["path", { d: "M4 3h.01" }],
	["path", { d: "M22 8h.01" }],
	["path", { d: "M15 2h.01" }],
	["path", { d: "M22 20h.01" }],
	[
		"path",
		{
			d: "m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10",
		},
	],
	["path", { d: "m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11c-.11.7-.72 1.22-1.43 1.22H17" }],
	["path", { d: "m11 2 .33.82c.34.86-.2 1.82-1.11 1.98C9.52 4.9 9 5.52 9 6.23V7" }],
	[
		"path",
		{
			d: "M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z",
		},
	],
] satisfies IconNode;

export const pause = [
	["rect", { x: "14", y: "3", width: "5", height: "18", rx: "1" }],
	["rect", { x: "5", y: "3", width: "5", height: "18", rx: "1" }],
] satisfies IconNode;

export const pawPrint = [
	["circle", { cx: "11", cy: "4", r: "2" }],
	["circle", { cx: "18", cy: "8", r: "2" }],
	["circle", { cx: "20", cy: "16", r: "2" }],
	[
		"path",
		{
			d: "M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10Z",
		},
	],
] satisfies IconNode;

export const pcCase = [
	["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2" }],
	["path", { d: "M15 14h.01" }],
	["path", { d: "M9 6h6" }],
	["path", { d: "M9 10h6" }],
] satisfies IconNode;

export const pen = [
	[
		"path",
		{
			d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
		},
	],
] satisfies IconNode;

export const penLine = [
	["path", { d: "M13 21h8" }],
	[
		"path",
		{
			d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
		},
	],
] satisfies IconNode;

export const penOff = [
	[
		"path",
		{
			d: "m10 10-6.157 6.162a2 2 0 0 0-.5.833l-1.322 4.36a.5.5 0 0 0 .622.624l4.358-1.323a2 2 0 0 0 .83-.5L14 13.982",
		},
	],
	["path", { d: "m12.829 7.172 4.359-4.346a1 1 0 1 1 3.986 3.986l-4.353 4.353" }],
	["path", { d: "m2 2 20 20" }],
] satisfies IconNode;

export const penTool = [
	[
		"path",
		{
			d: "m18 13-.654-4.736a4 4 0 00-2.756-3.266l-9.163-2.9a2 2 0 00-2.017.493l-.82.819a2 2 0 00-.492 2.017l2.9 9.163a4 4 0 003.266 2.756L13 18",
		},
	],
	[
		"path",
		{
			d: "M18.648 12.352a1.205 1.205 0 011.704 0l1.296 1.296a1.205 1.205 0 010 1.704l-6.296 6.296a1.205 1.205 0 01-1.704 0l-1.296-1.296a1.205 1.205 0 010-1.704z",
		},
	],
	["path", { d: "m3 3 6.586 6.586" }],
	["circle", { cx: "11", cy: "11", r: "2" }],
] satisfies IconNode;

export const pencil = [
	[
		"path",
		{
			d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
		},
	],
	["path", { d: "m15 5 4 4" }],
] satisfies IconNode;

export const pencilLine = [
	["path", { d: "M13 21h8" }],
	["path", { d: "m15 5 4 4" }],
	[
		"path",
		{
			d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
		},
	],
] satisfies IconNode;

export const pencilOff = [
	[
		"path",
		{
			d: "m10 10-6.157 6.162a2 2 0 0 0-.5.833l-1.322 4.36a.5.5 0 0 0 .622.624l4.358-1.323a2 2 0 0 0 .83-.5L14 13.982",
		},
	],
	["path", { d: "m12.829 7.172 4.359-4.346a1 1 0 1 1 3.986 3.986l-4.353 4.353" }],
	["path", { d: "m15 5 4 4" }],
	["path", { d: "m2 2 20 20" }],
] satisfies IconNode;

export const pencilRuler = [
	["path", { d: "M13 7 8.7 2.7a2.41 2.41 0 0 0-3.4 0L2.7 5.3a2.41 2.41 0 0 0 0 3.4L7 13" }],
	["path", { d: "m8 6 2-2" }],
	["path", { d: "m18 16 2-2" }],
	["path", { d: "m17 11 4.3 4.3c.94.94.94 2.46 0 3.4l-2.6 2.6c-.94.94-2.46.94-3.4 0L11 17" }],
	[
		"path",
		{
			d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
		},
	],
	["path", { d: "m15 5 4 4" }],
] satisfies IconNode;

export const pencilSparkles = [
	["path", { d: "M10 3H8" }],
	["path", { d: "m15.007 5.008 3.987 3.986" }],
	["path", { d: "M20 15v4" }],
	[
		"path",
		{
			d: "M21.174 6.813a2.82 2.82 0 0 0-3.986-3.987L3.842 16.175a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
		},
	],
	["path", { d: "M22 17h-4" }],
	["path", { d: "M4 5v4" }],
	["path", { d: "M6 7H2" }],
	["path", { d: "M9 2v2" }],
] satisfies IconNode;

export const pentagon = [
	[
		"path",
		{
			d: "M10.83 2.38a2 2 0 0 1 2.34 0l8 5.74a2 2 0 0 1 .73 2.25l-3.04 9.26a2 2 0 0 1-1.9 1.37H7.04a2 2 0 0 1-1.9-1.37L2.1 10.37a2 2 0 0 1 .73-2.25z",
		},
	],
] satisfies IconNode;

export const percent = [
	["line", { x1: "19", x2: "5", y1: "5", y2: "19" }],
	["circle", { cx: "6.5", cy: "6.5", r: "2.5" }],
	["circle", { cx: "17.5", cy: "17.5", r: "2.5" }],
] satisfies IconNode;

export const perfumeBottle = [
	["path", { d: "M 5 22 H 11.072" }],
	["path", { d: "M15 5 C 23 4 23.328 12.676 20 14.536" }],
	["path", { d: "M15.802 10.308 C 14.776 9.465 14 8.496 14 7" }],
	["path", { d: "M2 2h.01" }],
	["path", { d: "M2 7h.01" }],
	["path", { d: "M5 4.5h.01" }],
	["path", { d: "M8.127 22 A 8 8 0 0 1 4 15 3 3 0 0 1 4.879 12.879C 6.879 10.879 10 10 10 7" }],
	["circle", { cx: "18", cy: "18", r: "4" }],
	["rect", { x: "9", y: "2", width: "6", height: "5", rx: "1" }],
] satisfies IconNode;

export const personStanding = [
	["circle", { cx: "12", cy: "5", r: "1" }],
	["path", { d: "m9 20 3-6 3 6" }],
	["path", { d: "m6 8 6 2 6-2" }],
	["path", { d: "M12 10v4" }],
] satisfies IconNode;

export const phi = [
	["path", { d: "M12 2v20" }],
	["circle", { cx: "12", cy: "12", r: "7" }],
] satisfies IconNode;

export const philippinePeso = [
	["path", { d: "M20 11H4" }],
	["path", { d: "M20 7H4" }],
	["path", { d: "M7 21V4a1 1 0 0 1 1-1h4a1 1 0 0 1 0 12H7" }],
] satisfies IconNode;

export const phone = [
	[
		"path",
		{
			d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
		},
	],
] satisfies IconNode;

export const phoneCall = [
	["path", { d: "M13 2a9 9 0 0 1 9 9" }],
	["path", { d: "M13 6a5 5 0 0 1 5 5" }],
	[
		"path",
		{
			d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
		},
	],
] satisfies IconNode;

export const phoneForwarded = [
	["path", { d: "M14 6h8" }],
	["path", { d: "m18 2 4 4-4 4" }],
	[
		"path",
		{
			d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
		},
	],
] satisfies IconNode;

export const phoneIncoming = [
	["path", { d: "M16 2v6h6" }],
	["path", { d: "m22 2-6 6" }],
	[
		"path",
		{
			d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
		},
	],
] satisfies IconNode;

export const phoneLog = [
	[
		"path",
		{
			d: "M13.832 16.568a1 1 0 001.213-.303l.355-.465A2 2 0 0117 15h3a2 2 0 012 2v3a2 2 0 01-2 2A18 18 0 012 4a2 2 0 012-2h3a2 2 0 012 2v3a2 2 0 01-.8 1.6l-.468.351a1 1 0 00-.292 1.233 14 14 0 006.392 6.384",
		},
	],
	["path", { d: "M14.396 4.171h7.171" }],
	["path", { d: "M17.343 8.17h4.224" }],
] satisfies IconNode;

export const phoneMissed = [
	["path", { d: "m16 2 6 6" }],
	["path", { d: "m22 2-6 6" }],
	[
		"path",
		{
			d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
		},
	],
] satisfies IconNode;

export const phoneOff = [
	[
		"path",
		{
			d: "M10.1 13.9a14 14 0 0 0 3.732 2.668 1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2 18 18 0 0 1-12.728-5.272",
		},
	],
	["path", { d: "M22 2 2 22" }],
	[
		"path",
		{
			d: "M4.76 13.582A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 .244.473",
		},
	],
] satisfies IconNode;

export const phoneOutgoing = [
	["path", { d: "m16 8 6-6" }],
	["path", { d: "M22 8V2h-6" }],
	[
		"path",
		{
			d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
		},
	],
] satisfies IconNode;

export const pi = [
	["line", { x1: "9", x2: "9", y1: "4", y2: "20" }],
	["path", { d: "M4 7c0-1.7 1.3-3 3-3h13" }],
	["path", { d: "M18 20c-1.7 0-3-1.3-3-3V4" }],
] satisfies IconNode;

export const piano = [
	["path", { d: "M10 13v4" }],
	["path", { d: "M14 13v4" }],
	["path", { d: "M18 13v4" }],
	["path", { d: "M2 13h20" }],
	[
		"path",
		{
			d: "M22 11.5A3.5 3.5 0 0018.5 8a3.52 3.52 0 01-3.173-2A7 7 0 002 9v10a2 2 0 002 2h16a2 2 0 002-2z",
		},
	],
	["path", { d: "M6 13v4" }],
] satisfies IconNode;

export const pickaxe = [
	["path", { d: "m14 13-8.381 8.38a1 1 0 0 1-3.001-3L11 9.999" }],
	[
		"path",
		{
			d: "M15.973 4.027A13 13 0 0 0 5.902 2.373c-1.398.342-1.092 2.158.277 2.601a19.9 19.9 0 0 1 5.822 3.024",
		},
	],
	[
		"path",
		{
			d: "M16.001 11.999a19.9 19.9 0 0 1 3.024 5.824c.444 1.369 2.26 1.676 2.603.278A13 13 0 0 0 20 8.069",
		},
	],
	[
		"path",
		{
			d: "M18.352 3.352a1.205 1.205 0 0 0-1.704 0l-5.296 5.296a1.205 1.205 0 0 0 0 1.704l2.296 2.296a1.205 1.205 0 0 0 1.704 0l5.296-5.296a1.205 1.205 0 0 0 0-1.704z",
		},
	],
] satisfies IconNode;

export const pictureInPicture = [
	["path", { d: "M2 10h6V4" }],
	["path", { d: "m2 4 6 6" }],
	["path", { d: "M21 10V7a2 2 0 0 0-2-2h-7" }],
	["path", { d: "M3 14v2a2 2 0 0 0 2 2h3" }],
	["rect", { x: "12", y: "14", width: "10", height: "7", rx: "1" }],
] satisfies IconNode;

export const pictureInPicture2 = [
	["path", { d: "M21 9V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h4" }],
	["rect", { width: "10", height: "7", x: "12", y: "13", rx: "2" }],
] satisfies IconNode;

export const piggyBank = [
	[
		"path",
		{
			d: "M11 17h3v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3a3.16 3.16 0 0 0 2-2h1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-1a5 5 0 0 0-2-4V3a4 4 0 0 0-3.2 1.6l-.3.4H11a6 6 0 0 0-6 6v1a5 5 0 0 0 2 4v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1z",
		},
	],
	["path", { d: "M16 10h.01" }],
	["path", { d: "M2 8v1a2 2 0 0 0 2 2h1" }],
] satisfies IconNode;

export const pilcrow = [
	["path", { d: "M13 4v16" }],
	["path", { d: "M17 4v16" }],
	["path", { d: "M19 4H9.5a4.5 4.5 0 0 0 0 9H13" }],
] satisfies IconNode;

export const pilcrowLeft = [
	["path", { d: "M14 3v11" }],
	["path", { d: "M14 9h-3a3 3 0 0 1 0-6h9" }],
	["path", { d: "M18 3v11" }],
	["path", { d: "M22 18H2l4-4" }],
	["path", { d: "m6 22-4-4" }],
] satisfies IconNode;

export const pilcrowRight = [
	["path", { d: "M10 3v11" }],
	["path", { d: "M10 9H7a1 1 0 0 1 0-6h8" }],
	["path", { d: "M14 3v11" }],
	["path", { d: "m18 14 4 4H2" }],
	["path", { d: "m22 18-4 4" }],
] satisfies IconNode;

export const pill = [
	["path", { d: "m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z" }],
	["path", { d: "m8.5 8.5 7 7" }],
] satisfies IconNode;

export const pillBottle = [
	["path", { d: "M18 11h-4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4" }],
	["path", { d: "M6 7v13a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7" }],
	["rect", { width: "16", height: "5", x: "4", y: "2", rx: "1" }],
] satisfies IconNode;

export const pin = [
	["path", { d: "M12 17v5" }],
	[
		"path",
		{
			d: "M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z",
		},
	],
] satisfies IconNode;

export const pinOff = [
	["path", { d: "M12 17v5" }],
	["path", { d: "M15 9.34V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H7.89" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M9 9v1.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h11" }],
] satisfies IconNode;

export const pipette = [
	[
		"path",
		{
			d: "m12 9-8.414 8.414A2 2 0 0 0 3 18.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 3.828 21h1.344a2 2 0 0 0 1.414-.586L15 12",
		},
	],
	["path", { d: "m18 9 .4.4a1 1 0 1 1-3 3l-3.8-3.8a1 1 0 1 1 3-3l.4.4 3.4-3.4a1 1 0 1 1 3 3z" }],
	["path", { d: "m2 22 .414-.414" }],
] satisfies IconNode;

export const pizza = [
	["path", { d: "m12 14-1 1" }],
	["path", { d: "m13.75 18.25-1.25 1.42" }],
	["path", { d: "M17.775 5.654a15.68 15.68 0 0 0-12.121 12.12" }],
	["path", { d: "M18.8 9.3a1 1 0 0 0 2.1 7.7" }],
	[
		"path",
		{
			d: "M21.964 20.732a1 1 0 0 1-1.232 1.232l-18-5a1 1 0 0 1-.695-1.232A19.68 19.68 0 0 1 15.732 2.037a1 1 0 0 1 1.232.695z",
		},
	],
] satisfies IconNode;

export const plane = [
	[
		"path",
		{
			d: "M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z",
		},
	],
] satisfies IconNode;

export const planeLanding = [
	["path", { d: "M2 22h20" }],
	[
		"path",
		{
			d: "M3.77 10.77 2 9l2-4.5 1.1.55c.55.28.9.84.9 1.45s.35 1.17.9 1.45L8 8.5l3-6 1.05.53a2 2 0 0 1 1.09 1.52l.72 5.4a2 2 0 0 0 1.09 1.52l4.4 2.2c.42.22.78.55 1.01.96l.6 1.03c.49.88-.06 1.98-1.06 2.1l-1.18.15c-.47.06-.95-.02-1.37-.24L4.29 11.15a2 2 0 0 1-.52-.38Z",
		},
	],
] satisfies IconNode;

export const planeTakeoff = [
	["path", { d: "M2 22h20" }],
	[
		"path",
		{
			d: "M6.36 17.4 4 17l-2-4 1.1-.55a2 2 0 0 1 1.8 0l.17.1a2 2 0 0 0 1.8 0L8 12 5 6l.9-.45a2 2 0 0 1 2.09.2l4.02 3a2 2 0 0 0 2.1.2l4.19-2.06a2.41 2.41 0 0 1 1.73-.17L21 7a1.4 1.4 0 0 1 .87 1.99l-.38.76c-.23.46-.6.84-1.07 1.08L7.58 17.2a2 2 0 0 1-1.22.18Z",
		},
	],
] satisfies IconNode;

export const plantPot = [
	[
		"path",
		{
			d: "M14 8.536V6a4 4 0 014-4h1.5a.5.5 0 01.5.5V4a4 4 0 01-4 4 4 4 0 00-4 4 5 5 0 01-8-4 5 5 0 018 4c0 2 1 3 1 5",
		},
	],
	["path", { d: "m18 17-1.085 3.58A2 2 0 0115 22H9.002a2 2 0 01-1.913-1.418L6 17" }],
	["path", { d: "M5 17h14" }],
] satisfies IconNode;

export const play = [
	[
		"path",
		{ d: "M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z" },
	],
] satisfies IconNode;

export const playOff = [
	["path", { d: "m10.215 4.56 9.79 5.71a2 2 0 0 1 .003 3.458l-.393.23" }],
	["path", { d: "m16.042 16.042-8.034 4.686A2 2 0 0 1 5 19V5" }],
	["path", { d: "m2 2 20 20" }],
] satisfies IconNode;

export const playingCard = [
	[
		"path",
		{
			d: "M12.832 8.445a1 1 0 00-1.589-.098l-2.075 3.098a1 1 0 000 1.11l2 3a1 1 0 001.664 0l2-3a1 1 0 000-1.11z",
		},
	],
	["rect", { x: "5", y: "2", width: "14", height: "20", rx: "2" }],
] satisfies IconNode;

export const playingCards = [
	[
		"path",
		{
			d: "M14.832 8.445a1 1 0 00-1.589-.098l-2.075 3.098a1 1 0 000 1.11l2 3a1 1 0 001.664 0l2-3a1 1 0 000-1.11z",
		},
	],
	["path", { d: "m7.18 20.827-5-11a2 2 0 01.993-2.647L7 5.44" }],
	["rect", { x: "7", y: "2", width: "14", height: "20", rx: "2" }],
] satisfies IconNode;

export const playingCardsFan = [
	[
		"path",
		{
			d: "M12.65 7.65a2 2 0 012.629-1.046l5.51 2.374a2 2 0 011.046 2.628l-3.957 9.184a2 2 0 01-2.628 1.046l-5.51-2.374a2 2 0 01-1.046-2.628z",
		},
	],
	["path", { d: "M18 7.777V4a2 2 0 00-2-2h-6a2 2 0 00-2 2v10a2 2 0 001.137 1.805" }],
	[
		"path",
		{ d: "m8 4.389-4.364.809a2 2 0 00-1.602 2.33l1.822 9.833a2 2 0 002.331 1.602l2.542-.47" },
	],
] satisfies IconNode;

export const plug = [
	["path", { d: "M12 22v-5" }],
	["path", { d: "M15 8V2" }],
	["path", { d: "M17 8a1 1 0 0 1 1 1v4a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1z" }],
	["path", { d: "M9 8V2" }],
] satisfies IconNode;

export const plug2 = [
	["path", { d: "M9 2v6" }],
	["path", { d: "M15 2v6" }],
	["path", { d: "M12 17v5" }],
	["path", { d: "M5 8h14" }],
	["path", { d: "M6 11V8h12v3a6 6 0 1 1-12 0Z" }],
] satisfies IconNode;

export const plugZap = [
	["path", { d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z" }],
	["path", { d: "m2 22 3-3" }],
	["path", { d: "M7.5 13.5 10 11" }],
	["path", { d: "M10.5 16.5 13 14" }],
	["path", { d: "m18 3-4 4h6l-4 4" }],
] satisfies IconNode;

export const plus = [
	["path", { d: "M5 12h14" }],
	["path", { d: "M12 5v14" }],
] satisfies IconNode;

export const pocketKnife = [
	["path", { d: "M3 2v1c0 1 2 1 2 2S3 6 3 7s2 1 2 2-2 1-2 2 2 1 2 2" }],
	["path", { d: "M18 6h.01" }],
	["path", { d: "M6 18h.01" }],
	["path", { d: "M20.83 8.83a4 4 0 0 0-5.66-5.66l-12 12a4 4 0 1 0 5.66 5.66Z" }],
	["path", { d: "M18 11.66V22a4 4 0 0 0 4-4V6" }],
] satisfies IconNode;

export const podium = [
	["path", { d: "M12 6V2h-1" }],
	[
		"path",
		{
			d: "M9 15a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1",
		},
	],
	["path", { d: "M9 21V11a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v10" }],
] satisfies IconNode;

export const pointer = [
	["path", { d: "M22 14a8 8 0 0 1-8 8" }],
	["path", { d: "M18 11v-1a2 2 0 0 0-2-2a2 2 0 0 0-2 2" }],
	["path", { d: "M14 10V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1" }],
	["path", { d: "M10 9.5V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v10" }],
	[
		"path",
		{
			d: "M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
		},
	],
] satisfies IconNode;

export const pointerOff = [
	["path", { d: "M10 4.5V4a2 2 0 0 0-2.41-1.957" }],
	["path", { d: "M13.9 8.4a2 2 0 0 0-1.26-1.295" }],
	["path", { d: "M21.7 16.2A8 8 0 0 0 22 14v-3a2 2 0 1 0-4 0v-1a2 2 0 0 0-3.63-1.158" }],
	[
		"path",
		{ d: "m7 15-1.8-1.8a2 2 0 0 0-2.79 2.86L6 19.7a7.74 7.74 0 0 0 6 2.3h2a8 8 0 0 0 5.657-2.343" },
	],
	["path", { d: "M6 6v8" }],
	["path", { d: "m2 2 20 20" }],
] satisfies IconNode;

export const popcorn = [
	["path", { d: "M18 8a2 2 0 0 0 0-4 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0 0 4" }],
	["path", { d: "M10 22 9 8" }],
	["path", { d: "m14 22 1-14" }],
	[
		"path",
		{
			d: "M20 8c.5 0 .9.4.8 1l-2.6 12c-.1.5-.7 1-1.2 1H7c-.6 0-1.1-.4-1.2-1L3.2 9c-.1-.6.3-1 .8-1Z",
		},
	],
] satisfies IconNode;

export const popsicle = [
	[
		"path",
		{ d: "M18.6 14.4c.8-.8.8-2 0-2.8l-8.1-8.1a4.95 4.95 0 1 0-7.1 7.1l8.1 8.1c.9.7 2.1.7 2.9-.1Z" },
	],
	["path", { d: "m22 22-5.5-5.5" }],
] satisfies IconNode;

export const poundSterling = [
	["path", { d: "M18 7c0-5.333-8-5.333-8 0" }],
	["path", { d: "M10 7v14" }],
	["path", { d: "M6 21h12" }],
	["path", { d: "M6 13h10" }],
] satisfies IconNode;

export const power = [
	["path", { d: "M12 2v10" }],
	["path", { d: "M18.4 6.6a9 9 0 1 1-12.77.04" }],
] satisfies IconNode;

export const powerOff = [
	["path", { d: "M18.36 6.64A9 9 0 0 1 20.77 15" }],
	["path", { d: "M6.16 6.16a9 9 0 1 0 12.68 12.68" }],
	["path", { d: "M12 2v4" }],
	["path", { d: "m2 2 20 20" }],
] satisfies IconNode;

export const presentation = [
	["path", { d: "M2 3h20" }],
	["path", { d: "M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3" }],
	["path", { d: "m7 21 5-5 5 5" }],
] satisfies IconNode;

export const printer = [
	["path", { d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" }],
	["path", { d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6" }],
	["rect", { x: "6", y: "14", width: "12", height: "8", rx: "1" }],
] satisfies IconNode;

export const printer3d = [
	["path", { d: "M10 11v1" }],
	["path", { d: "M12 8h8" }],
	["path", { d: "M15 20v-3a1 1 0 00-1-1H9a1 1 0 00-1 1v3" }],
	["path", { d: "M4 20h16" }],
	["path", { d: "M4 22V4a2 2 0 012-2h12a2 2 0 012 2v18" }],
	["path", { d: "M4 8h4" }],
	[
		"path",
		{
			d: "M8.635 10.093A2 2 0 018 8.631V7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-.293.707l-1 1a1 1 0 01-1.414 0z",
		},
	],
] satisfies IconNode;

export const printerCheck = [
	["path", { d: "M13.5 22H7a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v.5" }],
	["path", { d: "m16 19 2 2 4-4" }],
	["path", { d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2" }],
	["path", { d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6" }],
] satisfies IconNode;

export const printerX = [
	["path", { d: "M12.531 22H7a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h6.377" }],
	["path", { d: "m16.5 16.5 5 5" }],
	["path", { d: "m16.5 21.5 5-5" }],
	["path", { d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1.5" }],
	["path", { d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6" }],
] satisfies IconNode;

export const projector = [
	["path", { d: "M5 7 3 5" }],
	["path", { d: "M9 6V3" }],
	["path", { d: "m13 7 2-2" }],
	["circle", { cx: "9", cy: "13", r: "3" }],
	[
		"path",
		{ d: "M11.83 12H20a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h2.17" },
	],
	["path", { d: "M16 16h2" }],
] satisfies IconNode;

export const proportions = [
	["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2" }],
	["path", { d: "M12 9v11" }],
	["path", { d: "M2 9h13a2 2 0 0 1 2 2v9" }],
] satisfies IconNode;

export const puzzle = [
	[
		"path",
		{
			d: "M15.39 4.39a1 1 0 0 0 1.68-.474 2.5 2.5 0 1 1 3.014 3.015 1 1 0 0 0-.474 1.68l1.683 1.682a2.414 2.414 0 0 1 0 3.414L19.61 15.39a1 1 0 0 1-1.68-.474 2.5 2.5 0 1 0-3.014 3.015 1 1 0 0 1 .474 1.68l-1.683 1.682a2.414 2.414 0 0 1-3.414 0L8.61 19.61a1 1 0 0 0-1.68.474 2.5 2.5 0 1 1-3.014-3.015 1 1 0 0 0 .474-1.68l-1.683-1.682a2.414 2.414 0 0 1 0-3.414L4.39 8.61a1 1 0 0 1 1.68.474 2.5 2.5 0 1 0 3.014-3.015 1 1 0 0 1-.474-1.68l1.683-1.682a2.414 2.414 0 0 1 3.414 0z",
		},
	],
] satisfies IconNode;

export const pyramid = [
	[
		"path",
		{
			d: "M2.5 16.88a1 1 0 0 1-.32-1.43l9-13.02a1 1 0 0 1 1.64 0l9 13.01a1 1 0 0 1-.32 1.44l-8.51 4.86a2 2 0 0 1-1.98 0Z",
		},
	],
	["path", { d: "M12 2v20" }],
] satisfies IconNode;

export const qrCode = [
	["rect", { width: "5", height: "5", x: "3", y: "3", rx: "1" }],
	["rect", { width: "5", height: "5", x: "16", y: "3", rx: "1" }],
	["rect", { width: "5", height: "5", x: "3", y: "16", rx: "1" }],
	["path", { d: "M21 16h-3a2 2 0 0 0-2 2v3" }],
	["path", { d: "M21 21v.01" }],
	["path", { d: "M12 7v3a2 2 0 0 1-2 2H7" }],
	["path", { d: "M3 12h.01" }],
	["path", { d: "M12 3h.01" }],
	["path", { d: "M12 16v.01" }],
	["path", { d: "M16 12h1" }],
	["path", { d: "M21 12v.01" }],
	["path", { d: "M12 21v-1" }],
] satisfies IconNode;

export const quote = [
	[
		"path",
		{
			d: "M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z",
		},
	],
	[
		"path",
		{
			d: "M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z",
		},
	],
] satisfies IconNode;

export const rabbit = [
	["path", { d: "M13 16a3 3 0 0 1 2.24 5" }],
	["path", { d: "M18 12h.01" }],
	[
		"path",
		{
			d: "M18 21h-8a4 4 0 0 1-4-4 7 7 0 0 1 7-7h.2L9.6 6.4a1 1 0 1 1 2.8-2.8L15.8 7h.2c3.3 0 6 2.7 6 6v1a2 2 0 0 1-2 2h-1a3 3 0 0 0-3 3",
		},
	],
	["path", { d: "M20 8.54V4a2 2 0 1 0-4 0v3" }],
	["path", { d: "M7.612 12.524a3 3 0 1 0-1.6 4.3" }],
] satisfies IconNode;

export const radar = [
	["path", { d: "M19.07 4.93A10 10 0 0 0 6.99 3.34" }],
	["path", { d: "M4 6h.01" }],
	["path", { d: "M2.29 9.62A10 10 0 1 0 21.31 8.35" }],
	["path", { d: "M16.24 7.76A6 6 0 1 0 8.23 16.67" }],
	["path", { d: "M12 18h.01" }],
	["path", { d: "M17.99 11.66A6 6 0 0 1 15.77 16.67" }],
	["circle", { cx: "12", cy: "12", r: "2" }],
	["path", { d: "m13.41 10.59 5.66-5.66" }],
] satisfies IconNode;

export const radiation = [
	["path", { d: "M12 12h.01" }],
	[
		"path",
		{
			d: "M14 15.4641a4 4 0 0 1-4 0L7.52786 19.74597 A 1 1 0 0 0 7.99303 21.16211 10 10 0 0 0 16.00697 21.16211 1 1 0 0 0 16.47214 19.74597z",
		},
	],
	[
		"path",
		{
			d: "M16 12a4 4 0 0 0-2-3.464l2.472-4.282a1 1 0 0 1 1.46-.305 10 10 0 0 1 4.006 6.94A1 1 0 0 1 21 12z",
		},
	],
	[
		"path",
		{
			d: "M8 12a4 4 0 0 1 2-3.464L7.528 4.254a1 1 0 0 0-1.46-.305 10 10 0 0 0-4.006 6.94A1 1 0 0 0 3 12z",
		},
	],
] satisfies IconNode;

export const radical = [
	[
		"path",
		{
			d: "M3 12h3.28a1 1 0 0 1 .948.684l2.298 7.934a.5.5 0 0 0 .96-.044L13.82 4.771A1 1 0 0 1 14.792 4H21",
		},
	],
] satisfies IconNode;

export const radio = [
	["path", { d: "M16.247 7.761a6 6 0 0 1 0 8.478" }],
	["path", { d: "M19.075 4.933a10 10 0 0 1 0 14.134" }],
	["path", { d: "M4.925 19.067a10 10 0 0 1 0-14.134" }],
	["path", { d: "M7.753 16.239a6 6 0 0 1 0-8.478" }],
	["circle", { cx: "12", cy: "12", r: "2" }],
] satisfies IconNode;

export const radioOff = [
	["path", { d: "M13.414 13.414a2 2 0 1 1-2.828-2.828" }],
	["path", { d: "M16.247 7.761a6 6 0 0 1 1.744 4.572" }],
	["path", { d: "M19.075 4.933a10 10 0 0 1 2.234 10.72" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M4.925 19.067a10 10 0 0 1 0-14.134" }],
	["path", { d: "M7.753 16.239a6 6 0 0 1 0-8.478" }],
] satisfies IconNode;

export const radioReceiver = [
	["path", { d: "M5 16v2" }],
	["path", { d: "M19 16v2" }],
	["rect", { width: "20", height: "8", x: "2", y: "8", rx: "2" }],
	["path", { d: "M18 12h.01" }],
] satisfies IconNode;

export const radioTower = [
	["path", { d: "M4.9 16.1C1 12.2 1 5.8 4.9 1.9" }],
	["path", { d: "M7.8 4.7a6.14 6.14 0 0 0-.8 7.5" }],
	["circle", { cx: "12", cy: "9", r: "2" }],
	["path", { d: "M16.2 4.8c2 2 2.26 5.11.8 7.47" }],
	["path", { d: "M19.1 1.9a9.96 9.96 0 0 1 0 14.1" }],
	["path", { d: "M9.5 18h5" }],
	["path", { d: "m8 22 4-11 4 11" }],
] satisfies IconNode;

export const radius = [
	["path", { d: "M20.34 17.52a10 10 0 1 0-2.82 2.82" }],
	["circle", { cx: "19", cy: "19", r: "2" }],
	["path", { d: "m13.41 13.41 4.18 4.18" }],
	["circle", { cx: "12", cy: "12", r: "2" }],
] satisfies IconNode;

export const rainbow = [
	["path", { d: "M22 17a10 10 0 0 0-20 0" }],
	["path", { d: "M6 17a6 6 0 0 1 12 0" }],
	["path", { d: "M10 17a2 2 0 0 1 4 0" }],
] satisfies IconNode;

export const rat = [
	["path", { d: "M13 22H4a2 2 0 0 1 0-4h12" }],
	["path", { d: "M13.236 18a3 3 0 0 0-2.2-5" }],
	["path", { d: "M16 9h.01" }],
	[
		"path",
		{
			d: "M16.82 3.94a3 3 0 1 1 3.237 4.868l1.815 2.587a1.5 1.5 0 0 1-1.5 2.1l-2.872-.453a3 3 0 0 0-3.5 3",
		},
	],
	["path", { d: "M17 4.988a3 3 0 1 0-5.2 2.052A7 7 0 0 0 4 14.015 4 4 0 0 0 8 18" }],
] satisfies IconNode;

export const ratio = [
	["rect", { width: "12", height: "20", x: "6", y: "2", rx: "2" }],
	["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2" }],
] satisfies IconNode;

export const receipt = [
	["path", { d: "M12 17V7" }],
	["path", { d: "M16 8h-6a2 2 0 0 0 0 4h4a2 2 0 0 1 0 4H8" }],
	[
		"path",
		{
			d: "M4 3a1 1 0 0 1 1-1 1.3 1.3 0 0 1 .7.2l.933.6a1.3 1.3 0 0 0 1.4 0l.934-.6a1.3 1.3 0 0 1 1.4 0l.933.6a1.3 1.3 0 0 0 1.4 0l.933-.6a1.3 1.3 0 0 1 1.4 0l.934.6a1.3 1.3 0 0 0 1.4 0l.933-.6A1.3 1.3 0 0 1 19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1 1.3 1.3 0 0 1-.7-.2l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.934.6a1.3 1.3 0 0 1-1.4 0l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-1.4 0l-.934-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-.7.2 1 1 0 0 1-1-1z",
		},
	],
] satisfies IconNode;

export const receiptCent = [
	["path", { d: "M12 7v10" }],
	["path", { d: "M14.828 14.829a4 4 0 0 1-5.656 0 4 4 0 0 1 0-5.657 4 4 0 0 1 5.656 0" }],
	[
		"path",
		{
			d: "M4 3a1 1 0 0 1 1-1 1.3 1.3 0 0 1 .7.2l.933.6a1.3 1.3 0 0 0 1.4 0l.934-.6a1.3 1.3 0 0 1 1.4 0l.933.6a1.3 1.3 0 0 0 1.4 0l.933-.6a1.3 1.3 0 0 1 1.4 0l.934.6a1.3 1.3 0 0 0 1.4 0l.933-.6A1.3 1.3 0 0 1 19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1 1.3 1.3 0 0 1-.7-.2l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.934.6a1.3 1.3 0 0 1-1.4 0l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-1.4 0l-.934-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-.7.2 1 1 0 0 1-1-1z",
		},
	],
] satisfies IconNode;

export const receiptEuro = [
	["path", { d: "M15.828 14.829a4 4 0 0 1-5.656 0 4 4 0 0 1 0-5.657 4 4 0 0 1 5.656 0" }],
	[
		"path",
		{
			d: "M4 3a1 1 0 0 1 1-1 1.3 1.3 0 0 1 .7.2l.933.6a1.3 1.3 0 0 0 1.4 0l.934-.6a1.3 1.3 0 0 1 1.4 0l.933.6a1.3 1.3 0 0 0 1.4 0l.933-.6a1.3 1.3 0 0 1 1.4 0l.934.6a1.3 1.3 0 0 0 1.4 0l.933-.6A1.3 1.3 0 0 1 19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1 1.3 1.3 0 0 1-.7-.2l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.934.6a1.3 1.3 0 0 1-1.4 0l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-1.4 0l-.934-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-.7.2 1 1 0 0 1-1-1z",
		},
	],
	["path", { d: "M8 12h5" }],
] satisfies IconNode;

export const receiptIndianRupee = [
	[
		"path",
		{
			d: "M4 3a1 1 0 0 1 1-1 1.3 1.3 0 0 1 .7.2l.933.6a1.3 1.3 0 0 0 1.4 0l.934-.6a1.3 1.3 0 0 1 1.4 0l.933.6a1.3 1.3 0 0 0 1.4 0l.933-.6a1.3 1.3 0 0 1 1.4 0l.934.6a1.3 1.3 0 0 0 1.4 0l.933-.6A1.3 1.3 0 0 1 19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1 1.3 1.3 0 0 1-.7-.2l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.934.6a1.3 1.3 0 0 1-1.4 0l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-1.4 0l-.934-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-.7.2 1 1 0 0 1-1-1z",
		},
	],
	["path", { d: "M8 11h8" }],
	["path", { d: "M8 7h8" }],
	["path", { d: "M9 7a4 4 0 0 1 0 8H8l3 2" }],
] satisfies IconNode;

export const receiptJapaneseYen = [
	["path", { d: "m12 10 3-3" }],
	[
		"path",
		{
			d: "M4 3a1 1 0 0 1 1-1 1.3 1.3 0 0 1 .7.2l.933.6a1.3 1.3 0 0 0 1.4 0l.934-.6a1.3 1.3 0 0 1 1.4 0l.933.6a1.3 1.3 0 0 0 1.4 0l.933-.6a1.3 1.3 0 0 1 1.4 0l.934.6a1.3 1.3 0 0 0 1.4 0l.933-.6A1.3 1.3 0 0 1 19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1 1.3 1.3 0 0 1-.7-.2l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.934.6a1.3 1.3 0 0 1-1.4 0l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-1.4 0l-.934-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-.7.2 1 1 0 0 1-1-1z",
		},
	],
	["path", { d: "M9 11h6" }],
	["path", { d: "M9 15h6" }],
	["path", { d: "m9 7 3 3v7" }],
] satisfies IconNode;

export const receiptPoundSterling = [
	["path", { d: "M10 17V9.5a1 1 0 0 1 5 0" }],
	[
		"path",
		{
			d: "M4 3a1 1 0 0 1 1-1 1.3 1.3 0 0 1 .7.2l.933.6a1.3 1.3 0 0 0 1.4 0l.934-.6a1.3 1.3 0 0 1 1.4 0l.933.6a1.3 1.3 0 0 0 1.4 0l.933-.6a1.3 1.3 0 0 1 1.4 0l.934.6a1.3 1.3 0 0 0 1.4 0l.933-.6A1.3 1.3 0 0 1 19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1 1.3 1.3 0 0 1-.7-.2l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.934.6a1.3 1.3 0 0 1-1.4 0l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-1.4 0l-.934-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-.7.2 1 1 0 0 1-1-1z",
		},
	],
	["path", { d: "M8 13h5" }],
	["path", { d: "M8 17h7" }],
] satisfies IconNode;

export const receiptRussianRuble = [
	[
		"path",
		{
			d: "M4 3a1 1 0 0 1 1-1 1.3 1.3 0 0 1 .7.2l.933.6a1.3 1.3 0 0 0 1.4 0l.934-.6a1.3 1.3 0 0 1 1.4 0l.933.6a1.3 1.3 0 0 0 1.4 0l.933-.6a1.3 1.3 0 0 1 1.4 0l.934.6a1.3 1.3 0 0 0 1.4 0l.933-.6A1.3 1.3 0 0 1 19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1 1.3 1.3 0 0 1-.7-.2l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.934.6a1.3 1.3 0 0 1-1.4 0l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-1.4 0l-.934-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-.7.2 1 1 0 0 1-1-1z",
		},
	],
	["path", { d: "M8 11h5a2 2 0 0 0 0-4h-3v10" }],
	["path", { d: "M8 15h5" }],
] satisfies IconNode;

export const receiptSwissFranc = [
	["path", { d: "M10 11h4" }],
	["path", { d: "M10 17V7h5" }],
	[
		"path",
		{
			d: "M4 3a1 1 0 0 1 1-1 1.3 1.3 0 0 1 .7.2l.933.6a1.3 1.3 0 0 0 1.4 0l.934-.6a1.3 1.3 0 0 1 1.4 0l.933.6a1.3 1.3 0 0 0 1.4 0l.933-.6a1.3 1.3 0 0 1 1.4 0l.934.6a1.3 1.3 0 0 0 1.4 0l.933-.6A1.3 1.3 0 0 1 19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1 1.3 1.3 0 0 1-.7-.2l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.934.6a1.3 1.3 0 0 1-1.4 0l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-1.4 0l-.934-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-.7.2 1 1 0 0 1-1-1z",
		},
	],
	["path", { d: "M8 15h5" }],
] satisfies IconNode;

export const receiptText = [
	["path", { d: "M13 16H8" }],
	["path", { d: "M14 8H8" }],
	["path", { d: "M16 12H8" }],
	[
		"path",
		{
			d: "M4 3a1 1 0 0 1 1-1 1.3 1.3 0 0 1 .7.2l.933.6a1.3 1.3 0 0 0 1.4 0l.934-.6a1.3 1.3 0 0 1 1.4 0l.933.6a1.3 1.3 0 0 0 1.4 0l.933-.6a1.3 1.3 0 0 1 1.4 0l.934.6a1.3 1.3 0 0 0 1.4 0l.933-.6A1.3 1.3 0 0 1 19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1 1.3 1.3 0 0 1-.7-.2l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.934.6a1.3 1.3 0 0 1-1.4 0l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-1.4 0l-.934-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-.7.2 1 1 0 0 1-1-1z",
		},
	],
] satisfies IconNode;

export const receiptTurkishLira = [
	["path", { d: "M10 7v10a5 5 0 0 0 5-5" }],
	["path", { d: "m14 8-6 3" }],
	[
		"path",
		{
			d: "M4 3a1 1 0 0 1 1-1 1.3 1.3 0 0 1 .7.2l.933.6a1.3 1.3 0 0 0 1.4 0l.934-.6a1.3 1.3 0 0 1 1.4 0l.933.6a1.3 1.3 0 0 0 1.4 0l.933-.6a1.3 1.3 0 0 1 1.4 0l.934.6a1.3 1.3 0 0 0 1.4 0l.933-.6A1.3 1.3 0 0 1 19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1 1.3 1.3 0 0 1-.7-.2l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.934.6a1.3 1.3 0 0 1-1.4 0l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-1.4 0l-.934-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-.7.2 1 1 0 0 1-1-1z",
		},
	],
] satisfies IconNode;

export const rectangleCircle = [
	["path", { d: "M14 4v16H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z" }],
	["circle", { cx: "14", cy: "12", r: "8" }],
] satisfies IconNode;

export const rectangleEllipsis = [
	["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2" }],
	["path", { d: "M12 12h.01" }],
	["path", { d: "M17 12h.01" }],
	["path", { d: "M7 12h.01" }],
] satisfies IconNode;

export const rectangleGoggles = [
	[
		"path",
		{
			d: "M20 6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-4a2 2 0 0 1-1.6-.8l-1.6-2.13a1 1 0 0 0-1.6 0L9.6 17.2A2 2 0 0 1 8 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z",
		},
	],
] satisfies IconNode;

export const rectangleHorizontal = [
	["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2" }],
] satisfies IconNode;

export const rectangleVertical = [
	["rect", { width: "12", height: "20", x: "6", y: "2", rx: "2" }],
] satisfies IconNode;

export const recycle = [
	["path", { d: "M7 19H4.815a1.83 1.83 0 0 1-1.57-.881 1.785 1.785 0 0 1-.004-1.784L7.196 9.5" }],
	["path", { d: "M11 19h8.203a1.83 1.83 0 0 0 1.556-.89 1.784 1.784 0 0 0 0-1.775l-1.226-2.12" }],
	["path", { d: "m14 16-3 3 3 3" }],
	["path", { d: "M8.293 13.596 7.196 9.5 3.1 10.598" }],
	[
		"path",
		{
			d: "m9.344 5.811 1.093-1.892A1.83 1.83 0 0 1 11.985 3a1.784 1.784 0 0 1 1.546.888l3.943 6.843",
		},
	],
	["path", { d: "m13.378 9.633 4.096 1.098 1.097-4.096" }],
] satisfies IconNode;

export const redo = [
	["path", { d: "M21 7v6h-6" }],
	["path", { d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7" }],
] satisfies IconNode;

export const redo2 = [
	["path", { d: "m15 14 5-5-5-5" }],
	["path", { d: "M20 9H9.5A5.5 5.5 0 0 0 4 14.5A5.5 5.5 0 0 0 9.5 20H13" }],
] satisfies IconNode;

export const redoDot = [
	["circle", { cx: "12", cy: "17", r: "1" }],
	["path", { d: "M21 7v6h-6" }],
	["path", { d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7" }],
] satisfies IconNode;

export const refreshCcw = [
	["path", { d: "M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" }],
	["path", { d: "M3 3v5h5" }],
	["path", { d: "M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" }],
	["path", { d: "M16 16h5v5" }],
] satisfies IconNode;

export const refreshCcwDot = [
	["path", { d: "M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" }],
	["path", { d: "M3 3v5h5" }],
	["path", { d: "M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" }],
	["path", { d: "M16 16h5v5" }],
	["circle", { cx: "12", cy: "12", r: "1" }],
] satisfies IconNode;

export const refreshCw = [
	["path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" }],
	["path", { d: "M21 3v5h-5" }],
	["path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" }],
	["path", { d: "M8 16H3v5" }],
] satisfies IconNode;

export const refreshCwOff = [
	["path", { d: "M21 8L18.74 5.74A9.75 9.75 0 0 0 12 3C11 3 10.03 3.16 9.13 3.47" }],
	["path", { d: "M8 16H3v5" }],
	["path", { d: "M3 12C3 9.51 4 7.26 5.64 5.64" }],
	["path", { d: "m3 16 2.26 2.26A9.75 9.75 0 0 0 12 21c2.49 0 4.74-1 6.36-2.64" }],
	["path", { d: "M21 12c0 1-.16 1.97-.47 2.87" }],
	["path", { d: "M21 3v5h-5" }],
	["path", { d: "M22 22 2 2" }],
] satisfies IconNode;

export const refrigerator = [
	["path", { d: "M5 6a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6Z" }],
	["path", { d: "M5 10h14" }],
	["path", { d: "M15 7v6" }],
] satisfies IconNode;

export const regex = [
	["path", { d: "M17 3v10" }],
	["path", { d: "m12.67 5.5 8.66 5" }],
	["path", { d: "m12.67 10.5 8.66-5" }],
	["path", { d: "M9 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2z" }],
] satisfies IconNode;

export const removeFormatting = [
	["path", { d: "M4 7V4h16v3" }],
	["path", { d: "M5 20h6" }],
	["path", { d: "M13 4 8 20" }],
	["path", { d: "m15 15 5 5" }],
	["path", { d: "m20 15-5 5" }],
] satisfies IconNode;

export const repeat = [
	["path", { d: "m17 2 4 4-4 4" }],
	["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14" }],
	["path", { d: "m7 22-4-4 4-4" }],
	["path", { d: "M21 13v1a4 4 0 0 1-4 4H3" }],
] satisfies IconNode;

export const repeat1 = [
	["path", { d: "m17 2 4 4-4 4" }],
	["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14" }],
	["path", { d: "m7 22-4-4 4-4" }],
	["path", { d: "M21 13v1a4 4 0 0 1-4 4H3" }],
	["path", { d: "M11 10h1v4" }],
] satisfies IconNode;

export const repeat2 = [
	["path", { d: "m2 9 3-3 3 3" }],
	["path", { d: "M13 18H7a2 2 0 0 1-2-2V6" }],
	["path", { d: "m22 15-3 3-3-3" }],
	["path", { d: "M11 6h6a2 2 0 0 1 2 2v10" }],
] satisfies IconNode;

export const repeatOff = [
	["path", { d: "M11.656 6H21l-4-4" }],
	["path", { d: "M17.898 17.898A4 4 0 0 1 17 18H3l4-4" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M21 13v1a4 4 0 0 1-.171 1.159" }],
	["path", { d: "m21 6-4 4" }],
	["path", { d: "M3 11v-1a4 4 0 0 1 3.102-3.898" }],
	["path", { d: "m7 22-4-4" }],
] satisfies IconNode;

export const replace = [
	["path", { d: "M14 4a1 1 0 0 1 1-1" }],
	["path", { d: "M15 10a1 1 0 0 1-1-1" }],
	["path", { d: "M21 4a1 1 0 0 0-1-1" }],
	["path", { d: "M21 9a1 1 0 0 1-1 1" }],
	["path", { d: "m3 7 3 3 3-3" }],
	["path", { d: "M6 10V5a2 2 0 0 1 2-2h2" }],
	["rect", { x: "3", y: "14", width: "7", height: "7", rx: "1" }],
] satisfies IconNode;

export const replaceAll = [
	["path", { d: "M14 14a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1" }],
	["path", { d: "M14 4a1 1 0 0 1 1-1" }],
	["path", { d: "M15 10a1 1 0 0 1-1-1" }],
	["path", { d: "M19 14a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1" }],
	["path", { d: "M21 4a1 1 0 0 0-1-1" }],
	["path", { d: "M21 9a1 1 0 0 1-1 1" }],
	["path", { d: "m3 7 3 3 3-3" }],
	["path", { d: "M6 10V5a2 2 0 0 1 2-2h2" }],
	["rect", { x: "3", y: "14", width: "7", height: "7", rx: "1" }],
] satisfies IconNode;

export const reply = [
	["path", { d: "M20 18v-2a4 4 0 0 0-4-4H4" }],
	["path", { d: "m9 17-5-5 5-5" }],
] satisfies IconNode;

export const replyAll = [
	["path", { d: "m12 17-5-5 5-5" }],
	["path", { d: "M22 18v-2a4 4 0 0 0-4-4H7" }],
	["path", { d: "m7 17-5-5 5-5" }],
] satisfies IconNode;

export const rewind = [
	["path", { d: "M12 6a2 2 0 0 0-3.414-1.414l-6 6a2 2 0 0 0 0 2.828l6 6A2 2 0 0 0 12 18z" }],
	["path", { d: "M22 6a2 2 0 0 0-3.414-1.414l-6 6a2 2 0 0 0 0 2.828l6 6A2 2 0 0 0 22 18z" }],
] satisfies IconNode;

export const ribbon = [
	["path", { d: "M12 11.22C11 9.997 10 9 10 8a2 2 0 0 1 4 0c0 1-.998 2.002-2.01 3.22" }],
	["path", { d: "m12 18 2.57-3.5" }],
	["path", { d: "M6.243 9.016a7 7 0 0 1 11.507-.009" }],
	["path", { d: "M9.35 14.53 12 11.22" }],
	[
		"path",
		{
			d: "M9.35 14.53C7.728 12.246 6 10.221 6 7a6 5 0 0 1 12 0c-.005 3.22-1.778 5.235-3.43 7.5l3.557 4.527a1 1 0 0 1-.203 1.43l-1.894 1.36a1 1 0 0 1-1.384-.215L12 18l-2.679 3.593a1 1 0 0 1-1.39.213l-1.865-1.353a1 1 0 0 1-.203-1.422z",
		},
	],
] satisfies IconNode;

export const road = [
	["path", { d: "M12 17v4" }],
	["path", { d: "M12 5V3" }],
	["path", { d: "M12 9v3" }],
	[
		"path",
		{
			d: "M2.077 18.449A2 2 0 0 0 4 21h16a2 2 0 0 0 1.924-2.55l-4-14A2 2 0 0 0 16 3H8a2 2 0 0 0-1.924 1.45z",
		},
	],
] satisfies IconNode;

export const robotArm = [
	["path", { d: "M12 21 7.5 8.322" }],
	["path", { d: "m14 7 1.75-3.767a.5.5 0 0 1 .662-.172L20 5.005" }],
	["path", { d: "m20 8.998-3.588 1.944a.5.5 0 0 1-.662-.172L14 7H8" }],
	["path", { d: "M3.486 21h10" }],
	["path", { d: "M5 21V8.732" }],
	["circle", { cx: "6", cy: "7", r: "2" }],
] satisfies IconNode;

export const robotVacuum = [
	["path", { d: "M11 17h2" }],
	["path", { d: "M12 12h.01" }],
	["path", { d: "M17 12a5 5 0 00-10 0" }],
	["path", { d: "M19 2v2.8" }],
	["path", { d: "M2 5h2.8" }],
	["path", { d: "M22 5h-2.8" }],
	["path", { d: "M5 2v2.8" }],
	["circle", { cx: "12", cy: "12", r: "10" }],
] satisfies IconNode;

export const rocket = [
	["path", { d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" }],
	[
		"path",
		{
			d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09",
		},
	],
	[
		"path",
		{
			d: "M9 12a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.4 22.4 0 0 1-4 2z",
		},
	],
	["path", { d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 .05 5 .05" }],
] satisfies IconNode;

export const rockingChair = [
	["path", { d: "m15 13 3.708 7.416" }],
	["path", { d: "M3 19a15 15 0 0 0 18 0" }],
	["path", { d: "m3 2 3.21 9.633A2 2 0 0 0 8.109 13H18" }],
	["path", { d: "m9 13-3.708 7.416" }],
] satisfies IconNode;

export const rollerCoaster = [
	["path", { d: "M6 19V5" }],
	["path", { d: "M10 19V6.8" }],
	["path", { d: "M14 19v-7.8" }],
	["path", { d: "M18 5v4" }],
	["path", { d: "M18 19v-6" }],
	["path", { d: "M22 19V9" }],
	["path", { d: "M2 19V9a4 4 0 0 1 4-4c2 0 4 1.33 6 4s4 4 6 4a4 4 0 1 0-3-6.65" }],
] satisfies IconNode;

export const rose = [
	["path", { d: "M17 10h-1a4 4 0 1 1 4-4v.534" }],
	["path", { d: "M17 6h1a4 4 0 0 1 1.42 7.74l-2.29.87a6 6 0 0 1-5.339-10.68l2.069-1.31" }],
	[
		"path",
		{ d: "M4.5 17c2.8-.5 4.4 0 5.5.8s1.8 2.2 2.3 3.7c-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2" },
	],
	["path", { d: "M9.77 12C4 15 2 22 2 22" }],
	["circle", { cx: "17", cy: "8", r: "2" }],
] satisfies IconNode;

export const rotate3d = [
	["path", { d: "m15.194 13.707 3.814 1.86-1.86 3.814" }],
	["path", { d: "M16.47214 7.52786 A 5 10 0 1 0 13 21.79796" }],
	["path", { d: "M21.79796 11 A 10 5 0 1 0 19 15.57071" }],
] satisfies IconNode;

export const rotateCcw = [
	["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" }],
	["path", { d: "M3 3v5h5" }],
] satisfies IconNode;

export const rotateCcwClock = [
	["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" }],
	["path", { d: "M3 3v5h5" }],
	["path", { d: "M12 7v5l4 2" }],
] satisfies IconNode;

export const rotateCcwKey = [
	["path", { d: "M12 7v6" }],
	["path", { d: "M12 9h2" }],
	["path", { d: "M3 12a9 9 0 1 0 9-9 9.74 9.74 0 0 0-6.74 2.74L3 8" }],
	["path", { d: "M3 3v5h5" }],
	["circle", { cx: "12", cy: "15", r: "2" }],
] satisfies IconNode;

export const rotateCcwSquare = [
	["path", { d: "M20 9V7a2 2 0 0 0-2-2h-6" }],
	["path", { d: "m15 2-3 3 3 3" }],
	["path", { d: "M20 13v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2" }],
] satisfies IconNode;

export const rotateCw = [
	["path", { d: "M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8" }],
	["path", { d: "M21 3v5h-5" }],
] satisfies IconNode;

export const rotateCwClock = [
	["path", { d: "M12 7v5l4 2" }],
	["path", { d: "M16 8h5V3" }],
	["path", { d: "m21 8-2.3-2.3A9.7 9.7 0 0012 3a9 9 0 109 9" }],
] satisfies IconNode;

export const rotateCwFadingClock = [
	["path", { d: "M12 3a9.75 9.75 0 0 1 6.74 2.74" }],
	["path", { d: "M18.74 5.74 21 8" }],
	["path", { d: "M21 8V3" }],
	["path", { d: "M7.5 19.794c-6-3.464-6-12.124 0-15.588" }],
	["path", { d: "M7.5 4.206A9 9 0 0 1 12 3" }],
	["path", { d: "M12 7v5l4 2" }],
	["path", { d: "M14 20.775A9 9 0 0 1 12 21" }],
	["path", { d: "M19 17.656a9 9 0 0 1-1.5 1.456" }],
	["path", { d: "M21 12a9 9 0 0 1-.228 2" }],
	["path", { d: "M21 8h-5" }],
] satisfies IconNode;

export const rotateCwSquare = [
	["path", { d: "M12 5H6a2 2 0 0 0-2 2v3" }],
	["path", { d: "m9 8 3-3-3-3" }],
	["path", { d: "M4 14v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" }],
] satisfies IconNode;

export const route = [
	["circle", { cx: "6", cy: "19", r: "3" }],
	["path", { d: "M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15" }],
	["circle", { cx: "18", cy: "5", r: "3" }],
] satisfies IconNode;

export const routeOff = [
	["circle", { cx: "6", cy: "19", r: "3" }],
	["path", { d: "M9 19h8.5c.4 0 .9-.1 1.3-.2" }],
	["path", { d: "M5.2 5.2A3.5 3.53 0 0 0 6.5 12H12" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M21 15.3a3.5 3.5 0 0 0-3.3-3.3" }],
	["path", { d: "M15 5h-4.3" }],
	["circle", { cx: "18", cy: "5", r: "3" }],
] satisfies IconNode;

export const router = [
	["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2" }],
	["path", { d: "M6.01 18H6" }],
	["path", { d: "M10.01 18H10" }],
	["path", { d: "M15 10v4" }],
	["path", { d: "M17.84 7.17a4 4 0 0 0-5.66 0" }],
	["path", { d: "M20.66 4.34a8 8 0 0 0-11.31 0" }],
] satisfies IconNode;

export const rows2 = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M3 12h18" }],
] satisfies IconNode;

export const rows3 = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M21 9H3" }],
	["path", { d: "M21 15H3" }],
] satisfies IconNode;

export const rows4 = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M21 7.5H3" }],
	["path", { d: "M21 12H3" }],
	["path", { d: "M21 16.5H3" }],
] satisfies IconNode;

export const rss = [
	["path", { d: "M4 11a9 9 0 0 1 9 9" }],
	["path", { d: "M4 4a16 16 0 0 1 16 16" }],
	["circle", { cx: "5", cy: "19", r: "1" }],
] satisfies IconNode;

export const rugbyBall = [
	["path", { d: "m10 10 4 4" }],
	["path", { d: "m13 7 4 4" }],
	[
		"path",
		{
			d: "M15.34 2.138A15 15 0 002.138 15.34c-.357 2.94.004 4.919.805 5.717.798.8 2.778 1.162 5.718.805A15 15 0 0021.862 8.661c.357-2.94-.004-4.92-.805-5.718-.798-.8-2.778-1.162-5.717-.805",
		},
	],
	["path", { d: "M17 7 7 17" }],
	["path", { d: "m7 13 4 4" }],
] satisfies IconNode;

export const ruler = [
	[
		"path",
		{
			d: "M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z",
		},
	],
	["path", { d: "m14.5 12.5 2-2" }],
	["path", { d: "m11.5 9.5 2-2" }],
	["path", { d: "m8.5 6.5 2-2" }],
	["path", { d: "m17.5 15.5 2-2" }],
] satisfies IconNode;

export const rulerDimensionLine = [
	["path", { d: "M10 15v-3" }],
	["path", { d: "M14 15v-3" }],
	["path", { d: "M18 15v-3" }],
	["path", { d: "M2 8V4" }],
	["path", { d: "M22 6H2" }],
	["path", { d: "M22 8V4" }],
	["path", { d: "M6 15v-3" }],
	["rect", { x: "2", y: "12", width: "20", height: "8", rx: "2" }],
] satisfies IconNode;

export const russianRuble = [
	["path", { d: "M6 11h8a4 4 0 0 0 0-8H9v18" }],
	["path", { d: "M6 15h8" }],
] satisfies IconNode;

export const sailboat = [
	["path", { d: "M10 2v15" }],
	["path", { d: "M7 22a4 4 0 0 1-4-4 1 1 0 0 1 1-1h16a1 1 0 0 1 1 1 4 4 0 0 1-4 4z" }],
	[
		"path",
		{ d: "M9.159 2.46a1 1 0 0 1 1.521-.193l9.977 8.98A1 1 0 0 1 20 13H4a1 1 0 0 1-.824-1.567z" },
	],
] satisfies IconNode;

export const salad = [
	[
		"path",
		{
			d: "M19.496 12a2.5 2.5 0 00.399-2.214A2 2 0 0020.32 6.5 2 2 0 0019 3a2 2 0 00-1.5.68 2 2 0 00-3.287.424 2.5 2.5 0 00-3.189 2.06A3 3 0 0012 12l4-4",
		},
	],
	["path", { d: "M4 12a1 1 0 00-.99 1.133A9 9 0 0012 21a9 9 0 008.99-7.867A1 1 0 0020 12z" }],
	["path", { d: "M7 21h10" }],
	["path", { d: "M9.85 6.907A3.5 3.5 0 005.05 12" }],
] satisfies IconNode;

export const sandwich = [
	["path", { d: "m2.37 11.223 8.372-6.777a2 2 0 0 1 2.516 0l8.371 6.777" }],
	["path", { d: "M21 15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-5.25" }],
	["path", { d: "M3 15a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h9" }],
	["path", { d: "m6.67 15 6.13 4.6a2 2 0 0 0 2.8-.4l3.15-4.2" }],
	["rect", { width: "20", height: "4", x: "2", y: "11", rx: "1" }],
] satisfies IconNode;

export const satellite = [
	[
		"path",
		{
			d: "m13.5 6.5-3.148-3.148a1.205 1.205 0 0 0-1.704 0L6.352 5.648a1.205 1.205 0 0 0 0 1.704L9.5 10.5",
		},
	],
	["path", { d: "M16.5 7.5 19 5" }],
	[
		"path",
		{
			d: "m17.5 10.5 3.148 3.148a1.205 1.205 0 0 1 0 1.704l-2.296 2.296a1.205 1.205 0 0 1-1.704 0L13.5 14.5",
		},
	],
	["path", { d: "M9 21a6 6 0 0 0-6-6" }],
	[
		"path",
		{
			d: "M9.352 10.648a1.205 1.205 0 0 0 0 1.704l2.296 2.296a1.205 1.205 0 0 0 1.704 0l4.296-4.296a1.205 1.205 0 0 0 0-1.704l-2.296-2.296a1.205 1.205 0 0 0-1.704 0z",
		},
	],
] satisfies IconNode;

export const satelliteDish = [
	["path", { d: "M18 12a6 6 0 00-6-6" }],
	[
		"path",
		{
			d: "M2.824 10.459a8 8 0 0010.717 10.717c.558-.276.623-1.012.183-1.452l-9.448-9.448c-.44-.44-1.176-.375-1.452.183",
		},
	],
	["path", { d: "M22 12A10 10 0 0012 2" }],
	["path", { d: "m9 15 4-4" }],
] satisfies IconNode;

export const saudiRiyal = [
	["path", { d: "m20 19.5-5.5 1.2" }],
	["path", { d: "M14.5 4v11.22a1 1 0 0 0 1.242.97L20 15.2" }],
	["path", { d: "m2.978 19.351 5.549-1.363A2 2 0 0 0 10 16V2" }],
	["path", { d: "M20 10 4 13.5" }],
] satisfies IconNode;

export const save = [
	[
		"path",
		{
			d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
		},
	],
	["path", { d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7" }],
	["path", { d: "M7 3v4a1 1 0 0 0 1 1h7" }],
] satisfies IconNode;

export const saveAll = [
	["path", { d: "M10 2v3a1 1 0 0 0 1 1h5" }],
	["path", { d: "M18 18v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6" }],
	["path", { d: "M18 22H4a2 2 0 0 1-2-2V6" }],
	[
		"path",
		{
			d: "M8 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9.172a2 2 0 0 1 1.414.586l2.828 2.828A2 2 0 0 1 22 6.828V16a2 2 0 0 1-2.01 2z",
		},
	],
] satisfies IconNode;

export const saveCheck = [
	[
		"path",
		{
			d: "M12.5 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h10.2a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4v4.35",
		},
	],
	["path", { d: "m16 19 2 2 4-4" }],
	["path", { d: "M17 15.13V14a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7" }],
	["path", { d: "M7 3v4a1 1 0 0 0 1 1h7" }],
] satisfies IconNode;

export const saveOff = [
	["path", { d: "M13 13H8a1 1 0 0 0-1 1v7" }],
	["path", { d: "M14 8h1" }],
	["path", { d: "M17 21v-4" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M20.41 20.41A2 2 0 0 1 19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 .59-1.41" }],
	["path", { d: "M9 3h6.2a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V15" }],
] satisfies IconNode;

export const savePen = [
	["path", { d: "M13.33 13H8a1 1 0 00-1 1v7" }],
	[
		"path",
		{
			d: "M14.363 17.634a2 2 0 00-.506.854l-.837 2.87a.5.5 0 00.62.62l2.87-.837a2 2 0 00.854-.506l4.013-4.009a1 1 0 10-3.004-3.004z",
		},
	],
	["path", { d: "M7 3v4a1 1 0 001 1h7" }],
	[
		"path",
		{ d: "M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h10.2a2 2 0 011.4.6l3.8 3.8a2 2 0 01.6 1.4v.3" },
	],
] satisfies IconNode;

export const savePlus = [
	[
		"path",
		{
			d: "M12.5 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h10.2a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V12",
		},
	],
	["path", { d: "M16 13H8a1 1 0 0 0-1 1v7" }],
	["path", { d: "M19 22v-6" }],
	["path", { d: "M22 19h-6" }],
	["path", { d: "M7 3v4a1 1 0 0 0 1 1h7" }],
] satisfies IconNode;

export const scale = [
	["path", { d: "M12 3v18" }],
	["path", { d: "m19 8 3 8a5 5 0 0 1-6 0zV7" }],
	["path", { d: "M3 7h1a17 17 0 0 0 8-2 17 17 0 0 0 8 2h1" }],
	["path", { d: "m5 8 3 8a5 5 0 0 1-6 0zV7" }],
	["path", { d: "M7 21h10" }],
] satisfies IconNode;

export const scale3d = [
	["path", { d: "M5 7v11a1 1 0 0 0 1 1h11" }],
	["path", { d: "M5.293 18.707 11 13" }],
	["circle", { cx: "19", cy: "19", r: "2" }],
	["circle", { cx: "5", cy: "5", r: "2" }],
] satisfies IconNode;

export const scaling = [
	["path", { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }],
	["path", { d: "M14 15H9v-5" }],
	["path", { d: "M16 3h5v5" }],
	["path", { d: "M21 3 9 15" }],
] satisfies IconNode;

export const scan = [
	["path", { d: "M3 7V5a2 2 0 0 1 2-2h2" }],
	["path", { d: "M17 3h2a2 2 0 0 1 2 2v2" }],
	["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2" }],
	["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2" }],
] satisfies IconNode;

export const scanBarcode = [
	["path", { d: "M3 7V5a2 2 0 0 1 2-2h2" }],
	["path", { d: "M17 3h2a2 2 0 0 1 2 2v2" }],
	["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2" }],
	["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2" }],
	["path", { d: "M8 7v10" }],
	["path", { d: "M12 7v10" }],
	["path", { d: "M17 7v10" }],
] satisfies IconNode;

export const scanBox = [
	["path", { d: "M12 12v5.5" }],
	["path", { d: "M17 3h2a2 2 0 012 2v2" }],
	["path", { d: "M21 17v2a2 2 0 01-2 2h-2" }],
	["path", { d: "M3 7V5a2 2 0 012-2h2" }],
	["path", { d: "M7 21H5a2 2 0 01-2-2v-2" }],
	["path", { d: "M7.264 9.252 12 12l4.737-2.748" }],
	[
		"path",
		{
			d: "M7.995 8.514A2 2 0 007 10.244v3.516a2 2 0 00.996 1.73l3 1.74a2 2 0 002.008 0l3-1.74A2 2 0 0017 13.76v-3.517a2 2 0 00-.995-1.73l-3-1.742a2 2 0 00-1.892-.064z",
		},
	],
] satisfies IconNode;

export const scanEye = [
	["path", { d: "M3 7V5a2 2 0 0 1 2-2h2" }],
	["path", { d: "M17 3h2a2 2 0 0 1 2 2v2" }],
	["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2" }],
	["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2" }],
	["circle", { cx: "12", cy: "12", r: "1" }],
	[
		"path",
		{
			d: "M18.944 12.33a1 1 0 0 0 0-.66 7.5 7.5 0 0 0-13.888 0 1 1 0 0 0 0 .66 7.5 7.5 0 0 0 13.888 0",
		},
	],
] satisfies IconNode;

export const scanFace = [
	["path", { d: "M3 7V5a2 2 0 0 1 2-2h2" }],
	["path", { d: "M17 3h2a2 2 0 0 1 2 2v2" }],
	["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2" }],
	["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2" }],
	["path", { d: "M8 14s1.5 2 4 2 4-2 4-2" }],
	["path", { d: "M9 9h.01" }],
	["path", { d: "M15 9h.01" }],
] satisfies IconNode;

export const scanHeart = [
	["path", { d: "M17 3h2a2 2 0 0 1 2 2v2" }],
	["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2" }],
	["path", { d: "M3 7V5a2 2 0 0 1 2-2h2" }],
	["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2" }],
	[
		"path",
		{ d: "M7.828 13.07A3 3 0 0 1 12 8.764a3 3 0 0 1 4.172 4.306l-3.447 3.62a1 1 0 0 1-1.449 0z" },
	],
] satisfies IconNode;

export const scanLine = [
	["path", { d: "M3 7V5a2 2 0 0 1 2-2h2" }],
	["path", { d: "M17 3h2a2 2 0 0 1 2 2v2" }],
	["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2" }],
	["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2" }],
	["path", { d: "M7 12h10" }],
] satisfies IconNode;

export const scanQrCode = [
	["path", { d: "M17 12v4a1 1 0 0 1-1 1h-4" }],
	["path", { d: "M17 3h2a2 2 0 0 1 2 2v2" }],
	["path", { d: "M17 8V7" }],
	["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2" }],
	["path", { d: "M3 7V5a2 2 0 0 1 2-2h2" }],
	["path", { d: "M7 17h.01" }],
	["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2" }],
	["rect", { x: "7", y: "7", width: "5", height: "5", rx: "1" }],
] satisfies IconNode;

export const scanSearch = [
	["path", { d: "M3 7V5a2 2 0 0 1 2-2h2" }],
	["path", { d: "M17 3h2a2 2 0 0 1 2 2v2" }],
	["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2" }],
	["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2" }],
	["circle", { cx: "12", cy: "12", r: "3" }],
	["path", { d: "m16 16-1.9-1.9" }],
] satisfies IconNode;

export const scanSquare = [
	["path", { d: "M3 7V5a2 2 0 0 1 2-2h2" }],
	["path", { d: "M17 3h2a2 2 0 0 1 2 2v2" }],
	["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2" }],
	["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2" }],
	["rect", { width: "8", height: "8", x: "8", y: "8", rx: "1" }],
] satisfies IconNode;

export const scanText = [
	["path", { d: "M3 7V5a2 2 0 0 1 2-2h2" }],
	["path", { d: "M17 3h2a2 2 0 0 1 2 2v2" }],
	["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2" }],
	["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2" }],
	["path", { d: "M7 8h8" }],
	["path", { d: "M7 12h10" }],
	["path", { d: "M7 16h6" }],
] satisfies IconNode;

export const school = [
	["path", { d: "M14 21v-3a2 2 0 0 0-4 0v3" }],
	["path", { d: "M18 4.933V21" }],
	["path", { d: "m4 6 7.106-3.79a2 2 0 0 1 1.788 0L20 6" }],
	[
		"path",
		{
			d: "m6 11-3.52 2.147a1 1 0 0 0-.48.854V19a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a1 1 0 0 0-.48-.853L18 11",
		},
	],
	["path", { d: "M6 4.933V21" }],
	["circle", { cx: "12", cy: "9", r: "2" }],
] satisfies IconNode;

export const scissors = [
	["circle", { cx: "6", cy: "6", r: "3" }],
	["path", { d: "M8.12 8.12 12 12" }],
	["path", { d: "M20 4 8.12 15.88" }],
	["circle", { cx: "6", cy: "18", r: "3" }],
	["path", { d: "M14.8 14.8 20 20" }],
] satisfies IconNode;

export const scissorsLineDashed = [
	["path", { d: "M5.42 9.42 8 12" }],
	["circle", { cx: "4", cy: "8", r: "2" }],
	["path", { d: "m14 6-8.58 8.58" }],
	["circle", { cx: "4", cy: "16", r: "2" }],
	["path", { d: "M10.8 14.8 14 18" }],
	["path", { d: "M16 12h-2" }],
	["path", { d: "M22 12h-2" }],
] satisfies IconNode;

export const scooter = [
	["path", { d: "M21 4h-3.5l2 11.05" }],
	["path", { d: "M6.95 17h5.142c.523 0 .95-.406 1.063-.916a6.5 6.5 0 0 1 5.345-5.009" }],
	["circle", { cx: "19.5", cy: "17.5", r: "2.5" }],
	["circle", { cx: "4.5", cy: "17.5", r: "2.5" }],
] satisfies IconNode;

export const scratchBlocks = [
	[
		"path",
		{
			d: "M19 5a2 2 0 012 2v11a2 2 0 01-2 2h-5.586a1 1 0 00-.707.293l-1.414 1.414a1 1 0 01-.707.293H8.414a1 1 0 01-.707-.293l-1.414-1.414A1 1 0 005.586 20H5a2 2 0 01-2-2V5.286c0-.394.11-.785.36-1.09a6 6 0 019.168-.133C12.996 4.6 13.637 5 14.35 5z",
		},
	],
	[
		"path",
		{
			d: "M21 12h-7.586a1 1 0 00-.707.293l-1.414 1.414a1 1 0 01-.707.293H8.414a1 1 0 01-.707-.293l-1.414-1.414A1 1 0 005.586 12H3",
		},
	],
] satisfies IconNode;

export const screenShare = [
	["path", { d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3" }],
	["path", { d: "M8 21h8" }],
	["path", { d: "M12 17v4" }],
	["path", { d: "m17 8 5-5" }],
	["path", { d: "M17 3h5v5" }],
] satisfies IconNode;

export const screenShareOff = [
	["path", { d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3" }],
	["path", { d: "M8 21h8" }],
	["path", { d: "M12 17v4" }],
	["path", { d: "m22 3-5 5" }],
	["path", { d: "m17 3 5 5" }],
] satisfies IconNode;

export const screw = [
	["path", { d: "M10 9v10" }],
	["path", { d: "M14 13v2" }],
	[
		"path",
		{
			d: "M16.5 10.5 5.706 21.294A2.4 2.4 0 014.002 22H2.5a.5.5 0 01-.5-.5v-1.502a2.4 2.4 0 01.706-1.704L13.5 7.5",
		},
	],
	[
		"path",
		{
			d: "M20.819 11.575a6 6 0 00.969-5.162.6.6 0 00-.981-.219l-.455.454a1.2 1.2 0 01-1.704 0l-1.296-1.296a1.2 1.2 0 010-1.704l.454-.453a.595.595 0 00-.219-.98 6 6 0 00-5.162.967 2 2 0 00-.222 3.019l5.596 5.597a2 2 0 003.02-.222",
		},
	],
	["path", { d: "M6 13v8" }],
] satisfies IconNode;

export const scroll = [
	["path", { d: "M19 17V5a2 2 0 0 0-2-2H4" }],
	[
		"path",
		{
			d: "M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3",
		},
	],
] satisfies IconNode;

export const scrollText = [
	["path", { d: "M15 12h-5" }],
	["path", { d: "M15 8h-5" }],
	["path", { d: "M19 17V5a2 2 0 0 0-2-2H4" }],
	[
		"path",
		{
			d: "M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3",
		},
	],
] satisfies IconNode;

export const search = [
	["path", { d: "m21 21-4.34-4.34" }],
	["circle", { cx: "11", cy: "11", r: "8" }],
] satisfies IconNode;

export const searchAlert = [
	["circle", { cx: "11", cy: "11", r: "8" }],
	["path", { d: "m21 21-4.3-4.3" }],
	["path", { d: "M11 7v4" }],
	["path", { d: "M11 15h.01" }],
] satisfies IconNode;

export const searchCheck = [
	["path", { d: "m8 11 2 2 4-4" }],
	["circle", { cx: "11", cy: "11", r: "8" }],
	["path", { d: "m21 21-4.3-4.3" }],
] satisfies IconNode;

export const searchCode = [
	["path", { d: "m13 13.5 2-2.5-2-2.5" }],
	["path", { d: "m21 21-4.3-4.3" }],
	["path", { d: "M9 8.5 7 11l2 2.5" }],
	["circle", { cx: "11", cy: "11", r: "8" }],
] satisfies IconNode;

export const searchSlash = [
	["path", { d: "m13.5 8.5-5 5" }],
	["circle", { cx: "11", cy: "11", r: "8" }],
	["path", { d: "m21 21-4.3-4.3" }],
] satisfies IconNode;

export const searchX = [
	["path", { d: "m13.5 8.5-5 5" }],
	["path", { d: "m8.5 8.5 5 5" }],
	["circle", { cx: "11", cy: "11", r: "8" }],
	["path", { d: "m21 21-4.3-4.3" }],
] satisfies IconNode;

export const section = [
	["path", { d: "M16 5a4 3 0 0 0-8 0c0 4 8 3 8 7a4 3 0 0 1-8 0" }],
	["path", { d: "M8 19a4 3 0 0 0 8 0c0-4-8-3-8-7a4 3 0 0 1 8 0" }],
] satisfies IconNode;

export const send = [
	[
		"path",
		{
			d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
		},
	],
	["path", { d: "m21.854 2.147-10.94 10.939" }],
] satisfies IconNode;

export const sendHorizontal = [
	[
		"path",
		{
			d: "M3.714 3.048a.498.498 0 0 0-.683.627l2.843 7.627a2 2 0 0 1 0 1.396l-2.842 7.627a.498.498 0 0 0 .682.627l18-8.5a.5.5 0 0 0 0-.904z",
		},
	],
	["path", { d: "M6 12h16" }],
] satisfies IconNode;

export const sendToBack = [
	["rect", { x: "14", y: "14", width: "8", height: "8", rx: "2" }],
	["rect", { x: "2", y: "2", width: "8", height: "8", rx: "2" }],
	["path", { d: "M7 14v1a2 2 0 0 0 2 2h1" }],
	["path", { d: "M14 7h1a2 2 0 0 1 2 2v1" }],
] satisfies IconNode;

export const separatorHorizontal = [
	["path", { d: "m16 16-4 4-4-4" }],
	["path", { d: "M3 12h18" }],
	["path", { d: "m8 8 4-4 4 4" }],
] satisfies IconNode;

export const separatorVertical = [
	["path", { d: "M12 3v18" }],
	["path", { d: "m16 16 4-4-4-4" }],
	["path", { d: "m8 8-4 4 4 4" }],
] satisfies IconNode;

export const server = [
	["rect", { width: "20", height: "8", x: "2", y: "2", rx: "2", ry: "2" }],
	["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", ry: "2" }],
	["line", { x1: "6", x2: "6.01", y1: "6", y2: "6" }],
	["line", { x1: "6", x2: "6.01", y1: "18", y2: "18" }],
] satisfies IconNode;

export const serverCog = [
	["path", { d: "m10.852 14.772-.383.923" }],
	["path", { d: "M13.148 14.772a3 3 0 1 0-2.296-5.544l-.383-.923" }],
	["path", { d: "m13.148 9.228.383-.923" }],
	["path", { d: "m13.53 15.696-.382-.924a3 3 0 1 1-2.296-5.544" }],
	["path", { d: "m14.772 10.852.923-.383" }],
	["path", { d: "m14.772 13.148.923.383" }],
	["path", { d: "M4.5 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-.5" }],
	["path", { d: "M4.5 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-.5" }],
	["path", { d: "M6 18h.01" }],
	["path", { d: "M6 6h.01" }],
	["path", { d: "m9.228 10.852-.923-.383" }],
	["path", { d: "m9.228 13.148-.923.383" }],
] satisfies IconNode;

export const serverCrash = [
	["path", { d: "M6 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2" }],
	["path", { d: "M6 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2" }],
	["path", { d: "M6 6h.01" }],
	["path", { d: "M6 18h.01" }],
	["path", { d: "m13 6-4 6h6l-4 6" }],
] satisfies IconNode;

export const serverNas = [
	["path", { d: "M10 16V8" }],
	["path", { d: "M14 16V8" }],
	["path", { d: "M18 16V8" }],
	["path", { d: "M6 12h.01" }],
	["path", { d: "M6 16h.01" }],
	["rect", { x: "2", y: "4", width: "20", height: "16", rx: "2" }],
] satisfies IconNode;

export const serverOff = [
	["path", { d: "M7 2h13a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5" }],
	["path", { d: "M10 10 2.5 2.5C2 2 2 2.5 2 5v3a2 2 0 0 0 2 2h6z" }],
	["path", { d: "M22 17v-1a2 2 0 0 0-2-2h-1" }],
	["path", { d: "M4 14a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16.5l1-.5.5.5-8-8H4z" }],
	["path", { d: "M6 18h.01" }],
	["path", { d: "m2 2 20 20" }],
] satisfies IconNode;

export const serverPlus = [
	["path", { d: "M12.5 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2" }],
	["path", { d: "M16 12h6" }],
	["path", { d: "M19 9v6" }],
	["path", { d: "M22 18v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h8.5" }],
	["path", { d: "M6 18h.01" }],
	["path", { d: "M6 6h.01" }],
] satisfies IconNode;

export const settings = [
	[
		"path",
		{
			d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
		},
	],
	["circle", { cx: "12", cy: "12", r: "3" }],
] satisfies IconNode;

export const settings2 = [
	["path", { d: "M14 17H5" }],
	["path", { d: "M19 7h-9" }],
	["circle", { cx: "17", cy: "17", r: "3" }],
	["circle", { cx: "7", cy: "7", r: "3" }],
] satisfies IconNode;

export const shapes = [
	[
		"path",
		{
			d: "M8.3 10a.7.7 0 0 1-.626-1.079L11.4 3a.7.7 0 0 1 1.198-.043L16.3 8.9a.7.7 0 0 1-.572 1.1Z",
		},
	],
	["rect", { x: "3", y: "14", width: "7", height: "7", rx: "1" }],
	["circle", { cx: "17.5", cy: "17.5", r: "3.5" }],
] satisfies IconNode;

export const share = [
	["path", { d: "M12 2v13" }],
	["path", { d: "m16 6-4-4-4 4" }],
	["path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" }],
] satisfies IconNode;

export const share2 = [
	["circle", { cx: "18", cy: "5", r: "3" }],
	["circle", { cx: "6", cy: "12", r: "3" }],
	["circle", { cx: "18", cy: "19", r: "3" }],
	["line", { x1: "8.59", x2: "15.42", y1: "13.51", y2: "17.49" }],
	["line", { x1: "15.41", x2: "8.59", y1: "6.51", y2: "10.49" }],
] satisfies IconNode;

export const sheet = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
	["line", { x1: "3", x2: "21", y1: "9", y2: "9" }],
	["line", { x1: "3", x2: "21", y1: "15", y2: "15" }],
	["line", { x1: "9", x2: "9", y1: "9", y2: "21" }],
	["line", { x1: "15", x2: "15", y1: "9", y2: "21" }],
] satisfies IconNode;

export const shell = [
	[
		"path",
		{
			d: "M14 11a2 2 0 1 1-4 0 4 4 0 0 1 8 0 6 6 0 0 1-12 0 8 8 0 0 1 16 0 10 10 0 1 1-20 0 11.93 11.93 0 0 1 2.42-7.22 2 2 0 1 1 3.16 2.44",
		},
	],
] satisfies IconNode;

export const shelvingUnit = [
	["path", { d: "M12 12V9a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3" }],
	["path", { d: "M16 20v-3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3" }],
	["path", { d: "M20 22V2" }],
	["path", { d: "M4 12h16" }],
	["path", { d: "M4 20h16" }],
	["path", { d: "M4 2v20" }],
	["path", { d: "M4 4h16" }],
] satisfies IconNode;

export const shield = [
	[
		"path",
		{
			d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
		},
	],
] satisfies IconNode;

export const shieldAlert = [
	[
		"path",
		{
			d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
		},
	],
	["path", { d: "M12 8v4" }],
	["path", { d: "M12 16h.01" }],
] satisfies IconNode;

export const shieldBan = [
	[
		"path",
		{
			d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
		},
	],
	["path", { d: "m4.243 5.21 14.39 12.472" }],
] satisfies IconNode;

export const shieldCheck = [
	[
		"path",
		{
			d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
		},
	],
	["path", { d: "m9 12 2 2 4-4" }],
] satisfies IconNode;

export const shieldCog = [
	["path", { d: "m10.929 14.467-.383.924" }],
	["path", { d: "M10.929 8.923 10.546 8" }],
	["path", { d: "M13.225 8.923 13.608 8" }],
	["path", { d: "m13.607 15.391-.382-.924" }],
	["path", { d: "m14.849 10.547.923-.383" }],
	["path", { d: "m14.849 12.843.923.383" }],
	[
		"path",
		{
			d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
		},
	],
	["path", { d: "m9.305 10.547-.923-.383" }],
	["path", { d: "m9.305 12.843-.923.383" }],
	["circle", { cx: "12.077", cy: "11.695", r: "3" }],
] satisfies IconNode;

export const shieldCogCorner = [
	[
		"path",
		{
			d: "M11 22c-3.806-1.45-7-3.966-7-9V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1v4",
		},
	],
	["path", { d: "M14.923 16.547 14 16.164" }],
	["path", { d: "m14.923 18.843-.923.383" }],
	["path", { d: "M16.547 14.923 16.164 14" }],
	["path", { d: "m16.547 20.467-.383.924" }],
	["path", { d: "m18.843 14.923.383-.923" }],
	["path", { d: "m19.225 21.391-.382-.924" }],
	["path", { d: "m20.467 16.547.923-.383" }],
	["path", { d: "m20.467 18.843.923.383" }],
	["circle", { cx: "17.695", cy: "17.695", r: "3" }],
] satisfies IconNode;

export const shieldEllipsis = [
	[
		"path",
		{
			d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
		},
	],
	["path", { d: "M8 12h.01" }],
	["path", { d: "M12 12h.01" }],
	["path", { d: "M16 12h.01" }],
] satisfies IconNode;

export const shieldHalf = [
	[
		"path",
		{
			d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
		},
	],
	["path", { d: "M12 22V2" }],
] satisfies IconNode;

export const shieldHouse = [
	[
		"path",
		{
			d: "M15 22a1 1 0 01-1-1v-4a1 1 0 01.445-.832l3-2a1 1 0 011.11 0l3 2A1 1 0 0122 17v4a1 1 0 01-1 1z",
		},
	],
	["path", { d: "M18 22v-3" }],
	[
		"path",
		{
			d: "M20 10.418V6a1 1 0 00-1-1c-2 0-4.49-1.19-6.24-2.72a1.17 1.17 0 00-1.52 0C9.5 3.8 7 5 5 5a1 1 0 00-1 1v7c0 4.602 2.67 7.1 6.037 8.603",
		},
	],
] satisfies IconNode;

export const shieldKeyhole = [
	["path", { d: "M12 13v3" }],
	[
		"path",
		{
			d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 01-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 011-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 011.52 0C14.51 3.81 17 5 19 5a1 1 0 011 1z",
		},
	],
	["circle", { cx: "12", cy: "11", r: "2" }],
] satisfies IconNode;

export const shieldLock = [
	[
		"path",
		{
			d: "M20 9.807V6a1 1 0 00-1-1c-2 0-4.49-1.19-6.24-2.72a1.17 1.17 0 00-1.52 0C9.5 3.8 7 5 5 5a1 1 0 00-1 1v7c0 3.88 2.107 6.254 5 7.796",
		},
	],
	["path", { d: "M19 17v-2a2 2 0 00-4 0v2" }],
	["rect", { x: "13", y: "17", width: "8", height: "5", rx: "1" }],
] satisfies IconNode;

export const shieldMinus = [
	[
		"path",
		{
			d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
		},
	],
	["path", { d: "M9 12h6" }],
] satisfies IconNode;

export const shieldOff = [
	["path", { d: "m2 2 20 20" }],
	[
		"path",
		{
			d: "M5 5a1 1 0 0 0-1 1v7c0 5 3.5 7.5 7.67 8.94a1 1 0 0 0 .67.01c2.35-.82 4.48-1.97 5.9-3.71",
		},
	],
	[
		"path",
		{
			d: "M9.309 3.652A12.252 12.252 0 0 0 11.24 2.28a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1v7a9.784 9.784 0 0 1-.08 1.264",
		},
	],
] satisfies IconNode;

export const shieldPlus = [
	[
		"path",
		{
			d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
		},
	],
	["path", { d: "M9 12h6" }],
	["path", { d: "M12 9v6" }],
] satisfies IconNode;

export const shieldQuestionMark = [
	[
		"path",
		{
			d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
		},
	],
	["path", { d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3" }],
	["path", { d: "M12 17h.01" }],
] satisfies IconNode;

export const shieldUser = [
	[
		"path",
		{
			d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
		},
	],
	["path", { d: "M6.376 18.91a6 6 0 0 1 11.249.003" }],
	["circle", { cx: "12", cy: "11", r: "4" }],
] satisfies IconNode;

export const shieldX = [
	[
		"path",
		{
			d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
		},
	],
	["path", { d: "m14.5 9.5-5 5" }],
	["path", { d: "m9.5 9.5 5 5" }],
] satisfies IconNode;

export const ship = [
	["path", { d: "M12 2v2" }],
	["path", { d: "M12 9.189V13" }],
	["path", { d: "M19 12V6a2 2 0 00-2-2H7a2 2 0 00-2 2v6" }],
	[
		"path",
		{
			d: "M19.38 19A11.6 11.6 0 0021 13l-8.188-3.639a2 2 0 00-1.624 0L3 13.001a11.6 11.6 0 002.81 7.76",
		},
	],
	[
		"path",
		{
			d: "M2 20c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
		},
	],
] satisfies IconNode;

export const shipCargo = [
	["path", { d: "M12 15v-3" }],
	["path", { d: "M12 2v2" }],
	[
		"path",
		{
			d: "M16.5 12V9a1 1 0 011-1h1a1 1 0 001-1V5a1 1 0 00-1-1h-13a1 1 0 00-1 1v2a1 1 0 001 1h1a1 1 0 011 1v3",
		},
	],
	[
		"path",
		{
			d: "M19.38 19c1.076-1.815 1.636-4.89 1.628-6.008a1 1 0 00-1-.992H3.984a1 1 0 00-1 .984c-.03 1.86.97 5.621 2.826 7.776",
		},
	],
	[
		"path",
		{
			d: "M2 20c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
		},
	],
] satisfies IconNode;

export const shipWheel = [
	["circle", { cx: "12", cy: "12", r: "8" }],
	["path", { d: "M12 2v7.5" }],
	["path", { d: "m19 5-5.23 5.23" }],
	["path", { d: "M22 12h-7.5" }],
	["path", { d: "m19 19-5.23-5.23" }],
	["path", { d: "M12 14.5V22" }],
	["path", { d: "M10.23 13.77 5 19" }],
	["path", { d: "M9.5 12H2" }],
	["path", { d: "M10.23 10.23 5 5" }],
	["circle", { cx: "12", cy: "12", r: "2.5" }],
] satisfies IconNode;

export const shirt = [
	[
		"path",
		{
			d: "M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z",
		},
	],
] satisfies IconNode;

export const shoppingBag = [
	["path", { d: "M16 10a4 4 0 0 1-8 0" }],
	["path", { d: "M3.103 6.034h17.794" }],
	[
		"path",
		{
			d: "M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z",
		},
	],
] satisfies IconNode;

export const shoppingBasket = [
	["path", { d: "m15 11-1 9" }],
	["path", { d: "m19 11-4-7" }],
	["path", { d: "M2 11h20" }],
	["path", { d: "m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4" }],
	["path", { d: "M4.5 15.5h15" }],
	["path", { d: "m5 11 4-7" }],
	["path", { d: "m9 11 1 9" }],
] satisfies IconNode;

export const shoppingCart = [
	["path", { d: "m2.05 2.05 1.099-.028a1 1 0 0 1 1.008.815l2.69 14.347A1 1 0 0 0 7.83 18H18" }],
	["path", { d: "M4.563 5h16.435a1 1 0 0 1 .981 1.204l-1.026 6.226A2 2 0 0 1 18.962 14H6.25" }],
	["circle", { cx: "18", cy: "20", r: "2" }],
	["circle", { cx: "8", cy: "20", r: "2" }],
] satisfies IconNode;

export const shoppingCartMinus = [
	["path", { d: "M16 5h6" }],
	["path", { d: "m2.05 2.05 1.099-.028a1 1 0 011.008.815l2.69 14.347A1 1 0 007.83 18H18" }],
	["path", { d: "M4.564 5H12" }],
	["path", { d: "M6.25 14h12.712a2 2 0 001.991-1.57l.514-3.113" }],
	["circle", { cx: "18", cy: "20", r: "2" }],
	["circle", { cx: "8", cy: "20", r: "2" }],
] satisfies IconNode;

export const shoppingCartPlus = [
	["path", { d: "M16 5h6" }],
	["path", { d: "M19 2v6" }],
	["path", { d: "m2.05 2.05 1.099-.028a1 1 0 011.008.815l2.69 14.347A1 1 0 007.83 18H18" }],
	["path", { d: "M4.564 5H12" }],
	["path", { d: "M6.25 14h12.712a2 2 0 001.991-1.57l.172-1.041" }],
	["circle", { cx: "18", cy: "20", r: "2" }],
	["circle", { cx: "8", cy: "20", r: "2" }],
] satisfies IconNode;

export const shovel = [
	[
		"path",
		{
			d: "M21.56 4.56a1.5 1.5 0 0 1 0 2.122l-.47.47a3 3 0 0 1-4.212-.03 3 3 0 0 1 0-4.243l.44-.44a1.5 1.5 0 0 1 2.121 0z",
		},
	],
	[
		"path",
		{
			d: "M3 22a1 1 0 0 1-1-1v-3.586a1 1 0 0 1 .293-.707l3.355-3.355a1.205 1.205 0 0 1 1.704 0l3.296 3.296a1.205 1.205 0 0 1 0 1.704l-3.355 3.355a1 1 0 0 1-.707.293z",
		},
	],
	["path", { d: "m9 15 7.879-7.878" }],
] satisfies IconNode;

export const showerHead = [
	["path", { d: "m4 4 2.5 2.5" }],
	["path", { d: "M13.5 6.5a4.95 4.95 0 0 0-7 7" }],
	["path", { d: "M15 5 5 15" }],
	["path", { d: "M14 17v.01" }],
	["path", { d: "M10 16v.01" }],
	["path", { d: "M13 13v.01" }],
	["path", { d: "M16 10v.01" }],
	["path", { d: "M11 20v.01" }],
	["path", { d: "M17 14v.01" }],
	["path", { d: "M20 11v.01" }],
] satisfies IconNode;

export const shredder = [
	[
		"path",
		{ d: "M4 13V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v5" },
	],
	["path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M10 22v-5" }],
	["path", { d: "M14 19v-2" }],
	["path", { d: "M18 20v-3" }],
	["path", { d: "M2 13h20" }],
	["path", { d: "M6 20v-3" }],
] satisfies IconNode;

export const shrimp = [
	[
		"path",
		{
			d: "M10 2a3.28 3.28 0 003.227 1.798l6.17-.561A1 1 0 1119.614 8H8.5a6.44 6.44 0 00-5.63 9.75A6.5 6.5 0 008.5 21c1.38 0 2-.5 2.5-1",
		},
	],
	["path", { d: "M10 8a8.5 8.5 0 000 8" }],
	["path", { d: "M11 22c-.5-.5-1.12-1-2.5-1a1 1 0 010-5H12a7 7 0 007-7V8" }],
	["path", { d: "M13 12h.01" }],
	["path", { d: "M8 16c-2 0-4.5-4-4-6" }],
] satisfies IconNode;

export const shrimpOff = [
	["path", { d: "M10 2a3.28 3.28 0 003.227 1.798l6.17-.561A1 1 0 1119.614 8H13.5" }],
	["path", { d: "M11 20c-.5.5-1.12 1-2.5 1a1 1 0 010-5H12a7 7 0 003.283-.817" }],
	["path", { d: "M11 22c-.5-.5-1.12-1-2.5-1a6.5 6.5 0 01-5.63-3.25 6.44 6.44 0 015.236-9.744" }],
	["path", { d: "M18.04 12.54A7 7 0 0019 9V8" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M8 16c-2 0-4.5-4-4-6" }],
	["path", { d: "M9.43 9.33A8.5 8.5 0 0010 16" }],
] satisfies IconNode;

export const shrink = [
	["path", { d: "m15 15 6 6m-6-6v4.8m0-4.8h4.8" }],
	["path", { d: "M9 19.8V15m0 0H4.2M9 15l-6 6" }],
	["path", { d: "M15 4.2V9m0 0h4.8M15 9l6-6" }],
	["path", { d: "M9 4.2V9m0 0H4.2M9 9 3 3" }],
] satisfies IconNode;

export const shrub = [
	["path", { d: "M12 22v-5.172a2 2 0 0 0-.586-1.414L9.5 13.5" }],
	["path", { d: "M14.5 14.5 12 17" }],
	["path", { d: "M17 8.8A6 6 0 0 1 13.8 20H10A6.5 6.5 0 0 1 7 8a5 5 0 0 1 10 0z" }],
] satisfies IconNode;

export const shuffle = [
	["path", { d: "m18 14 4 4-4 4" }],
	["path", { d: "m18 2 4 4-4 4" }],
	["path", { d: "M2 18h1.973a4 4 0 0 0 3.3-1.7l5.454-8.6a4 4 0 0 1 3.3-1.7H22" }],
	["path", { d: "M2 6h1.972a4 4 0 0 1 3.6 2.2" }],
	["path", { d: "M22 18h-6.041a4 4 0 0 1-3.3-1.8l-.359-.45" }],
] satisfies IconNode;

export const sigma = [
	[
		"path",
		{
			d: "M18 7V5a1 1 0 0 0-1-1H6.5a.5.5 0 0 0-.4.8l4.5 6a2 2 0 0 1 0 2.4l-4.5 6a.5.5 0 0 0 .4.8H17a1 1 0 0 0 1-1v-2",
		},
	],
] satisfies IconNode;

export const signal = [
	["path", { d: "M2 20h.01" }],
	["path", { d: "M7 20v-4" }],
	["path", { d: "M12 20v-8" }],
	["path", { d: "M17 20V8" }],
	["path", { d: "M22 4v16" }],
] satisfies IconNode;

export const signalHigh = [
	["path", { d: "M2 20h.01" }],
	["path", { d: "M7 20v-4" }],
	["path", { d: "M12 20v-8" }],
	["path", { d: "M17 20V8" }],
] satisfies IconNode;

export const signalLow = [
	["path", { d: "M2 20h.01" }],
	["path", { d: "M7 20v-4" }],
] satisfies IconNode;

export const signalMedium = [
	["path", { d: "M2 20h.01" }],
	["path", { d: "M7 20v-4" }],
	["path", { d: "M12 20v-8" }],
] satisfies IconNode;

export const signalZero = [["path", { d: "M2 20h.01" }]] satisfies IconNode;

export const signature = [
	[
		"path",
		{
			d: "m21 17-2.156-1.868A.5.5 0 0 0 18 15.5v.5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1c0-2.545-3.991-3.97-8.5-4a1 1 0 0 0 0 5c4.153 0 4.745-11.295 5.708-13.5a2.5 2.5 0 1 1 3.31 3.284",
		},
	],
	["path", { d: "M3 21h18" }],
] satisfies IconNode;

export const signpost = [
	["path", { d: "M12 13v8" }],
	["path", { d: "M12 3v3" }],
	[
		"path",
		{
			d: "M2.354 10.354a1.207 1.207 0 0 1 0-1.708l2.06-2.06A2 2 0 0 1 5.828 6h12.344a2 2 0 0 1 1.414.586l2.06 2.06a1.207 1.207 0 0 1 0 1.708l-2.06 2.06a2 2 0 0 1-1.414.586H5.828a2 2 0 0 1-1.414-.586z",
		},
	],
] satisfies IconNode;

export const signpostBig = [
	["path", { d: "M10 9H4L2 7l2-2h6" }],
	["path", { d: "M14 5h6l2 2-2 2h-6" }],
	["path", { d: "M10 22V4a2 2 0 1 1 4 0v18" }],
	["path", { d: "M8 22h8" }],
] satisfies IconNode;

export const siren = [
	["path", { d: "M7 18v-6a5 5 0 1 1 10 0v6" }],
	["path", { d: "M5 21a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2z" }],
	["path", { d: "M21 12h1" }],
	["path", { d: "M18.5 4.5 18 5" }],
	["path", { d: "M2 12h1" }],
	["path", { d: "M12 2v1" }],
	["path", { d: "m4.929 4.929.707.707" }],
	["path", { d: "M12 12v6" }],
] satisfies IconNode;

export const sixteenthNotes = [
	["path", { d: "M21 16V3a1 1 0 0 0-1.28-.96l-10 2.917a1 1 0 0 0-.72.96V19" }],
	["path", { d: "M21 6 9 9.5" }],
	["circle", { cx: "18", cy: "16", r: "3" }],
	["circle", { cx: "6", cy: "19", r: "3" }],
] satisfies IconNode;

export const skipBack = [
	[
		"path",
		{
			d: "M17.971 4.285A2 2 0 0 1 21 6v12a2 2 0 0 1-3.029 1.715l-9.997-5.998a2 2 0 0 1-.003-3.432z",
		},
	],
	["path", { d: "M3 20V4" }],
] satisfies IconNode;

export const skipForward = [
	["path", { d: "M21 4v16" }],
	[
		"path",
		{ d: "M6.029 4.285A2 2 0 0 0 3 6v12a2 2 0 0 0 3.029 1.715l9.997-5.998a2 2 0 0 0 .003-3.432z" },
	],
] satisfies IconNode;

export const skull = [
	["path", { d: "m12.5 17-.5-1-.5 1h1z" }],
	[
		"path",
		{
			d: "M15 22a1 1 0 0 0 1-1v-1a2 2 0 0 0 1.56-3.25 8 8 0 1 0-11.12 0A2 2 0 0 0 8 20v1a1 1 0 0 0 1 1z",
		},
	],
	["circle", { cx: "15", cy: "12", r: "1" }],
	["circle", { cx: "9", cy: "12", r: "1" }],
] satisfies IconNode;

export const slash = [["path", { d: "M22 2 2 22" }]] satisfies IconNode;

export const slice = [
	[
		"path",
		{
			d: "M11 16.586V19a1 1 0 0 1-1 1H2L18.37 3.63a1 1 0 1 1 3 3l-9.663 9.663a1 1 0 0 1-1.414 0L8 14",
		},
	],
] satisfies IconNode;

export const slidersHorizontal = [
	["path", { d: "M10 5H3" }],
	["path", { d: "M12 19H3" }],
	["path", { d: "M14 3v4" }],
	["path", { d: "M16 17v4" }],
	["path", { d: "M21 12h-9" }],
	["path", { d: "M21 19h-5" }],
	["path", { d: "M21 5h-7" }],
	["path", { d: "M8 10v4" }],
	["path", { d: "M8 12H3" }],
] satisfies IconNode;

export const slidersVertical = [
	["path", { d: "M10 8h4" }],
	["path", { d: "M12 21v-9" }],
	["path", { d: "M12 8V3" }],
	["path", { d: "M17 16h4" }],
	["path", { d: "M19 12V3" }],
	["path", { d: "M19 21v-5" }],
	["path", { d: "M3 14h4" }],
	["path", { d: "M5 10V3" }],
	["path", { d: "M5 21v-7" }],
] satisfies IconNode;

export const smartphone = [
	["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2" }],
	["path", { d: "M12 18h.01" }],
] satisfies IconNode;

export const smartphoneCharging = [
	["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2" }],
	["path", { d: "M12.667 8 10 12h4l-2.667 4" }],
] satisfies IconNode;

export const smartphoneNfc = [
	["rect", { width: "7", height: "12", x: "2", y: "6", rx: "1" }],
	["path", { d: "M13 8.32a7.43 7.43 0 0 1 0 7.36" }],
	["path", { d: "M16.46 6.21a11.76 11.76 0 0 1 0 11.58" }],
	["path", { d: "M19.91 4.1a15.91 15.91 0 0 1 .01 15.8" }],
] satisfies IconNode;

export const smartphoneUserRound = [
	["path", { d: "M10 22H6a2 2 0 01-2-2V4a2 2 0 012-2h10a2 2 0 012 2v4" }],
	["path", { d: "M11 18h.01" }],
	["path", { d: "M22 22a4 4 0 00-8 0" }],
	["circle", { cx: "18", cy: "15", r: "3" }],
] satisfies IconNode;

export const snail = [
	["path", { d: "M2 13a6 6 0 1 0 12 0 4 4 0 1 0-8 0 2 2 0 0 0 4 0" }],
	["circle", { cx: "10", cy: "13", r: "8" }],
	["path", { d: "M2 21h12c4.4 0 8-3.6 8-8V7a2 2 0 1 0-4 0v6" }],
	["path", { d: "M18 3 19.1 5.2" }],
	["path", { d: "M22 3 20.9 5.2" }],
] satisfies IconNode;

export const snowflake = [
	["path", { d: "m10 20-1.25-2.5L6 18" }],
	["path", { d: "M10 4 8.75 6.5 6 6" }],
	["path", { d: "m14 20 1.25-2.5L18 18" }],
	["path", { d: "m14 4 1.25 2.5L18 6" }],
	["path", { d: "m17 21-3-6h-4" }],
	["path", { d: "m17 3-3 6 1.5 3" }],
	["path", { d: "M2 12h6.5L10 9" }],
	["path", { d: "m20 10-1.5 2 1.5 2" }],
	["path", { d: "M22 12h-6.5L14 15" }],
	["path", { d: "m4 10 1.5 2L4 14" }],
	["path", { d: "m7 21 3-6-1.5-3" }],
	["path", { d: "m7 3 3 6h4" }],
] satisfies IconNode;

export const soapDispenserDroplet = [
	["path", { d: "M10.5 2v4" }],
	["path", { d: "M14 2H7a2 2 0 0 0-2 2" }],
	[
		"path",
		{
			d: "M19.29 14.76A6.67 6.67 0 0 1 17 11a6.6 6.6 0 0 1-2.29 3.76c-1.15.92-1.71 2.04-1.71 3.19 0 2.22 1.8 4.05 4 4.05s4-1.83 4-4.05c0-1.16-.57-2.26-1.71-3.19",
		},
	],
	["path", { d: "M9.607 21H6a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h7V7a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3" }],
] satisfies IconNode;

export const sofa = [
	["path", { d: "M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3" }],
	[
		"path",
		{
			d: "M2 16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z",
		},
	],
	["path", { d: "M4 18v2" }],
	["path", { d: "M20 18v2" }],
	["path", { d: "M12 4v9" }],
] satisfies IconNode;

export const solarPanel = [
	["path", { d: "M11 2h2" }],
	["path", { d: "m14.28 14-4.56 8" }],
	["path", { d: "m21 22-1.558-4H4.558" }],
	["path", { d: "M3 10v2" }],
	[
		"path",
		{
			d: "M6.245 15.04A2 2 0 0 1 8 14h12a1 1 0 0 1 .864 1.505l-3.11 5.457A2 2 0 0 1 16 22H4a1 1 0 0 1-.863-1.506z",
		},
	],
	["path", { d: "M7 2a4 4 0 0 1-4 4" }],
	["path", { d: "m8.66 7.66 1.41 1.41" }],
] satisfies IconNode;

export const soup = [
	[
		"path",
		{ d: "M11.248 3c.273.1.808.53.747 1.36-.05.83-.938 1.2-.989 2.02-.06.78.333 1.24.727 1.62" },
	],
	[
		"path",
		{ d: "M16.252 3c.268.1.794.53.745 1.36-.06.83-.923 1.2-.993 2.02-.05.78.338 1.24.725 1.62" },
	],
	["path", { d: "M19.5 12 22 6" }],
	["path", { d: "M4 12a1 1 0 00-.99 1.133A9 9 0 0012 21a9 9 0 008.99-7.867A1 1 0 0020 12z" }],
	[
		"path",
		{ d: "M6.252 3c.268.1.794.53.745 1.36-.06.83-.923 1.2-.993 2.02-.05.78.338 1.24.735 1.62" },
	],
	["path", { d: "M7 21h10" }],
] satisfies IconNode;

export const space = [
	["path", { d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1" }],
] satisfies IconNode;

export const spade = [
	["path", { d: "M12 18v4" }],
	[
		"path",
		{
			d: "M2 14.499a5.5 5.5 0 0 0 9.591 3.675.6.6 0 0 1 .818.001A5.5 5.5 0 0 0 22 14.5c0-2.29-1.5-4-3-5.5l-5.492-5.312a2 2 0 0 0-3-.02L5 8.999c-1.5 1.5-3 3.2-3 5.5",
		},
	],
] satisfies IconNode;

export const sparkle = [
	[
		"path",
		{
			d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
		},
	],
] satisfies IconNode;

export const sparkles = [
	[
		"path",
		{
			d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
		},
	],
	["path", { d: "M20 2v4" }],
	["path", { d: "M22 4h-4" }],
	["circle", { cx: "4", cy: "20", r: "2" }],
] satisfies IconNode;

export const speaker = [
	["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2" }],
	["path", { d: "M12 6h.01" }],
	["circle", { cx: "12", cy: "14", r: "4" }],
	["path", { d: "M12 14h.01" }],
] satisfies IconNode;

export const speech = [
	[
		"path",
		{
			d: "M8.8 20v-4.1l1.9.2a2.3 2.3 0 0 0 2.164-2.1V8.3A5.37 5.37 0 0 0 2 8.25c0 2.8.656 3.054 1 4.55a5.77 5.77 0 0 1 .029 2.758L2 20",
		},
	],
	["path", { d: "M19.8 17.8a7.5 7.5 0 0 0 .003-10.603" }],
	["path", { d: "M17 15a3.5 3.5 0 0 0-.025-4.975" }],
] satisfies IconNode;

export const spellCheck = [
	["path", { d: "m20 15-5.5 5.5L12 18" }],
	["path", { d: "m4 16 6-12 5.115 10.23" }],
	["path", { d: "M6 12h8" }],
] satisfies IconNode;

export const spellCheck2 = [
	["path", { d: "m6 16 6-12 6 12" }],
	["path", { d: "M8 12h8" }],
	[
		"path",
		{
			d: "M4 21c1.1 0 1.1-1 2.3-1s1.1 1 2.3 1c1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1",
		},
	],
] satisfies IconNode;

export const spline = [
	["circle", { cx: "19", cy: "5", r: "2" }],
	["circle", { cx: "5", cy: "19", r: "2" }],
	["path", { d: "M5 17A12 12 0 0 1 17 5" }],
] satisfies IconNode;

export const splinePointer = [
	[
		"path",
		{
			d: "M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z",
		},
	],
	["path", { d: "M5 17A12 12 0 0 1 17 5" }],
	["circle", { cx: "19", cy: "5", r: "2" }],
	["circle", { cx: "5", cy: "19", r: "2" }],
] satisfies IconNode;

export const split = [
	["path", { d: "M16 3h5v5" }],
	["path", { d: "M8 3H3v5" }],
	["path", { d: "M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3" }],
	["path", { d: "m15 9 6-6" }],
] satisfies IconNode;

export const spool = [
	[
		"path",
		{
			d: "M17 13.44 4.442 17.082A2 2 0 0 0 4.982 21H19a2 2 0 0 0 .558-3.921l-1.115-.32A2 2 0 0 1 17 14.837V7.66",
		},
	],
	[
		"path",
		{
			d: "m7 10.56 12.558-3.642A2 2 0 0 0 19.018 3H5a2 2 0 0 0-.558 3.921l1.115.32A2 2 0 0 1 7 9.163v7.178",
		},
	],
] satisfies IconNode;

export const sportShoe = [
	["path", { d: "m15 10.42 4.8-5.07" }],
	["path", { d: "M19 18h3" }],
	[
		"path",
		{
			d: "M9.5 22 21.414 9.415A2 2 0 0 0 21.2 6.4l-5.61-4.208A1 1 0 0 0 14 3v2a2 2 0 0 1-1.394 1.906L8.677 8.053A1 1 0 0 0 8 9c-.155 6.393-2.082 9-4 9a2 2 0 0 0 0 4h14",
		},
	],
] satisfies IconNode;

export const spotlight = [
	["path", { d: "M15.295 19.562 16 22" }],
	["path", { d: "m17 16 3.758 2.098" }],
	["path", { d: "m19 12.5 3.026-.598" }],
	[
		"path",
		{
			d: "M7.61 6.3a3 3 0 0 0-3.92 1.3l-1.38 2.79a3 3 0 0 0 1.3 3.91l6.89 3.597a1 1 0 0 0 1.342-.447l3.106-6.211a1 1 0 0 0-.447-1.341z",
		},
	],
	["path", { d: "M8 9V2" }],
] satisfies IconNode;

export const sprayCan = [
	["path", { d: "M3 3h.01" }],
	["path", { d: "M7 5h.01" }],
	["path", { d: "M11 7h.01" }],
	["path", { d: "M3 7h.01" }],
	["path", { d: "M7 9h.01" }],
	["path", { d: "M3 11h.01" }],
	["rect", { width: "4", height: "4", x: "15", y: "5" }],
	["path", { d: "m19 9 2 2v10c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1V11l2-2" }],
	["path", { d: "m13 14 8-2" }],
	["path", { d: "m13 19 8-2" }],
] satisfies IconNode;

export const sprout = [
	[
		"path",
		{
			d: "M14 9.536V7a4 4 0 0 1 4-4h1.5a.5.5 0 0 1 .5.5V5a4 4 0 0 1-4 4 4 4 0 0 0-4 4c0 2 1 3 1 5a5 5 0 0 1-1 3",
		},
	],
	["path", { d: "M4 9a5 5 0 0 1 8 4 5 5 0 0 1-8-4" }],
	["path", { d: "M5 21h14" }],
] satisfies IconNode;

export const square = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
] satisfies IconNode;

export const squareActivity = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M17 12h-2l-2 5-2-10-2 5H7" }],
] satisfies IconNode;

export const squareArrowDown = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M12 8v8" }],
	["path", { d: "m8 12 4 4 4-4" }],
] satisfies IconNode;

export const squareArrowDownLeft = [
	["path", { d: "M15 15H9l6-6" }],
	["path", { d: "M9 15V9" }],
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
] satisfies IconNode;

export const squareArrowDownRight = [
	["path", { d: "M15 15 9 9" }],
	["path", { d: "M9 15h6V9" }],
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
] satisfies IconNode;

export const squareArrowLeft = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "m12 8-4 4 4 4" }],
	["path", { d: "M16 12H8" }],
] satisfies IconNode;

export const squareArrowOutDownLeft = [
	["path", { d: "M13 21h6a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6" }],
	["path", { d: "m3 21 9-9" }],
	["path", { d: "M9 21H3v-6" }],
] satisfies IconNode;

export const squareArrowOutDownRight = [
	["path", { d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6" }],
	["path", { d: "m21 21-9-9" }],
	["path", { d: "M21 15v6h-6" }],
] satisfies IconNode;

export const squareArrowOutUpLeft = [
	["path", { d: "M13 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6" }],
	["path", { d: "m3 3 9 9" }],
	["path", { d: "M3 9V3h6" }],
] satisfies IconNode;

export const squareArrowOutUpRight = [
	["path", { d: "M21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6" }],
	["path", { d: "m21 3-9 9" }],
	["path", { d: "M15 3h6v6" }],
] satisfies IconNode;

export const squareArrowRight = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M8 12h8" }],
	["path", { d: "m12 16 4-4-4-4" }],
] satisfies IconNode;

export const squareArrowRightEnter = [
	["path", { d: "m10 16 4-4-4-4" }],
	["path", { d: "M3 12h11" }],
	["path", { d: "M3 8V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3" }],
] satisfies IconNode;

export const squareArrowRightExit = [
	["path", { d: "M10 12h11" }],
	["path", { d: "m17 16 4-4-4-4" }],
	[
		"path",
		{ d: "M21 6.344V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-1.344" },
	],
] satisfies IconNode;

export const squareArrowUp = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "m16 12-4-4-4 4" }],
	["path", { d: "M12 16V8" }],
] satisfies IconNode;

export const squareArrowUpLeft = [
	["path", { d: "M15 15 9 9" }],
	["path", { d: "M9 15V9h6" }],
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
] satisfies IconNode;

export const squareArrowUpRight = [
	["path", { d: "M15 15V9H9" }],
	["path", { d: "m9 15 6-6" }],
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
] satisfies IconNode;

export const squareAsterisk = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M12 8v8" }],
	["path", { d: "m8.5 14 7-4" }],
	["path", { d: "m8.5 10 7 4" }],
] satisfies IconNode;

export const squareBookmark = [
	[
		"path",
		{
			d: "M11 3v7.751a.25.25 0 00.407.195l2.28-1.834a.5.5 0 01.627 0l2.28 1.834a.25.25 0 00.406-.195V3",
		},
	],
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
] satisfies IconNode;

export const squareBottomDashedScissors = [
	["path", { d: "M14 21h1" }],
	["path", { d: "m17 17-2.18-2.18" }],
	["path", { d: "M5 21a2 2 0 01-2-2V5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2" }],
	["path", { d: "M9 21h1" }],
	["path", { d: "M9.56 14.44 17 7" }],
	["path", { d: "M9.56 9.56 12 12" }],
	["circle", { cx: "8.5", cy: "15.5", r: "1.5" }],
	["circle", { cx: "8.5", cy: "8.5", r: "1.5" }],
] satisfies IconNode;

export const squareCenterlineDashedHorizontal = [
	["path", { d: "M8 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h3" }],
	["path", { d: "M16 3h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-3" }],
	["path", { d: "M12 20v2" }],
	["path", { d: "M12 14v2" }],
	["path", { d: "M12 8v2" }],
	["path", { d: "M12 2v2" }],
] satisfies IconNode;

export const squareCenterlineDashedVertical = [
	["path", { d: "M21 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v3" }],
	["path", { d: "M21 16v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3" }],
	["path", { d: "M4 12H2" }],
	["path", { d: "M10 12H8" }],
	["path", { d: "M16 12h-2" }],
	["path", { d: "M22 12h-2" }],
] satisfies IconNode;

export const squareChartGantt = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M9 8h7" }],
	["path", { d: "M8 12h6" }],
	["path", { d: "M11 16h5" }],
] satisfies IconNode;

export const squareCheck = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "m16 9-5.5 5.5L8 12" }],
] satisfies IconNode;

export const squareCheckBig = [
	["path", { d: "M21 10.656V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.344" }],
	["path", { d: "m9 11 3 3L22 4" }],
] satisfies IconNode;

export const squareChevronDown = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "m16 10-4 4-4-4" }],
] satisfies IconNode;

export const squareChevronLeft = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "m14 16-4-4 4-4" }],
] satisfies IconNode;

export const squareChevronRight = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "m10 8 4 4-4 4" }],
] satisfies IconNode;

export const squareChevronUp = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "m8 14 4-4 4 4" }],
] satisfies IconNode;

export const squareCode = [
	["path", { d: "m10 9-3 3 3 3" }],
	["path", { d: "m14 15 3-3-3-3" }],
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
] satisfies IconNode;

export const squareDashed = [
	["path", { d: "M5 3a2 2 0 0 0-2 2" }],
	["path", { d: "M19 3a2 2 0 0 1 2 2" }],
	["path", { d: "M21 19a2 2 0 0 1-2 2" }],
	["path", { d: "M5 21a2 2 0 0 1-2-2" }],
	["path", { d: "M9 3h1" }],
	["path", { d: "M9 21h1" }],
	["path", { d: "M14 3h1" }],
	["path", { d: "M14 21h1" }],
	["path", { d: "M3 9v1" }],
	["path", { d: "M21 9v1" }],
	["path", { d: "M3 14v1" }],
	["path", { d: "M21 14v1" }],
] satisfies IconNode;

export const squareDashedBottom = [
	["path", { d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2" }],
	["path", { d: "M9 21h1" }],
	["path", { d: "M14 21h1" }],
] satisfies IconNode;

export const squareDashedBottomCode = [
	["path", { d: "M10 9.5 8 12l2 2.5" }],
	["path", { d: "M14 21h1" }],
	["path", { d: "m14 9.5 2 2.5-2 2.5" }],
	["path", { d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2" }],
	["path", { d: "M9 21h1" }],
] satisfies IconNode;

export const squareDashedKanban = [
	["path", { d: "M8 7v7" }],
	["path", { d: "M12 7v4" }],
	["path", { d: "M16 7v9" }],
	["path", { d: "M5 3a2 2 0 0 0-2 2" }],
	["path", { d: "M9 3h1" }],
	["path", { d: "M14 3h1" }],
	["path", { d: "M19 3a2 2 0 0 1 2 2" }],
	["path", { d: "M21 9v1" }],
	["path", { d: "M21 14v1" }],
	["path", { d: "M21 19a2 2 0 0 1-2 2" }],
	["path", { d: "M14 21h1" }],
	["path", { d: "M9 21h1" }],
	["path", { d: "M5 21a2 2 0 0 1-2-2" }],
	["path", { d: "M3 14v1" }],
	["path", { d: "M3 9v1" }],
] satisfies IconNode;

export const squareDashedMousePointer = [
	[
		"path",
		{
			d: "M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z",
		},
	],
	["path", { d: "M5 3a2 2 0 0 0-2 2" }],
	["path", { d: "M19 3a2 2 0 0 1 2 2" }],
	["path", { d: "M5 21a2 2 0 0 1-2-2" }],
	["path", { d: "M9 3h1" }],
	["path", { d: "M9 21h2" }],
	["path", { d: "M14 3h1" }],
	["path", { d: "M3 9v1" }],
	["path", { d: "M21 9v2" }],
	["path", { d: "M3 14v1" }],
] satisfies IconNode;

export const squareDashedPlus = [
	["path", { d: "M5 3a2 2 0 0 0-2 2" }],
	["path", { d: "M19 3a2 2 0 0 1 2 2" }],
	["path", { d: "M21 19a2 2 0 0 1-2 2" }],
	["path", { d: "M5 21a2 2 0 0 1-2-2" }],
	["path", { d: "M9 3h1" }],
	["path", { d: "M9 21h1" }],
	["path", { d: "M14 3h1" }],
	["path", { d: "M14 21h1" }],
	["path", { d: "M3 9v1" }],
	["path", { d: "M21 9v1" }],
	["path", { d: "M3 14v1" }],
	["path", { d: "M21 14v1" }],
	["path", { d: "M8 12h8" }],
	["path", { d: "M12 8v8" }],
] satisfies IconNode;

export const squareDashedText = [
	["path", { d: "M14 21h1" }],
	["path", { d: "M14 3h1" }],
	["path", { d: "M19 3a2 2 0 0 1 2 2" }],
	["path", { d: "M21 14v1" }],
	["path", { d: "M21 19a2 2 0 0 1-2 2" }],
	["path", { d: "M21 9v1" }],
	["path", { d: "M3 14v1" }],
	["path", { d: "M3 9v1" }],
	["path", { d: "M5 21a2 2 0 0 1-2-2" }],
	["path", { d: "M5 3a2 2 0 0 0-2 2" }],
	["path", { d: "M7 12h10" }],
	["path", { d: "M7 16h6" }],
	["path", { d: "M7 8h8" }],
	["path", { d: "M9 21h1" }],
	["path", { d: "M9 3h1" }],
] satisfies IconNode;

export const squareDashedTopSolid = [
	["path", { d: "M14 21h1" }],
	["path", { d: "M21 14v1" }],
	["path", { d: "M21 19a2 2 0 0 1-2 2" }],
	["path", { d: "M21 9v1" }],
	["path", { d: "M3 14v1" }],
	["path", { d: "M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2" }],
	["path", { d: "M3 9v1" }],
	["path", { d: "M5 21a2 2 0 0 1-2-2" }],
	["path", { d: "M9 21h1" }],
] satisfies IconNode;

export const squareDashedX = [
	["path", { d: "M14 21h1" }],
	["path", { d: "M14 3h1" }],
	["path", { d: "M19 3a2 2 0 012 2" }],
	["path", { d: "M21 14v1" }],
	["path", { d: "M21 19a2 2 0 01-2 2" }],
	["path", { d: "M21 9v1" }],
	["path", { d: "M3 14v1" }],
	["path", { d: "M3 9v1" }],
	["path", { d: "M5 21a2 2 0 01-2-2" }],
	["path", { d: "M5 3a2 2 0 00-2 2" }],
	["path", { d: "m9 15 6-6" }],
	["path", { d: "M9 21h1" }],
	["path", { d: "M9 3h1" }],
	["path", { d: "m9 9 6 6" }],
] satisfies IconNode;

export const squareDashedXCorner = [
	["path", { d: "M14 3h1" }],
	["path", { d: "m16 16 5 5" }],
	["path", { d: "M19 3a2 2 0 012 2" }],
	["path", { d: "m21 16-5 5" }],
	["path", { d: "M21 9v1" }],
	["path", { d: "M3 14v1" }],
	["path", { d: "M3 9v1" }],
	["path", { d: "M5 21a2 2 0 01-2-2" }],
	["path", { d: "M5 3a2 2 0 00-2 2" }],
	["path", { d: "M9 21h1" }],
	["path", { d: "M9 3h1" }],
] satisfies IconNode;

export const squareDimensions = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M12 7H7v5" }],
	["path", { d: "M12 17h5v-5" }],
] satisfies IconNode;

export const squareDivide = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
	["line", { x1: "8", x2: "16", y1: "12", y2: "12" }],
	["line", { x1: "12", x2: "12", y1: "16", y2: "16" }],
	["line", { x1: "12", x2: "12", y1: "8", y2: "8" }],
] satisfies IconNode;

export const squareDot = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["circle", { cx: "12", cy: "12", r: "1" }],
] satisfies IconNode;

export const squareEqual = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M7 10h10" }],
	["path", { d: "M7 14h10" }],
] satisfies IconNode;

export const squareExclamationPoint = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["line", { x1: "12", x2: "12", y1: "8", y2: "12" }],
	["line", { x1: "12", x2: "12.01", y1: "16", y2: "16" }],
] satisfies IconNode;

export const squareFunction = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
	["path", { d: "M9 17c2 0 2.8-1 2.8-2.8V10c0-2 1-3.3 3.2-3" }],
	["path", { d: "M9 11.2h5.7" }],
] satisfies IconNode;

export const squareKanban = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M8 7v7" }],
	["path", { d: "M12 7v4" }],
	["path", { d: "M16 7v9" }],
] satisfies IconNode;

export const squareLibrary = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M7 7v10" }],
	["path", { d: "M11 7v10" }],
	["path", { d: "m15 7 2 10" }],
] satisfies IconNode;

export const squareM = [
	[
		"path",
		{ d: "M8 16V8.5a.5.5 0 0 1 .9-.3l2.7 3.599a.5.5 0 0 0 .8 0l2.7-3.6a.5.5 0 0 1 .9.3V16" },
	],
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
] satisfies IconNode;

export const squareMenu = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M7 8h10" }],
	["path", { d: "M7 12h10" }],
	["path", { d: "M7 16h10" }],
] satisfies IconNode;

export const squareMinus = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M8 12h8" }],
] satisfies IconNode;

export const squareMousePointer = [
	[
		"path",
		{
			d: "M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z",
		},
	],
	["path", { d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6" }],
] satisfies IconNode;

export const squareOff = [
	["path", { d: "M20.4 20.4a2 2 0 01-1.4.6H5a2 2 0 01-2-2V5a2 2 0 01.59-1.41" }],
	["path", { d: "M21 15.3V5a2 2 0 00-2-2H8.7" }],
	["path", { d: "M22 22 2 2" }],
] satisfies IconNode;

export const squareParking = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M9 17V7h4a3 3 0 0 1 0 6H9" }],
] satisfies IconNode;

export const squareParkingOff = [
	["path", { d: "M3.6 3.6A2 2 0 0 1 5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-.59 1.41" }],
	["path", { d: "M3 8.7V19a2 2 0 0 0 2 2h10.3" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M13 13a3 3 0 1 0 0-6H9v2" }],
	["path", { d: "M9 17v-2.3" }],
] satisfies IconNode;

export const squarePause = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["line", { x1: "10", x2: "10", y1: "15", y2: "9" }],
	["line", { x1: "14", x2: "14", y1: "15", y2: "9" }],
] satisfies IconNode;

export const squarePen = [
	["path", { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }],
	[
		"path",
		{
			d: "M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z",
		},
	],
] satisfies IconNode;

export const squarePercent = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "m15 9-6 6" }],
	["path", { d: "M9 9h.01" }],
	["path", { d: "M15 15h.01" }],
] satisfies IconNode;

export const squarePi = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M7 7h10" }],
	["path", { d: "M10 7v10" }],
	["path", { d: "M16 17a2 2 0 0 1-2-2V7" }],
] satisfies IconNode;

export const squarePilcrow = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M12 12H9.5a2.5 2.5 0 0 1 0-5H17" }],
	["path", { d: "M12 7v10" }],
	["path", { d: "M16 7v10" }],
] satisfies IconNode;

export const squarePlay = [
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
	[
		"path",
		{
			d: "M9 9.003a1 1 0 0 1 1.517-.859l4.997 2.997a1 1 0 0 1 0 1.718l-4.997 2.997A1 1 0 0 1 9 14.996z",
		},
	],
] satisfies IconNode;

export const squarePlus = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M8 12h8" }],
	["path", { d: "M12 8v8" }],
] satisfies IconNode;

export const squarePower = [
	["path", { d: "M12 7v4" }],
	["path", { d: "M7.998 9.003a5 5 0 1 0 8-.005" }],
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
] satisfies IconNode;

export const squareRadical = [
	["path", { d: "M7 12h2l2 5 2-10h4" }],
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
] satisfies IconNode;

export const squareRoundCorner = [
	["path", { d: "M21 11a8 8 0 0 0-8-8" }],
	["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" }],
] satisfies IconNode;

export const squareScissors = [
	["path", { d: "m17 17-2.18-2.18" }],
	["path", { d: "M9.56 14.44 17 7" }],
	["path", { d: "M9.56 9.56 12 12" }],
	["circle", { cx: "8.5", cy: "15.5", r: "1.5" }],
	["circle", { cx: "8.5", cy: "8.5", r: "1.5" }],
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
] satisfies IconNode;

export const squareSigma = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M16 8.9V7H8l4 5-4 5h8v-1.9" }],
] satisfies IconNode;

export const squareSlash = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["line", { x1: "9", x2: "15", y1: "15", y2: "9" }],
] satisfies IconNode;

export const squareSparkles = [
	["path", { d: "M11 15H7" }],
	[
		"path",
		{
			d: "M15.41 2.49a.6.6 0 011.18 0l.63 3.334a1.2 1.2 0 00.956.955l3.334.631a.6.6 0 010 1.18l-3.334.63a1.2 1.2 0 00-.955.956l-.631 3.334a.6.6 0 01-1.18 0l-.63-3.334a1.2 1.2 0 00-.956-.955L10.49 8.59a.6.6 0 010-1.18l3.334-.63a1.2 1.2 0 00.955-.956z",
		},
	],
	["path", { d: "M21 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h6" }],
	["path", { d: "M9 13v4" }],
] satisfies IconNode;

export const squareSplitHorizontal = [
	["path", { d: "M12 2v20" }],
	["path", { d: "M16 3h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-3" }],
	["path", { d: "M8 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3" }],
] satisfies IconNode;

export const squareSplitVertical = [
	["path", { d: "M2 12h20" }],
	["path", { d: "M21 16v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3" }],
	["path", { d: "M3 8V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3" }],
] satisfies IconNode;

export const squareSquare = [
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
	["rect", { x: "8", y: "8", width: "8", height: "8", rx: "1" }],
] satisfies IconNode;

export const squareStack = [
	["path", { d: "M4 10c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2" }],
	["path", { d: "M10 16c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2" }],
	["rect", { width: "8", height: "8", x: "14", y: "14", rx: "2" }],
] satisfies IconNode;

export const squareStar = [
	[
		"path",
		{
			d: "M11.035 7.69a1 1 0 0 1 1.909.024l.737 1.452a1 1 0 0 0 .737.535l1.634.256a1 1 0 0 1 .588 1.806l-1.172 1.168a1 1 0 0 0-.282.866l.259 1.613a1 1 0 0 1-1.541 1.134l-1.465-.75a1 1 0 0 0-.912 0l-1.465.75a1 1 0 0 1-1.539-1.133l.258-1.613a1 1 0 0 0-.282-.866l-1.156-1.153a1 1 0 0 1 .572-1.822l1.633-.256a1 1 0 0 0 .737-.535z",
		},
	],
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
] satisfies IconNode;

export const squareStop = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["rect", { x: "9", y: "9", width: "6", height: "6", rx: "1" }],
] satisfies IconNode;

export const squareTerminal = [
	["path", { d: "m7 11 2-2-2-2" }],
	["path", { d: "M11 13h4" }],
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
] satisfies IconNode;

export const squareText = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M7 8h8" }],
	["path", { d: "M7 12h10" }],
	["path", { d: "M7 16h6" }],
] satisfies IconNode;

export const squareUser = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["circle", { cx: "12", cy: "10", r: "3" }],
	["path", { d: "M7 21v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2" }],
] satisfies IconNode;

export const squareUserRound = [
	["path", { d: "M18 21a6 6 0 0 0-12 0" }],
	["circle", { cx: "12", cy: "11", r: "4" }],
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
] satisfies IconNode;

export const squareX = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
	["path", { d: "m15 9-6 6" }],
	["path", { d: "m9 9 6 6" }],
] satisfies IconNode;

export const squaresExclude = [
	[
		"path",
		{
			d: "M16 12v2a2 2 0 0 1-2 2H9a1 1 0 0 0-1 1v3a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2h0",
		},
	],
	[
		"path",
		{
			d: "M4 16a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v3a1 1 0 0 1-1 1h-5a2 2 0 0 0-2 2v2",
		},
	],
] satisfies IconNode;

export const squaresIntersect = [
	["path", { d: "M10 22a2 2 0 0 1-2-2" }],
	["path", { d: "M14 2a2 2 0 0 1 2 2" }],
	["path", { d: "M16 22h-2" }],
	["path", { d: "M2 10V8" }],
	["path", { d: "M2 4a2 2 0 0 1 2-2" }],
	["path", { d: "M20 8a2 2 0 0 1 2 2" }],
	["path", { d: "M22 14v2" }],
	["path", { d: "M22 20a2 2 0 0 1-2 2" }],
	["path", { d: "M4 16a2 2 0 0 1-2-2" }],
	["path", { d: "M8 10a2 2 0 0 1 2-2h5a1 1 0 0 1 1 1v5a2 2 0 0 1-2 2H9a1 1 0 0 1-1-1z" }],
	["path", { d: "M8 2h2" }],
] satisfies IconNode;

export const squaresSubtract = [
	["path", { d: "M10 22a2 2 0 0 1-2-2" }],
	["path", { d: "M16 22h-2" }],
	[
		"path",
		{
			d: "M16 4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-5a2 2 0 0 1 2-2h5a1 1 0 0 0 1-1z",
		},
	],
	["path", { d: "M20 8a2 2 0 0 1 2 2" }],
	["path", { d: "M22 14v2" }],
	["path", { d: "M22 20a2 2 0 0 1-2 2" }],
] satisfies IconNode;

export const squaresUnite = [
	[
		"path",
		{
			d: "M4 16a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v3a1 1 0 0 0 1 1h3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2v-3a1 1 0 0 0-1-1z",
		},
	],
] satisfies IconNode;

export const squircle = [
	["path", { d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9-9 9-9-1.8-9-9 1.8-9 9-9" }],
] satisfies IconNode;

export const squircleDashed = [
	["path", { d: "M13.77 3.043a34 34 0 0 0-3.54 0" }],
	["path", { d: "M13.771 20.956a33 33 0 0 1-3.541.001" }],
	["path", { d: "M20.18 17.74c-.51 1.15-1.29 1.93-2.439 2.44" }],
	["path", { d: "M20.18 6.259c-.51-1.148-1.291-1.929-2.44-2.438" }],
	["path", { d: "M20.957 10.23a33 33 0 0 1 0 3.54" }],
	["path", { d: "M3.043 10.23a34 34 0 0 0 .001 3.541" }],
	["path", { d: "M6.26 20.179c-1.15-.508-1.93-1.29-2.44-2.438" }],
	["path", { d: "M6.26 3.82c-1.149.51-1.93 1.291-2.44 2.44" }],
] satisfies IconNode;

export const squirrel = [
	["path", { d: "M15.236 22a3 3 0 0 0-2.2-5" }],
	["path", { d: "M16 20a3 3 0 0 1 3-3h1a2 2 0 0 0 2-2v-2a4 4 0 0 0-4-4V4" }],
	["path", { d: "M18 13h.01" }],
	[
		"path",
		{
			d: "M18 6a4 4 0 0 0-4 4 7 7 0 0 0-7 7c0-5 4-5 4-10.5a4.5 4.5 0 1 0-9 0 2.5 2.5 0 0 0 5 0C7 10 3 11 3 17c0 2.8 2.2 5 5 5h10",
		},
	],
] satisfies IconNode;

export const stamp = [
	["path", { d: "M14 13V8.5C14 7 15 7 15 5a3 3 0 0 0-6 0c0 2 1 2 1 3.5V13" }],
	[
		"path",
		{
			d: "M20 15.5a2.5 2.5 0 0 0-2.5-2.5h-11A2.5 2.5 0 0 0 4 15.5V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1z",
		},
	],
	["path", { d: "M5 22h14" }],
] satisfies IconNode;

export const star = [
	[
		"path",
		{
			d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
		},
	],
] satisfies IconNode;

export const starCheck = [
	[
		"path",
		{
			d: "m19.06 12.501 2.78-2.707a.53.53 0 0 0-.294-.905l-5.166-.755a2.1 2.1 0 0 1-1.595-1.16l-2.31-4.68a.53.53 0 0 0-.95.001L9.216 6.974a2.1 2.1 0 0 1-1.597 1.16l-5.165.755a.53.53 0 0 0-.294.906l3.736 3.637a2.1 2.1 0 0 1 .611 1.879l-.88 5.139a.53.53 0 0 0 .769.56l4.617-2.428.027-.014",
		},
	],
	["path", { d: "m15 18 2 2 4-4" }],
] satisfies IconNode;

export const starHalf = [
	[
		"path",
		{
			d: "M12 18.338a2.1 2.1 0 0 0-.987.244L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16l2.309-4.679A.53.53 0 0 1 12 2",
		},
	],
] satisfies IconNode;

export const starMinus = [
	["path", { d: "M15 18h6" }],
	[
		"path",
		{
			d: "M17.688 14a2.1 2.1 0 0 1 .416-.568l3.736-3.638a.53.53 0 0 0-.294-.905l-5.166-.755a2.1 2.1 0 0 1-1.595-1.16l-2.31-4.68a.53.53 0 0 0-.95.001L9.216 6.974a2.1 2.1 0 0 1-1.597 1.16l-5.165.755a.53.53 0 0 0-.294.906l3.736 3.637a2.1 2.1 0 0 1 .611 1.879l-.88 5.139a.53.53 0 0 0 .769.56l4.617-2.428.027-.014",
		},
	],
] satisfies IconNode;

export const starOff = [
	[
		"path",
		{
			d: "m10.344 4.688 1.181-2.393a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.237 3.152",
		},
	],
	[
		"path",
		{
			d: "m17.945 17.945.43 2.505a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a8 8 0 0 0 .4-.099",
		},
	],
	["path", { d: "m2 2 20 20" }],
] satisfies IconNode;

export const starPlus = [
	[
		"path",
		{
			d: "M11.013 18.582 6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16l2.309-4.679a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904L20 11.5",
		},
	],
	["path", { d: "M15 18h6" }],
	["path", { d: "M18 15v6" }],
] satisfies IconNode;

export const starX = [
	["path", { d: "m15.5 15.5 5 5" }],
	[
		"path",
		{
			d: "m20.063 11.525 1.777-1.731a.53.53 0 0 0-.294-.905l-5.166-.755a2.1 2.1 0 0 1-1.595-1.16l-2.31-4.68a.53.53 0 0 0-.95.001L9.216 6.974a2.1 2.1 0 0 1-1.597 1.16l-5.165.755a.53.53 0 0 0-.294.906l3.736 3.637a2.1 2.1 0 0 1 .611 1.879l-.88 5.139a.53.53 0 0 0 .769.56l4.617-2.428a2.1 2.1 0 0 1 .987-.243 2 2 0 0 1 .132.004",
		},
	],
	["path", { d: "m20.5 15.5-5 5" }],
] satisfies IconNode;

export const stepBack = [
	[
		"path",
		{
			d: "M13.971 4.285A2 2 0 0 1 17 6v12a2 2 0 0 1-3.029 1.715l-9.997-5.998a2 2 0 0 1-.003-3.432z",
		},
	],
	["path", { d: "M21 20V4" }],
] satisfies IconNode;

export const stepForward = [
	[
		"path",
		{ d: "M10.029 4.285A2 2 0 0 0 7 6v12a2 2 0 0 0 3.029 1.715l9.997-5.998a2 2 0 0 0 .003-3.432z" },
	],
	["path", { d: "M3 4v16" }],
] satisfies IconNode;

export const stethoscope = [
	["path", { d: "M11 2v2" }],
	["path", { d: "M5 2v2" }],
	["path", { d: "M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1" }],
	["path", { d: "M8 15a6 6 0 0 0 12 0v-3" }],
	["circle", { cx: "20", cy: "10", r: "2" }],
] satisfies IconNode;

export const sticker = [
	[
		"path",
		{
			d: "M21 9a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 15 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2z",
		},
	],
	["path", { d: "M15 3v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M8 13h.01" }],
	["path", { d: "M16 13h.01" }],
	["path", { d: "M10 16s.8 1 2 1c1.3 0 2-1 2-1" }],
] satisfies IconNode;

export const stickyNote = [
	[
		"path",
		{
			d: "M21 9a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 15 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2z",
		},
	],
	["path", { d: "M15 3v5a1 1 0 0 0 1 1h5" }],
] satisfies IconNode;

export const stickyNoteCheck = [
	["path", { d: "m15 19 2 2 4-4" }],
	["path", { d: "M15 3v5a1 1 0 0 0 1 1h5" }],
	[
		"path",
		{
			d: "M21 13V9a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 15 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6.5",
		},
	],
] satisfies IconNode;

export const stickyNoteMinus = [
	["path", { d: "M15 3v5a1 1 0 0 0 1 1h5" }],
	[
		"path",
		{
			d: "M21 14V9a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 15 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.35",
		},
	],
	["path", { d: "M21 18h-6" }],
] satisfies IconNode;

export const stickyNoteOff = [
	["path", { d: "M15 3v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M3.586 3.586A2 2 0 0 0 3 5v14a2 2 0 0 0 2 2h14a2 2 0 0 0 1.414-.586" }],
	["path", { d: "M8.656 3H15a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 21 9v6.344" }],
] satisfies IconNode;

export const stickyNotePlus = [
	["path", { d: "M15 3v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "M18 15v6" }],
	[
		"path",
		{
			d: "M21 12.356V9a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 15 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.355",
		},
	],
	["path", { d: "M21 18h-6" }],
] satisfies IconNode;

export const stickyNoteX = [
	["path", { d: "M15 3v5a1 1 0 0 0 1 1h5" }],
	["path", { d: "m16 16 5 5" }],
	[
		"path",
		{
			d: "M21 12V9a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 15 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7",
		},
	],
	["path", { d: "m21 16-5 5" }],
] satisfies IconNode;

export const stickyNotes = [
	[
		"path",
		{
			d: "M10 8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 16 14v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2z",
		},
	],
	["path", { d: "M10 8v5a1 1 0 0 0 1 1h5" }],
	[
		"path",
		{
			d: "M8 4a2 2 0 0 1 2-2h6a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 22 8v6a2 2 0 0 1-2 2",
		},
	],
	["path", { d: "M16 2v5a1 1 0 0 0 1 1h5" }],
] satisfies IconNode;

export const stone = [
	[
		"path",
		{
			d: "M11.264 2.205A4 4 0 0 0 6.42 4.211l-4 8a4 4 0 0 0 1.359 5.117l6 4a4 4 0 0 0 4.438 0l6-4a4 4 0 0 0 1.576-4.592l-2-6a4 4 0 0 0-2.53-2.53z",
		},
	],
	["path", { d: "M11.99 22 14 12l7.822 3.184" }],
	["path", { d: "M14 12 8.47 2.302" }],
] satisfies IconNode;

export const store = [
	["path", { d: "M15 21v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5" }],
	[
		"path",
		{
			d: "M17.774 10.31a1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.451 0 1.12 1.12 0 0 0-1.548 0 2.5 2.5 0 0 1-3.452 0 1.12 1.12 0 0 0-1.549 0 2.5 2.5 0 0 1-3.77-3.248l2.889-4.184A2 2 0 0 1 7 2h10a2 2 0 0 1 1.653.873l2.895 4.192a2.5 2.5 0 0 1-3.774 3.244",
		},
	],
	["path", { d: "M4 10.95V19a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8.05" }],
] satisfies IconNode;

export const stretchHorizontal = [
	["rect", { width: "20", height: "6", x: "2", y: "4", rx: "2" }],
	["rect", { width: "20", height: "6", x: "2", y: "14", rx: "2" }],
] satisfies IconNode;

export const stretchVertical = [
	["rect", { width: "6", height: "20", x: "4", y: "2", rx: "2" }],
	["rect", { width: "6", height: "20", x: "14", y: "2", rx: "2" }],
] satisfies IconNode;

export const strikethrough = [
	["path", { d: "M16 4H9a3 3 0 0 0-2.83 4" }],
	["path", { d: "M14 12a4 4 0 0 1 0 8H6" }],
	["line", { x1: "4", x2: "20", y1: "12", y2: "12" }],
] satisfies IconNode;

export const subscript = [
	["path", { d: "m4 5 8 8" }],
	["path", { d: "m12 5-8 8" }],
	[
		"path",
		{
			d: "M20 19h-4c0-1.5.44-2 1.5-2.5S20 15.33 20 14c0-.47-.17-.93-.48-1.29a2.11 2.11 0 0 0-2.62-.44c-.42.24-.74.62-.9 1.07",
		},
	],
] satisfies IconNode;

export const summary = [
	["path", { d: "M15 4H7" }],
	["path", { d: "m18 16 3 3-3 3" }],
	["path", { d: "M3 4v13a2 2 0 0 0 2 2h16" }],
	["path", { d: "M7 14h7" }],
	["path", { d: "M7 9h12" }],
] satisfies IconNode;

export const sun = [
	["circle", { cx: "12", cy: "12", r: "4" }],
	["path", { d: "M12 2v2" }],
	["path", { d: "M12 20v2" }],
	["path", { d: "m4.93 4.93 1.41 1.41" }],
	["path", { d: "m17.66 17.66 1.41 1.41" }],
	["path", { d: "M2 12h2" }],
	["path", { d: "M20 12h2" }],
	["path", { d: "m6.34 17.66-1.41 1.41" }],
	["path", { d: "m19.07 4.93-1.41 1.41" }],
] satisfies IconNode;

export const sunDim = [
	["circle", { cx: "12", cy: "12", r: "4" }],
	["path", { d: "M12 4h.01" }],
	["path", { d: "M20 12h.01" }],
	["path", { d: "M12 20h.01" }],
	["path", { d: "M4 12h.01" }],
	["path", { d: "M17.657 6.343h.01" }],
	["path", { d: "M17.657 17.657h.01" }],
	["path", { d: "M6.343 17.657h.01" }],
	["path", { d: "M6.343 6.343h.01" }],
] satisfies IconNode;

export const sunMedium = [
	["circle", { cx: "12", cy: "12", r: "4" }],
	["path", { d: "M12 3v1" }],
	["path", { d: "M12 20v1" }],
	["path", { d: "M3 12h1" }],
	["path", { d: "M20 12h1" }],
	["path", { d: "m18.364 5.636-.707.707" }],
	["path", { d: "m6.343 17.657-.707.707" }],
	["path", { d: "m5.636 5.636.707.707" }],
	["path", { d: "m17.657 17.657.707.707" }],
] satisfies IconNode;

export const sunMoon = [
	["path", { d: "M12 2v2" }],
	[
		"path",
		{
			d: "M14.837 16.385a6 6 0 1 1-7.223-7.222c.624-.147.97.66.715 1.248a4 4 0 0 0 5.26 5.259c.589-.255 1.396.09 1.248.715",
		},
	],
	["path", { d: "M16 12a4 4 0 0 0-4-4" }],
	["path", { d: "m19 5-1.256 1.256" }],
	["path", { d: "M20 12h2" }],
] satisfies IconNode;

export const sunSnow = [
	["path", { d: "M10 21v-1" }],
	["path", { d: "M10 4V3" }],
	["path", { d: "M10 9a3 3 0 0 0 0 6" }],
	["path", { d: "m14 20 1.25-2.5L18 18" }],
	["path", { d: "m14 4 1.25 2.5L18 6" }],
	["path", { d: "m17 21-3-6 1.5-3H22" }],
	["path", { d: "m17 3-3 6 1.5 3" }],
	["path", { d: "M2 12h1" }],
	["path", { d: "m20 10-1.5 2 1.5 2" }],
	["path", { d: "m3.64 18.36.7-.7" }],
	["path", { d: "m4.34 6.34-.7-.7" }],
] satisfies IconNode;

export const sunrise = [
	["path", { d: "M12 2v8" }],
	["path", { d: "m4.93 10.93 1.41 1.41" }],
	["path", { d: "M2 18h2" }],
	["path", { d: "M20 18h2" }],
	["path", { d: "m19.07 10.93-1.41 1.41" }],
	["path", { d: "M22 22H2" }],
	["path", { d: "m8 6 4-4 4 4" }],
	["path", { d: "M16 18a4 4 0 0 0-8 0" }],
] satisfies IconNode;

export const sunset = [
	["path", { d: "M12 10V2" }],
	["path", { d: "m4.93 10.93 1.41 1.41" }],
	["path", { d: "M2 18h2" }],
	["path", { d: "M20 18h2" }],
	["path", { d: "m19.07 10.93-1.41 1.41" }],
	["path", { d: "M22 22H2" }],
	["path", { d: "m16 6-4 4-4-4" }],
	["path", { d: "M16 18a4 4 0 0 0-8 0" }],
] satisfies IconNode;

export const superscript = [
	["path", { d: "m4 19 8-8" }],
	["path", { d: "m12 19-8-8" }],
	[
		"path",
		{
			d: "M20 12h-4c0-1.5.442-2 1.5-2.5S20 8.334 20 7.002c0-.472-.17-.93-.484-1.29a2.105 2.105 0 0 0-2.617-.436c-.42.239-.738.614-.899 1.06",
		},
	],
] satisfies IconNode;

export const swatchBook = [
	["path", { d: "M11 17a4 4 0 0 1-8 0V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2Z" }],
	["path", { d: "M16.7 13H19a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H7" }],
	["path", { d: "M 7 17h.01" }],
	[
		"path",
		{ d: "m11 8 2.3-2.3a2.4 2.4 0 0 1 3.404.004L18.6 7.6a2.4 2.4 0 0 1 .026 3.434L9.9 19.8" },
	],
] satisfies IconNode;

export const swissFranc = [
	["path", { d: "M10 21V3h8" }],
	["path", { d: "M6 16h9" }],
	["path", { d: "M10 9.5h7" }],
] satisfies IconNode;

export const switchCamera = [
	["path", { d: "M11 19H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h5" }],
	["path", { d: "M13 5h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-5" }],
	["circle", { cx: "12", cy: "12", r: "3" }],
	["path", { d: "m18 22-3-3 3-3" }],
	["path", { d: "m6 2 3 3-3 3" }],
] satisfies IconNode;

export const sword = [
	["path", { d: "m11 19-6-6" }],
	["path", { d: "m5 21-2-2" }],
	["path", { d: "m8 16-4 4" }],
	["path", { d: "M9.5 17.5 20.414 6.586A2 2 0 0021 5.172V3h-2.172a2 2 0 00-1.414.586L6.5 14.5" }],
] satisfies IconNode;

export const swords = [
	["path", { d: "m13 19 6-6" }],
	["path", { d: "M14.5 17.5 3.586 6.586A2 2 0 013 5.172V3h2.172a2 2 0 011.414.586L17.5 14.5" }],
	[
		"path",
		{ d: "m14.828 6.172 2.586-2.586A2 2 0 0118.828 3H21v2.172a2 2 0 01-.586 1.414l-2.586 2.586" },
	],
	["path", { d: "m16 16 4 4" }],
	["path", { d: "m19 21 2-2" }],
	["path", { d: "m5 14 4 4" }],
	["path", { d: "m5 21-2-2" }],
	["path", { d: "M7.5 16.5 4 20" }],
] satisfies IconNode;

export const syringe = [
	["path", { d: "m18 2 4 4" }],
	["path", { d: "m17 7 3-3" }],
	["path", { d: "M19 9 8.7 19.3c-1 1-2.5 1-3.4 0l-.6-.6c-1-1-1-2.5 0-3.4L15 5" }],
	["path", { d: "m9 11 4 4" }],
	["path", { d: "m5 19-3 3" }],
	["path", { d: "m14 4 6 6" }],
] satisfies IconNode;

export const table = [
	["path", { d: "M12 3v18" }],
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M3 9h18" }],
	["path", { d: "M3 15h18" }],
] satisfies IconNode;

export const table2 = [
	["path", { d: "M3 9h18" }],
	["path", { d: "M9 3v18" }],
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
] satisfies IconNode;

export const tableCellsMerge = [
	["path", { d: "M12 21v-6" }],
	["path", { d: "M12 9V3" }],
	["path", { d: "M3 15h18" }],
	["path", { d: "M3 9h18" }],
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
] satisfies IconNode;

export const tableCellsSplit = [
	["path", { d: "M12 15V9" }],
	["path", { d: "M3 15h18" }],
	["path", { d: "M3 9h18" }],
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
] satisfies IconNode;

export const tableColumnsSplit = [
	["path", { d: "M14 14v2" }],
	["path", { d: "M14 20v2" }],
	["path", { d: "M14 2v2" }],
	["path", { d: "M14 8v2" }],
	["path", { d: "M2 15h8" }],
	["path", { d: "M2 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H2" }],
	["path", { d: "M2 9h8" }],
	["path", { d: "M22 15h-4" }],
	["path", { d: "M22 3h-2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2" }],
	["path", { d: "M22 9h-4" }],
	["path", { d: "M5 3v18" }],
] satisfies IconNode;

export const tableOfContents = [
	["path", { d: "M16 5H3" }],
	["path", { d: "M16 12H3" }],
	["path", { d: "M16 19H3" }],
	["path", { d: "M21 5h.01" }],
	["path", { d: "M21 12h.01" }],
	["path", { d: "M21 19h.01" }],
] satisfies IconNode;

export const tableProperties = [
	["path", { d: "M15 3v18" }],
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["path", { d: "M21 9H3" }],
	["path", { d: "M21 15H3" }],
] satisfies IconNode;

export const tableRowsSplit = [
	["path", { d: "M14 10h2" }],
	["path", { d: "M15 22v-8" }],
	["path", { d: "M15 2v4" }],
	["path", { d: "M2 10h2" }],
	["path", { d: "M20 10h2" }],
	["path", { d: "M3 19h18" }],
	["path", { d: "M3 22v-6a2 2 135 0 1 2-2h14a2 2 45 0 1 2 2v6" }],
	["path", { d: "M3 2v2a2 2 45 0 0 2 2h14a2 2 135 0 0 2-2V2" }],
	["path", { d: "M8 10h2" }],
	["path", { d: "M9 22v-8" }],
	["path", { d: "M9 2v4" }],
] satisfies IconNode;

export const tablet = [
	["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", ry: "2" }],
	["line", { x1: "12", x2: "12.01", y1: "18", y2: "18" }],
] satisfies IconNode;

export const tabletSmartphone = [
	["rect", { width: "10", height: "14", x: "3", y: "8", rx: "2" }],
	["path", { d: "M5 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2.4" }],
	["path", { d: "M8 18h.01" }],
] satisfies IconNode;

export const tablets = [
	["circle", { cx: "7", cy: "7", r: "5" }],
	["circle", { cx: "17", cy: "17", r: "5" }],
	["path", { d: "M12 17h10" }],
	["path", { d: "m3.46 10.54 7.08-7.08" }],
] satisfies IconNode;

export const tag = [
	[
		"path",
		{
			d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z",
		},
	],
	["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor" }],
] satisfies IconNode;

export const tagPlus = [
	["path", { d: "M16 13h6" }],
	[
		"path",
		{
			d: "m16.5 6.5-3.914-3.914A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l1.79-1.79",
		},
	],
	["path", { d: "M19 10v6" }],
	["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor" }],
] satisfies IconNode;

export const tagX = [
	[
		"path",
		{
			d: "m16.5 6.5-3.914-3.914A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.43 2.43 0 0 0 3.42 0l1.79-1.79",
		},
	],
	["path", { d: "m16.5 10.5 5 5" }],
	["path", { d: "m21.5 10.5-5 5" }],
	["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor" }],
] satisfies IconNode;

export const tags = [
	[
		"path",
		{
			d: "M13.172 2a2 2 0 0 1 1.414.586l6.71 6.71a2.4 2.4 0 0 1 0 3.408l-4.592 4.592a2.4 2.4 0 0 1-3.408 0l-6.71-6.71A2 2 0 0 1 6 9.172V3a1 1 0 0 1 1-1z",
		},
	],
	["path", { d: "M2 7v6.172a2 2 0 0 0 .586 1.414l6.71 6.71a2.4 2.4 0 0 0 3.191.193" }],
	["circle", { cx: "10.5", cy: "6.5", r: ".5", fill: "currentColor" }],
] satisfies IconNode;

export const tally1 = [["path", { d: "M4 4v16" }]] satisfies IconNode;

export const tally2 = [
	["path", { d: "M4 4v16" }],
	["path", { d: "M9 4v16" }],
] satisfies IconNode;

export const tally3 = [
	["path", { d: "M4 4v16" }],
	["path", { d: "M9 4v16" }],
	["path", { d: "M14 4v16" }],
] satisfies IconNode;

export const tally4 = [
	["path", { d: "M4 4v16" }],
	["path", { d: "M9 4v16" }],
	["path", { d: "M14 4v16" }],
	["path", { d: "M19 4v16" }],
] satisfies IconNode;

export const tally5 = [
	["path", { d: "M4 4v16" }],
	["path", { d: "M9 4v16" }],
	["path", { d: "M14 4v16" }],
	["path", { d: "M19 4v16" }],
	["path", { d: "M22 6 2 18" }],
] satisfies IconNode;

export const tangent = [
	["circle", { cx: "17", cy: "4", r: "2" }],
	["path", { d: "M15.59 5.41 5.41 15.59" }],
	["circle", { cx: "4", cy: "17", r: "2" }],
	["path", { d: "M12 22s-4-9-1.5-11.5S22 12 22 12" }],
] satisfies IconNode;

export const target = [
	["circle", { cx: "12", cy: "12", r: "10" }],
	["circle", { cx: "12", cy: "12", r: "6" }],
	["circle", { cx: "12", cy: "12", r: "2" }],
] satisfies IconNode;

export const telescope = [
	[
		"path",
		{
			d: "m10.065 12.493-6.18 1.318a.934.934 0 0 1-1.108-.702l-.537-2.15a1.07 1.07 0 0 1 .691-1.265l13.504-4.44",
		},
	],
	["path", { d: "m13.56 11.747 4.332-.924" }],
	["path", { d: "m16 21-3.105-6.21" }],
	[
		"path",
		{
			d: "M16.485 5.94a2 2 0 0 1 1.455-2.425l1.09-.272a1 1 0 0 1 1.212.727l1.515 6.06a1 1 0 0 1-.727 1.213l-1.09.272a2 2 0 0 1-2.425-1.455z",
		},
	],
	["path", { d: "m6.158 8.633 1.114 4.456" }],
	["path", { d: "m8 21 3.105-6.21" }],
	["circle", { cx: "12", cy: "13", r: "2" }],
] satisfies IconNode;

export const tent = [
	["path", { d: "M3.5 21 14 3" }],
	["path", { d: "M20.5 21 10 3" }],
	["path", { d: "M15.5 21 12 15l-3.5 6" }],
	["path", { d: "M2 21h20" }],
] satisfies IconNode;

export const tentTree = [
	["circle", { cx: "4", cy: "4", r: "2" }],
	["path", { d: "m14 5 3-3 3 3" }],
	["path", { d: "m14 10 3-3 3 3" }],
	["path", { d: "M17 14V2" }],
	["path", { d: "M17 14H7l-5 8h20Z" }],
	["path", { d: "M8 14v8" }],
	["path", { d: "m9 14 5 8" }],
] satisfies IconNode;

export const terminal = [
	["path", { d: "M12 19h8" }],
	["path", { d: "m4 17 6-6-6-6" }],
] satisfies IconNode;

export const testTube = [
	["path", { d: "M14.5 2v17.5c0 1.4-1.1 2.5-2.5 2.5c-1.4 0-2.5-1.1-2.5-2.5V2" }],
	["path", { d: "M8.5 2h7" }],
	["path", { d: "M14.5 16h-5" }],
] satisfies IconNode;

export const testTubeDiagonal = [
	["path", { d: "M21 7 6.82 21.18a2.83 2.83 0 0 1-3.99-.01a2.83 2.83 0 0 1 0-4L17 3" }],
	["path", { d: "m16 2 6 6" }],
	["path", { d: "M12 16H4" }],
] satisfies IconNode;

export const testTubes = [
	["path", { d: "M9 2v17.5A2.5 2.5 0 0 1 6.5 22A2.5 2.5 0 0 1 4 19.5V2" }],
	["path", { d: "M20 2v17.5a2.5 2.5 0 0 1-2.5 2.5a2.5 2.5 0 0 1-2.5-2.5V2" }],
	["path", { d: "M3 2h7" }],
	["path", { d: "M14 2h7" }],
	["path", { d: "M9 16H4" }],
	["path", { d: "M20 16h-5" }],
] satisfies IconNode;

export const textAlignCenter = [
	["path", { d: "M21 5H3" }],
	["path", { d: "M17 12H7" }],
	["path", { d: "M19 19H5" }],
] satisfies IconNode;

export const textAlignEnd = [
	["path", { d: "M21 5H3" }],
	["path", { d: "M21 12H9" }],
	["path", { d: "M21 19H7" }],
] satisfies IconNode;

export const textAlignJustify = [
	["path", { d: "M3 5h18" }],
	["path", { d: "M3 12h18" }],
	["path", { d: "M3 19h18" }],
] satisfies IconNode;

export const textAlignJustifyCenter = [
	["path", { d: "M3 5h18" }],
	["path", { d: "M3 12h18" }],
	["path", { d: "M7 19h10" }],
] satisfies IconNode;

export const textAlignJustifyEnd = [
	["path", { d: "M3 5h18" }],
	["path", { d: "M3 12h18" }],
	["path", { d: "M11 19h10" }],
] satisfies IconNode;

export const textAlignJustifyStart = [
	["path", { d: "M3 5h18" }],
	["path", { d: "M3 12h18" }],
	["path", { d: "M3 19h10" }],
] satisfies IconNode;

export const textAlignStart = [
	["path", { d: "M21 5H3" }],
	["path", { d: "M15 12H3" }],
	["path", { d: "M17 19H3" }],
] satisfies IconNode;

export const textCursor = [
	["path", { d: "M17 22h-1a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h1" }],
	["path", { d: "M7 22h1a4 4 0 0 0 4-4" }],
	["path", { d: "M7 2h1a4 4 0 0 1 4 4" }],
] satisfies IconNode;

export const textCursorInput = [
	["path", { d: "M12 20h-1a2 2 0 0 1-2-2 2 2 0 0 1-2 2H6" }],
	["path", { d: "M13 8h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7" }],
	["path", { d: "M5 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1" }],
	["path", { d: "M6 4h1a2 2 0 0 1 2 2 2 2 0 0 1 2-2h1" }],
	["path", { d: "M9 6v12" }],
] satisfies IconNode;

export const textInitial = [
	["path", { d: "M15 5h6" }],
	["path", { d: "M15 12h6" }],
	["path", { d: "M3 19h18" }],
	["path", { d: "m3 12 3.553-7.724a.5.5 0 0 1 .894 0L11 12" }],
	["path", { d: "M3.92 10h6.16" }],
] satisfies IconNode;

export const textQuote = [
	["path", { d: "M17 5H3" }],
	["path", { d: "M21 12H8" }],
	["path", { d: "M21 19H8" }],
	["path", { d: "M3 12v7" }],
] satisfies IconNode;

export const textSearch = [
	["path", { d: "M21 5H3" }],
	["path", { d: "M10 12H3" }],
	["path", { d: "M10 19H3" }],
	["circle", { cx: "17", cy: "15", r: "3" }],
	["path", { d: "m21 19-1.9-1.9" }],
] satisfies IconNode;

export const textWrap = [
	["path", { d: "m16 16-3 3 3 3" }],
	["path", { d: "M3 12h14.5a1 1 0 0 1 0 7H13" }],
	["path", { d: "M3 19h6" }],
	["path", { d: "M3 5h18" }],
] satisfies IconNode;

export const theater = [
	["path", { d: "M2 10s3-3 3-8" }],
	["path", { d: "M22 10s-3-3-3-8" }],
	["path", { d: "M10 2c0 4.4-3.6 8-8 8" }],
	["path", { d: "M14 2c0 4.4 3.6 8 8 8" }],
	["path", { d: "M2 10s2 2 2 5" }],
	["path", { d: "M22 10s-2 2-2 5" }],
	["path", { d: "M8 15h8" }],
	["path", { d: "M2 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1" }],
	["path", { d: "M14 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1" }],
] satisfies IconNode;

export const thermometer = [
	["path", { d: "M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z" }],
] satisfies IconNode;

export const thermometerSnowflake = [
	["path", { d: "m10 20-1.25-2.5L6 18" }],
	["path", { d: "M10 4 8.75 6.5 6 6" }],
	["path", { d: "M10.585 15H10" }],
	["path", { d: "M2 12h6.5L10 9" }],
	["path", { d: "M20 14.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0z" }],
	["path", { d: "m4 10 1.5 2L4 14" }],
	["path", { d: "m7 21 3-6-1.5-3" }],
	["path", { d: "m7 3 3 6h2" }],
] satisfies IconNode;

export const thermometerSun = [
	["path", { d: "M12 2v2" }],
	["path", { d: "M12 8a4 4 0 0 0-1.645 7.647" }],
	["path", { d: "M2 12h2" }],
	["path", { d: "M20 14.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0z" }],
	["path", { d: "m4.93 4.93 1.41 1.41" }],
	["path", { d: "m6.34 17.66-1.41 1.41" }],
] satisfies IconNode;

export const thumbsDown = [
	[
		"path",
		{
			d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z",
		},
	],
	["path", { d: "M17 14V2" }],
] satisfies IconNode;

export const thumbsUp = [
	[
		"path",
		{
			d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z",
		},
	],
	["path", { d: "M7 10v12" }],
] satisfies IconNode;

export const ticTacToe = [
	["path", { d: "M12 2v20" }],
	["path", { d: "m21 16-5 5" }],
	["path", { d: "m21 21-5-5" }],
	["path", { d: "M22 12H2" }],
	["path", { d: "M8 3 3 8" }],
	["path", { d: "M8 8 3 3" }],
	["circle", { cx: "18.5", cy: "5.5", r: "2.5" }],
	["circle", { cx: "5.5", cy: "18.5", r: "2.5" }],
] satisfies IconNode;

export const ticket = [
	[
		"path",
		{
			d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
		},
	],
	["path", { d: "M13 5v2" }],
	["path", { d: "M13 17v2" }],
	["path", { d: "M13 11v2" }],
] satisfies IconNode;

export const ticketCheck = [
	[
		"path",
		{
			d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
		},
	],
	["path", { d: "m9 12 2 2 4-4" }],
] satisfies IconNode;

export const ticketMinus = [
	[
		"path",
		{
			d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
		},
	],
	["path", { d: "M9 12h6" }],
] satisfies IconNode;

export const ticketPercent = [
	[
		"path",
		{
			d: "M2 9a3 3 0 1 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 1 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
		},
	],
	["path", { d: "M9 9h.01" }],
	["path", { d: "m15 9-6 6" }],
	["path", { d: "M15 15h.01" }],
] satisfies IconNode;

export const ticketPlus = [
	[
		"path",
		{
			d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
		},
	],
	["path", { d: "M9 12h6" }],
	["path", { d: "M12 9v6" }],
] satisfies IconNode;

export const ticketSlash = [
	[
		"path",
		{
			d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
		},
	],
	["path", { d: "m9.5 14.5 5-5" }],
] satisfies IconNode;

export const ticketX = [
	[
		"path",
		{
			d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
		},
	],
	["path", { d: "m9.5 14.5 5-5" }],
	["path", { d: "m9.5 9.5 5 5" }],
] satisfies IconNode;

export const tickets = [
	["path", { d: "m3.173 8.18 11-5a2 2 0 0 1 2.647.993L18.56 8" }],
	["path", { d: "M6 10V8" }],
	["path", { d: "M6 14v1" }],
	["path", { d: "M6 19v2" }],
	["rect", { x: "2", y: "8", width: "20", height: "13", rx: "2" }],
] satisfies IconNode;

export const ticketsPlane = [
	["path", { d: "M10.5 17h1.227a2 2 0 0 0 1.345-.52L18 12" }],
	["path", { d: "m12 13.5 3.794.506" }],
	["path", { d: "m3.173 8.18 11-5a2 2 0 0 1 2.647.993L18.56 8" }],
	["path", { d: "M6 10V8" }],
	["path", { d: "M6 14v1" }],
	["path", { d: "M6 19v2" }],
	["rect", { x: "2", y: "8", width: "20", height: "13", rx: "2" }],
] satisfies IconNode;

export const timeline = [
	["path", { d: "M4 12h.01" }],
	["path", { d: "M4 16h.01" }],
	["path", { d: "M4 20h.01" }],
	["path", { d: "M4 4h.01" }],
	["path", { d: "M4 8h.01" }],
	[
		"path",
		{
			d: "M9.414 13.414a2 2 0 0 0 1.414.586H19a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-8.172a2 2 0 0 0-1.414.586L8 12z",
		},
	],
	[
		"path",
		{
			d: "M9.414 21.414a2 2 0 0 0 1.414.586H19a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-8.172a2 2 0 0 0-1.414.586L8 20z",
		},
	],
	[
		"path",
		{
			d: "M9.414 5.414A2 2 0 0 0 10.828 6H19a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-8.172a2 2 0 0 0-1.414.586L8 4z",
		},
	],
] satisfies IconNode;

export const timer = [
	["line", { x1: "10", x2: "14", y1: "2", y2: "2" }],
	["line", { x1: "12", x2: "15", y1: "14", y2: "11" }],
	["circle", { cx: "12", cy: "14", r: "8" }],
] satisfies IconNode;

export const timerOff = [
	["path", { d: "M10 2h4" }],
	["path", { d: "M4.6 11a8 8 0 0 0 1.7 8.7 8 8 0 0 0 8.7 1.7" }],
	["path", { d: "M7.4 7.4a8 8 0 0 1 10.3 1 8 8 0 0 1 .9 10.2" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M12 12v-2" }],
] satisfies IconNode;

export const timerReset = [
	["path", { d: "M10 2h4" }],
	["path", { d: "M12 14v-4" }],
	["path", { d: "M4 13a8 8 0 0 1 8-7 8 8 0 1 1-5.3 14L4 17.6" }],
	["path", { d: "M9 17H4v5" }],
] satisfies IconNode;

export const toggleLeft = [
	["circle", { cx: "9", cy: "12", r: "3" }],
	["rect", { width: "20", height: "14", x: "2", y: "5", rx: "7" }],
] satisfies IconNode;

export const toggleRight = [
	["circle", { cx: "15", cy: "12", r: "3" }],
	["rect", { width: "20", height: "14", x: "2", y: "5", rx: "7" }],
] satisfies IconNode;

export const toilet = [
	[
		"path",
		{
			d: "M7 12h13a1 1 0 0 1 1 1 5 5 0 0 1-5 5h-.598a.5.5 0 0 0-.424.765l1.544 2.47a.5.5 0 0 1-.424.765H5.402a.5.5 0 0 1-.424-.765L7 18",
		},
	],
	["path", { d: "M8 18a5 5 0 0 1-5-5V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8" }],
] satisfies IconNode;

export const tombstone = [
	["path", { d: "M11 10h2" }],
	["path", { d: "M19 21V10a7 7 0 00-14 0v11" }],
	["path", { d: "M2 21h20" }],
	["path", { d: "M9 14h6" }],
] satisfies IconNode;

export const toolCase = [
	["path", { d: "M10 15h4" }],
	[
		"path",
		{
			d: "m14.5 4.058.571-1.429a1 1 0 011.3-.558l5 2a1 1 0 01.549.534.88.88 0 01.01.765l-2.332 5.83",
		},
	],
	[
		"path",
		{
			d: "M15.634 11a2 2 0 00-.186-.34l-1.17-1.757 1.31-1.656a2 2 0 00-2.109-3.165l-2.032.57-1.17-1.758a2 2 0 00-3.664 1.028l-.086 2.11-2.032.568a2 2 0 00-.155 3.8l1.617.6",
		},
	],
	["path", { d: "M4 12.006A1 1 0 014.994 11H19a1 1 0 011 1v7a2 2 0 01-2 2H6a2 2 0 01-2-2z" }],
] satisfies IconNode;

export const toolbox = [
	["path", { d: "M16 12v4" }],
	["path", { d: "M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" }],
	[
		"path",
		{
			d: "M17 6a2 2 0 011.414.586l3 3A2 2 0 0122 11v8a2 2 0 01-2 2H4a2 2 0 01-2-2v-8a2 2 0 01.586-1.414l3-3A2 2 0 017 6z",
		},
	],
	["path", { d: "M2 14h20" }],
	["path", { d: "M8 12v4" }],
] satisfies IconNode;

export const toothbrush = [
	["path", { d: "M15 11c-2 2-4 2-6 4l-7 7" }],
	[
		"path",
		{
			d: "m22 4-7.414 7.414-2-2A2 2 0 0114 6c0-.512.196-1.024.586-1.414A2 2 0 0116 4a2 2 0 013.262-1.552l2.152 2.138",
		},
	],
] satisfies IconNode;

export const toothbrushSparkles = [
	["path", { d: "M10 3H8" }],
	["path", { d: "M14.586 11.414 22 4" }],
	["path", { d: "M15 11a8 8 0 01-.429.4" }],
	[
		"path",
		{
			d: "m2 22 7-7c1.857-1.857 3.714-1.99 5.571-3.6l-1.985-1.986A2 2 0 0114 6a2 2 0 012-2 2 2 0 013.262-1.552l2.152 2.138",
		},
	],
	["path", { d: "M20 15v4" }],
	["path", { d: "M22 17h-4" }],
	["path", { d: "M4 5v4" }],
	["path", { d: "M6 7H2" }],
	["path", { d: "M9 2v2" }],
] satisfies IconNode;

export const tornado = [
	["path", { d: "M21 4H3" }],
	["path", { d: "M18 8H6" }],
	["path", { d: "M19 12H9" }],
	["path", { d: "M16 16h-6" }],
	["path", { d: "M11 20H9" }],
] satisfies IconNode;

export const torus = [
	["ellipse", { cx: "12", cy: "11", rx: "3", ry: "2" }],
	["ellipse", { cx: "12", cy: "12.5", rx: "10", ry: "8.5" }],
] satisfies IconNode;

export const touchpad = [
	["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2" }],
	["path", { d: "M2 14h20" }],
	["path", { d: "M12 20v-6" }],
] satisfies IconNode;

export const touchpadOff = [
	["path", { d: "M12 20v-6" }],
	["path", { d: "M19.656 14H22" }],
	["path", { d: "M2 14h12" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M20 20H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2" }],
	["path", { d: "M9.656 4H20a2 2 0 0 1 2 2v10.344" }],
] satisfies IconNode;

export const towelRack = [
	["path", { d: "M22 7h-2" }],
	[
		"path",
		{
			d: "M6.5 3h11A2.5 2.5 0 0 1 20 5.5V20a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1V5.5a1 1 0 0 0-5 0V17a1 1 0 0 0 1 1h4",
		},
	],
	["path", { d: "M9 7H2" }],
] satisfies IconNode;

export const towerControl = [
	["path", { d: "M18.2 12.27 20 6H4l1.8 6.27a1 1 0 0 0 .95.73h10.5a1 1 0 0 0 .96-.73Z" }],
	["path", { d: "M8 13v9" }],
	["path", { d: "M16 22v-9" }],
	["path", { d: "m9 6 1 7" }],
	["path", { d: "m15 6-1 7" }],
	["path", { d: "M12 6V2" }],
	["path", { d: "M13 2h-2" }],
] satisfies IconNode;

export const toyBrick = [
	["rect", { width: "18", height: "12", x: "3", y: "8", rx: "1" }],
	["path", { d: "M10 8V5c0-.6-.4-1-1-1H6a1 1 0 0 0-1 1v3" }],
	["path", { d: "M19 8V5c0-.6-.4-1-1-1h-3a1 1 0 0 0-1 1v3" }],
] satisfies IconNode;

export const tractor = [
	["path", { d: "m10 11 11 .9a1 1 0 0 1 .8 1.1l-.665 4.158a1 1 0 0 1-.988.842H20" }],
	["path", { d: "M16 18h-5" }],
	["path", { d: "M18 5a1 1 0 0 0-1 1v5.573" }],
	["path", { d: "M3 4h8.129a1 1 0 0 1 .99.863L13 11.246" }],
	["path", { d: "M4 11V4" }],
	["path", { d: "M7 15h.01" }],
	["path", { d: "M8 10.1V4" }],
	["circle", { cx: "18", cy: "18", r: "2" }],
	["circle", { cx: "7", cy: "15", r: "5" }],
] satisfies IconNode;

export const trafficCone = [
	["path", { d: "M16.05 10.966a5 2.5 0 0 1-8.1 0" }],
	[
		"path",
		{
			d: "m16.923 14.049 4.48 2.04a1 1 0 0 1 .001 1.831l-8.574 3.9a2 2 0 0 1-1.66 0l-8.574-3.91a1 1 0 0 1 0-1.83l4.484-2.04",
		},
	],
	["path", { d: "M16.949 14.14a5 2.5 0 1 1-9.9 0L10.063 3.5a2 2 0 0 1 3.874 0z" }],
	["path", { d: "M9.194 6.57a5 2.5 0 0 0 5.61 0" }],
] satisfies IconNode;

export const trailer = [
	["path", { d: "M10 11.341V10" }],
	["path", { d: "M14 13v-3" }],
	["path", { d: "M18 17V8a2 2 0 00-2-2H4a2 2 0 00-2 2v7a2 2 0 002 2h2" }],
	["path", { d: "M22 15v1a1 1 0 01-1 1H10" }],
	["path", { d: "M6 11.341V10" }],
	["circle", { cx: "8", cy: "17", r: "2" }],
] satisfies IconNode;

export const trainFront = [
	["path", { d: "M8 3.1V7a4 4 0 0 0 8 0V3.1" }],
	["path", { d: "m9 15-1-1" }],
	["path", { d: "m15 15 1-1" }],
	["path", { d: "M9 19c-2.8 0-5-2.2-5-5v-4a8 8 0 0 1 16 0v4c0 2.8-2.2 5-5 5Z" }],
	["path", { d: "m8 19-2 3" }],
	["path", { d: "m16 19 2 3" }],
] satisfies IconNode;

export const trainFrontTunnel = [
	["path", { d: "M2 22V12a10 10 0 1 1 20 0v10" }],
	["path", { d: "M15 6.8v1.4a3 2.8 0 1 1-6 0V6.8" }],
	["path", { d: "M10 15h.01" }],
	["path", { d: "M14 15h.01" }],
	["path", { d: "M10 19a4 4 0 0 1-4-4v-3a6 6 0 1 1 12 0v3a4 4 0 0 1-4 4Z" }],
	["path", { d: "m9 19-2 3" }],
	["path", { d: "m15 19 2 3" }],
] satisfies IconNode;

export const trainTrack = [
	["path", { d: "M2 17 17 2" }],
	["path", { d: "m2 14 8 8" }],
	["path", { d: "m5 11 8 8" }],
	["path", { d: "m8 8 8 8" }],
	["path", { d: "m11 5 8 8" }],
	["path", { d: "m14 2 8 8" }],
	["path", { d: "M7 22 22 7" }],
] satisfies IconNode;

export const tramFront = [
	["rect", { width: "16", height: "16", x: "4", y: "3", rx: "2" }],
	["path", { d: "M4 11h16" }],
	["path", { d: "M12 3v8" }],
	["path", { d: "m8 19-2 3" }],
	["path", { d: "m18 22-2-3" }],
	["path", { d: "M8 15h.01" }],
	["path", { d: "M16 15h.01" }],
] satisfies IconNode;

export const transgender = [
	["path", { d: "M12 16v6" }],
	["path", { d: "M14 20h-4" }],
	["path", { d: "M18 2h4v4" }],
	["path", { d: "m2 2 7.17 7.17" }],
	["path", { d: "M2 5.355V2h3.357" }],
	["path", { d: "m22 2-7.17 7.17" }],
	["path", { d: "M8 5 5 8" }],
	["circle", { cx: "12", cy: "12", r: "4" }],
] satisfies IconNode;

export const trash = [
	["path", { d: "M10 11v6" }],
	["path", { d: "M14 11v6" }],
	["path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" }],
	["path", { d: "M3 6h18" }],
	["path", { d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" }],
] satisfies IconNode;

export const trashOff = [
	["path", { d: "M10 11v6" }],
	["path", { d: "M14 17v-3" }],
	["path", { d: "M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-1.576.768" }],
	["path", { d: "M19 6v7.344" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M21 6h-9.344" }],
	["path", { d: "M3 6h3" }],
	["path", { d: "M5 6v14a2 2 0 002 2h10a2 2 0 002-2v-1" }],
] satisfies IconNode;

export const treeDeciduous = [
	[
		"path",
		{
			d: "M8 19a4 4 0 0 1-2.24-7.32A3.5 3.5 0 0 1 9 6.03V6a3 3 0 1 1 6 0v.04a3.5 3.5 0 0 1 3.24 5.65A4 4 0 0 1 16 19Z",
		},
	],
	["path", { d: "M12 19v3" }],
] satisfies IconNode;

export const treePalm = [
	["path", { d: "M13 8c0-2.76-2.46-5-5.5-5S2 5.24 2 8h2l1-1 1 1h4" }],
	["path", { d: "M13 7.14A5.82 5.82 0 0 1 16.5 6c3.04 0 5.5 2.24 5.5 5h-3l-1-1-1 1h-3" }],
	[
		"path",
		{
			d: "M5.89 9.71c-2.15 2.15-2.3 5.47-.35 7.43l4.24-4.25.7-.7.71-.71 2.12-2.12c-1.95-1.96-5.27-1.8-7.42.35",
		},
	],
	["path", { d: "M11 15.5c.5 2.5-.17 4.5-1 6.5h4c2-5.5-.5-12-1-14" }],
] satisfies IconNode;

export const treePine = [
	[
		"path",
		{
			d: "m17 14 3 3.3a1 1 0 0 1-.7 1.7H4.7a1 1 0 0 1-.7-1.7L7 14h-.3a1 1 0 0 1-.7-1.7L9 9h-.2A1 1 0 0 1 8 7.3L12 3l4 4.3a1 1 0 0 1-.8 1.7H15l3 3.3a1 1 0 0 1-.7 1.7H17Z",
		},
	],
	["path", { d: "M12 22v-3" }],
] satisfies IconNode;

export const trees = [
	["path", { d: "M10 10v.2A3 3 0 0 1 8.9 16H5a3 3 0 0 1-1-5.8V10a3 3 0 0 1 6 0Z" }],
	["path", { d: "M7 16v6" }],
	["path", { d: "M13 19v3" }],
	[
		"path",
		{
			d: "M12 19h8.3a1 1 0 0 0 .7-1.7L18 14h.3a1 1 0 0 0 .7-1.7L16 9h.2a1 1 0 0 0 .8-1.7L13 3l-1.4 1.5",
		},
	],
] satisfies IconNode;

export const trendingDown = [
	["path", { d: "M16 17h6v-6" }],
	["path", { d: "m22 17-8.5-8.5-5 5L2 7" }],
] satisfies IconNode;

export const trendingUp = [
	["path", { d: "M16 7h6v6" }],
	["path", { d: "m22 7-8.5 8.5-5-5L2 17" }],
] satisfies IconNode;

export const trendingUpDown = [
	["path", { d: "M14.828 14.828 21 21" }],
	["path", { d: "M21 16v5h-5" }],
	["path", { d: "m21 3-9 9-4-4-6 6" }],
	["path", { d: "M21 8V3h-5" }],
] satisfies IconNode;

export const triangle = [
	["path", { d: "M13.73 4a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" }],
] satisfies IconNode;

export const triangleAlert = [
	["path", { d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" }],
	["path", { d: "M12 9v4" }],
	["path", { d: "M12 17h.01" }],
] satisfies IconNode;

export const triangleDashed = [
	["path", { d: "M10.17 4.193a2 2 0 0 1 3.666.013" }],
	["path", { d: "M14 21h2" }],
	["path", { d: "m15.874 7.743 1 1.732" }],
	["path", { d: "m18.849 12.952 1 1.732" }],
	["path", { d: "M21.824 18.18a2 2 0 0 1-1.835 2.824" }],
	["path", { d: "M4.024 21a2 2 0 0 1-1.839-2.839" }],
	["path", { d: "m5.136 12.952-1 1.732" }],
	["path", { d: "M8 21h2" }],
	["path", { d: "m8.102 7.743-1 1.732" }],
] satisfies IconNode;

export const triangleRight = [
	["path", { d: "M22 18a2 2 0 0 1-2 2H3c-1.1 0-1.3-.6-.4-1.3L20.4 4.3c.9-.7 1.6-.4 1.6.7Z" }],
] satisfies IconNode;

export const trianglesCenterlineDashedHorizontal = [
	["path", { d: "M10 12H8" }],
	["path", { d: "M16 12h-2" }],
	["path", { d: "M22 12h-2" }],
	["path", { d: "M4 12H2" }],
	[
		"path",
		{ d: "M7.298 20.288A1 1 0 008 22h8a1 1 0 00.703-1.712l-3.991-3.99a1 1 0 00-1.424-.001z" },
	],
	["path", { d: "M7.298 3.712A1 1 0 018 2h8a1 1 0 01.703 1.712l-3.991 3.99a1 1 0 01-1.424.001z" }],
] satisfies IconNode;

export const trianglesCenterlineDashedVertical = [
	["path", { d: "M12 14v2" }],
	["path", { d: "M12 20v2" }],
	["path", { d: "M12 2v2" }],
	["path", { d: "M12 8v2" }],
	[
		"path",
		{ d: "M20.288 16.703A1 1 0 0022 16V8a1 1 0 00-1.712-.703l-3.99 3.991a1 1 0 00-.001 1.424z" },
	],
	["path", { d: "M3.712 16.703A1 1 0 012 16V8a1 1 0 011.712-.703l3.99 3.991a1 1 0 01.001 1.424z" }],
] satisfies IconNode;

export const trophy = [
	["path", { d: "M10 14.66V17a1 1 0 0 1-1 1 2 2 0 0 0-2 2v2" }],
	["path", { d: "M14 14.66V17a1 1 0 0 0 1 1 2 2 0 0 1 2 2v2" }],
	["path", { d: "M17.916 10H19.5A2.5 2.5 0 0 0 22 7.5V5a1 1 0 0 0-1-1h-3" }],
	["path", { d: "M4 22h16" }],
	["path", { d: "M6 9a6 6 0 0 0 12 0V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1z" }],
	["path", { d: "M6.084 10H4.5A2.5 2.5 0 0 1 2 7.5V5a1 1 0 0 1 1-1h3" }],
] satisfies IconNode;

export const truck = [
	["path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" }],
	["path", { d: "M15 18H9" }],
	[
		"path",
		{ d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14" },
	],
	["circle", { cx: "17", cy: "18", r: "2" }],
	["circle", { cx: "7", cy: "18", r: "2" }],
] satisfies IconNode;

export const truckElectric = [
	["path", { d: "M14 19V7a2 2 0 0 0-2-2H9" }],
	["path", { d: "M15 19H9" }],
	["path", { d: "M19 19h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62L18.3 9.38a1 1 0 0 0-.78-.38H14" }],
	["path", { d: "M2 13v5a1 1 0 0 0 1 1h2" }],
	["path", { d: "M4 3 2.15 5.15a.495.495 0 0 0 .35.86h2.15a.47.47 0 0 1 .35.86L3 9.02" }],
	["circle", { cx: "17", cy: "19", r: "2" }],
	["circle", { cx: "7", cy: "19", r: "2" }],
] satisfies IconNode;

export const tubeLotion = [
	["path", { d: "M15 18v3a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-3" }],
	[
		"path",
		{
			d: "M17 2a2 2 0 0 1 1.6 3.2A8 8 0 0 0 17 10v6a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-6a8 8 0 0 0-1.6-4.8A2 2 0 0 1 7 2z",
		},
	],
	["path", { d: "M7 10a6.47 6.47 0 0 1 5 0 6.47 6.47 0 0 0 5 0" }],
] satisfies IconNode;

export const turkishLira = [
	["path", { d: "M15 4 5 9" }],
	["path", { d: "m15 8.5-10 5" }],
	["path", { d: "M18 12a9 9 0 0 1-9 9V3" }],
] satisfies IconNode;

export const turntable = [
	["path", { d: "M10 12.01h.01" }],
	["path", { d: "M18 8v4a8 8 0 0 1-1.07 4" }],
	["circle", { cx: "10", cy: "12", r: "4" }],
	["rect", { x: "2", y: "4", width: "20", height: "16", rx: "2" }],
] satisfies IconNode;

export const turtle = [
	[
		"path",
		{
			d: "m12 10 2 4v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3a8 8 0 1 0-16 0v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3l2-4h4Z",
		},
	],
	["path", { d: "M4.82 7.9 8 10" }],
	["path", { d: "M15.18 7.9 12 10" }],
	["path", { d: "M16.93 10H20a2 2 0 0 1 0 4H2" }],
] satisfies IconNode;

export const tv = [
	["path", { d: "m17 2-5 5-5-5" }],
	["rect", { width: "20", height: "15", x: "2", y: "7", rx: "2" }],
] satisfies IconNode;

export const tvMinimal = [
	["path", { d: "M7 21h10" }],
	["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2" }],
] satisfies IconNode;

export const tvMinimalPlay = [
	[
		"path",
		{
			d: "M15.033 9.44a.647.647 0 0 1 0 1.12l-4.065 2.352a.645.645 0 0 1-.968-.56V7.648a.645.645 0 0 1 .967-.56z",
		},
	],
	["path", { d: "M7 21h10" }],
	["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2" }],
] satisfies IconNode;

export const type = [
	["path", { d: "M12 4v16" }],
	["path", { d: "M4 7V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2" }],
	["path", { d: "M9 20h6" }],
] satisfies IconNode;

export const typeOutline = [
	[
		"path",
		{
			d: "M14 16.5a.5.5 0 0 0 .5.5h.5a2 2 0 0 1 0 4H9a2 2 0 0 1 0-4h.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V8a2 2 0 0 1-4 0V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v3a2 2 0 0 1-4 0v-.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5Z",
		},
	],
] satisfies IconNode;

export const umbrella = [
	["path", { d: "M12 13v7a2 2 0 0 0 4 0" }],
	["path", { d: "M12 2v2" }],
	["path", { d: "M20.992 13a1 1 0 0 0 .97-1.274 10.284 10.284 0 0 0-19.923 0A1 1 0 0 0 3 13z" }],
] satisfies IconNode;

export const umbrellaOff = [
	["path", { d: "M12 13v7a2 2 0 0 0 4 0" }],
	["path", { d: "M12 2v2" }],
	["path", { d: "M18.656 13h2.336a1 1 0 0 0 .97-1.274 10.284 10.284 0 0 0-12.07-7.51" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M5.961 5.957a10.28 10.28 0 0 0-3.922 5.769A1 1 0 0 0 3 13h10" }],
] satisfies IconNode;

export const underline = [
	["path", { d: "M6 4v6a6 6 0 0 0 12 0V4" }],
	["line", { x1: "4", x2: "20", y1: "20", y2: "20" }],
] satisfies IconNode;

export const undo = [
	["path", { d: "M3 7v6h6" }],
	["path", { d: "M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13" }],
] satisfies IconNode;

export const undo2 = [
	["path", { d: "M9 14 4 9l5-5" }],
	["path", { d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11" }],
] satisfies IconNode;

export const undoDot = [
	["path", { d: "M21 17a9 9 0 0 0-15-6.7L3 13" }],
	["path", { d: "M3 7v6h6" }],
	["circle", { cx: "12", cy: "17", r: "1" }],
] satisfies IconNode;

export const unfoldHorizontal = [
	["path", { d: "M16 12h6" }],
	["path", { d: "M8 12H2" }],
	["path", { d: "M12 2v2" }],
	["path", { d: "M12 8v2" }],
	["path", { d: "M12 14v2" }],
	["path", { d: "M12 20v2" }],
	["path", { d: "m19 15 3-3-3-3" }],
	["path", { d: "m5 9-3 3 3 3" }],
] satisfies IconNode;

export const unfoldVertical = [
	["path", { d: "M12 22v-6" }],
	["path", { d: "M12 8V2" }],
	["path", { d: "M4 12H2" }],
	["path", { d: "M10 12H8" }],
	["path", { d: "M16 12h-2" }],
	["path", { d: "M22 12h-2" }],
	["path", { d: "m15 19-3 3-3-3" }],
	["path", { d: "m15 5-3-3-3 3" }],
] satisfies IconNode;

export const ungroup = [
	["rect", { x: "11", y: "14", width: "10", height: "7", rx: "2" }],
	["rect", { x: "3", y: "3", width: "10", height: "7", rx: "2" }],
] satisfies IconNode;

export const university = [
	["path", { d: "M14 21v-3a2 2 0 0 0-4 0v3" }],
	["path", { d: "M18 12h.01" }],
	["path", { d: "M18 16h.01" }],
	[
		"path",
		{
			d: "M22 7a1 1 0 0 0-1-1h-2a2 2 0 0 1-1.143-.359L13.143 2.36a2 2 0 0 0-2.286-.001L6.143 5.64A2 2 0 0 1 5 6H3a1 1 0 0 0-1 1v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2z",
		},
	],
	["path", { d: "M6 12h.01" }],
	["path", { d: "M6 16h.01" }],
	["circle", { cx: "12", cy: "10", r: "2" }],
] satisfies IconNode;

export const unlink = [
	[
		"path",
		{
			d: "m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71",
		},
	],
	[
		"path",
		{ d: "m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71" },
	],
	["line", { x1: "8", x2: "8", y1: "2", y2: "5" }],
	["line", { x1: "2", x2: "5", y1: "8", y2: "8" }],
	["line", { x1: "16", x2: "16", y1: "19", y2: "22" }],
	["line", { x1: "19", x2: "22", y1: "16", y2: "16" }],
] satisfies IconNode;

export const unlink2 = [
	["path", { d: "M15 7h2a5 5 0 0 1 0 10h-2m-6 0H7A5 5 0 0 1 7 7h2" }],
] satisfies IconNode;

export const unplug = [
	["path", { d: "m19 5 3-3" }],
	["path", { d: "m2 22 3-3" }],
	["path", { d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z" }],
	["path", { d: "M7.5 13.5 10 11" }],
	["path", { d: "M10.5 16.5 13 14" }],
	["path", { d: "m12 6 6 6 2.3-2.3a2.4 2.4 0 0 0 0-3.4l-2.6-2.6a2.4 2.4 0 0 0-3.4 0Z" }],
] satisfies IconNode;

export const upload = [
	["path", { d: "M12 3v12" }],
	["path", { d: "m17 8-5-5-5 5" }],
	["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }],
] satisfies IconNode;

export const usb = [
	["circle", { cx: "10", cy: "7", r: "1" }],
	["circle", { cx: "4", cy: "20", r: "1" }],
	["path", { d: "M4.7 19.3 19 5" }],
	["path", { d: "m21 3-3 1 2 2Z" }],
	["path", { d: "M9.26 7.68 5 12l2 5" }],
	["path", { d: "m10 14 5 2 3.5-3.5" }],
	["path", { d: "m18 12 1-1 1 1-1 1Z" }],
] satisfies IconNode;

export const usbCPort = [
	["path", { d: "M6 12h12" }],
	["rect", { x: "2", y: "8", width: "20", height: "8", rx: "4" }],
] satisfies IconNode;

export const user = [
	["path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" }],
	["circle", { cx: "12", cy: "7", r: "4" }],
] satisfies IconNode;

export const userCheck = [
	["path", { d: "m16 11 2 2 4-4" }],
	["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }],
	["circle", { cx: "9", cy: "7", r: "4" }],
] satisfies IconNode;

export const userCog = [
	["path", { d: "M10 15H6a4 4 0 0 0-4 4v2" }],
	["path", { d: "m14.305 16.53.923-.382" }],
	["path", { d: "m15.228 13.852-.923-.383" }],
	["path", { d: "m16.852 12.228-.383-.923" }],
	["path", { d: "m16.852 17.772-.383.924" }],
	["path", { d: "m19.148 12.228.383-.923" }],
	["path", { d: "m19.53 18.696-.382-.924" }],
	["path", { d: "m20.772 13.852.924-.383" }],
	["path", { d: "m20.772 16.148.924.383" }],
	["circle", { cx: "18", cy: "15", r: "3" }],
	["circle", { cx: "9", cy: "7", r: "4" }],
] satisfies IconNode;

export const userGroup = [
	["path", { d: "M17 21v-1a2 2 0 00-2-2H9a2 2 0 00-2 2v1" }],
	["path", { d: "M19 10h1a2 2 0 012 2v1" }],
	["path", { d: "M5 10H4a2 2 0 00-2 2v1" }],
	["circle", { cx: "12", cy: "11", r: "3" }],
	["circle", { cx: "18", cy: "4", r: "2" }],
	["circle", { cx: "6", cy: "4", r: "2" }],
] satisfies IconNode;

export const userKey = [
	["path", { d: "M20 11v6" }],
	["path", { d: "M20 13h2" }],
	["path", { d: "M3 21v-2a4 4 0 0 1 4-4h6a4 4 0 0 1 2.072.578" }],
	["circle", { cx: "10", cy: "7", r: "4" }],
	["circle", { cx: "20", cy: "19", r: "2" }],
] satisfies IconNode;

export const userLock = [
	["path", { d: "M19 16v-2a2 2 0 0 0-4 0v2" }],
	["path", { d: "M9.5 15H7a4 4 0 0 0-4 4v2" }],
	["circle", { cx: "10", cy: "7", r: "4" }],
	["rect", { x: "13", y: "16", width: "8", height: "5", rx: ".899" }],
] satisfies IconNode;

export const userMinus = [
	["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }],
	["circle", { cx: "9", cy: "7", r: "4" }],
	["line", { x1: "22", x2: "16", y1: "11", y2: "11" }],
] satisfies IconNode;

export const userPen = [
	["path", { d: "M11.5 15H7a4 4 0 0 0-4 4v2" }],
	[
		"path",
		{
			d: "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
		},
	],
	["circle", { cx: "10", cy: "7", r: "4" }],
] satisfies IconNode;

export const userPlus = [
	["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }],
	["circle", { cx: "9", cy: "7", r: "4" }],
	["line", { x1: "19", x2: "19", y1: "8", y2: "14" }],
	["line", { x1: "22", x2: "16", y1: "11", y2: "11" }],
] satisfies IconNode;

export const userRound = [
	["circle", { cx: "12", cy: "8", r: "5" }],
	["path", { d: "M20 21a8 8 0 0 0-16 0" }],
] satisfies IconNode;

export const userRoundArrowLeft = [
	["path", { d: "m19 16-3 3" }],
	["path", { d: "M2 21a8 8 0 0 1 12.664-6.5" }],
	["path", { d: "M22 19h-6l3 3" }],
	["circle", { cx: "10", cy: "8", r: "5" }],
] satisfies IconNode;

export const userRoundCheck = [
	["path", { d: "M2 21a8 8 0 0 1 13.292-6" }],
	["circle", { cx: "10", cy: "8", r: "5" }],
	["path", { d: "m16 19 2 2 4-4" }],
] satisfies IconNode;

export const userRoundCog = [
	["path", { d: "m14.305 19.53.923-.382" }],
	["path", { d: "m15.228 16.852-.923-.383" }],
	["path", { d: "m16.852 15.228-.383-.923" }],
	["path", { d: "m16.852 20.772-.383.924" }],
	["path", { d: "m19.148 15.228.383-.923" }],
	["path", { d: "m19.53 21.696-.382-.924" }],
	["path", { d: "M2 21a8 8 0 0 1 10.434-7.62" }],
	["path", { d: "m20.772 16.852.924-.383" }],
	["path", { d: "m20.772 19.148.924.383" }],
	["circle", { cx: "10", cy: "8", r: "5" }],
	["circle", { cx: "18", cy: "18", r: "3" }],
] satisfies IconNode;

export const userRoundGroup = [
	["path", { d: "M17 21a5 5 0 00-10 0" }],
	["path", { d: "M22 10.5a3.5 3.5 0 00-5.507-2.868" }],
	["path", { d: "M7.507 7.632A3.5 3.5 0 002 10.5" }],
	["circle", { cx: "12", cy: "13", r: "3" }],
	["circle", { cx: "18.5", cy: "4.5", r: "2.5" }],
	["circle", { cx: "5.5", cy: "4.5", r: "2.5" }],
] satisfies IconNode;

export const userRoundKey = [
	["path", { d: "M19 11v6" }],
	["path", { d: "M19 13h2" }],
	["path", { d: "M2 21a8 8 0 0 1 12.868-6.349" }],
	["circle", { cx: "10", cy: "8", r: "5" }],
	["circle", { cx: "19", cy: "19", r: "2" }],
] satisfies IconNode;

export const userRoundMinus = [
	["path", { d: "M2 21a8 8 0 0 1 13.292-6" }],
	["circle", { cx: "10", cy: "8", r: "5" }],
	["path", { d: "M22 19h-6" }],
] satisfies IconNode;

export const userRoundPen = [
	["path", { d: "M2 21a8 8 0 0 1 10.821-7.487" }],
	[
		"path",
		{
			d: "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
		},
	],
	["circle", { cx: "10", cy: "8", r: "5" }],
] satisfies IconNode;

export const userRoundPlus = [
	["path", { d: "M2 21a8 8 0 0 1 13.292-6" }],
	["circle", { cx: "10", cy: "8", r: "5" }],
	["path", { d: "M19 16v6" }],
	["path", { d: "M22 19h-6" }],
] satisfies IconNode;

export const userRoundSearch = [
	["circle", { cx: "10", cy: "8", r: "5" }],
	["path", { d: "M2 21a8 8 0 0 1 10.434-7.62" }],
	["circle", { cx: "18", cy: "18", r: "3" }],
	["path", { d: "m22 22-1.9-1.9" }],
] satisfies IconNode;

export const userRoundStar = [
	[
		"path",
		{
			d: "M16.051 12.616a1 1 0 0 1 1.909.024l.737 1.452a1 1 0 0 0 .737.535l1.634.256a1 1 0 0 1 .588 1.806l-1.172 1.168a1 1 0 0 0-.282.866l.259 1.613a1 1 0 0 1-1.541 1.134l-1.465-.75a1 1 0 0 0-.912 0l-1.465.75a1 1 0 0 1-1.539-1.133l.258-1.613a1 1 0 0 0-.282-.867l-1.156-1.152a1 1 0 0 1 .572-1.822l1.633-.256a1 1 0 0 0 .737-.535z",
		},
	],
	["path", { d: "M2 21a8 8 0 0 1 6.778-7.905" }],
	["path", { d: "M8.927 12.885a5 5 0 1 1 6.061-4.535" }],
] satisfies IconNode;

export const userRoundX = [
	["path", { d: "m16.5 16.5 5 5" }],
	["path", { d: "M2 21a8 8 0 0 1 11.531-7.18" }],
	["path", { d: "m21.5 16.5-5 5" }],
	["circle", { cx: "10", cy: "8", r: "5" }],
] satisfies IconNode;

export const userSearch = [
	["circle", { cx: "10", cy: "7", r: "4" }],
	["path", { d: "M10.3 15H7a4 4 0 0 0-4 4v2" }],
	["circle", { cx: "17", cy: "17", r: "3" }],
	["path", { d: "m21 21-1.9-1.9" }],
] satisfies IconNode;

export const userShield = [
	["path", { d: "M10 15H6a4 4 0 0 0-4 4v2" }],
	[
		"path",
		{
			d: "M22 17.5c0 2.499-1.75 3.749-3.83 4.474a.5.5 0 0 1-.335-.005c-2.085-.72-3.835-1.97-3.835-4.47V14a.5.5 0 0 1 .5-.499c1 0 2.25-.6 3.12-1.36a.6.6 0 0 1 .76-.001c.875.765 2.12 1.36 3.12 1.36a.5.5 0 0 1 .5.5z",
		},
	],
	["circle", { cx: "9", cy: "7", r: "4" }],
] satisfies IconNode;

export const userStar = [
	[
		"path",
		{
			d: "M16.051 12.616a1 1 0 0 1 1.909.024l.737 1.452a1 1 0 0 0 .737.535l1.634.256a1 1 0 0 1 .588 1.806l-1.172 1.168a1 1 0 0 0-.282.866l.259 1.613a1 1 0 0 1-1.541 1.134l-1.465-.75a1 1 0 0 0-.912 0l-1.465.75a1 1 0 0 1-1.539-1.133l.258-1.613a1 1 0 0 0-.282-.866l-1.156-1.153a1 1 0 0 1 .572-1.822l1.633-.256a1 1 0 0 0 .737-.535z",
		},
	],
	["path", { d: "M8 15H7a4 4 0 0 0-4 4v2" }],
	["circle", { cx: "10", cy: "7", r: "4" }],
] satisfies IconNode;

export const userX = [
	["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }],
	["circle", { cx: "9", cy: "7", r: "4" }],
	["line", { x1: "17", x2: "22", y1: "8", y2: "13" }],
	["line", { x1: "22", x2: "17", y1: "8", y2: "13" }],
] satisfies IconNode;

export const users = [
	["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }],
	["path", { d: "M16 3.128a4 4 0 0 1 0 7.744" }],
	["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87" }],
	["circle", { cx: "9", cy: "7", r: "4" }],
] satisfies IconNode;

export const usersCollaboration = [
	["path", { d: "M12.925 3.047a9 9 0 017.616 6.11" }],
	["path", { d: "M13 22a2 2 0 012-2h4a2 2 0 012 2" }],
	["path", { d: "M3 12a2 2 0 012-2h4a2 2 0 012 2" }],
	["path", { d: "M3.889 15.9a9 9 0 005.247 4.632" }],
	["circle", { cx: "17", cy: "14", r: "2" }],
	["circle", { cx: "7", cy: "4", r: "2" }],
] satisfies IconNode;

export const usersRound = [
	["path", { d: "M18 21a8 8 0 0 0-16 0" }],
	["circle", { cx: "10", cy: "8", r: "5" }],
	["path", { d: "M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3" }],
] satisfies IconNode;

export const usersRoundCollaboration = [
	["path", { d: "M20.453 8.911a9 9 0 00-6.696-5.738" }],
	["path", { d: "M21 22a4 4 0 00-8 0" }],
	["path", { d: "M3 12a4 4 0 017.963-.543" }],
	["path", { d: "M3.889 15.9a9 9 0 005.247 4.632" }],
	["circle", { cx: "17", cy: "15", r: "3" }],
	["circle", { cx: "7", cy: "5", r: "3" }],
] satisfies IconNode;

export const utensils = [
	["path", { d: "M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" }],
	["path", { d: "M7 2v20" }],
	["path", { d: "M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7" }],
] satisfies IconNode;

export const utensilsCrossed = [
	["path", { d: "m16 2-2.3 2.3a3 3 0 0 0 0 4.2l1.8 1.8a3 3 0 0 0 4.2 0L22 8" }],
	["path", { d: "M15 15 3.3 3.3a4.2 4.2 0 0 0 0 6l7.3 7.3c.7.7 2 .7 2.8 0L15 15Zm0 0 7 7" }],
	["path", { d: "m2.1 21.8 6.4-6.3" }],
	["path", { d: "m19 5-7 7" }],
] satisfies IconNode;

export const utilityPole = [
	["path", { d: "M12 2v20" }],
	["path", { d: "M2 5h20" }],
	["path", { d: "M3 3v2" }],
	["path", { d: "M7 3v2" }],
	["path", { d: "M17 3v2" }],
	["path", { d: "M21 3v2" }],
	["path", { d: "m19 5-7 7-7-7" }],
] satisfies IconNode;

export const van = [
	[
		"path",
		{
			d: "M13 6v5a1 1 0 0 0 1 1h6.102a1 1 0 0 1 .712.298l.898.91a1 1 0 0 1 .288.702V17a1 1 0 0 1-1 1h-3",
		},
	],
	["path", { d: "M5 18H3a1 1 0 0 1-1-1V8a2 2 0 0 1 2-2h12c1.1 0 2.1.8 2.4 1.8l1.176 4.2" }],
	["path", { d: "M9 18h5" }],
	["circle", { cx: "16", cy: "18", r: "2" }],
	["circle", { cx: "7", cy: "18", r: "2" }],
] satisfies IconNode;

export const variable = [
	["path", { d: "M8 21s-4-3-4-9 4-9 4-9" }],
	["path", { d: "M16 3s4 3 4 9-4 9-4 9" }],
	["line", { x1: "15", x2: "9", y1: "9", y2: "15" }],
	["line", { x1: "9", x2: "15", y1: "9", y2: "15" }],
] satisfies IconNode;

export const vault = [
	["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
	["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor" }],
	["path", { d: "m7.9 7.9 2.7 2.7" }],
	["circle", { cx: "16.5", cy: "7.5", r: ".5", fill: "currentColor" }],
	["path", { d: "m13.4 10.6 2.7-2.7" }],
	["circle", { cx: "7.5", cy: "16.5", r: ".5", fill: "currentColor" }],
	["path", { d: "m7.9 16.1 2.7-2.7" }],
	["circle", { cx: "16.5", cy: "16.5", r: ".5", fill: "currentColor" }],
	["path", { d: "m13.4 13.4 2.7 2.7" }],
	["circle", { cx: "12", cy: "12", r: "2" }],
] satisfies IconNode;

export const vectorPolygon = [
	["path", { d: "m12.828 4.813 5.344 2.375" }],
	["path", { d: "m15.769 18.153 3.461-8.306" }],
	["path", { d: "m5.687 14.074 7.625 4.852" }],
	["path", { d: "M9.772 5.579 5.228 11.42" }],
	["circle", { cx: "11", cy: "4", r: "2" }],
	["circle", { cx: "15", cy: "20", r: "2" }],
	["circle", { cx: "20", cy: "8", r: "2" }],
	["circle", { cx: "4", cy: "13", r: "2" }],
] satisfies IconNode;

export const vectorSquare = [
	["path", { d: "M17.055 4.533a24 24 0 00-10.11 0" }],
	["path", { d: "M19.467 17.055a24 24 0 000-10.11" }],
	["path", { d: "M4.533 6.945a24 24 0 000 10.11" }],
	["path", { d: "M6.945 19.467a24 24 0 0010.11 0" }],
	["circle", { cx: "19", cy: "19", r: "2" }],
	["circle", { cx: "19", cy: "5", r: "2" }],
	["circle", { cx: "5", cy: "19", r: "2" }],
	["circle", { cx: "5", cy: "5", r: "2" }],
] satisfies IconNode;

export const vegan = [
	["path", { d: "M16 8q6 0 6-6-6 0-6 6" }],
	["path", { d: "M17.41 3.59a10 10 0 1 0 3 3" }],
	["path", { d: "M2 2a26.6 26.6 0 0 1 10 20c.9-6.82 1.5-9.5 4-14" }],
] satisfies IconNode;

export const venetianMask = [
	["path", { d: "M18 11c-1.5 0-2.5.5-3 2" }],
	[
		"path",
		{
			d: "M4 6a2 2 0 0 0-2 2v4a5 5 0 0 0 5 5 8 8 0 0 1 5 2 8 8 0 0 1 5-2 5 5 0 0 0 5-5V8a2 2 0 0 0-2-2h-3a8 8 0 0 0-5 2 8 8 0 0 0-5-2z",
		},
	],
	["path", { d: "M6 11c1.5 0 2.5.5 3 2" }],
] satisfies IconNode;

export const venus = [
	["path", { d: "M12 15v7" }],
	["path", { d: "M9 19h6" }],
	["circle", { cx: "12", cy: "9", r: "6" }],
] satisfies IconNode;

export const venusAndMars = [
	["path", { d: "M10 20h4" }],
	["path", { d: "M12 16v6" }],
	["path", { d: "M17 2h4v4" }],
	["path", { d: "m21 2-5.46 5.46" }],
	["circle", { cx: "12", cy: "11", r: "5" }],
] satisfies IconNode;

export const vibrate = [
	["path", { d: "m2 8 2 2-2 2 2 2-2 2" }],
	["path", { d: "m22 8-2 2 2 2-2 2 2 2" }],
	["rect", { width: "8", height: "14", x: "8", y: "5", rx: "1" }],
] satisfies IconNode;

export const vibrateOff = [
	["path", { d: "m2 8 2 2-2 2 2 2-2 2" }],
	["path", { d: "m22 8-2 2 2 2-2 2 2 2" }],
	["path", { d: "M8 8v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2" }],
	["path", { d: "M16 10.34V6c0-.55-.45-1-1-1h-4.34" }],
	["line", { x1: "2", x2: "22", y1: "2", y2: "22" }],
] satisfies IconNode;

export const video = [
	["path", { d: "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5" }],
	["rect", { x: "2", y: "6", width: "14", height: "12", rx: "2" }],
] satisfies IconNode;

export const videoOff = [
	["path", { d: "M10.66 6H14a2 2 0 0 1 2 2v2.5l5.248-3.062A.5.5 0 0 1 22 7.87v8.196" }],
	["path", { d: "M16 16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2" }],
	["path", { d: "m2 2 20 20" }],
] satisfies IconNode;

export const videotape = [
	["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2" }],
	["path", { d: "M2 8h20" }],
	["circle", { cx: "8", cy: "14", r: "2" }],
	["path", { d: "M8 12h8" }],
	["circle", { cx: "16", cy: "14", r: "2" }],
] satisfies IconNode;

export const view = [
	["path", { d: "M21 17v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2" }],
	["path", { d: "M21 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2" }],
	["circle", { cx: "12", cy: "12", r: "1" }],
	[
		"path",
		{
			d: "M18.944 12.33a1 1 0 0 0 0-.66 7.5 7.5 0 0 0-13.888 0 1 1 0 0 0 0 .66 7.5 7.5 0 0 0 13.888 0",
		},
	],
] satisfies IconNode;

export const virus = [
	["path", { d: "M12 14.991h.01" }],
	["path", { d: "M12 22v-3" }],
	["path", { d: "M12 2v3" }],
	["path", { d: "M13 22h-2" }],
	["path", { d: "M13 2h-2" }],
	["path", { d: "M13.99 10H14" }],
	["path", { d: "m16.5 19.794-1-1.733" }],
	["path", { d: "m16.5 4.205-1 1.732" }],
	["path", { d: "m19.794 16.5-1.732-1" }],
	["path", { d: "m19.794 7.5-1.732 1" }],
	["path", { d: "M2 12h3" }],
	["path", { d: "M2 13v-2" }],
	["path", { d: "M22 12h-3" }],
	["path", { d: "M22 13v-2" }],
	["path", { d: "m4.206 16.5 1.732-1" }],
	["path", { d: "m4.206 7.5 1.732 1" }],
	["path", { d: "m7.5 19.794 1-1.733" }],
	["path", { d: "m7.5 4.205 1 1.732" }],
	["path", { d: "M9 12h.01" }],
	["circle", { cx: "12", cy: "12", r: "7" }],
] satisfies IconNode;

export const virusOff = [
	["path", { d: "M10.01 10h.01" }],
	["path", { d: "M12 14.991h.01" }],
	["path", { d: "M12 22v-3" }],
	["path", { d: "M12 2v3" }],
	["path", { d: "M13 22h-2" }],
	["path", { d: "M13 2h-2" }],
	["path", { d: "m16.5 19.794-1-1.733" }],
	["path", { d: "m16.5 4.205-1 1.732" }],
	["path", { d: "M18.891 13.235a7 7 0 00-8.126-8.126" }],
	["path", { d: "m19.794 7.5-1.732 1" }],
	["path", { d: "M2 12h3" }],
	["path", { d: "M2 13v-2" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M22 12h-3" }],
	["path", { d: "M22 13v-2" }],
	["path", { d: "m4.206 16.5 1.732-1" }],
	["path", { d: "m4.206 7.5 1.732 1" }],
	["path", { d: "M7.05 7.05a7 7 0 009.9 9.9" }],
	["path", { d: "m7.5 19.794 1-1.733" }],
	["path", { d: "M9 12h.01" }],
] satisfies IconNode;

export const voicemail = [
	["circle", { cx: "6", cy: "12", r: "4" }],
	["circle", { cx: "18", cy: "12", r: "4" }],
	["line", { x1: "6", x2: "18", y1: "16", y2: "16" }],
] satisfies IconNode;

export const volleyball = [
	["path", { d: "M11 7a16 16 20 0 1 10.98 4.362" }],
	["path", { d: "M12 12a13 13 0 0 1-8.66 5" }],
	["path", { d: "M16.83 13.634a16 16 0 0 1-9.267 7.328" }],
	["path", { d: "M20.66 17A13 13 0 0 0 12 12a13 13 0 0 1 0-10" }],
	["path", { d: "M8.17 15.366a16 16 0 0 1-1.713-11.69" }],
	["circle", { cx: "12", cy: "12", r: "10" }],
] satisfies IconNode;

export const volume = [
	[
		"path",
		{
			d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
		},
	],
] satisfies IconNode;

export const volume1 = [
	[
		"path",
		{
			d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
		},
	],
	["path", { d: "M16 9a5 5 0 0 1 0 6" }],
] satisfies IconNode;

export const volume2 = [
	[
		"path",
		{
			d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
		},
	],
	["path", { d: "M16 9a5 5 0 0 1 0 6" }],
	["path", { d: "M19.364 18.364a9 9 0 0 0 0-12.728" }],
] satisfies IconNode;

export const volumeOff = [
	["path", { d: "M16 9a5 5 0 0 1 .95 2.293" }],
	["path", { d: "M19.364 5.636a9 9 0 0 1 1.889 9.96" }],
	["path", { d: "m2 2 20 20" }],
	[
		"path",
		{
			d: "m7 7-.587.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298V11",
		},
	],
	["path", { d: "M9.828 4.172A.686.686 0 0 1 11 4.657v.686" }],
] satisfies IconNode;

export const volumeX = [
	[
		"path",
		{
			d: "M11 4.702a.7.7 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.7.7 0 0 0 11 19.298z",
		},
	],
	["path", { d: "m16.5 14.5 5-5" }],
	["path", { d: "m16.5 9.5 5 5" }],
] satisfies IconNode;

export const vote = [
	["path", { d: "m9 12 2 2 4-4" }],
	["path", { d: "M5 7c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v12H5V7Z" }],
	["path", { d: "M22 19H2" }],
] satisfies IconNode;

export const wallet = [
	[
		"path",
		{
			d: "M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1",
		},
	],
	["path", { d: "M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4" }],
] satisfies IconNode;

export const walletCards = [
	["path", { d: "M3 11h3.75a2 2 0 0 1 1.6.8l.45.6a4 4 0 0 0 6.4 0l.45-.6a2 2 0 0 1 1.6-.8H21" }],
	["path", { d: "M3 7h18" }],
	["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }],
] satisfies IconNode;

export const walletMinimal = [
	["path", { d: "M17 14h.01" }],
	["path", { d: "M7 7h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14" }],
] satisfies IconNode;

export const wallpaper = [
	["path", { d: "M12 17v4" }],
	["path", { d: "M8 21h8" }],
	["path", { d: "m9 17 6.1-6.1a2 2 0 0 1 2.81.01L22 15" }],
	["circle", { cx: "8", cy: "9", r: "2" }],
	["rect", { x: "2", y: "3", width: "20", height: "14", rx: "2" }],
] satisfies IconNode;

export const wand = [
	["path", { d: "M15 4V2" }],
	["path", { d: "M15 16v-2" }],
	["path", { d: "M8 9h2" }],
	["path", { d: "M20 9h2" }],
	["path", { d: "M17.8 11.8 19 13" }],
	["path", { d: "M15 9h.01" }],
	["path", { d: "M17.8 6.2 19 5" }],
	["path", { d: "m3 21 9-9" }],
	["path", { d: "M12.2 6.2 11 5" }],
] satisfies IconNode;

export const wandSparkles = [
	[
		"path",
		{
			d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72",
		},
	],
	["path", { d: "m14 7 3 3" }],
	["path", { d: "M5 6v4" }],
	["path", { d: "M19 14v4" }],
	["path", { d: "M10 2v2" }],
	["path", { d: "M7 8H3" }],
	["path", { d: "M21 16h-4" }],
	["path", { d: "M11 3H9" }],
] satisfies IconNode;

export const warehouse = [
	["path", { d: "M18 21V10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v11" }],
	[
		"path",
		{
			d: "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 1.132-1.803l7.95-3.974a2 2 0 0 1 1.837 0l7.948 3.974A2 2 0 0 1 22 8z",
		},
	],
	["path", { d: "M6 13h12" }],
	["path", { d: "M6 17h12" }],
] satisfies IconNode;

export const washingMachine = [
	["path", { d: "M3 6h3" }],
	["path", { d: "M17 6h.01" }],
	["rect", { width: "18", height: "20", x: "3", y: "2", rx: "2" }],
	["circle", { cx: "12", cy: "13", r: "5" }],
	["path", { d: "M12 18a2.5 2.5 0 0 0 0-5 2.5 2.5 0 0 1 0-5" }],
] satisfies IconNode;

export const watch = [
	["path", { d: "M12 10v2.2l1.6 1" }],
	["path", { d: "m16.13 7.66-.81-4.05a2 2 0 0 0-2-1.61h-2.68a2 2 0 0 0-2 1.61l-.78 4.05" }],
	["path", { d: "m7.88 16.36.8 4a2 2 0 0 0 2 1.61h2.72a2 2 0 0 0 2-1.61l.81-4.05" }],
	["circle", { cx: "12", cy: "12", r: "6" }],
] satisfies IconNode;

export const wavesArrowDown = [
	["path", { d: "M12 10L12 2" }],
	["path", { d: "M16 6L12 10L8 6" }],
	[
		"path",
		{
			d: "M2 15C2.6 15.5 3.2 16 4.5 16C7 16 7 14 9.5 14C12.1 14 11.9 16 14.5 16C17 16 17 14 19.5 14C20.8 14 21.4 14.5 22 15",
		},
	],
	[
		"path",
		{
			d: "M2 21C2.6 21.5 3.2 22 4.5 22C7 22 7 20 9.5 20C12.1 20 11.9 22 14.5 22C17 22 17 20 19.5 20C20.8 20 21.4 20.5 22 21",
		},
	],
] satisfies IconNode;

export const wavesArrowUp = [
	["path", { d: "M12 2v8" }],
	[
		"path",
		{
			d: "M2 15c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
		},
	],
	[
		"path",
		{
			d: "M2 21c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
		},
	],
	["path", { d: "m8 6 4-4 4 4" }],
] satisfies IconNode;

export const wavesHorizontal = [
	["path", { d: "M2 12q2.5 2 5 0t5 0 5 0 5 0" }],
	["path", { d: "M2 19q2.5 2 5 0t5 0 5 0 5 0" }],
	["path", { d: "M2 5q2.5 2 5 0t5 0 5 0 5 0" }],
] satisfies IconNode;

export const wavesLadder = [
	["path", { d: "M19 5a2 2 0 0 0-2 2v11" }],
	[
		"path",
		{
			d: "M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
		},
	],
	["path", { d: "M7 13h10" }],
	["path", { d: "M7 9h10" }],
	["path", { d: "M9 5a2 2 0 0 0-2 2v11" }],
] satisfies IconNode;

export const wavesVertical = [
	["path", { d: "M12 2q2 2.5 0 5t0 5 0 5 0 5" }],
	["path", { d: "M19 2q2 2.5 0 5t0 5 0 5 0 5" }],
	["path", { d: "M5 2q2 2.5 0 5t0 5 0 5 0 5" }],
] satisfies IconNode;

export const waypoints = [
	["path", { d: "m10.586 5.414-5.172 5.172" }],
	["path", { d: "m18.586 13.414-5.172 5.172" }],
	["path", { d: "M6 12h12" }],
	["circle", { cx: "12", cy: "20", r: "2" }],
	["circle", { cx: "12", cy: "4", r: "2" }],
	["circle", { cx: "20", cy: "12", r: "2" }],
	["circle", { cx: "4", cy: "12", r: "2" }],
] satisfies IconNode;

export const webcam = [
	["circle", { cx: "12", cy: "10", r: "8" }],
	["circle", { cx: "12", cy: "10", r: "3" }],
	["path", { d: "M7 22h10" }],
	["path", { d: "M12 22v-4" }],
] satisfies IconNode;

export const webcamOff = [
	["path", { d: "M12 22v-4" }],
	["path", { d: "M12.754 7.096a3 3 0 0 1 2.15 2.15" }],
	["path", { d: "M12.863 12.873a3 3 0 0 1-3.736-3.735" }],
	["path", { d: "M16.566 16.57A8 8 0 0 1 5.43 5.433" }],
	["path", { d: "m2 2 20 20" }],
	["path", { d: "M7 22h10" }],
	["path", { d: "M8.478 2.817a8 8 0 0 1 10.705 10.705" }],
] satisfies IconNode;

export const webhook = [
	["path", { d: "M18 16.98h-5.99c-1.1 0-1.95.94-2.48 1.9A4 4 0 0 1 2 17c.01-.7.2-1.4.57-2" }],
	["path", { d: "m6 17 3.13-5.78c.53-.97.1-2.18-.5-3.1a4 4 0 1 1 6.89-4.06" }],
	["path", { d: "m12 6 3.13 5.73C15.66 12.7 16.9 13 18 13a4 4 0 0 1 0 8" }],
] satisfies IconNode;

export const webhookOff = [
	["path", { d: "M17 17h-5c-1.09-.02-1.94.92-2.5 1.9A3 3 0 1 1 2.57 15" }],
	["path", { d: "M9 3.4a4 4 0 0 1 6.52.66" }],
	["path", { d: "m6 17 3.1-5.8a2.5 2.5 0 0 0 .057-2.05" }],
	["path", { d: "M20.3 20.3a4 4 0 0 1-2.3.7" }],
	["path", { d: "M18.6 13a4 4 0 0 1 3.357 3.414" }],
	["path", { d: "m12 6 .6 1" }],
	["path", { d: "m2 2 20 20" }],
] satisfies IconNode;

export const weight = [
	["circle", { cx: "12", cy: "5", r: "3" }],
	[
		"path",
		{
			d: "M6.5 8a2 2 0 0 0-1.905 1.46L2.1 18.5A2 2 0 0 0 4 21h16a2 2 0 0 0 1.925-2.54L19.4 9.5A2 2 0 0 0 17.48 8Z",
		},
	],
] satisfies IconNode;

export const weightTilde = [
	[
		"path",
		{
			d: "M6.5 8a2 2 0 0 0-1.906 1.46L2.1 18.5A2 2 0 0 0 4 21h16a2 2 0 0 0 1.925-2.54L19.4 9.5A2 2 0 0 0 17.48 8z",
		},
	],
	["path", { d: "M7.999 15a2.5 2.5 0 0 1 4 0 2.5 2.5 0 0 0 4 0" }],
	["circle", { cx: "12", cy: "5", r: "3" }],
] satisfies IconNode;

export const wheat = [
	["path", { d: "M2 22 16 8" }],
	[
		"path",
		{ d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z" },
	],
	[
		"path",
		{ d: "M7.47 8.53 9 7l1.53 1.53a3.5 3.5 0 0 1 0 4.94L9 15l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z" },
	],
	[
		"path",
		{ d: "M11.47 4.53 13 3l1.53 1.53a3.5 3.5 0 0 1 0 4.94L13 11l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z" },
	],
	["path", { d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z" }],
	[
		"path",
		{
			d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
		},
	],
	[
		"path",
		{
			d: "M15.47 13.47 17 15l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
		},
	],
	[
		"path",
		{
			d: "M19.47 9.47 21 11l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L13 11l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
		},
	],
] satisfies IconNode;

export const wheatOff = [
	["path", { d: "m2 22 10-10" }],
	["path", { d: "m16 8-1.17 1.17" }],
	[
		"path",
		{ d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z" },
	],
	["path", { d: "m8 8-.53.53a3.5 3.5 0 0 0 0 4.94L9 15l1.53-1.53c.55-.55.88-1.25.98-1.97" }],
	["path", { d: "M10.91 5.26c.15-.26.34-.51.56-.73L13 3l1.53 1.53a3.5 3.5 0 0 1 .28 4.62" }],
	["path", { d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z" }],
	[
		"path",
		{
			d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
		},
	],
	["path", { d: "m16 16-.53.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.49 3.49 0 0 1 1.97-.98" }],
	["path", { d: "M18.74 13.09c.26-.15.51-.34.73-.56L21 11l-1.53-1.53a3.5 3.5 0 0 0-4.62-.28" }],
	["line", { x1: "2", x2: "22", y1: "2", y2: "22" }],
] satisfies IconNode;

export const whistle = [
	["path", { d: "M10 6v4" }],
	["path", { d: "M21 6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-5.675A7 7 0 1 1 9 6z" }],
] satisfies IconNode;

export const wholeWord = [
	["circle", { cx: "7", cy: "12", r: "3" }],
	["path", { d: "M10 9v6" }],
	["circle", { cx: "17", cy: "12", r: "3" }],
	["path", { d: "M14 7v8" }],
	["path", { d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1" }],
] satisfies IconNode;

export const wifi = [
	["path", { d: "M12 20h.01" }],
	["path", { d: "M2 8.82a15 15 0 0 1 20 0" }],
	["path", { d: "M5 12.859a10 10 0 0 1 14 0" }],
	["path", { d: "M8.5 16.429a5 5 0 0 1 7 0" }],
] satisfies IconNode;

export const wifiCog = [
	["path", { d: "m14.305 19.53.923-.382" }],
	["path", { d: "m15.228 16.852-.923-.383" }],
	["path", { d: "m16.852 15.228-.383-.923" }],
	["path", { d: "m16.852 20.772-.383.924" }],
	["path", { d: "m19.148 15.228.383-.923" }],
	["path", { d: "m19.53 21.696-.382-.924" }],
	["path", { d: "M2 8.82a15 15 0 0120 0" }],
	["path", { d: "m20.772 16.852.924-.383" }],
	["path", { d: "m20.772 19.148.924.383" }],
	["path", { d: "M5 12.859a10 10 0 0110.18-2.342" }],
	["path", { d: "M8.5 16.429a5 5 0 011.998-1.2" }],
	["circle", { cx: "18", cy: "18", r: "3" }],
] satisfies IconNode;

export const wifiHigh = [
	["path", { d: "M12 20h.01" }],
	["path", { d: "M5 12.859a10 10 0 0 1 14 0" }],
	["path", { d: "M8.5 16.429a5 5 0 0 1 7 0" }],
] satisfies IconNode;

export const wifiLock = [
	["path", { d: "M2 8.82a15 15 0 0120 0" }],
	["path", { d: "M20 16v-2a2 2 0 00-4 0v2" }],
	["path", { d: "M5 12.859a10 10 0 018.436-2.756" }],
	["path", { d: "M8.5 16.429a5 5 0 011.794-1.13" }],
	["rect", { x: "14", y: "16", width: "8", height: "5", rx: "1" }],
] satisfies IconNode;

export const wifiLow = [
	["path", { d: "M12 20h.01" }],
	["path", { d: "M8.5 16.429a5 5 0 0 1 7 0" }],
] satisfies IconNode;

export const wifiOff = [
	["path", { d: "M12 20h.01" }],
	["path", { d: "M8.5 16.429a5 5 0 0 1 7 0" }],
	["path", { d: "M5 12.859a10 10 0 0 1 5.17-2.69" }],
	["path", { d: "M19 12.859a10 10 0 0 0-2.007-1.523" }],
	["path", { d: "M2 8.82a15 15 0 0 1 4.177-2.643" }],
	["path", { d: "M22 8.82a15 15 0 0 0-11.288-3.764" }],
	["path", { d: "m2 2 20 20" }],
] satisfies IconNode;

export const wifiPen = [
	["path", { d: "M2 8.82a15 15 0 0 1 20 0" }],
	[
		"path",
		{
			d: "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
		},
	],
	["path", { d: "M5 12.859a10 10 0 0 1 10.5-2.222" }],
	["path", { d: "M8.5 16.429a5 5 0 0 1 3-1.406" }],
] satisfies IconNode;

export const wifiSync = [
	["path", { d: "M11.965 10.105v4L13.5 12.5a5 5 0 0 1 8 1.5" }],
	["path", { d: "M11.965 14.105h4" }],
	["path", { d: "M17.965 18.105h4L20.43 19.71a5 5 0 0 1-8-1.5" }],
	["path", { d: "M2 8.82a15 15 0 0 1 20 0" }],
	["path", { d: "M21.965 22.105v-4" }],
	["path", { d: "M5 12.86a10 10 0 0 1 3-2.032" }],
	["path", { d: "M8.5 16.429h.01" }],
] satisfies IconNode;

export const wifiZero = [["path", { d: "M12 20h.01" }]] satisfies IconNode;

export const wind = [
	["path", { d: "M12.8 19.6A2 2 0 1 0 14 16H2" }],
	["path", { d: "M17.5 8a2.5 2.5 0 1 1 2 4H2" }],
	["path", { d: "M9.8 4.4A2 2 0 1 1 11 8H2" }],
] satisfies IconNode;

export const windArrowDown = [
	["path", { d: "M10 2v8" }],
	["path", { d: "M12.8 21.6A2 2 0 1 0 14 18H2" }],
	["path", { d: "M17.5 10a2.5 2.5 0 1 1 2 4H2" }],
	["path", { d: "m6 6 4 4 4-4" }],
] satisfies IconNode;

export const windArrowUp = [
	["path", { d: "M10 2v8" }],
	["path", { d: "M12.8 21.6A2 2 0 1 0 14 18H2" }],
	["path", { d: "M17.5 10a2.5 2.5 0 1 1 2 4H2" }],
	["path", { d: "m6 6 4 -4 4 4" }],
] satisfies IconNode;

export const wine = [
	["path", { d: "M8 22h8" }],
	["path", { d: "M7 10h10" }],
	["path", { d: "M12 15v7" }],
	["path", { d: "M12 15a5 5 0 0 0 5-5c0-2-.5-4-2-8H9c-1.5 4-2 6-2 8a5 5 0 0 0 5 5Z" }],
] satisfies IconNode;

export const wineOff = [
	["path", { d: "M8 22h8" }],
	["path", { d: "M7 10h3m7 0h-1.343" }],
	["path", { d: "M12 15v7" }],
	[
		"path",
		{
			d: "M7.307 7.307A12.33 12.33 0 0 0 7 10a5 5 0 0 0 7.391 4.391M8.638 2.981C8.75 2.668 8.872 2.34 9 2h6c1.5 4 2 6 2 8 0 .407-.05.809-.145 1.198",
		},
	],
	["line", { x1: "2", x2: "22", y1: "2", y2: "22" }],
] satisfies IconNode;

export const workflow = [
	["rect", { width: "8", height: "8", x: "3", y: "3", rx: "2" }],
	["path", { d: "M7 11v4a2 2 0 0 0 2 2h4" }],
	["rect", { width: "8", height: "8", x: "13", y: "13", rx: "2" }],
] satisfies IconNode;

export const worm = [
	["path", { d: "m19 12-1.5 3" }],
	["path", { d: "M19.63 18.81 22 20" }],
	[
		"path",
		{
			d: "M6.47 8.23a1.68 1.68 0 0 1 2.44 1.93l-.64 2.08a6.76 6.76 0 0 0 10.16 7.67l.42-.27a1 1 0 1 0-2.73-4.21l-.42.27a1.76 1.76 0 0 1-2.63-1.99l.64-2.08A6.66 6.66 0 0 0 3.94 3.9l-.7.4a1 1 0 1 0 2.55 4.34z",
		},
	],
] satisfies IconNode;

export const wrench = [
	[
		"path",
		{
			d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.106-3.105c.32-.322.863-.22.983.218a6 6 0 0 1-8.259 7.057l-7.91 7.91a1 1 0 0 1-2.999-3l7.91-7.91a6 6 0 0 1 7.057-8.259c.438.12.54.662.219.984z",
		},
	],
] satisfies IconNode;

export const wrenchOff = [
	[
		"path",
		{
			d: "M10.747 5.093a6 6 0 0 1 6.841-2.882c.438.12.54.662.219.984L14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.106-3.105c.32-.322.863-.22.983.218a6 6 0 0 1-2.882 6.842",
		},
	],
	["path", { d: "m13.5 13.5-7.88 7.88a1 1 0 0 1-2.999-3l7.88-7.88" }],
	["path", { d: "m2 2 20 20" }],
] satisfies IconNode;

export const x = [
	["path", { d: "M18 6 6 18" }],
	["path", { d: "m6 6 12 12" }],
] satisfies IconNode;

export const xLineTop = [
	["path", { d: "M18 4H6" }],
	["path", { d: "M18 8 6 20" }],
	["path", { d: "m6 8 12 12" }],
] satisfies IconNode;

export const zap = [
	[
		"path",
		{
			d: "M15.914 4a1.5 1.5 0 00-2.474-1.561l-9 9A1.5 1.5 0 005.5 14h4.002a.5.5 0 01.471.666L8.086 20a1.5 1.5 0 002.475 1.56l9-9A1.5 1.5 0 0018.5 10h-3.997a.5.5 0 01-.472-.667z",
		},
	],
] satisfies IconNode;

export const zapOff = [
	["path", { d: "M10.768 5.111 13.44 2.44a1.5 1.5 0 012.474 1.561l-1.633 4.625" }],
	["path", { d: "m18.889 13.232.672-.672A1.5 1.5 0 0018.5 10h-2.844" }],
	["path", { d: "m2 2 20 20" }],
	[
		"path",
		{
			d: "m7.94 7.94-3.5 3.499A1.5 1.5 0 005.5 14h4.002a.5.5 0 01.471.666L8.086 20a1.5 1.5 0 002.475 1.56l5.5-5.5",
		},
	],
] satisfies IconNode;

export const zodiacAquarius = [
	[
		"path",
		{
			d: "m2 10 2.456-3.684a.7.7 0 0 1 1.106-.013l2.39 3.413a.7.7 0 0 0 1.096-.001l2.402-3.432a.7.7 0 0 1 1.098 0l2.402 3.432a.7.7 0 0 0 1.098 0l2.389-3.413a.7.7 0 0 1 1.106.013L22 10",
		},
	],
	[
		"path",
		{
			d: "m2 18.002 2.456-3.684a.7.7 0 0 1 1.106-.013l2.39 3.413a.7.7 0 0 0 1.097 0l2.402-3.432a.7.7 0 0 1 1.098 0l2.402 3.432a.7.7 0 0 0 1.098 0l2.389-3.413a.7.7 0 0 1 1.106.013L22 18.002",
		},
	],
] satisfies IconNode;

export const zodiacAries = [
	["path", { d: "M12 7.5a4.5 4.5 0 1 1 5 4.5" }],
	["path", { d: "M7 12a4.5 4.5 0 1 1 5-4.5V21" }],
] satisfies IconNode;

export const zodiacCancer = [
	["path", { d: "M21 14.5A9 6.5 0 0 1 5.5 19" }],
	["path", { d: "M3 9.5A9 6.5 0 0 1 18.5 5" }],
	["circle", { cx: "17.5", cy: "14.5", r: "3.5" }],
	["circle", { cx: "6.5", cy: "9.5", r: "3.5" }],
] satisfies IconNode;

export const zodiacCapricorn = [
	["path", { d: "M11 21a3 3 0 0 0 3-3V6.5a1 1 0 0 0-7 0" }],
	["path", { d: "M7 19V6a3 3 0 0 0-3-3h0" }],
	["circle", { cx: "17", cy: "17", r: "3" }],
] satisfies IconNode;

export const zodiacGemini = [
	["path", { d: "M16 4.525v14.948" }],
	["path", { d: "M20 3A17 17 0 0 1 4 3" }],
	["path", { d: "M4 21a17 17 0 0 1 16 0" }],
	["path", { d: "M8 4.525v14.948" }],
] satisfies IconNode;

export const zodiacLeo = [
	["path", { d: "M10 16c0-4-3-4.5-3-8a5 5 0 0 1 10 0c0 3.466-3 6.196-3 10a3 3 0 0 0 6 0" }],
	["circle", { cx: "7", cy: "16", r: "3" }],
] satisfies IconNode;

export const zodiacLibra = [
	[
		"path",
		{ d: "M3 16h6.857c.162-.012.19-.323.038-.38a6 6 0 1 1 4.212 0c-.153.057-.125.368.038.38H21" },
	],
	["path", { d: "M3 20h18" }],
] satisfies IconNode;

export const zodiacOphiuchus = [
	["path", { d: "M3 10A6.06 6.06 0 0 1 12 10 A6.06 6.06 0 0 0 21 10" }],
	["path", { d: "M6 3v12a6 6 0 0 0 12 0V3" }],
] satisfies IconNode;

export const zodiacPisces = [
	["path", { d: "M19 21a15 15 0 0 1 0-18" }],
	["path", { d: "M20 12H4" }],
	["path", { d: "M5 3a15 15 0 0 1 0 18" }],
] satisfies IconNode;

export const zodiacSagittarius = [
	["path", { d: "M15 3h6v6" }],
	["path", { d: "M21 3 3 21" }],
	["path", { d: "m9 9 6 6" }],
] satisfies IconNode;

export const zodiacScorpio = [
	["path", { d: "M10 19V5.5a1 1 0 0 1 5 0V17a2 2 0 0 0 2 2h5l-3-3" }],
	["path", { d: "m22 19-3 3" }],
	["path", { d: "M5 19V5.5a1 1 0 0 1 5 0" }],
	["path", { d: "M5 5.5A2.5 2.5 0 0 0 2.5 3" }],
] satisfies IconNode;

export const zodiacTaurus = [
	["circle", { cx: "12", cy: "15", r: "6" }],
	["path", { d: "M18 3A6 6 0 0 1 6 3" }],
] satisfies IconNode;

export const zodiacVirgo = [
	["path", { d: "M11 5.5a1 1 0 0 1 5 0V16a5 5 0 0 0 5 5" }],
	["path", { d: "M16 11.5a1 1 0 0 1 5 0V16a5 5 0 0 1-5 5" }],
	["path", { d: "M6 19V6a3 3 0 0 0-3-3h0" }],
	["path", { d: "M6 5.5a1 1 0 0 1 5 0V19" }],
] satisfies IconNode;

export const zoomIn = [
	["circle", { cx: "11", cy: "11", r: "8" }],
	["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65" }],
	["line", { x1: "11", x2: "11", y1: "8", y2: "14" }],
	["line", { x1: "8", x2: "14", y1: "11", y2: "11" }],
] satisfies IconNode;

export const zoomOut = [
	["circle", { cx: "11", cy: "11", r: "8" }],
	["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65" }],
	["line", { x1: "8", x2: "14", y1: "11", y2: "11" }],
] satisfies IconNode;
